import React, { useEffect, useState, useRef, useDebugValue } from "react";
import axiosAuth from "../Axios/Interceptors";
import AppContext from "../Context/Context";
import { useParams } from "react-router-dom";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";
import { useGlobalState } from "../Context/GlobalStateContext";
import {
  addMinutes,
  countries,
  formateDate,
  formateDateWithTime,
  getChanges,
  IsDateBetweenTwoDates,
  isObjectEmpty,
  isValidDate,
  isValidEmail,
} from "../Shared/Utility";
import SingleSelectSearchableDropdown from "../App/SingleSelectSearchableDropdown";
import PackingJob from "../App/PackingJob";
import moment from "moment";
import { json, zip } from "d3";
import ConfirmationModal from "../App/ConfirmationModal";
import MNVLineItems from "../App/MNVLineItems";
import MobileInput from "../MobileInput/MobileInput";
import LocationsSuggestions from "../App/LocationsSuggestions";
import ShowMapMarker from "../App/ShowMapMarker";
import DragDrop from "../DragDrop/DragDrop";
import PTDragDropUpload from "../DragDrop/PTDragDropUpload";
import Conversation from "../App/Conversation";
import AutocompleteComponent from "../App/AutocompleteComponent";
import {
  showErrorMessage,
  showInfoMessage,
  showSuccessMessage,
} from "../Shared/Toast";
import MultiSelectionDropdown from "../App/MultiSelectionDropdown";
import MultiSelectionDropdownWithSave from "../App/MultiSelectionDropdownWithSave";
import QuillEditor from "../QuillEditor";

function QuoteDetail() {
  const globalState = useGlobalState();
  const params = useParams();
  const jobId = params.quoteId;
  const [JobId, setJobId] = useState(Number(jobId));

  const [isAnimation, setIsAnimation] = useState(false);
  const mountedRef = useRef(true);
  const [items, setItems] = useState<any[]>([]);

  const [showUpdateClientModal, setShowUpdateClientModal] = useState(false);
  const [showLineItemModal, setShowLineItemModal] = useState(false);
  const [showSlotsModal, setShowSlotsModal] = useState(false);
  const [showBespokeModal, setShowBespokeModal] = useState(false);
  const [showSendPaymentLink, setShowSendPaymentLink] = useState(false);
  const [showLiabilityChangesPopup, setShowLiabilityChangesPopup] =
    useState(false);
  const [showAddPaymentMethods, setShowAddPaymentMethods] = useState(false);
  const [sendWAModal, setSendWAModal] = useState(false);
  const [sendEmailModal, setEmailModal] = useState(false);
  const [
    MNVQuoteRecordDataForForeignKeys,
    setMNVQuoteRecordDataForForeignKeys,
  ] = useState<any>(null);
  const [services, setServices] = useState<any>(null);
  const [MNVQuote, setMNVQuote] = useState<any>({});
  const initialInfoRef = useRef<any>(null);
  const isAddressChangedRef = useRef<any>({});
  const previousAddressRef = useRef<any>(null);

  const [isAddressChangedOnce, setIsAddressChangedOnce] = useState<boolean>(false);
  const [MNVQuoteBKTotalAmount, setMNVQuoteBKTotalAmount] = useState<number>(0);
  const [InvoiceBalanceValue, setInvoiceBalanceValue] =
    useState<any>(undefined);
    const [AdditionalStopBK, setAdditionalStopBK] =
    useState<any>(undefined);

  const [AllLinkedQuotes, setAllLinkedQuotes] = useState<any[]>([]);
  const [JobRelatedData, setJobRelatedData] = useState<any>({});
  const [QuoteId, setQuoteId] = useState<number>(0);
  const [travelType, setTravelType] = useState("Local");

  const [QuoteLogs, setQuoteLogs] = useState<any[]>([]);
  const [QuoteLogTypes, setQuoteLogTypes] = useState<any[]>([]);

  // Example for LogFilters (from your Angular this.LogFilters)
  const [LogFilters, setLogFilters] = useState<any>({
    MNVQuoteID: -1,
    TypeIDs: 0,
    StartDate: "",
    EndDate: "",
  });

  const [IsFirstTime, setIsFirstTime] = useState(true);
  const [IsNewQuote, setIsNewQuote] = useState(true);
  const [TotalStairs, setTotalStairs] = useState(0);
  const [PTFilesList, setPTFilesList] = useState([]);

  const [BespokeDate, setBespokeDate] = useState<string>("");
  const [BespokeTime, setBespokeTime] = useState<string>("");
  const [BespokeTimeEnd, setBespokeTimeEnd] = useState<string>("");
  const [MoversCalculation, setMoversCalculation] = useState<any>({});

  const [infoBackup, setInfoBackup] = useState<any>({
    FromCountryCode: "",
  });

  const [info, setInfo] = useState<any>({
    FromCountryCode: "",
    IsItemsOver100KG: false,
    IsFirstFollowUpDone: false,
    IsSecondFollowUpDone: false,
    Name: false,
    Description: false,
  });

  const infoRef = useRef<any | null>(null);
  infoRef.current = info;
  const [TrustPilotEmail, setTrustPilotEmail] = useState(false);

  const [quoteLoadingTime, setQuoteLoadingTime] = useState<Date>(new Date());
  const [MNVQuoteDetail, setMNVQuoteDetail] = useState<any[]>([]);
  const [MNVQuoteStairDetail, setMNVQuoteStairDetail] = useState<any[]>([]);
  let [AdditionalServices, setAdditionalServices] = useState<any[]>([]);

  const [ExtraHours, setExtraHours] = useState(0);
  const [PayableAmount, setPayableAmount] = useState(0);
  const [CongestionFee, setCongestionFee] = useState(0);
  const [ClientEmail, setClientEmail] = useState("");
  const [ClientAddress, setClientAddress] = useState("");
  const [ClientInstructions, setClientInstructions] = useState("");
  const [ClientPhone, setClientPhone] = useState("");
  const [ClientMobile, setClientMobile] = useState("");
  const [ClientName, setClientName] = useState("");
  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [ClientType, setClientType] = useState(0);
  const [ServiceID, setServiceID] = useState(0);
  const [ClientID, setClientID] = useState<any>(0);
  const [SavedClientID, setSavedClientID] = useState(0);
  const [FileURL, setFileURL] = useState("");

  const [ClientsAutocomplete, setClientsAutocomplete] = useState<any[]>([]);
  const [ClientsList, setClientsList] = useState<any[]>([]);
  const [ShowEdit, setShowEdit] = useState(false);
  const [IsClientAddClicked, setIsClientAddClicked] = useState(false);
  const [VanTypesList, setVanTypesList] = useState<any>([]);
  const [MoverTypesList, setMoverTypesList] = useState<any>([]);

  const [selectedTime, setSelectedTime] = useState("");
  const [NewTime, setNewTime] = useState("");
  //const [trvalType, setTrvalType] = useState("Local");
  const [CurrentSelectedService, setCurrentSelectedService] = useState(0);

  const [ThirdPartyTotalPaid, setThirdPartyTotalPaid] = useState(0);
  const [AnyBankDeposit, setAnyBankDeposit] = useState(0);

  const [LineItemsOverAll, setLineItemsOverAll] = useState([]);
  const [LineItems, setLineItems] = useState<any>([]);
  const [LineMainItems, setLineMainItems] = useState<any>([]);

  const [loadingTimeInSeconds, setLoadingTimeInSeconds] = useState(0);
  const [unloadingTimeInSeconds, setUnloadingTimeInSeconds] = useState(0);
  const [ShowTotalDistance, setShowTotalDistance] = useState<any>(0);
  const [PTDDurationDisplay, setPTDDurationDisplay] = useState("");

  const [coupenCode, setCoupenCode] = useState("");
  const [ShowDiscount, setShowDiscount] = useState(false);
  const [AlreadyAppliedDiscount, setAlreadyAppliedDiscount] = useState(false);
  const [PTDiscountUsedID, setPTDiscountUsedID] = useState(0);
  const [DiscountType, setDiscountType] = useState(0);
  const [Discount, setDiscount] = useState(0);
  const [DiscountObj, setDiscountObj] = useState<any>({});
  const [calculations, setcalculations] = useState<any>({});
  // const calculationsRef = useRef<any | null>(null);
  // calculationsRef.current = calculations;
  const [DicountValueVoucher, setDicountValueVoucher] = useState(0);
  const [LongQuoteDiscount, setLongQuoteDiscount] = useState(0);
  const [QuoteAmount, setQuoteAmount] = useState(0);
  const [distance, setDistance] = useState<any>({});

  const distanceRef = useRef<any | null>(null);
  distanceRef.current = distance;

  const [serviceQuestionAnswers, setServiceQuestionAnswers] = useState([]);

  const [optionsFromDB, setOptionsFromDB] = useState<any>([]);

  const [optionsDataFromDB, setOptionsDataFromDB] = useState<any>([]);
  const [IsVATEditable, setIsVATEditable] = useState(false);
  const [VatCopy, setVatCopy] = useState(0);
  const [DepositOnlyPercentage, setDepositOnlyPercentage] = useState(0);
  const [configurations, setConfigurations] = useState<any[]>([]);
  const [Vat, setVat] = useState(0);
  const [updateVatFunction, setupdateVatFunction] = useState(0);
  const [Base, setBase] = useState(0);
  const [VanMinimumBookingMinutes, setVanMinimumBookingMinutes] = useState(0);
  const [MoversMinimumBookingMinutes, setMoversMinimumBookingMinutes] =
    useState(0);

  const [slotsArray, setSlotsArray] = useState<any[]>([]);

  const [Rates, setRates] = useState<any[]>([]);
  const [AdditionalRateAndVAT, setAdditionalRateAndVAT] = useState(0);
  const [AdditionalRateAndVATAllVans, setAdditionalRateAndVATAllVans] =
    useState(0);

  const [isCalculateDistance, setIsCalculateDistance] = useState(0);
  const [isSlotsLoaded, setIsSlotsLoaded] = useState(0);
  const [isCalculateStairs, setIsCalculateStairs] = useState(0);
  const [isCalculatePayment, setIsCalculatePayment] = useState(0);
  const [isQuoteDataLoading, setIsQuoteDataLoading] = useState(0);

  const [damageClaimClientDetailData, setDamageClaimClientDetailData] =
    useState<any[]>([]);
  const [damageClaimJobData, setDamageClaimJobData] = useState<any[]>([]);
  const [clientJobData, setClientJobData] = useState<any[]>([]);
  const [showClientJobModal, setShowClientJobModal] = useState(false);
  const [selectedClientJobObject, setSelectedClientJobObject] = useState<any>(
    {},
  );

  const [isChanged, setIsChanged] = useState(false);
  const [isCongestion, setIsCongestion] = useState(false);
  const [previousJobs, setPreviousJobs] = useState(false);

  const [LineItemsAmounts, setLineItemsAmounts] = useState({
    Credit: 0,
    TaxFreeCredit: 0,
    Debit: 0,
    Total: 0,
    Paid: 0,
    Refund: 0,
    Balance: 0,
    Liability: 0,
    LiabilityID: 0,
    PendingLineItemCount: 0,
    OtherDiscount: 0,
    OverAllOtherDiscount: 0,
    Cancellation: 0,
    OverallCancellation: 0,
    OverAllCredit: 0,
    OverAllDebit: 0,
    OverAllRefund: 0,
    OverAllSubtotal: 0,
    OverAllVAT: 0,
    OverAllTotal: 0,
    OverAllPaid: 0,
    OverAllBalance: 0,
    OverAllTaxFreeCredit: 0,
  });

  const [ClientData, setClientData] = useState<any>({
    MNVClientID: 0,
    SiteUserID: 0,
    TypeID: 2,
    BusinessName: "",
    FirstName: "",
    SurName: "",
    LastName: "",
    EmailAddress: "",
    Mobile: "",
    Telephone: "",
    PostCode: "",
    Address: "",
    AddressLine2: "",
    VATNumber: "",
    CompanyNumber: "",
    OtherEmails: "",
    IsActive: true,
    DefaultPromoCode: "",
    Notes: "",
    IsVIPClient: false,
    ReferencedByID: 0,
  });

  const ClearClient = () => {
    setClientData({
      MNVClientID: 0,
      SiteUserID: 0,
      TypeID: 2,
      BusinessName: "",
      FirstName: "",
      SurName: "",
      LastName: "",
      EmailAddress: "",
      Mobile: "",
      Telephone: "",
      PostCode: "",
      Address: "",
      AddressLine2: "",
      VATNumber: "",
      CompanyNumber: "",
      OtherEmails: "",
      IsActive: true,
      DefaultPromoCode: "",
      Notes: "",
      IsVIPClient: false,
      ReferencedByID: 0,
    });
  };

  const [ConfirmationModalObject, setConfirmationModalObject] = useState({
    ShowPopup: false,
    Heading: "",
    Message: "",
    ID: 0,
    SelectedID: 0,
    OtherID: 0,
  });

  useEffect(() => {
    mountedRef.current = true;
    if (JobId && Number(JobId) > 0) {
      setJobRelatedData((prev: any) => ({ ...prev, MNVJobID: Number(JobId) }));
      MNVQuoteGetCompleteDataSetForForeignKeysDropDown();
      getServices();
      LoadAllQuotesLinkedToThisJob(JobId, 1);
      GetData();
    }
    return () => {
      mountedRef.current = false;
    };
  }, [jobId]);

  useEffect(() => {
    getMoveManagerUserList(QuoteId);
    clearAllData();
    GetInvoiceDataByQuoteID();
  }, [QuoteId]);

  useEffect(() => {
    if (info && info.ToType) {
      // console.log("CheckStorageType");
      CheckStorageType();
    }
  }, [info.ToType]);

  useEffect(() => {
    if (isCalculateStairs) {
      CalculateStairs();
      setIsCalculateStairs(0);
    }
  }, [isCalculateStairs]);

  useEffect(() => {
    if (
      isCalculateDistance &&
      MNVQuote.ToPostalCode != undefined &&
      MNVQuote.ToPostalCode != ""
    ) {
      setIsCalculateDistance(0);
      CalculateDistance();
    }
  }, [
    MNVQuote.FromPostalCode,
    info.AdditionalStop,
    MNVQuote.ToPostalCode,
    isCalculateDistance,
  ]);

  const prevDeps = useRef<any>({});

  useEffect(() => {
    if (isQuoteDataLoading == 0 && info.MNVVanTypeID > 0) {
      setIsCalculatePayment(0);
      // console.log("prevDeps.current: " + JSON.stringify(prevDeps.current));
      GetTotalAmountValue();

      prevDeps.current = {
        TotalDistance: calculations.TotalDistance,
        travelType: travelType,
        TotalStairs: TotalStairs,
        SlotID: info.SlotID,
        Tier: info.Tier,
        RequestedDate: info.RequestedDate,
        RequestedTime: info.RequestedTime,
        selectedTime: selectedTime,
        loadingTimeInSeconds: loadingTimeInSeconds,
        unloadingTimeInSeconds: unloadingTimeInSeconds,
        MNVMoverTypeID: info.MNVMoverTypeID,
        MNVVanTypeID: info.MNVVanTypeID,
        DiscountType: DiscountType,
        isQuoteDataLoading: isQuoteDataLoading,
        isCalculatePayment: isCalculatePayment,
      };
    }
  }, [
    calculations.TotalDistance,
    travelType,
    TotalStairs,
    info.SlotID,
    info.Tier,
    info.RequestedDate,
    info.RequestedTime,
    selectedTime,
    loadingTimeInSeconds,
    unloadingTimeInSeconds,
    info.MNVMoverTypeID,
    info.MNVVanTypeID,
    DiscountType,
    isQuoteDataLoading,
    isCalculatePayment,
  ]);

  useEffect(() => {
    if (info.MNVVanTypeID > 0) GetVanSlots(false);
  }, [info.MNVVanTypeID]);

  useEffect(() => {
    if (isSlotsLoaded == 1) {
      // console.log("isSlotsLoaded: " + isSlotsLoaded);
      setIsSlotsLoaded(0);
      GetTotalAmountValue();
      CheckAndUpdateAvailableVansForTheSlots();
    }
  }, [isSlotsLoaded]);

  useEffect(() => {
    CalculateAdditionalTimeAmount(1);
  }, [MNVQuote.Mover2ID, MNVQuote.Mover3ID]);

  useEffect(() => {
    ClearLogsFilters(0);
  }, []);

  useEffect(() => {
    LoadLogsData();
  }, [JobRelatedData.MNVJobID]);

  useEffect(() => {
    if (updateVatFunction && updateVatFunction > 0) {
      CalculatePayments(QuoteCalculations, calculations);
      Update(1, QuoteId, 0);
    }
  }, [updateVatFunction]);

  function clearAllData() {
    setLineItems([]);
    setLineItemsAmounts({
      Credit: 0,
      TaxFreeCredit: 0,
      Debit: 0,
      Total: 0,
      Paid: 0,
      Refund: 0,
      Balance: 0,
      Liability: 0,
      LiabilityID: 0,
      PendingLineItemCount: 0,
      OtherDiscount: 0,
      OverAllOtherDiscount: 0,
      Cancellation: 0,
      OverallCancellation: 0,
      OverAllCredit: 0,
      OverAllDebit: 0,
      OverAllRefund: 0,
      OverAllSubtotal: 0,
      OverAllVAT: 0,
      OverAllTotal: 0,
      OverAllPaid: 0,
      OverAllBalance: 0,
      OverAllTaxFreeCredit: 0,
    });
  }

  //#region FKs Data
  function MNVQuoteGetCompleteDataSetForForeignKeysDropDown() {
    setIsAnimation(true);
    axiosAuth
      .get(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/MNVQuoteGetCompleteDataSetForForeignKeysV2",
      )
      .then((response) => {
        // Assign the data
        setMNVQuoteRecordDataForForeignKeys(response.data.Data);
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  const GetData = async () => {
    try {
      const response = await axiosAuth.get(
        AppContext.APIURL + "api/MNVQuoteAdmin/LoadVanAndMoverType",
      );

      setVanTypesList(response.data.Data[0]);
      setMoverTypesList(response.data.Data[1]);
    } catch (error) {
      console.error(error);
    }
  };

  function getServices() {
    setIsAnimation(true);

    axiosAuth
      .get(AppContext.APIURL + "api/MNVQuoteAdmin/GetServices")
      .then((response) => {
        setServices(response.data.Data[0]); // use React state setter
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }
  //#endregion FKs Data

  //#region Job/Quote Data
  function GetMainJobID() {
    return JobRelatedData.MNVJobID;
  }

  function LoadAllQuotesLinkedToThisJob(
    MNVJobID: any,
    p_intFirstTime: number,
    p_intShouldLoadQuoteData: number = 1,
    p_boolIsAddNew: number = 0,
  ) {
    setIsAnimation(true); // optional loader

    const data = { MNVJobID };
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/MNVQuoteGetDataSetByMNVJobIDCustom",
        data,
      )
      .then((response) => {
        const result = response.data.Data;
        let count = 0;
        for (let index = 0; index < result[0].length; index++) {
          count++;
          if (
            result[0][index].Name == "" ||
            result[0][index].Name == "New Service " ||
            result[0][index].Name == "New Service"
          ) {
            result[0][index].Name = "Service " + count;
          }
          result[0][index].EditServiceName = false;
          result[0][index].ShowPosition = false;
        }

        setAllLinkedQuotes(result[0]); // React state

        if (result[1] && result[1][0]) {
          setJobRelatedData((prev: any) => ({
            ...prev,
            Amounts: result[1][0],
          }));
        }

        if (p_intShouldLoadQuoteData) {
          // Call additional functions
          CheckTrustPilotEmailData(MNVJobID);

          const quotes = result[0];

          if (
            quotes.length > 0 &&
            p_intFirstTime &&
            quotes[0].MNVJobID == quotes[0].MNVVanID
          ) {
            LoadDataForSpecificQuote(quotes[0].MNVQuoteID);
          } else if (quotes.length > 0 && !p_boolIsAddNew) {
            if (QuoteId == 0) setQuoteId(quotes[0].MNVQuoteID);
            LoadDataForSpecificQuote(quotes[0].MNVQuoteID);
          } else if (quotes.length > 0 && p_boolIsAddNew) {
            LoadDataForSpecificQuote(quotes[quotes.length - 1].MNVQuoteID);
          }
        }

        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      if (checkIfThereIsAnyDifferenceInBalance() != 0) {
        event.preventDefault();
        event.returnValue = "";
      } else return;
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [calculations.Balance]);

  function LoadDataForSpecificQuote(
    p_intMNVQuoteID: number,
    p_boolManualCall: boolean = false,
  ) {
    // Call system configurations

    // const updated = [...AllLinkedQuotes];
    // for (let index = 0; index < updated.length; index++) {
    //   updated[index].EditServiceName = false;
    //   updated[index].ShowPosition = false;
    // }
    // if (updated.length > 0) setAllLinkedQuotes(updated);

    let unsavedBalance = false;
    if (checkIfThereIsAnyDifferenceInBalance() != 0) unsavedBalance = true;

    if (
      QuoteId != p_intMNVQuoteID &&
      (IsCalledAfterVanDeletion || unsavedBalance)
    ) {
      Update(1, p_intMNVQuoteID, 0);
    } else {
      GetSystemConfigurations(p_intMNVQuoteID);

      if (!p_boolManualCall) {
        setQuoteId(p_intMNVQuoteID);

        // Call other functions
        MNVQuoteGetRecordForEdit(p_intMNVQuoteID);
      } else {
        CheckIfAnyChangesAreMade(p_intMNVQuoteID, false);
      }
    }
    // Load storage and future payment data
    //  MNVQuoteStorageAndFuturePaymentGetCompleteGridDataCustom(true);
  }

  function MNVQuoteGetRecordForEdit(id: number) {
    //Clear all the existing data
    setInfo({});
    setMNVQuote({});
    setAdditionalServices([]);
    setMoversCalculation({}); // Reset calculation state

    // Reset bespoke date/time
    setBespokeDate("");
    setBespokeTime("");
    setBespokeTimeEnd("");

    setItems([]);

    setQuoteCalculations({});

    setIsAnimation(true); // optional loader
    let data: any = {};
    data.MNVQuoteID = Number(id);
    setIsQuoteDataLoading(1);
    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuoteAdmin/MNVQuoteGetQuoteByID", data)
      .then((response) => {
        const result = response.data.Data;

        setQuoteLoadingTime(new Date());

        let quoteData = result[0][0];

        let MNVQuoteAdditionalStops = result[1];
        let MNVQuoteDetail = result[2];
        let MNVQuoteStairDetail = result[3];
        let AdditionalServicesTemp = result[4];

        quoteData.LatLngList = quoteData?.ServiceSubID;
        setMNVQuote(quoteData);
        setMNVQuoteBKTotalAmount(quoteData.TotalAmount);
        setMNVQuoteDetail(MNVQuoteDetail);
        setMNVQuoteStairDetail(MNVQuoteStairDetail);

        AdditionalServices = AdditionalServicesTemp;
        setAdditionalServices([...AdditionalServicesTemp]);

        GetDriversOfThisJob(id);
        GetAdditionalCharges();

        info.MNVVanTypeID = 0;
        info.Tier = "";
        if (quoteData) {
          setMNVQuote((prev: any) => ({
            ...prev,
            JobID: quoteData.JobID,
          }));

          setPayableAmount(quoteData.PayableAmount);
          setCongestionFee(quoteData.CongestionFee);
          setClientEmail(quoteData.EmailAddress);
          setClientAddress(quoteData.Address);
          setClientInstructions(quoteData.ClientInstructions);
          setClientPhone(quoteData.Telephone);
          setClientMobile(quoteData.Mobile);
          setClientName(quoteData.ClientName);
          setFirstName(quoteData.FirstName);
          setLastName(quoteData.LastName);
          setClientType(quoteData.TypeID);
          setServiceID(quoteData.MNVMoveTypeServiceID);
          setClientID(quoteData.MNVClientID);
          setSavedClientID(quoteData.MNVClientID);
          setFileURL(quoteData.FileURL);

          setJobRelatedData((prev: any) => ({
            ...prev,
            MNVClientID: quoteData.MNVClientID,
          }));

          setClientData(quoteData);

          setClientData((prev: any) => ({
            ...prev,
            MobileWA: quoteData.Mobile.replace("-", ""),
          }));

          SearchByClientName(quoteData.EmailAddress, true);
          getClientListAll(quoteData.EmailAddress);
          GetQuoteRelatedPaymentAccountDetails(id);
          setduration(quoteData.Duration);
          MNVDamageClaimGetHistoricalData(1, quoteData.MNVClientID);
          MNVDamageClaimGetHistoricalData(2, quoteData.JobID);
          getThisClientJobs(quoteData.MNVClientID);
          // Handle requested/start/end times
          if (
            quoteData.RequestedDate &&
            new Date(quoteData.RequestedDate).getFullYear() <= 1920
          )
            quoteData.RequestedDate = "";

          if (quoteData.RequestedTime == "00:00-00:00")
            quoteData.RequestedTime = "";

          if (quoteData.StartTime)
            quoteData.StartTime = formateDateWithTime(quoteData.StartTime);
          if (quoteData.EndTime)
            quoteData.EndTime = formateDateWithTime(quoteData.EndTime);

          // Country codes
          let countryCodes = quoteData.ToFloor.split("#PTSep#");
          quoteData.FromCountryCode = countryCodes[0] || "GB";
          quoteData.ToCountryCode = countryCodes[1] || "GB";

          //Info object
          info.Tier = quoteData.TierID;
          info.AdditionalStop = MNVQuoteAdditionalStops;
          setAdditionalStopBK(structuredClone(MNVQuoteAdditionalStops));

          info.MNVVanTypeID = quoteData.MNVVanTypeID;

          info.CourtesyCallBefore = quoteData.CourtesyCallBefore;
          info.CourtesyCallBeforeNotes = quoteData.CourtesyCallBeforeNotes;
          info.CourtesyCallAfter = quoteData.CourtesyCallAfter;
          info.CourtesyCallAfterNotes = quoteData.CourtesyCallAfterNotes;
          info.VanName = VanTypesList.find(
            (v: any) => v.VanTypeID == quoteData.MNVVanTypeID,
          )?.VanTypeName;

          const infoObject = {
            ...quoteData,
            Tier: quoteData.TierID,
            AdditionalStop: MNVQuoteAdditionalStops,
            MNVVanTypeID: quoteData.MNVVanTypeID,
            CourtesyCallBefore: quoteData.CourtesyCallBefore,
            CourtesyCallBeforeNotes: quoteData.CourtesyCallBeforeNotes,
            CourtesyCallAfter: quoteData.CourtesyCallAfter,
            CourtesyCallAfterNotes: quoteData.CourtesyCallAfterNotes,
            VanName: VanTypesList.find(
              (v: any) => v.VanTypeID == quoteData.MNVVanTypeID,
            )?.VanTypeName,
          };

          infoRef.current = infoObject;
          setInfo(infoObject);
          setInfoBackup({ ...infoObject });

          previousAddressRef.current = structuredClone(infoObject);
          isAddressChangedRef.current = {};

          const van1 = VanTypesList.filter(
            (z: any) => z.VanTypeID == quoteData.MNVVanTypeID,
          )[0];

          setCurrentSelectedService(ServiceID);
          const mover = MoverTypesList.filter(
            (z: any) => z.MoverTypeID == quoteData.MNVMoverTypeID,
          )[0];

          setSelectedTime(quoteData.RequiredVanTime);
          setNewTime(quoteData.RequiredVanTime);
          setTravelType(quoteData.IsLocalQuote ? "Local" : "Long");

          // Distance calculations
          const distanceObj = {
            DTPTimeSeconds: MNVQuoteDetail[0]?.DTimeInSeconds || 0,
            PTDTimeSeconds: MNVQuoteDetail[1]?.DTimeInSeconds || 0,
            DTDTimeSeconds: MNVQuoteDetail[2]?.DTimeInSeconds || 0,
            DTP: MNVQuoteDetail[0]?.DDistanceInMiles || 0,
            PTD: MNVQuoteDetail[1]?.DDistanceInMiles || 0,
            DTD: MNVQuoteDetail[2]?.DDistanceInMiles || 0,
          };

          setcalculations((prev: any) => ({
            ...prev,
            TotalDistance: (
              distanceObj.DTP +
              distanceObj.PTD +
              distanceObj.DTD
            ).toFixed(2),
          }));

          distanceRef.current = distanceObj;
          setDistance(distanceObj);
          // Discount handling
          if (quoteData.PTDiscountID > 0) {
            setcalculations((prev: any) => ({
              ...prev,
              PTDiscountID: quoteData.PTDiscountID,
            }));

            setAlreadyAppliedDiscount(true);
            setPTDiscountUsedID(quoteData.PTDiscountUsedID);
            setDiscountType(quoteData.DiscountValueType);
            setDiscount(quoteData.DiscountValue);
            setCoupenCode(quoteData.DiscountCode);
            setShowDiscount(true);
          } else if (quoteData.DefaultPromoCode == "") {
            setAlreadyAppliedDiscount(false);
            setPTDiscountUsedID(0);
            setDiscountType(0);
            setDiscount(0);
            setCoupenCode("");
            setShowDiscount(false);
          } else if (quoteData.DefaultPromoCode != "") {
            setCoupenCode(quoteData.DefaultPromoCode);
            VerifyCode(quoteData.DefaultPromoCode);
          }

          MNVMinimumChargeAndBankHolidayData();

          if (van1) SetVanType(van1, false);

          setcalculations((prev: any) => ({
            ...prev,
            EstimatedLoadingTime: quoteData.LoadingTime,
            EstimatedUnLoadingTime: quoteData.UnloadingTime,
          }));
          setLoadingTimeInSeconds(quoteData.LoadingTime);
          setUnloadingTimeInSeconds(quoteData.UnloadingTime);

          onServiceChangeForEdit(quoteData.MNVMoveTypeServiceID);
          GetServiceOptions(id, quoteData.MNVMoveTypeServiceID);
          //GetServiceQuestionAndAnswers(id);

          setIsCalculateStairs(1);
        }

        setTimeout(() => {
          setIsQuoteDataLoading(0);
        }, 500);

        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  const updateCourtesyCallData = () => {
    let data: any = {};
    data.MNVQuoteID = QuoteId;
    data.CourtesyCallBefore =
      info.CourtesyCallBefore == null || info.CourtesyCallBefore == ""
        ? false
        : info.CourtesyCallBefore;
    data.CourtesyCallBeforeNotes =
      info.CourtesyCallBeforeNotes == null ? "" : info.CourtesyCallBeforeNotes;
    data.CourtesyCallAfter =
      info.CourtesyCallAfter == null || info.CourtesyCallAfter == ""
        ? false
        : info.CourtesyCallAfter;
    data.CourtesyCallAfterNotes =
      info.CourtesyCallAfterNotes == null ? "" : info.CourtesyCallAfterNotes;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/UpdateCourtesyCallData",
        data,
      )
      .then((response) => {
        const result = response.data;
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const MNVDamageClaimGetHistoricalData = async (
    type: number,
    Id: number | string,
  ) => {
    const currentDate = new Date();

    const payload: any = {
      mnvclientid: type === 1 ? Id : 0,
      jobid: type === 2 ? Id : "",
      mnvmoverid: 0,
      startdate: new Date(
        new Date().setFullYear(currentDate.getFullYear() - 5),
      ),
      enddate: new Date(new Date().setFullYear(currentDate.getFullYear() + 5)),
    };

    try {
      const res = await axiosAuth.post(
        AppContext.APIURL + "api/MNVQuoteAdmin/MNVDamageClaimGetHistoricalData",
        payload,
      );

      const data = res.data[0];

      if (type === 1) {
        setDamageClaimClientDetailData(data);
      } else if (type === 2) {
        setDamageClaimJobData(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getThisClientJobs = (ClientID: number) => {
    let data: any = {};
    data.clientid = ClientID;
    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuoteAdmin/MNVGetThisClientJobs", data)
      .then((response) => {
        const result = response.data.Data[0];
        setClientJobData(result);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const copyThisJob = (MNVJobIDCopyFrom: number, MNVJobIDCopyTo: number) => {
    let data: any = {};
    data.mnvjobidcopyfrom = MNVJobIDCopyFrom;
    data.mnvjobidcopyto = MNVJobIDCopyTo;
    setIsAnimation(true);
    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuoteAdmin/MNVCopyThisJob", data)
      .then((response) => {
        const result = response.data.Data[0];
        setIsAnimation(false);
        setShowClientJobModal(false);

        getThisClientJobs(MNVQuote.MNVClientID);
        if (MNVJobIDCopyTo > 0) {
          LoadAllQuotesLinkedToThisJob(MNVJobIDCopyTo, 1);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const GetInvoiceDataByQuoteID = async (UpdateQuoteData = 0) => {
    const data = { MNVQuoteID: GetMainJobID() };

    try {
      const response = await axiosAuth.post(
        AppContext.APIURL + "api/MNVQuoteAdmin/GetInvoiceDataByQuoteID",
        data,
      );

      const invoice = response.data[0] || [];
      const lineItems = response.data[1] || [];
      const lineMain = response.data[2] || [];

      if (invoice.length > 0) setInvoiceBalanceValue(invoice[0].Balance);
      setLineMainItems(lineMain);
      setLineItemsOverAll(lineItems);

      let updatedAmounts = {
        ...LineItemsAmounts,
        Credit: 0,
        TaxFreeCredit: 0,
        Debit: 0,
        Refund: 0,
        Cancellation: 0,
        OverallCancellation: 0,
        OverAllCredit: 0,
        OverAllTaxFreeCredit: 0,
        OverAllDebit: 0,
        OverAllRefund: 0,
        OverAllTotal: 0,
        OverAllPaid: 0,
        OverAllOtherDiscount: 0,
        PendingLineItemCount: 0,
      };

      if (invoice.length > 0) {
        updatedAmounts.Balance = invoice[0].Balance;
      }

      let tempLineItems: any[] = [];

      let anyBankDeposit = 0;
      let thirdPartyTotalPaid = 0;

      let paidViaThirdParty = 0;
      let paidViaBank = 0;
      let overAllPaidViaBank = 0;

      let discountWriteOff = 0;
      let overAllDiscountWriteOff = 0;

      lineItems.forEach((item: any) => {
        // Bank deposit
        if (
          item.SourceType === 2 &&
          item.ObjectType === 3 &&
          item.TransactionType === 2
        ) {
          anyBankDeposit = 1;
        }

        // Third party total
        if (
          item.SourceType === 1 &&
          item.ObjectType === 2 &&
          item.TransactionType === 2
        ) {
          thirdPartyTotalPaid += item.Amount;
        }

        // Pending
        if (item.Status === 1) {
          updatedAmounts.PendingLineItemCount += 1;
        }

        /* ---------------- CREDIT / DEBIT ---------------- */
        if (item.SourceType === 2 || item.SourceType === 3) {
          if (item.TransactionType === 1) {
            if (item.ObjectType === 7)
              updatedAmounts.OverAllTaxFreeCredit += item.Amount;
            else updatedAmounts.OverAllCredit += item.Amount;
          } else {
            updatedAmounts.OverAllDebit += item.Amount;
          }

          const belongsToQuote =
            item.OtherObjectID === QuoteId ||
            AdditionalServices.some(
              (s: any) => s.MNVQuoteID === item.OtherObjectID,
            );

          if (belongsToQuote) {
            tempLineItems.push(item);

            if (item.TransactionType === 1) {
              if (item.ObjectType === 7)
                updatedAmounts.TaxFreeCredit += item.Amount;
              else updatedAmounts.Credit += item.Amount;
            } else {
              updatedAmounts.Debit += item.Amount;
            }
          }
        }

        /* ---------------- PAID VIA THIRD PARTY ---------------- */
        if (
          item.TransactionType === 2 &&
          item.ObjectType === 2 &&
          item.SourceType !== 4
        ) {
          paidViaThirdParty += item.Amount;
        }

        /* ---------------- PAID VIA BANK / CASH ---------------- */
        if (
          item.TransactionType === 2 &&
          item.ObjectType === 3 &&
          item.SourceType !== 4
        ) {
          overAllPaidViaBank += item.Amount;

          const belongsToQuote =
            item.OtherObjectID === QuoteId ||
            AdditionalServices.some(
              (s: any) => s.MNVQuoteID === item.OtherObjectID,
            );

          if (belongsToQuote) {
            paidViaBank += item.Amount;
          }
        }

        /* ---------------- OTHER DISCOUNT ---------------- */
        if (
          item.TransactionType === 2 &&
          item.ObjectType === 4 &&
          item.SourceType !== 4
        ) {
          overAllDiscountWriteOff += item.Amount;

          const belongsToQuote =
            item.OtherObjectID === QuoteId ||
            AdditionalServices.some(
              (s: any) => s.MNVQuoteID === item.OtherObjectID,
            );

          if (belongsToQuote) {
            discountWriteOff += item.Amount;
          }
        }

        /* ---------------- CANCELLATION ---------------- */
        if (
          item.TransactionType === 2 &&
          item.ObjectType === 5 &&
          item.SourceType !== 4
        ) {
          updatedAmounts.OverallCancellation += item.Amount;

          const belongsToQuote =
            item.OtherObjectID === QuoteId ||
            AdditionalServices.some(
              (s: any) => s.MNVQuoteID === item.OtherObjectID,
            );

          if (belongsToQuote) {
            updatedAmounts.Cancellation += item.Amount;
          }
        }

        /* ---------------- REFUND ---------------- */
        if (item.TransactionType === 3) {
          updatedAmounts.Refund += item.Amount;
          updatedAmounts.OverAllRefund += item.Amount;
        }
      });

      /* ---------------- TOTALS ---------------- */
      updatedAmounts.Total =
        updatedAmounts.Credit + updatedAmounts.TaxFreeCredit;

      updatedAmounts.OverAllTotal =
        updatedAmounts.OverAllCredit + updatedAmounts.OverAllTaxFreeCredit;

      updatedAmounts.Paid = paidViaBank + paidViaThirdParty;
      updatedAmounts.OverAllPaid = overAllPaidViaBank + paidViaThirdParty;

      updatedAmounts.OtherDiscount = discountWriteOff;
      updatedAmounts.OverAllOtherDiscount = overAllDiscountWriteOff;

      setLineItems(tempLineItems);
      setLineItemsAmounts(updatedAmounts);
      setAnyBankDeposit(anyBankDeposit);
      setThirdPartyTotalPaid(thirdPartyTotalPaid);

      /* ---------------- DISCOUNT CHECK ---------------- */
      let alreadyAppliedDiscount = false;
      let showDiscount = false;

      lineMain.forEach((item: any) => {
        if (item.OtherObjectID === QuoteId && item.DiscountAmount > 0) {
          alreadyAppliedDiscount = true;
          showDiscount = true;
          setDiscountType(item.DiscountValueType);
          setDiscount(item.DiscountValue);
        }
      });

      setAlreadyAppliedDiscount(alreadyAppliedDiscount);
      setShowDiscount(showDiscount);

      setIsCalculatePayment(1);
      if (UpdateQuoteData) {
        Update(0);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const [QuoteRelatedPaymentAccount, setQuoteRelatedPaymentAccount] =
    useState<any>([]);

  const GetQuoteRelatedPaymentAccountDetails = (QuoteID: number) => {
    const data: any = { QuoteID };

    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/GetQuoteRelatedPaymentAccountDetails",
        data,
      )
      .then((response) => {
        setQuoteRelatedPaymentAccount(response.data[0]);
      })
      .catch((error) => console.error(error));
  };

  const GetSystemConfigurations = (MNVQuoteID: number) => {
    const data: any = { MNVQuoteID };

    axiosAuth
      .post(
        AppContext.APIURL + "api/Configurations/GetDataForCalculations",
        data,
      )
      .then((response) => {
        const result = response.data;
        const configList = result[0];

        setConfigurations(configList);

        const vatValue = configList.filter(
          (x: any) => x.SystemConfigurationID == 11,
        )[0]?.Value;
        const depositValue = configList.filter(
          (x: any) => x.SystemConfigurationID == 33,
        )[0]?.Value;
        const baseValue = configList.filter(
          (x: any) => x.SystemConfigurationID == 13,
        )[0]?.Value;
        const vanMin = configList.filter(
          (x: any) => x.SystemConfigurationID == 4,
        )[0]?.Value;
        const movMin = configList.filter(
          (x: any) => x.SystemConfigurationID == 5,
        )[0]?.Value;

        setVat(vatValue);
        setDepositOnlyPercentage(depositValue);
        setVatCopy(vatValue);
        setBase(baseValue);
        setVanMinimumBookingMinutes(vanMin);
        setMoversMinimumBookingMinutes(movMin);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const [resources, setResources] = useState([]);
  const [driverID, setDriverID] = useState(0);
  const [helper1, setHelper1] = useState(0);
  const [helper2, setHelper2] = useState(0);
  const [selectedMovers, setSelectedMovers] = useState<any>({});

  const GetDriversOfThisJob = async (id: any) => {
    const data = { QuoteID: id };

    try {
      const res = await axiosAuth.post(
        AppContext.APIURL + "api/MNVQuoteAdmin/MNVGetDriverOfThisJob",
        data,
      );
      const fetchedResources = res.data[0]; // Assuming same structure as Angular

      setResources(fetchedResources);

      const updatedSelectedMovers: any = { ...selectedMovers };
      const updatedAdditionalServices: any = [...AdditionalServices];

      fetchedResources.forEach((resource: any) => {
        if (resource.MNVQuoteID == id) {
          // Main job
          if (resource.RoleID == 1) {
            setDriverID(resource.MNVMoverID);
            updatedSelectedMovers.DriverName = resource.Name;
            updatedSelectedMovers.DriverEmail = resource.EmailAddress;
            updatedSelectedMovers.DriverMobile = resource.MobileNo;
          } else if (resource.RoleID == 2) {
            setHelper1(resource.MNVMoverID);
            updatedSelectedMovers.Helper1Name = resource.Name;
            updatedSelectedMovers.Helper1Email = resource.EmailAddress;
          } else if (resource.RoleID == 3) {
            setHelper2(resource.MNVMoverID);
            updatedSelectedMovers.Helper2Name = resource.Name;
            updatedSelectedMovers.Helper2Email = resource.EmailAddress;
          }
        } else {
          // Additional services
          updatedAdditionalServices.forEach((service: any) => {
            if (resource.MNVQuoteID == service.MNVQuoteID) {
              if (resource.RoleID == 1) {
                service.DriverID = resource.MNVMoverID;
                service.DriverName = resource.Name;
                service.DriverEmail = resource.EmailAddress;
                service.DriverMobile = resource.MobileNo;
              } else if (resource.RoleID == 2) {
                service.Helper1ID = resource.MNVMoverID;
                service.Helper1Name = resource.Name;
                service.Helper1Email = resource.EmailAddress;
              } else if (resource.RoleID == 3) {
                service.Helper2ID = resource.MNVMoverID;
                service.Helper2Name = resource.Name;
                service.Helper2Email = resource.EmailAddress;
              }
            }
          });
        }
      });

      setSelectedMovers(updatedSelectedMovers);
      if (fetchedResources.length == 0) setSelectedMovers({});
      if (updatedAdditionalServices.length > 0) {
        // AdditionalServices=updatedAdditionalServices;
        // setAdditionalServices(updatedAdditionalServices);
      }
    } catch (error) {
      console.error(error);
    }
  };

  function CheckTrustPilotEmailData(MNVJobID: any) {
    const data = { MNVJobID: MNVJobID };

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/CheckTrustPilotEmailData",
        data,
      )
      .then((response) => {
        const l_arrResponse = response.data[0][0];
        if (l_arrResponse.Status == 1) {
          setTrustPilotEmail(true); // React state
        } else {
          setTrustPilotEmail(false);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  //#endregion Job/Quote Data

  //#region Discount
  const VerifyCode = (paramCouponCode = "") => {
    if (paramCouponCode !== "") {
      const data: any = {
        Code: paramCouponCode,
        Date: new Date(),
        MNVQuoteID: QuoteId,
      };

      axiosAuth
        .post(
          AppContext.APIURL + "api/MNVQuoteAdmin/GetDiscountValidation",
          data,
        )
        .then((res) => {
          const ResponsData: any = res.data;
          const discountObjFromDB = ResponsData[1];
          setDiscountObj(discountObjFromDB);

          if (ResponsData[0][0].Status == 0) {
            showErrorMessage(ResponsData[0][0].Message);
          } else {
            setShowDiscount(true);
            setDiscountType(discountObjFromDB[0].PTDiscountTypeID);
            setDiscount(discountObjFromDB[0].DiscountValue);
            calculations.PTDiscountID = discountObjFromDB[0].PTDiscountID;
            setcalculations((prev: any) => ({
              ...prev,
              PTDiscountID: discountObjFromDB[0].PTDiscountID,
            }));
            setCoupenCode("");

            //CalculatePayments();
          }
        });
    }
  };

  const CancelAlreadyAppliedDiscount = () => {
    const data: any = {
      MNVQuoteID: QuoteId,
    };

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/CancelAlreadyAppliedDiscount",
        data,
      )
      .then((res) => {
        const ResponsData: any = res.data;
        setDiscountObj(ResponsData[1]);

        setShowDiscount(false);
        setDiscountType(1);
        setDiscount(0);
        calculations.PTDiscountID = 0;
        setcalculations((prev: any) => ({
          ...prev,
          PTDiscountID: 0,
        }));

        setCoupenCode("");

        //CalculatePayments();
        // Update(1, QuoteId, 0);
      });
  };
  //#endregion Discount

  //#region Quote Calculations
  const [DTPMilesAfterAllowance, setDTPMilesAfterAllowance] =
    useState<number>(0);
  const [DTDMilesAfterAllowance, setDTDMilesAfterAllowance] =
    useState<number>(0);
  const [DTPTimeAfterAllowance, setDTPTimeAfterAllowance] = useState<number>(0);
  const [DTDTimeAfterAllowance, setDTDTimeAfterAllowance] = useState<number>(0);
  const [duration, setduration] = useState<any>(0);

  const [MaxMoversWithOneVan, setMaxMoversWithOneVan] = useState(0);
  const [MaxMoversWithOneVanText, setMaxMoversWithOneVanText] = useState("");
  let [QuoteCalculations, setQuoteCalculations] = useState<any>({});

  // const QuoteCalculationsRef = useRef<any | null>(null);
  // QuoteCalculations = QuoteCalculations;

  const [bankHolidays, setBankHolidays] = useState<any[]>([]);
  const [minimumCharges, setMinimumCharges] = useState<any[]>([]);

  const MNVMinimumChargeAndBankHolidayData = async () => {
    try {
      const response = await axiosAuth.post(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/MNVMinimumChargeAndBankHolidayData",
        {},
      );

      const minCharges = response.data[0];
      const holidays = response.data[1];

      setMinimumCharges(minCharges);
      setBankHolidays(holidays);

      if (MNVQuote.MNVVanTypeID != null) {
        getMinimumHoursBasedOnMoverVanAndTier(
          MNVQuote.MNVVanTypeID,
          MNVQuote.MNVMoverTypeID,
          info.Tier,
          MNVQuote.RequestedDate,
          0,
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const GetTotalAmountValue = async (
    p_boolCalledFromDistanceCalculation = 0,
  ) => {
    let data: any = {
      Distance_DTP: distance.DTP,
      Distance_PTD: distance.PTD,
      Distance_DTD: distance.DTD,
      Time_DTPTimeSeconds: distance.DTPTimeSeconds,
      Time_PTDTimeSeconds: distance.PTDTimeSeconds,
      Time_DTDTimeSeconds: distance.DTDTimeSeconds,
      TravelType: travelType,
      LoadingUnLoadingTimeInMinutes:
        loadingTimeInSeconds + unloadingTimeInSeconds,
      TotalStairs: TotalStairs,
      MNVVanTypeID: info.MNVVanTypeID,
      MNVMoverTypeID: info.MNVMoverTypeID,
      TotalHours: thisRequiredTime.requiredTime,
      SlotID: info.SlotID,
    };

    let thisShowTotalDistance = Number(data.Distance_PTD).toFixed(2);

    setShowTotalDistance(thisShowTotalDistance);

    setPTDDurationDisplay(
      GetDurationTextForSeconds(Number(data.Time_PTDTimeSeconds)),
    );

    let date = new Date(info.RequestedDate);
    let time = info.RequestedTime;

    data.time = time;
    data.day = date;
    data.IsCongestion = false;

    let postcodes =
      info.FromPostalCode?.replace(" ", "") +
      "," +
      info.ToPostalCode?.replace(" ", "");

    info.AdditionalStop?.forEach((x: any) => {
      postcodes += "," + x.PostCode?.replace(" ", "");
    });

    data.PostCodes = postcodes;
    data.MNVQuoteID = MNVQuote.MNVQuoteID;
    data.SelectedHours = selectedTime;
    data.LatLngList = MNVQuote.LatLngList;
    data.AdditionalTimeInMinutes = 0;

    if (!isNaN(info.Name) && info.Name !== "" && info.Name !== "N/A") {
      data.AdditionalTimeInMinutes = info.Name;
    }

    // Loader
    if (IsFirstTime) {
      setIsAnimation(true);
    }

    // console.log("GetTotalAmountValue data: " + JSON.stringify(data));

    try {
      let response: any = await axiosAuth.post(
        AppContext.APIURL + "api/MNVQuoteAdmin/GetTotalAmountValue",
        data,
      );

      if (response.status == 200) {
        response = response.data;
        //console.log("Loaded: " + JSON.stringify(response));

        // Hide Loader
        if (IsFirstTime) {
          setIsAnimation(false);
        }

        setIsFirstTime(false);
        QuoteCalculations = response;
        //setQuoteCalculations(response);

        // React-safe selectedTime logic
        setSelectedTime((prev) => {
          if (prev > response.TotalHours && travelType == "Local") return prev;
          if (!prev || travelType !== "Local") return response.TotalHours;
          return prev;
        });

        setInfo((prevState: any) => ({
          ...prevState,
          TotalStairs: TotalStairs,
          RequiredTime: selectedTime,
          Duration: GetDurationText(),
        }));

        QuoteCalculations = CalculateStartPrice(response);
        AssignDataForDB(QuoteCalculations);

        if (response.Amount !== undefined) {
          //GetAdditionalCharges();
        }

        if (MNVQuote.MNVQuoteStatusID == 4) {
          CalculateAdditionalTimeAmount(1);

          AdditionalServices.forEach((x: any, i: number) => {
            CalculateAdditionalTimeAmountForAdditionalVan(i, 1);
          });
        }

        // if (IsCalledAfterVanDeletion) {
        //   setIsCalledAfterVanDeletion(false);
        //   Update(1, QuoteId, 0);
        // }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const CalculateStartPrice = (QuoteCalculationsParam: any) => {
    let updatedItems = [...items];
    let qc = { ...QuoteCalculationsParam };
    let l_decTotalHours = qc.TotalHours;
    // console.log("QuoteCalculationsParam", QuoteCalculationsParam);
    const IsBankHoliday = IsThisDateInBankHoliday(new Date(info.RequestedDate));

    qc.TotalHours = Number(qc.TotalHours);

    if (MNVQuote.MNVMoverTypeID == 1)
      qc.TotalAmountWithOutBaseAmount = Number(qc.Amount - qc.BaseDriverAmount);
    else if (MNVQuote.MNVMoverTypeID == 2)
      qc.TotalAmountWithOutBaseAmount = Number(
        qc.Amount - (qc.BaseDriverAmount + qc.BaseHelperAmount),
      );
    else if (MNVQuote.MNVMoverTypeID >= 3)
      qc.TotalAmountWithOutBaseAmount = Number(
        qc.Amount -
          (qc.BaseDriverAmount +
            qc.BaseHelperAmount * (MNVQuote.MNVMoverTypeID - 1)),
      );

    for (let i = 0; i < updatedItems.length; i++) {
      let l_decMinPrice = Number.MAX_SAFE_INTEGER;

      for (let j = 0; j < updatedItems[i].Slots.length; j++) {
        let slot = { ...updatedItems[i].Slots[j] };

        let l_decSlotPrice = 0;

        let l_intMNVTimeSlotID = Number(slot["SlotId"]);
        let l_decDriverRate = Number(slot["DriverRate"]);
        let l_decOtherVanDriverRate = Number(slot["OtherVanDriverRate"]);
        let l_decHelperRate = Number(slot["HelperRate"]);

        let l_intTierID = Number(slot["TierID"]);
        let l_boolManualUpdate = false;

        if (
          ((j == 0 && qc.Tier < l_intTierID) ||
            (j == updatedItems[i].Slots.length - 1 && qc.Tier > l_intTierID)) &&
          (info.SlotID == 0 || info.SlotID == 10000) &&
          new Date(info.RequestedDate).getDay() ==
            new Date(updatedItems[i].Date).getDay()
        ) {
          l_boolManualUpdate = true;
          l_decDriverRate = qc.DriverRate;
          l_decOtherVanDriverRate = qc.OtherVanDriverRate;
          l_decHelperRate = qc.HelperRate;
        }

        let l_decBooking = Number(slot["Booking"]);
        let l_decVans = Number(slot["Vans"]);

        let l_decExtraHours = Number(slot["SlotCharge"]) / 60;

        let l_decDriverAmount =
          (qc.TotalHours + l_decExtraHours) * l_decDriverRate;
        let l_decOtherVanDriverAmount =
          (qc.TotalHours + l_decExtraHours) * l_decOtherVanDriverRate;
        let l_decHelperAmount =
          (qc.TotalHours + l_decExtraHours) * l_decHelperRate;

        if (MNVQuote.MNVMoverTypeID == 1)
          l_decSlotPrice = qc.TotalAmountWithOutBaseAmount + l_decDriverAmount;
        else if (MNVQuote.MNVMoverTypeID == 2)
          l_decSlotPrice =
            qc.TotalAmountWithOutBaseAmount +
            l_decDriverAmount +
            l_decHelperAmount;
        else if (MNVQuote.MNVMoverTypeID >= 3)
          l_decSlotPrice =
            qc.TotalAmountWithOutBaseAmount +
            l_decDriverAmount +
            l_decHelperAmount * (MNVQuote.MNVMoverTypeID - 1);

        slot["CalculatedPrice"] = Number(l_decSlotPrice);

        const slotDate = new Date(updatedItems[i].Date);
        const reqDate = new Date(info.RequestedDate);

        if (
          info.SlotID == l_intMNVTimeSlotID &&
          reqDate.getDay() == slotDate.getDay()
        ) {
          const l_oIsBankHoliday = IsThisDateInBankHoliday(slotDate);

          if (!IsBankHoliday && !l_oIsBankHoliday) {
            qc.Amount = slot["CalculatedPrice"];
            l_decTotalHours = qc.TotalHours + l_decExtraHours;

            qc.IndividualDriverAmount =
              qc.IndividualDriverAmount -
              qc.BaseDriverAmount +
              l_decDriverAmount;

            qc.IndividualDriverAmountOtherVan =
              qc.IndividualDriverAmount -
              qc.BaseDriverAmount +
              l_decOtherVanDriverAmount;

            qc.IndividualHelper1Amount =
              qc.IndividualHelper1Amount -
              qc.BaseHelperAmount +
              l_decHelperAmount;

            qc.BaseDriverAmount = l_decDriverAmount;
            qc.BaseDriverAmountOtherVan = l_decOtherVanDriverAmount;
            qc.BaseHelperAmount = l_decHelperAmount;
          }
        } else if (
          (j == 0 || l_intTierID == qc.Tier || l_boolManualUpdate) &&
          (info.SlotID == 0 || info.SlotID == 10000) &&
          reqDate.getDay() == slotDate.getDay()
        ) {
          const l_oIsBankHoliday = IsThisDateInBankHoliday(slotDate);

          if (!IsBankHoliday && !l_oIsBankHoliday) {
            qc.Amount = slot["CalculatedPrice"];
            l_decTotalHours = qc.TotalHours + l_decExtraHours;

            qc.IndividualDriverAmount =
              qc.IndividualDriverAmount -
              qc.BaseDriverAmount +
              l_decDriverAmount;

            qc.IndividualDriverAmountOtherVan =
              qc.IndividualDriverAmount -
              qc.BaseDriverAmount +
              l_decOtherVanDriverAmount;

            qc.IndividualHelper1Amount =
              qc.IndividualHelper1Amount -
              qc.BaseHelperAmount +
              l_decHelperAmount;

            qc.BaseDriverAmount = l_decDriverAmount;
            qc.BaseDriverAmountOtherVan = l_decOtherVanDriverAmount;
            qc.BaseHelperAmount = l_decHelperAmount;
          }
        }

        if (j == 0) l_decMinPrice = l_decSlotPrice;

        if (l_decSlotPrice < l_decMinPrice && l_decBooking < l_decVans)
          l_decMinPrice = l_decSlotPrice;

        updatedItems[i].Slots[j] = slot;
      }

      updatedItems[i]["MinStartPrice"] = Number(l_decMinPrice);
    }

    qc.TotalHours = l_decTotalHours;
    qc.AmountBK = qc.Amount;

    setItems(updatedItems);

    //console.log('updatedItems: '+JSON.stringify(updatedItems));
    //console.log('qc: '+JSON.stringify(qc));

    QuoteCalculations = CalculateAdditionalServicesAmounts(qc);
    return QuoteCalculations;
  };

  const CalculateAdditionalServicesAmounts = (QuoteCalculationsParam: any) => {
    let updatedQuoteAmount = QuoteCalculationsParam.AmountBK;
    let maxMovers = MNVQuote.MNVMoverTypeID;

    const updatedServices = AdditionalServices.map((service) => {
      let initialAmount = 0;

      if (maxMovers < service.MNVMoverTypeID) {
        maxMovers = service.MNVMoverTypeID;
      }

      const isSameVan = service.MNVVanTypeID == MNVQuote.MNVVanTypeID;

      if (isSameVan) {
        if (service.MNVMoverTypeID == 1) {
          initialAmount =
            QuoteCalculationsParam.QuoteBaseDriverAmount +
            QuoteCalculationsParam.BaseDriverAmount;
        } else if (service.MNVMoverTypeID == 2) {
          initialAmount =
            QuoteCalculationsParam.QuoteBaseDriverAmount +
            QuoteCalculationsParam.BaseDriverAmount +
            QuoteCalculationsParam.QuoteBaseHelperAmount +
            QuoteCalculationsParam.BaseHelperAmount;
        } else if (service.MNVMoverTypeID >= 3) {
          initialAmount =
            QuoteCalculationsParam.QuoteBaseDriverAmount +
            QuoteCalculationsParam.BaseDriverAmount +
            QuoteCalculationsParam.QuoteBaseHelperAmount *
              (service.MNVMoverTypeID - 1) +
            QuoteCalculationsParam.BaseHelperAmount *
              (service.MNVMoverTypeID - 1);
        }
      } else {
        if (service.MNVMoverTypeID == 1) {
          initialAmount =
            QuoteCalculationsParam.QuoteBaseDriverAmount +
            QuoteCalculationsParam.BaseDriverAmountOtherVan;
        } else if (service.MNVMoverTypeID == 2) {
          initialAmount =
            QuoteCalculationsParam.QuoteBaseDriverAmount +
            QuoteCalculationsParam.BaseDriverAmountOtherVan +
            QuoteCalculationsParam.QuoteBaseHelperAmount +
            QuoteCalculationsParam.BaseHelperAmount;
        } else if (service.MNVMoverTypeID >= 3) {
          initialAmount =
            QuoteCalculationsParam.QuoteBaseDriverAmount +
            QuoteCalculationsParam.BaseDriverAmountOtherVan +
            QuoteCalculationsParam.QuoteBaseHelperAmount *
              (service.MNVMoverTypeID - 1) +
            QuoteCalculationsParam.BaseHelperAmount *
              (service.MNVMoverTypeID - 1);
        }
      }

      const vat = initialAmount * 0.2;
      const payable = initialAmount + vat;

      updatedQuoteAmount += initialAmount;

      return {
        ...service,
        InitialAmount: initialAmount,
        Vat: vat,
        PayableAmount: payable,
      };
    });

    // Update state
    AdditionalServices = [...updatedServices];
    setAdditionalServices([...updatedServices]);

    QuoteCalculationsParam.Amount = updatedQuoteAmount;
    QuoteCalculations = QuoteCalculationsParam;
    setQuoteCalculations({ ...QuoteCalculationsParam });

    // Max movers text
    let moverText = (maxMovers - 1).toString();
    if (maxMovers > 3) {
      moverText = "2";
      for (let i = 3; i < maxMovers; i++) {
        moverText += "+" + i.toString();
      }
    }

    setMaxMoversWithOneVan(maxMovers);
    setMaxMoversWithOneVanText(moverText);

    return QuoteCalculationsParam;
  };

  const AssignDataForDB = (QuoteCalculationsParam: any) => {
    if (QuoteCalculationsParam.Amount !== undefined) {
      setInfo((prev: any) => ({
        ...prev,
        LoadingUnLoadingTimeInMinutes:
          QuoteCalculationsParam.LoadingUnLoadingTimeInMinutes,
        Tier: QuoteCalculationsParam.Tier,
      }));

      let calculationsTemp = { ...calculations };
      calculationsTemp.CongestionCharge = QuoteCalculationsParam.CongestionFee;
      calculationsTemp.LongDistanceFuelCostPerMile =
        QuoteCalculationsParam.FuelCost;
      calculationsTemp.LongDistanceQuote = QuoteCalculationsParam.Amount;
      calculationsTemp.LocalDistanceQuote = QuoteCalculationsParam.Amount;
      calculationsTemp.Tier = QuoteCalculationsParam.Tier;
      calculationsTemp.DTPMilesAfterAllowance = distance.DTP;
      calculationsTemp.PTDMilesAfterAllowance = distance.PTD;
      calculationsTemp.DTDMilesAfterAllowance = distance.DTD;
      calculationsTemp.DTPFeeManAndMover =
        QuoteCalculationsParam.DriverTimeInSecondsDTP;
      calculationsTemp.PTDFeeManAndMover =
        QuoteCalculationsParam.DriverTimeInSecondsPTD;
      calculationsTemp.DTDepoFeeManAndMover =
        QuoteCalculationsParam.DriverTimeInSecondsDTD;
      calculationsTemp.VMPerMileRateDTP = QuoteCalculationsParam.Distance_DTP;
      calculationsTemp.VMPerMileRatePTD = QuoteCalculationsParam.Distance_PTD;
      calculationsTemp.VMPerMileRateDTD = QuoteCalculationsParam.Distance_DTD;
      calculationsTemp.RoundingTimeInSeconds =
        QuoteCalculationsParam.RoundingTimeInSeconds;

      // setcalculations((prev: any) => ({
      //   ...prev,
      //   CongestionCharge: QuoteCalculationsParam.CongestionFee,
      //   LongDistanceFuelCostPerMile: QuoteCalculationsParam.FuelCost,
      //   LongDistanceQuote: QuoteCalculationsParam.Amount,
      //   LocalDistanceQuote: QuoteCalculationsParam.Amount,
      //   Tier: QuoteCalculationsParam.Tier,
      //   DTPMilesAfterAllowance: distance.DTP,
      //   PTDMilesAfterAllowance: distance.PTD,
      //   DTDMilesAfterAllowance: distance.DTD,
      //   DTPFeeManAndMover: QuoteCalculationsParam.DriverTimeInSecondsDTP,
      //   PTDFeeManAndMover: QuoteCalculationsParam.DriverTimeInSecondsPTD,
      //   DTDepoFeeManAndMover: QuoteCalculationsParam.DriverTimeInSecondsDTD,
      //   VMPerMileRateDTP: QuoteCalculationsParam.Distance_DTP,
      //   VMPerMileRatePTD: QuoteCalculationsParam.Distance_PTD,
      //   VMPerMileRateDTD: QuoteCalculationsParam.Distance_DTD,
      //   RoundingTimeInSeconds: QuoteCalculationsParam.RoundingTimeInSeconds,
      // }));

      // Call any calculation functions as needed
      CalculatePayments(QuoteCalculationsParam, calculationsTemp);
    }
  };

  const CalculatePayments = (
    QuoteCalculationsParam: any,
    calculationsParam: any,
  ) => {
    if (!QuoteCalculationsParam || QuoteCalculationsParam.Amount == undefined) {
      QuoteCalculationsParam.Amount = 0;
    }

    let amount = Number((QuoteCalculationsParam.Amount + 0.00001).toFixed(2));

    if (
      MNVQuote.MNVQuoteStatusID == 5 &&
      JobRelatedData.Amounts.EnableNotification == 1
    ) {
      amount = LineItemsAmounts.OverAllPaid / (1 + Vat / 100);
    }

    setQuoteAmount(amount);

    let discountValue = 0;

    if (DiscountType == 1) {
      discountValue = Number(((amount * Discount) / 100 + 0.00001).toFixed(2));
    } else {
      discountValue = Discount;
    }

    setDicountValueVoucher(discountValue);
    MNVQuote.Discount = discountValue;

    let AmountAfterDiscount =
      amount - discountValue - LineItemsAmounts.OtherDiscount;

    let QuoteAmountWithLineItems = Number(
      (AmountAfterDiscount + LineItemsAmounts.Total).toFixed(2),
    );

    let VATAmount = Number(
      (
        ((QuoteAmountWithLineItems - LineItemsAmounts.TaxFreeCredit) * Vat) /
        100
      ).toFixed(2),
    );

    let AmountWithVAT = QuoteAmountWithLineItems + VATAmount;

    calculationsParam.LocalQuoteSubTotal = AmountAfterDiscount;
    calculationsParam.LocalQuoteVat = VATAmount;
    calculationsParam.LocalQuoteTotal = AmountWithVAT;

    calculationsParam.InitialAmount = amount;
    calculationsParam.LineItemsTotal = LineItemsAmounts.Total;
    calculationsParam.Discount = discountValue;
    calculationsParam.AmountAfterDiscount = QuoteAmountWithLineItems;
    calculationsParam.VAT = VATAmount;
    calculationsParam.AmountAfterVAT = AmountWithVAT;

    if (
      calculationsParam.Balance == -0.01 ||
      calculationsParam.Balance == 0.01
    ) {
      calculationsParam.Balance = 0;
    }

    // ----------- OVER ALL CALCULATIONS -------------
    let QuoteAmountOverAll = amount;
    let VoucherDiscountAmountOverAll = discountValue;

    for (let i = 0; i < LineMainItems.length; i++) {
      if (LineMainItems[i].OtherObjectID !== QuoteId) {
        VoucherDiscountAmountOverAll += LineMainItems[i].DiscountAmount;
        QuoteAmountOverAll += LineMainItems[i].Amount;
      }
    }

    let OverAllAmountAfterDiscount =
      QuoteAmountOverAll -
      VoucherDiscountAmountOverAll -
      LineItemsAmounts.OverAllOtherDiscount;

    let OverAllQuoteAmountWithLineItem = Number(
      (OverAllAmountAfterDiscount + LineItemsAmounts.OverAllTotal).toFixed(2),
    );

    calculationsParam.OverAllAmountAfterDiscount =
      OverAllQuoteAmountWithLineItem;

    let OverAllVATAmount = Number(
      (
        ((OverAllQuoteAmountWithLineItem -
          LineItemsAmounts.OverAllTaxFreeCredit) *
          Vat) /
        100
      ).toFixed(2),
    );

    let OverAllAmountWithVAT =
      OverAllQuoteAmountWithLineItem + OverAllVATAmount;

    calculationsParam.OverAllVAT = OverAllVATAmount;
    calculationsParam.OverAllAmountAfterVAT = OverAllAmountWithVAT;

    calculationsParam.Balance = Number(
      (
        OverAllAmountWithVAT +
        LineItemsAmounts.OverAllRefund -
        (LineItemsAmounts.OverAllPaid + LineItemsAmounts.OverallCancellation)
      ).toFixed(2),
    );

    LineItemsAmounts.Balance = calculationsParam.Balance;

    setcalculations(calculationsParam);

    CalculatePaymentsForEachMover(QuoteCalculationsParam);
  };

  useEffect(() => {
    CalculatePaymentsForEachMover(QuoteCalculations);
  }, [QuoteCalculations.IndividualDriverAmount]);

  const CalculatePaymentsForEachMover = (QuoteCalculationsParam: any) => {
    if (
      QuoteCalculationsParam.IndividualDriverAmount &&
      QuoteCalculationsParam.IndividualDriverAmount > 0
    ) {
      let moverData: any = { ...MoversCalculation };
      for (let i = 0; i < 3; i++) {
        let amount = 0;
        if (i == 0) {
          amount = Number(QuoteCalculationsParam.IndividualDriverAmount);
        } else if (i == 1) {
          amount = Number(
            QuoteCalculationsParam.IndividualDriverAmount +
              QuoteCalculationsParam.IndividualHelper1Amount,
          );
        } else if (i == 2) {
          amount = Number(
            QuoteCalculationsParam.IndividualDriverAmount +
              QuoteCalculationsParam.IndividualHelper1Amount * 2,
          );
        }
        amount = Number((amount + 0.00001).toFixed(2));
        let moverDiscount =
          DiscountType == 1 ? (amount * Discount) / 100 : Discount;
        const moverNo = i + 1;
        moverData[`Mover${moverNo}Amount`] = amount;
        moverData[`Mover${moverNo}Discount`] = moverDiscount;
        let amountAfterDisc =
          amount - moverDiscount - LineItemsAmounts.OtherDiscount;
        moverData[`Mover${moverNo}AmountAfterDiscount`] = amountAfterDisc;
        let QuoteAmountWithLineItem = Number(
          (amountAfterDisc + LineItemsAmounts.Total).toFixed(2),
        );
        moverData[`Mover${moverNo}VATAmount`] = Number(
          ((QuoteAmountWithLineItem * Vat) / 100).toFixed(2),
        );
        moverData[`Mover${moverNo}AmountWithVAT`] =
          QuoteAmountWithLineItem + moverData[`Mover${moverNo}VATAmount`];
      }

      // console.log('CalculatePaymentsForEachMover: '+JSON.stringify(moverData));
      setMoversCalculation(moverData);
      CalculateAdditionalCharges(Rates, moverData);
    }
  };

  //MM TODO:: check why need to call it every time
  const GetAdditionalCharges = () => {
    const data: any = { MNVQuoteID: QuoteId };

    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVRates/MNVRatesGetDataSetForAdditionalCharges",
        data,
      )
      .then((response) => {
        const result = response.data.Data;
        setRates(result[0]);
      })
      .catch((err) => console.error(err));
  };

  const CalculateAdditionalCharges = (ratesList: any[], moverData: any) => {
    let addRate = 0;
    let addRateAllVans = 0;

    //let moverData: any = { ...MoversCalculation };
    if (ratesList && ratesList.length > 0) {
      const Tier = "Tier" + info.Tier + "Add";

      const VanTierRate = ratesList.filter(
        (z) => z.ObjectTypeID == 1 && z.ObjectID == info.MNVVanTypeID,
      )[0];

      const DriverTierRate = ratesList.filter(
        (z) => z.ObjectTypeID == 2 && z.ObjectID == 0,
      )[0];

      let VanAdditionalRate = 0;
      if (VanTierRate != undefined) VanAdditionalRate = VanTierRate[Tier];
      let DriverAdditionalRate = 0;
      if (DriverAdditionalRate != undefined)
        DriverAdditionalRate = DriverTierRate[Tier];

      // --- MAIN MOVERS CALCULATION ---
      if (info.MNVMoverTypeID == 1) {
        addRate = VanAdditionalRate;
      }
      if (info.MNVMoverTypeID == 2) {
        addRate = VanAdditionalRate + DriverAdditionalRate;
      }
      if (info.MNVMoverTypeID >= 3) {
        addRate =
          VanAdditionalRate +
          DriverAdditionalRate +
          DriverAdditionalRate +
          (info.MNVMoverTypeID - 3) * DriverAdditionalRate;
      }

      addRateAllVans = addRate;

      moverData.Mover1AdditionalRateAndVAT = VanAdditionalRate;
      moverData.Mover2AdditionalRateAndVAT =
        VanAdditionalRate + DriverAdditionalRate;
      moverData.Mover3AdditionalRateAndVAT =
        VanAdditionalRate + DriverAdditionalRate + DriverAdditionalRate;

      if (info.MNVMoverTypeID > 3) {
        moverData.Mover3AdditionalRateAndVAT =
          VanAdditionalRate +
          DriverAdditionalRate +
          DriverAdditionalRate +
          (info.MNVMoverTypeID - 3) * DriverAdditionalRate;
      }

      let AdditionalServicesBK = [...AdditionalServices];

      // ---- LOOP ADDITIONAL SERVICES ----
      for (let i = 0; i < AdditionalServicesBK.length; i++) {
        //const Tier = "Tier" + AdditionalServicesBK[i].TierID + "Add";
        const Tier = "Tier" + info.Tier + "Add";

        const VanTierRate2 = ratesList.filter(
          (z) =>
            z.ObjectTypeID == 1 &&
            z.ObjectID == AdditionalServicesBK[i].MNVVanTypeID,
        )[0];

        const DriverTierRate2 = ratesList.filter(
          (z) => z.ObjectTypeID == 2 && z.ObjectID == 0,
        )[0];

        const VanAdditionalRate2 = VanTierRate2[Tier];
        const DriverAdditionalRate2 = DriverTierRate2[Tier];

        if (AdditionalServicesBK[i].MNVMoverTypeID == 1) {
          AdditionalServicesBK[i].AdditionalRateAndVAT = VanAdditionalRate2;
          addRateAllVans += AdditionalServicesBK[i].AdditionalRateAndVAT;
        }
        if (AdditionalServicesBK[i].MNVMoverTypeID == 2) {
          AdditionalServicesBK[i].AdditionalRateAndVAT =
            VanAdditionalRate2 + DriverAdditionalRate2;
          addRateAllVans += AdditionalServicesBK[i].AdditionalRateAndVAT;
        }
        if (AdditionalServicesBK[i].MNVMoverTypeID >= 3) {
          AdditionalServicesBK[i].AdditionalRateAndVAT =
            VanAdditionalRate2 +
            DriverAdditionalRate2 +
            DriverAdditionalRate2 +
            (AdditionalServicesBK[i].MNVMoverTypeID - 3) *
              DriverAdditionalRate2;

          addRateAllVans += AdditionalServicesBK[i].AdditionalRateAndVAT;
        }
      }

      if (AdditionalServicesBK.length > 0) {
        AdditionalServices = AdditionalServicesBK;
        setAdditionalServices([...AdditionalServicesBK]);
      }
    }

    //SET STATES

    // console.log('CalculateAdditionalCharges: '+JSON.stringify(moverData));
    setMoversCalculation({
      ...moverData,
      Mover1AdditionalRateAndVAT: moverData.Mover1AdditionalRateAndVAT,
      Mover2AdditionalRateAndVAT: moverData.Mover2AdditionalRateAndVAT,
      Mover3AdditionalRateAndVAT: moverData.Mover3AdditionalRateAndVAT,
    });

    setAdditionalRateAndVAT(addRate);
    setAdditionalRateAndVATAllVans(addRateAllVans);
  };

  const CalculateAdditionalTimeAmount = (p_boolNeedToChange = 0) => {
    let updatedQuote = { ...MNVQuote };

    if (p_boolNeedToChange) {
      if (updatedQuote.AdditionalTimeInHours == undefined) {
        if (updatedQuote.Mover2ID / 60 >= 1)
          updatedQuote.AdditionalTimeInHours = Math.floor(
            updatedQuote.Mover2ID / 60,
          );
      }

      if (updatedQuote.AdditionalTimeInMinutes == undefined) {
        if (updatedQuote.Mover2ID % 60 >= 1)
          updatedQuote.AdditionalTimeInMinutes = Math.floor(
            updatedQuote.Mover2ID % 60,
          );
      }
    }

    let totalTimeInMinutes = 0;

    if (updatedQuote.AdditionalTimeInHours !== undefined)
      totalTimeInMinutes += updatedQuote.AdditionalTimeInHours * 60;

    if (updatedQuote.AdditionalTimeInMinutes !== undefined)
      totalTimeInMinutes += updatedQuote.AdditionalTimeInMinutes;

    updatedQuote.Mover2ID = parseInt(totalTimeInMinutes.toString());
    updatedQuote.AdditionalTimeCharges =
      (totalTimeInMinutes / 30) * AdditionalRateAndVAT;

    CalculateAdditionalStairsAmount(updatedQuote);
  };

  const CalculateAdditionalStairsAmount = (updatedQuote: any) => {
    updatedQuote.DriverAdditionalStairsCharges =
      updatedQuote.Mover3ID * QuoteCalculations.DriverPerStairRate;
    updatedQuote.HelperAdditionalStairsCharges =
      updatedQuote.Mover3ID * QuoteCalculations.HelperPerStairRate;

    if (updatedQuote.MNVMoverTypeID == 1) {
      updatedQuote.AdditionalStairsCharges =
        updatedQuote.DriverAdditionalStairsCharges;
    } else if (updatedQuote.MNVMoverTypeID == 2) {
      updatedQuote.AdditionalStairsCharges =
        updatedQuote.DriverAdditionalStairsCharges +
        updatedQuote.HelperAdditionalStairsCharges;
    } else if (updatedQuote.MNVMoverTypeID >= 3) {
      updatedQuote.AdditionalStairsCharges =
        updatedQuote.DriverAdditionalStairsCharges +
        updatedQuote.HelperAdditionalStairsCharges *
          (updatedQuote.MNVMoverTypeID - 1);
    }

    setMNVQuote(updatedQuote);
  };

  const CalculateAdditionalTimeAmountForAdditionalVan = (
    index: number,
    p_boolNeedToChange = 0,
  ) => {
    const updatedServices = [...AdditionalServices];
    const service = { ...updatedServices[index] };

    if (p_boolNeedToChange) {
      if (service.AdditionalTimeInHours == undefined) {
        if (service.Mover2ID / 60 >= 1)
          service.AdditionalTimeInHours = Math.floor(service.Mover2ID / 60);
      }

      if (service.AdditionalTimeInMinutes == undefined) {
        if (service.Mover2ID % 60 >= 1)
          service.AdditionalTimeInMinutes = Math.floor(service.Mover2ID % 60);
      }
    }

    let totalTimeInMinutes = 0;
    if (service.AdditionalTimeInHours !== undefined)
      totalTimeInMinutes += service.AdditionalTimeInHours * 60;

    if (service.AdditionalTimeInMinutes !== undefined)
      totalTimeInMinutes += service.AdditionalTimeInMinutes;

    service.Mover2ID = parseInt(totalTimeInMinutes.toString());
    service.AdditionalTimeCharges =
      (totalTimeInMinutes / 30) * service.AdditionalRateAndVAT;

    updatedServices[index] = service;

    CalculateAdditionalStairsAmountForAdditionalVan(index, updatedServices);
  };

  const CalculateAdditionalStairsAmountForAdditionalVan = (
    index: number,
    updatedServices: any,
  ) => {
    const service = { ...updatedServices[index] };

    service.DriverAdditionalStairsCharges =
      service.Mover3ID * QuoteCalculations.DriverPerStairRate;
    service.HelperAdditionalStairsCharges =
      service.Mover3ID * QuoteCalculations.HelperPerStairRate;

    if (service.MNVMoverTypeID == 1) {
      service.AdditionalStairsCharges = service.DriverAdditionalStairsCharges;
    } else if (service.MNVMoverTypeID == 2) {
      service.AdditionalStairsCharges =
        service.DriverAdditionalStairsCharges +
        service.HelperAdditionalStairsCharges;
    } else if (service.MNVMoverTypeID == 3) {
      service.AdditionalStairsCharges =
        service.DriverAdditionalStairsCharges +
        service.HelperAdditionalStairsCharges * 2;
    }

    updatedServices[index] = service;

    AdditionalServices = updatedServices;
    setAdditionalServices(updatedServices);
  };

  const CalculateStairs = () => {
    let totalStairs = 0;

    if (info.AdditionalStop && info.AdditionalStop.length > 0) {
      info.AdditionalStop.forEach((stop: any) => {
        if (
          !stop.AdditionalStopAvailableLift ||
          stop.AdditionalStopAvailableLift !== "Yes"
        ) {
          if (stop.NoOfStairs !== -1 && stop.NoOfStairs !== -2) {
            totalStairs += Number(stop.NoOfStairs);
          } else if (stop.NoOfStairs == -2) {
            totalStairs += 1;
          }
        }
        if (stop.AdditionalStairs != 0) {
          if (stop.AdditionalStairs > 2)
            totalStairs += stop.AdditionalStairs - 2;
          if (stop.AdditionalStairs == 2)
            totalStairs += stop.AdditionalStairs - 1;
        }
      });
    }

    // From location stairs
    if (!info.FromAvailableLift || info.FromAvailableLift !== "Yes") {
      if (info.FromNumberOfStairs !== -1 && info.FromNumberOfStairs !== -2) {
        totalStairs += Number(info.FromNumberOfStairs);
      } else if (info.FromNumberOfStairs == -2) {
        totalStairs += 1;
      }
    }

    if (info.FromAdditionalStairs != 0) {
      if (info.FromAdditionalStairs > 2)
        totalStairs += info.FromAdditionalStairs - 2;
      if (info.FromAdditionalStairs == 2)
        totalStairs += info.FromAdditionalStairs - 1;
    }

    // To location stairs
    if (!info.ToAvailableLift || info.ToAvailableLift !== "Yes") {
      if (info.ToNoOfStairs !== -1 && info.ToNoOfStairs !== -2) {
        totalStairs += Number(info.ToNoOfStairs);
      } else if (info.ToNoOfStairs == -2) {
        totalStairs += 1;
      }
    }

    if (info.ToAdditionalStairs != 0) {
      if (info.ToAdditionalStairs > 2)
        totalStairs += info.ToAdditionalStairs - 2;
      if (info.ToAdditionalStairs == 2)
        totalStairs += info.ToAdditionalStairs - 1;
    }

    // Update state
    setTotalStairs(totalStairs);
    return totalStairs;
  };

  const IsThisDateInBankHoliday = (requestedDate: Date) => {
    if (bankHolidays.length > 0) {
      for (let i = 0; i < bankHolidays.length; i++) {
        if (
          IsDateBetweenTwoDates(
            bankHolidays[i]["StartDate"],
            requestedDate,
            bankHolidays[i]["EndDate"],
          )
        ) {
          return true;
        }
      }
    }
    return false;
  };

  function GetDurationText() {
    var l_decTotalSeconds = (distance.DTPTimeSeconds +
      distance.PTDTimeSeconds +
      distance.DTDTimeSeconds) as number;
    var l_decTotalSeconds = Number(l_decTotalSeconds);
    var h = Math.floor((l_decTotalSeconds % (3600 * 24)) / 3600);
    var m = Math.floor((l_decTotalSeconds % 3600) / 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minute " : " minutes ") : "";

    let duration = hDisplay + mDisplay; //travel time

    setduration(duration);

    return duration;
  }

  function GetDurationTextForSeconds(p_decTotalSeconds: any) {
    var l_decTotalSeconds = p_decTotalSeconds as number;
    var l_decTotalSeconds = Number(l_decTotalSeconds);
    var h = Math.floor((l_decTotalSeconds % (3600 * 24)) / 3600);
    var m = Math.floor((l_decTotalSeconds % 3600) / 60);

    var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? " minute " : " minutes ") : "";

    var duration = hDisplay + mDisplay; //travel time

    return duration;
  }

  //#endregion Quote Calculations

  //#region Add/Delete Quotes

  const [IsCalledAfterVanDeletion, setIsCalledAfterVanDeletion] =
    useState(false);

  function AddNewConfirmation(p_intCheckedChanges = 0) {
    if (p_intCheckedChanges) {
      setConfirmationModalObject({
        ShowPopup: true,
        Heading: "Confirmation",
        Message: "Do you want to use the details from service 1?",
        ID: 1,
        SelectedID: 0,
        OtherID: 0,
      });
    } else {
      CheckIfAnyChangesAreMade(0, false);
    }
  }

  function AddNew(MNVQuoteID: number, IsChildOfCurrentQuote = false) {
    if (
      !IsChildOfCurrentQuote ||
      (IsChildOfCurrentQuote && !CheckIfAnyChangesAreMade(MNVQuoteID, true))
    ) {
      const data: any = {
        MNVJobID: JobRelatedData.MNVJobID,
        MNVQuoteID: MNVQuoteID,
        MNVClientID: JobRelatedData.MNVClientID,
        IsChildOfCurrentQuote: IsChildOfCurrentQuote,
        ServiceID: AllLinkedQuotes.length + 1,
      };

      setIsAnimation(true);

      axiosAuth
        .post(AppContext.APIURL + "api/MNVQuoteAdmin/AddNew", data)
        .then((result) => {
          setIsAnimation(false);

          if (Number(result.data) > 0) {
            if (IsChildOfCurrentQuote) {
              setIsCalledAfterVanDeletion(true);
              LoadAllQuotesLinkedToThisJob(JobRelatedData.MNVJobID, 0, 0);
              MNVQuoteGetRecordForEdit(MNVQuoteID);
            } else {
              LoadAllQuotesLinkedToThisJob(JobRelatedData.MNVJobID, 1, 1, 1);
            }
          }
        })
        .catch((error) => {
          setIsAnimation(false);
          console.error(error);
        });
    } else {
      showErrorMessage(
        "Please save the current changes, then try to add additional Van.",
      );
    }
  }

  const UnlinkQuoteFromJob = (
    MNVQuoteID: number,
    p_boolFirstTime: any,
    Index: number,
  ) => {
    let NextMNVQuoteID = 0;

    // Same logic as Angular
    if (Index == 0 && AllLinkedQuotes.length > 0) {
      NextMNVQuoteID = AllLinkedQuotes[Index + 1]?.MNVQuoteID ?? 0;
    }

    if (AdditionalServices.length > 0 && p_boolFirstTime) {
      showErrorMessage(
        "Please delete all extra vans in this service, then delete service.",
      );
      return;
    } else if (!p_boolFirstTime && CheckIfAnyChangesAreMade(MNVQuoteID, true)) {
      showErrorMessage(
        "Please save the current changes, then try to delete this Van.",
      );
      return;
    }

    const data: any = {
      MNVQuoteID,
      NextMNVQuoteID,
    };

    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/MNVQuoteUnlinkQuoteFromJob",
        data,
      )
      .then((result) => {
        setIsAnimation(false);

        const l_oResponse = result.data[0];

        if (l_oResponse[0].Status == 0) {
          showErrorMessage(l_oResponse[0].Message);
        } else {
          if (!p_boolFirstTime) {
            setIsCalledAfterVanDeletion(true);
            LoadAllQuotesLinkedToThisJob(JobRelatedData.MNVJobID, 0, 0);
            MNVQuoteGetRecordForEdit(QuoteId);
          } else {
            LoadAllQuotesLinkedToThisJob(
              JobRelatedData.MNVJobID,
              p_boolFirstTime,
              1,
            );
          }
        }
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  function CheckIfAnyChangesAreMade(
    p_intMNVQuoteID: any,
    p_boolOnlyCheck: any,
  ) {
    var l_oInfo = JSON.parse(JSON.stringify(info));
    delete l_oInfo.TotalStairs;
    delete l_oInfo.RequiredTime;
    delete l_oInfo.AdditionalStairsCharges;
    delete l_oInfo.AdditionalTimeCharges;
    delete l_oInfo.AdditionalTimeInHours;
    delete l_oInfo.AdditionalTimeInMinutes;
    delete l_oInfo.DriverAdditionalStairsCharges;
    delete l_oInfo.HelperAdditionalStairsCharges;
    delete l_oInfo.MinimumHours;
    delete l_oInfo.Tier;

    var l_oDifference = getChanges(infoBackup, l_oInfo);
    l_oDifference = {};

    if (!p_boolOnlyCheck) {
      if (!isObjectEmpty(l_oDifference)) {
        var Message = "Do you want to save the current service changes?";

        setConfirmationModalObject({
          ShowPopup: true,
          Heading: "Confirmation",
          Message: Message,
          ID: 9999,
          SelectedID: p_intMNVQuoteID,
          OtherID: 0,
        });

        // Swal.fire({
        //   title: '',
        //   text: Message,
        //   icon: 'warning',
        //   showCancelButton: true,
        //   confirmButtonColor: '#3085d6',
        //   cancelButtonColor: '#d33',
        //   confirmButtonText: 'Yes',
        //   cancelButtonText: 'No'
        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     if (p_intMNVQuoteID > 0)
        //       Update(1, p_intMNVQuoteID, 0);
        //     else
        //       Update(1, 0, 1);
        //   }
        //   else {
        //     if (p_intMNVQuoteID > 0){
        //      LoadDataForSpecificQuote(p_intMNVQuoteID);
        //     }
        //     else{
        //       AddNewConfirmation(1);
        //     }
        //   }
        // })
      } else {
        if (p_intMNVQuoteID > 0) {
          LoadDataForSpecificQuote(p_intMNVQuoteID);
        } else {
          AddNewConfirmation(1);
        }
      }
    } else {
      if (!isObjectEmpty(l_oDifference)) {
        return true;
      } else {
        return false;
      }
    }
  }

  function checkIfThereIsAnyDifferenceInBalance() {
    let diff = 0;

    if (
      InvoiceBalanceValue != undefined &&
      calculations.Balance != undefined &&
      InvoiceBalanceValue != calculations.Balance
    )
      diff = calculations.Balance - InvoiceBalanceValue;
    return diff;
  }

  //#endregion Add/Delete Quotes

  //#region Quote Setup

  const SearchByClientName = (val: string, autoCall = false) => {
    const data = { Name: val };

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/GetClientsAutoComplete",
        data,
      )
      .then((response) => {
        const result = response.data.Data[0];
        setClientsAutocomplete(result);

        if (autoCall) {
          onClientSelected(result[0]);
          setClientName(result[0]);
        } else {
          // same transformation as Angular
          const formatted = result.map((client: any) => ({
            ...client,
            Name: `${client.Name} ${client.BusinessName == "" ? "" : "|"} ${
              client.BusinessName
            } ${client.EmailAddress == "" ? "" : "|"} ${client.EmailAddress} ${
              client.Mobile == "" ? "" : "|"
            } ${client.Mobile}`,
          }));

          setClientsAutocomplete(formatted);
        }
      })
      .catch((error) => console.error(error));
  };

  const getClientListAll = (val: string) => {
    const data = { Name: val };

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/GetClientsAutoComplete",
        data,
      )
      .then((response) => {
        const result = response.data.Data[0];
        // same transformation as Angular
        const formatted = result.map((client: any) => ({
          ...client,
          Name: `${client.Name} ${client.BusinessName == "" ? "" : "|"} ${
            client.BusinessName
          } ${client.EmailAddress == "" ? "" : "|"} ${client.EmailAddress} ${
            client.Mobile == "" ? "" : "|"
          } ${client.Mobile}`,
          PID: client.MNVClientID,
        }));

        setClientsList(formatted);
      })
      .catch((error) => console.error(error));
  };

  const onClientSelected = (item: any) => {
    setShowEdit(true);
    setClientData((prev: any) => ({
      ...prev,
      MobileWA: item.Mobile ? item.Mobile.replace("-", "") : "",
    }));
  };

  function updateSelectedPIDForParentSingleSelect(
    type: any,
    value: any,
    otherID: any,
    addNewText: any,
  ) {
    if (type == 1) {
      setClientName(value.Name);
      setClientID(value.PID);
      SetSelectedMobileNumber(value.Mobile);
      setClientMobile(value.Mobile);
      setClientData(value);

      MNVDamageClaimGetHistoricalData(1, value.PID);
    }
  }

  function KeyUpInputData(value: any) {
    getClientListAll(value);
  }

  const SaveClient = () => {
    const data: any = {
      SiteUserID: 0,
      MNVClientID: 0,
      TypeID: Number(ClientData.TypeID),
      BusinessName: ClientData.BusinessName,
      FirstName: ClientData.FirstName,
      SurName: ClientData.SurName,
      LastName: ClientData.LastName,
      EmailAddress: ClientData.EmailAddress,
      Mobile: ClientData.Mobile,
      Telephone: ClientData.Telephone,
      PostCode: ClientData.PostCode,
      Address: ClientData.Address,
      AddressLine2: ClientData.AddressLine2,
      VATNumber: ClientData.VATNumber,
      ExtraTextField1: ClientData.CompanyNumber,
      OtherEmails: ClientData.OtherEmails,
      IsActive: true,
    };

    axiosAuth
      .post(AppContext.APIURL + "api/MNVClient/MNVClientSave", data)
      .then((response) => {
        const result = response.data.Data;

        if (result.length > 0 && result[0].Status == 1) {
          setIsClientAddClicked(false);

          // Auto-search again like Angular
          if (data.EmailAddress && data.EmailAddress !== "") {
            SearchByClientName(data.EmailAddress, true);
          }

          // Set state fields
          setClientName(data.FirstName + " " + data.LastName);
          setFirstName(data.FirstName);
          setLastName(data.LastName);
          setClientEmail(data.EmailAddress);
          setClientMobile(data.Mobile);
          setClientPhone(data.Telephone);
          setClientAddress(data.Address);
          setClientType(data.TypeID);
          setClientID(result[0].PID);

          setClientData((prev: any) => ({
            ...prev,
            MNVClientID: result[0].PID,
          }));
          // Close Modal
          setShowUpdateClientModal(false);
          getClientListAll(data.EmailAddress);
        } else {
          showErrorMessage(result[0].Message);
        }
      })
      .catch((error) => console.error(error));
  };

  const UpdateClient = (reload = true) => {
    const data: any = {
      MNVClientID: Number(ClientData.MNVClientID),
      SiteUserID: Number(ClientData.SiteUserID),
      TypeID: Number(ClientData.TypeID),
      BusinessName: ClientData.BusinessName,
      FirstName: ClientData.FirstName,
      SurName: ClientData.SurName,
      LastName: ClientData.LastName,
      EmailAddress: ClientData.EmailAddress,
      Mobile: ClientData.Mobile,
      Telephone: ClientData.Telephone,
      PostCode: ClientData.PostCode,
      Address: ClientData.Address,
      AddressLine2: ClientData.AddressLine2,
      VATNumber: ClientData.VATNumber,
      ExtraTextField1: ClientData.CompanyNumber,
      OtherEmails: ClientData.OtherEmails,
      IsActive: ClientData.IsActive == "" ? true : ClientData.IsActive,
      IsVIPClient: ClientData.IsVIPClient,
      Notes: ClientData.Notes,
      DefaultPromoCode: ClientData.DefaultPromoCode,
      ReferencedByID: ClientData.ReferencedByID,
    };

    axiosAuth
      .post(AppContext.APIURL + "api/MNVClient/MNVClientSave", data)
      .then((response) => {
        const result = response.data.Data;
        if (reload == true) {
          if (result.length > 0 && result[0].Status == 1) {
            // Auto-search again like Angular
            if (data.EmailAddress && data.EmailAddress !== "") {
              SearchByClientName(data.EmailAddress, true);
            }

            // Close Modal
            setShowUpdateClientModal(false);
            getClientListAll(data.EmailAddress);
          } else {
            showErrorMessage(result[0].Message);
          }
        }
      })
      .catch((error) => console.error(error));
  };

  const [SelectedMobileNumber, SetSelectedMobileNumber] = useState("");
  useEffect(() => {
    if (SelectedMobileNumber != "+44-") {
      setClientData((prev: any) => ({
        ...prev,
        Mobile: SelectedMobileNumber,
        MobileWA: SelectedMobileNumber.replace("-", ""),
      }));
    }
  }, [SelectedMobileNumber]);

  const [showSuggesstions, setShowSuggesstions] = useState(false);
  const [showAdditionalSuggesstions, setShowAdditionalSuggesstions] =
    useState(false);
  const [showToSuggesstions, setShowToSuggesstions] = useState(false);
  function setPickupDetails(addressDetail: any) {
    setMNVQuote({
      ...MNVQuote,
      FromPostalCode: addressDetail.PostCode,
      FromAddress: addressDetail.Street,
      FromCity: addressDetail.City,
    });

    setInfo({
      ...info,
      FromPostalCode: addressDetail.PostCode,
      FromAddress: addressDetail.Street,
      FromCity: addressDetail.City,
    });

    setShowSuggesstions(false);
    setIsCalculateDistance(1);
  }

  function setPickupDetails_Additional(addressDetail: any, index: any) {
    let thisobj = { ...info };
    thisobj.AdditionalStop[index].PostCode = addressDetail.PostCode;
    thisobj.AdditionalStop[index].Address = addressDetail.Street;
    thisobj.AdditionalStop[index].City = addressDetail.City;
    info.AdditionalStop[index].LocationsSuggestions = false;
    setInfo(thisobj);
    setIsCalculateDistance(1);
  }

  function setPickupDetails_To(addressDetail: any) {
    setMNVQuote({
      ...MNVQuote,
      ToPostalCode: addressDetail.PostCode,
      ToAddress: addressDetail.Street,
      ToCity: addressDetail.City,
    });

    setInfo({
      ...info,
      ToPostalCode: addressDetail.PostCode,
      ToAddress: addressDetail.Street,
      ToCity: addressDetail.City,
    });

    setShowToSuggesstions(false);
    setIsCalculateDistance(1);
  }

  const getAddress = (place: any, type: number, index: number) => {
    if (!place?.address_components) return;

    const updatedInfo = { ...info };
    const updatedQuote = { ...MNVQuote };

    if (type === 1) {
      updatedInfo.FromPostalCode = "";
      updatedQuote.FromPostalCode = "";
    } else if (type === 2) {
      updatedInfo.AdditionalStop[index].PostCode = "";
    } else if (type === 3) {
      updatedInfo.ToPostalCode = "";
      updatedQuote.ToPostalCode = "";
    }

    for (const component of place.address_components) {
      const componentType = component.types[0];

      switch (componentType) {
        case "postal_code":
          if (type === 1) {
            updatedInfo.FromPostalCode = component.short_name;
            updatedQuote.FromPostalCode = component.short_name;
          } else if (type === 2) {
            updatedInfo.AdditionalStop[index].PostCode = component.short_name;
          } else if (type === 3) {
            updatedInfo.ToPostalCode = component.short_name;
            updatedQuote.ToPostalCode = component.short_name;
          }
          break;

        case "route":
          if (type === 1) {
            updatedInfo.FromAddress = component.short_name;
            updatedQuote.FromAddress = component.short_name;
          } else if (type === 2) {
            updatedInfo.AdditionalStop[index].Address = component.short_name;
          } else if (type === 3) {
            updatedInfo.ToAddress = component.short_name;
            updatedQuote.ToAddress = component.short_name;
          }
          break;

        case "locality":
          if (type === 1) {
            updatedInfo.FromCity = component.short_name;
            updatedQuote.FromCity = component.short_name;
          } else if (type === 2) {
            updatedInfo.AdditionalStop[index].City = component.short_name;
          } else if (type === 3) {
            updatedInfo.ToCity = component.short_name;
            updatedQuote.ToCity = component.short_name;
          }
          break;
      }
    }

    if (type === 1 && updatedInfo.FromPostalCode == "") {
      updatedInfo.FromPostalCode = updatedInfo.FromAddress;
      updatedQuote.FromPostalCode = updatedQuote.FromAddress;
    } else if (type === 2 && updatedInfo.AdditionalStop[index].PostCode == "") {
      updatedInfo.AdditionalStop[index].PostCode =
        updatedInfo.AdditionalStop[index].Address;
    } else if (type === 3 && updatedInfo.ToPostalCode == "") {
      updatedInfo.ToPostalCode = updatedInfo.ToAddress;
      updatedQuote.ToPostalCode = updatedQuote.ToAddress;
    }

    setInfo(updatedInfo);
    setMNVQuote(updatedQuote);
    setIsCalculateDistance(1);
  };

  function markCalculateDistance(type: number, value: string, index: number) {
    const updatedInfo = { ...info };
    const updatedQuote = { ...MNVQuote };

    if (type === 1) {
      updatedInfo.FromPostalCode = value;
      updatedQuote.FromPostalCode = value;
    } else if (type === 2) {
      updatedInfo.AdditionalStop[index].PostCode = value;
    } else if (type === 3) {
      updatedInfo.ToPostalCode = value;
      updatedQuote.ToPostalCode = value;
    }

    setInfo(updatedInfo);
    setMNVQuote(updatedQuote);
    setIsCalculateDistance(1);
  }

  function setPickupLocation(selectedLocation: any) {}

  const AddStop = () => {
    if (info.AdditionalStop.length < 5) {
      const obj = {
        Index: 0 + 1,
        CountryCode: "GB",
        PostCode: "",
        Street: "",
        City: "",
        NoOfStairs: 0,
        WaitingTimeInMinutes: 0,
        DistanceInMiles: 0,
        TimeInSeconds: 0,
        Amount: 0,
        AdditionalStopType: "",
        AdditionalStopFloor: "",
        AdditionalStopAvailableLift: "",
      };

      setInfo((prev: any) => ({
        ...prev,
        AdditionalStop: [...prev.AdditionalStop, obj],
      }));

      setIsCalculateDistance(1);
    } else {
      showErrorMessage("Sorry, you can not exceed more then 5 stops");
    }
  };

  const RemoveAdditionalStop = (index: any) => {
    setInfo((prev: any) => {
      const updated = [...prev.AdditionalStop];
      updated.splice(index, 1);

      return {
        ...prev,
        AdditionalStop: updated,
      };
    });

    setIsCalculateDistance(1);
  };

  function updateAdditionalStop(index: any, colName: any, value: any) {
    let thisobj = { ...info };
    thisobj.AdditionalStop[index][colName] = value;
    infoRef.current = { ...thisobj };
    setInfo(thisobj);

    setIsCalculateDistance(1);
  }

  const CheckStorageType = () => {
    let isStorage = false;

    if (info.ToType == "Our Storage") {
      isStorage = true;
    } else {
      for (let i = 0; i < info.AdditionalStop.length; i++) {
        if (info.AdditionalStop[i].AdditionalStopType == "Our Storage") {
          isStorage = true;
          break;
        }
      }
    }
    setIsStorageType(isStorage);
  };

  const ChangeQuoteType = () => {
    if (!MNVQuote.IsLocalQuote) {
      setTravelType("Local");

      setInfo((prev: any) => ({
        ...prev,
        IsLocalQuote: true,
      }));
    } else {
      setTravelType("Long");

      setInfo((prev: any) => ({
        ...prev,
        IsLocalQuote: false,
      }));
    }
  };

  const [show, setShow] = useState(false);
  const [currentLat, setCurrentLat] = useState<number>(0);
  const [currentLng, setCurrentLng] = useState<number>(0);

  const openPopupForLocationOnMap = (type: number, idx: number = 0) => {
    MNVQuote.LocationType = type;

    let lat = 0;
    let lng = 0;

    if (type < 0) {
      MNVQuote.CurrentLat = 0;
      MNVQuote.CurrentLng = 0;

      let LatLngList = MNVQuote.LatLngList;
      if (LatLngList) {
        const list = LatLngList.split("#");
        if (list.length > 1) {
          let currentLatLng = list[0];

          if (type == -2) currentLatLng = list[list.length - 1];
          else if (type == -3) currentLatLng = list[idx + 1];

          const [latStr, lngStr] = currentLatLng.split(",");
          if (latStr && lngStr) {
            lat = parseFloat(latStr);
            lng = parseFloat(lngStr);
            MNVQuote.CurrentLat = lat;
            MNVQuote.CurrentLng = lng;
          }
        }
      }
    }

    setCurrentLat(lat);
    setCurrentLng(lng);
    setShow(true); // Open modal
  };

  const [isServiceChanged, setIsServiceChanged] = useState(false);
  const [response, setResponse] = useState<any>([]);
  const [questionsAndOptions, setQuestionsAndOptions] = useState<any>([]);

  const [questions, setQuestions] = useState<any>([]);
  const [subQuestions, setSubQuestions] = useState<any>([]);
  const [questionsPreReq, setQuestionsPreReq] = useState<any>([]);
  const [questionsRoutes, setQuestionsRoutes] = useState<any>([]);
  const [questionOptions, setQuestionOptions] = useState<any>([]);

  function onServiceChangeForEdit(id: any) {
    setCurrentSelectedService(id);
    setResponse([]);
  }

  const onServiceChange = (e: any, id: any) => {
    setIsServiceChanged(true);
    setCurrentSelectedService(id);
    setResponse([]);
    setServiceID(id);

    if (e.target.checked) {
      GetServiceQuestionsAndOptions(id);
      GetServiceQuestionsAndOptionsV2(id, optionsFromDB);
    }
  };

  const GetServiceQuestionsAndOptionsV2 = async (
    id: any,
    p_optionsFromDB: any,
  ) => {
    try {
      const res = await axiosAuth.get(
        AppContext.APIURL +
          `api/MNVQuoteAdmin/GetServicesQuestionsOptionsV2?serviceId=${id}`,
      );
      let questionsData = res.data.Data[0];
      let subQuestionsData = res.data.Data[1];
      let questionsPreReqData = res.data.Data[2];
      let questionsOptionsData = res.data.Data[3];
      let questionsRoutesData = res.data.Data[4];
      // console.log("Q data: ", res.data.Data);

      if (p_optionsFromDB && p_optionsFromDB.length > 0) {
        for (let i = 0; i < questionsOptionsData.length; i++) {
          for (let j = 0; j < p_optionsFromDB.length; j++) {
            if (
              questionsOptionsData[i].MNVMoveTypeServiceQuestionOptionID ==
              p_optionsFromDB[j]
            ) {
              questionsOptionsData[i].IsChecked = true;
            }
          }
        }
      }

      setQuestions(questionsData);
      setQuestionOptions(questionsOptionsData);
      setSubQuestions(subQuestionsData);
      setQuestionsPreReq(questionsPreReqData);
      setQuestionsRoutes(questionsRoutesData);
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  };

  function showThisQuestion(p_MNVMoveTypeServiceQuestionID: any) {
    let showQuestion = true;

    if (questionsPreReq && questionsPreReq.length > 0) {
      for (let i = 0; i < questionsPreReq.length; i++) {
        if (
          p_MNVMoveTypeServiceQuestionID ==
          questionsPreReq[i].MNVMoveTypeServiceQuestionID
        ) {
          let OptionIDsArray = questionsPreReq[i].OptionIDs.split(",");
          let count = 0;
          for (let j = 0; j < OptionIDsArray.length; j++) {
            for (let k = 0; k < optionsDataFromDB.length; k++) {
              if (optionsDataFromDB[k].OptionID == OptionIDsArray[j]) {
                count++;
              }
            }
          }
          if (count == OptionIDsArray.length) {
            showQuestion = true;
            break;
          } else {
            showQuestion = false;
          }
        }
      }
    }

    return showQuestion;
  }

  const GetServiceQuestionsAndOptions = async (id: any) => {
    try {
      const res = await axiosAuth.get(
        AppContext.APIURL +
          `api/MNVQuoteAdmin/GetServicesQuestionsOptions?serviceId=${id}`,
      );
      setQuestionsAndOptions(res.data.ServiceQuestions);
    } catch (error) {
      console.error("Error fetching questions:", error);
    }
  };

  const onOptionChange = (optionId: number, questionId: number) => {
    setResponse((prev: any[]) => {
      const updated: any[] = [
        ...prev.filter((r) => r.QuestionId !== questionId),
        { QuestionId: questionId, OptionId: optionId },
      ];

      return updated.sort((a, b) => a.QuestionId - b.QuestionId);
    });

    let thisoptionsDataFromDB = [...optionsDataFromDB];
    let found = false;
    for (let index = 0; index < thisoptionsDataFromDB.length; index++) {
      if (thisoptionsDataFromDB[index].QuestionID == questionId) {
        thisoptionsDataFromDB[index].OptionID = optionId;
        found = true;
        break;
      }
    }
    if (found == false) {
      thisoptionsDataFromDB.push({
        OptionID: optionId,
        QuestionID: questionId,
      });
    }

    setOptionsDataFromDB(thisoptionsDataFromDB);
  };

  const GetServiceQuestionAndAnswers = async (quoteId: any) => {
    const data = { QuoteID: quoteId };

    try {
      const result = await axiosAuth.post(
        AppContext.APIURL + "api/MNVQuoteAdmin/MNVGetServiceOptionsResponseV1",
        data,
      );

      setServiceQuestionAnswers(result.data[0]);
    } catch (error) {
      console.error(error);
    }
  };

  const GetServiceOptions = async (QuoteId: any, ServiceID: any) => {
    const data = { QuoteID: QuoteId };

    try {
      const res = await axiosAuth.post(
        AppContext.APIURL + "api/MNVQuoteAdmin/MNVGetServiceOptionsResponse",
        data,
      );

      const options = res.data[0]; // Assuming the response structure is the same
      setOptionsDataFromDB(options);
      const optionIds = options.map((option: { OptionID: any }) =>
        Number(option.OptionID),
      );
      setOptionsFromDB(optionIds);
      // console.log("optionsFromDB: ", options);
      GetServiceQuestionsAndOptions(ServiceID);
      GetServiceQuestionsAndOptionsV2(ServiceID, optionIds);
    } catch (error) {
      console.error(error);
    }
  };

  const [OldIndex, setOldIndex] = useState("");
  const [FreeMiles, setFreeMiles] = useState(0);
  const [FreeMinutes, setFreeMinutes] = useState(0);
  const [slots, setSlots] = useState<any>(null);
  const [IsTomarrowBookingAllowed, setIsTomarrowBookingAllowed] =
    useState(false);
  const [IsVanSlotsLoadingInProgress, setIsVanSlotsLoadingInProgress] =
    useState(false);

  const SelectVan = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedVanTypeId = Number(event.target.value);

    // reset values
    setInfo((prev: any) => ({
      ...prev,
      SlotID: -1,
      RequestedDate: "",
      RequestedTime: "",
    }));

    setMNVQuote((prev: any) => ({
      ...prev,
      SlotID: -1,
      RequestedDate: "",
      RequestedTime: "",
    }));

    // find selected van
    const van = VanTypesList.find((z: any) => z.VanTypeID == selectedVanTypeId);

    if (van) {
      SetVanType(van, true);
      SetMinimumHours();
    }
  };

  const SetVanType = (van: any, updateLoadingAndUnloadingTime: boolean) => {
    // reset index
    setOldIndex("");

    // update info
    setInfo((prev: any) => ({
      ...prev,
      MNVVanTypeID: van.VanTypeID,
      VanName: van.VanTypeName,
    }));

    // free allowances
    setFreeMiles(van.FreeAllowanceMiles);
    setFreeMinutes(van.FreeAllowanceMinutes);

    if (updateLoadingAndUnloadingTime) {
      // calculations
      setcalculations((prev: any) => ({
        ...prev,
        EstimatedLoadingTime: van.MinimumLoadingMinutes,
        EstimatedUnLoadingTime: van.MinimumUnLoadingMinutes,
        FuelCostPerMile: van.FuelCostPerMile,
        FreeAllowanceMiles: van.FreeAllowanceMiles,
        FreeAllowanceMinutes: van.FreeAllowanceMinutes,
      }));

      // time in seconds
      setLoadingTimeInSeconds(van.MinimumLoadingMinutes);
      setUnloadingTimeInSeconds(van.MinimumUnLoadingMinutes);
    } else {
      // calculations
      setcalculations((prev: any) => ({
        ...prev,
        FuelCostPerMile: van.FuelCostPerMile,
        FreeAllowanceMiles: van.FreeAllowanceMiles,
        FreeAllowanceMinutes: van.FreeAllowanceMinutes,
      }));
    }
  };

  function SelectVanForAdditional(value: any, index: any, colName: any) {
    let thisobj = [...AdditionalServices];
    thisobj[index][colName] = value;
    setAdditionalServices(thisobj);
    setIsCalculatePayment(1);
  }

  const GetVanSlots = async (showAnimation: boolean) => {
    const data: any = {
      VanTypeId: info.MNVVanTypeID,
      Date: new Date(Date.now() + 20 * 24 * 60 * 60 * 1000),
      TotalBookingHours: selectedTime,
      IsAdminSide: true,
      JobID: MNVQuote.JobID,
      MNVQuoteID: QuoteId,
    };

    setIsVanSlotsLoadingInProgress(true);

    if (showAnimation) setIsAnimation(true);

    try {
      const res = await axiosAuth.post(
        AppContext.APIURL + "api/MNVQuoteAdmin/GetAvailableTimeSlotByDate",
        data,
      );

      setIsVanSlotsLoadingInProgress(false);

      const result = res.data;

      if (showAnimation) setIsAnimation(false);

      setSlots(result[0]);
      setIsTomarrowBookingAllowed(result.IsTomarrowBookingAllowd);

      setItems(result.Slots);

      // set default date & time
      if (
        result.Slots?.length > 0 &&
        (!info.RequestedDate ||
          info.RequestedDate == "" ||
          !info.RequestedTime ||
          info.RequestedTime == "")
      ) {
        setInfo((prev: any) => ({
          ...prev,
          RequestedDate: result.Slots[0].Date,
          RequestedTime:
            result.Slots[0].Slots?.length > 0
              ? result.Slots[0].Slots[0].Name
              : "",

          SlotID:
            result.Slots[0].Slots?.length > 0
              ? result.Slots[0].Slots[0].SlotId
              : 0,
          Tier:
            result.Slots[0].Slots?.length > 0
              ? result.Slots[0].Slots[0].TierID
              : 0,
        }));
      }

      LoadMore(false, result.Slots);
    } catch (error) {
      setIsVanSlotsLoadingInProgress(false);
      console.error(error);
    }
  };

  const LoadMore = async (
    showAnimation: boolean = true,
    itemsParam: any = items,
  ) => {
    const data: any = {
      VanTypeId: info.MNVVanTypeID,
      Start: itemsParam.length,
      End: itemsParam.length + 7,
      LastDate:
        itemsParam.length > 0
          ? itemsParam[itemsParam.length - 1].Date
          : new Date(),
      TotalBookingHours: selectedTime,
      JobID: MNVQuote.JobID,
      MNVQuoteID: QuoteId,
    };

    try {
      if (showAnimation) setIsAnimation(true);

      const res = await axiosAuth.post(
        AppContext.APIURL + "api/MNVQuoteAdmin/LoadMoreSlots",
        data,
      );

      if (showAnimation) setIsAnimation(false);

      // IMPORTANT: immutable update
      setItems((prev: any[]) => [...prev, ...res.data.Slots]);

      // Recursive call preserved (same Angular behavior)
      if (showAnimation) {
        LoadMore(false, res.data.Slots);
      } else {
        setIsSlotsLoaded(1);
      }
    } catch (error) {
      if (showAnimation) setIsAnimation(false);
      console.error(error);
    }
  };

  const CheckAndUpdateAvailableVansForTheSlots = () => {
    setItems((prevItems: any[]) => {
      const updatedItems = [...prevItems];

      for (let i = 0; i < updatedItems.length; i++) {
        if (
          new Date(updatedItems[i].Date).toDateString() ==
          new Date(info.RequestedDate).toDateString()
        ) {
          for (let j = 0; j < updatedItems[i].Slots.length; j++) {
            if (
              MNVQuote.MNVQuoteStatusID !== 0 &&
              MNVQuote.MNVQuoteStatusID !== 5 &&
              MNVQuote.MNVQuoteStatusID !== 6 &&
              MNVQuote.SlotID == updatedItems[i].Slots[j].SlotId
            ) {
              updatedItems[i].Slots[j] = {
                ...updatedItems[i].Slots[j],
                AvailableVans:
                  updatedItems[i].Slots[j].Vans -
                  updatedItems[i].Slots[j].Booking -
                  1,
              };
              break;
            }
          }
          break;
        }
      }

      return updatedItems;
    });
  };

  const [IsTimeChange, setIsTimeChange] = useState<boolean>(false);
  const [thisRequiredTime, setthisRequiredTime] = useState<any>({});
  const onHourChange = (val: any) => {
    // Update state safely
    setNewTime(val);
    setIsTimeChange(true);

    // Minimum Booking Time check...
    if (parseFloat(val) < parseFloat(thisRequiredTime.requiredTime)) {
      setSelectedTime(thisRequiredTime.requiredTime);
      showErrorMessage("Time can not be less than minimum booking time.");
    } else {
      setSelectedTime(val);
    }
  };

  const SetMinimumHours = () => {
    if (
      MNVQuote.MNVVanTypeID != null &&
      MNVQuote.MNVMoverTypeID != null &&
      info.Tier != null &&
      MNVQuote.RequestedDate != null
    ) {
      getMinimumHoursBasedOnMoverVanAndTier(
        MNVQuote.MNVVanTypeID,
        MNVQuote.MNVMoverTypeID,
        info.Tier,
        MNVQuote.RequestedDate,
        0,
      );
    }
  };

  const getMinimumHoursBasedOnMoverVanAndTier = (
    MNVVanTypeID: any,
    MNVMoverTypeID: any,
    TierID: any,
    RequestedDate: Date,
    Override: any,
  ) => {
    let minimumHours: any = 2;

    // Extra services override van & mover type
    if (AdditionalServices.length > 0) {
      MNVVanTypeID = 3;
      MNVMoverTypeID = 3;
    }

    if (MNVMoverTypeID > 3) MNVMoverTypeID = 3;

    let tierChanged = false;

    // ---- CHECK BANK HOLIDAY ----
    if (bankHolidays.length > 0) {
      for (let i = 0; i < bankHolidays.length; i++) {
        if (
          IsDateBetweenTwoDates(
            bankHolidays[i]["StartDate"],
            RequestedDate,
            bankHolidays[i]["EndDate"],
          )
        ) {
          TierID = 3;

          setcalculations((prev: any) => {
            if (prev.Tier < TierID) {
              setInfo((iPrev: any) => ({ ...iPrev, Tier: TierID }));
              tierChanged = true;
              return { ...prev, Tier: TierID };
            }
            return prev;
          });

          break;
        }
      }
    }

    // ---- CHECK MINIMUM CHARGES ----
    if (minimumCharges.length > 0) {
      const found = minimumCharges.filter(
        (item: any) =>
          item.MNVVanTypeID == MNVVanTypeID &&
          item.MNVMoverTypeID == MNVMoverTypeID &&
          item.TierID == TierID,
      );

      if (found.length > 0) minimumHours = found[0]["MinimumHours"];
    } else {
      // FULL fallback logic (unchanged)
      if (TierID == 1) {
        if (MNVVanTypeID == 1 && MNVMoverTypeID == 1) minimumHours = 2;
        else if (MNVVanTypeID == 1 && MNVMoverTypeID == 2) minimumHours = 2;
        else if (MNVVanTypeID == 1 && MNVMoverTypeID >= 3) minimumHours = 3;
        else if (MNVVanTypeID == 2 && MNVMoverTypeID == 1) minimumHours = 2;
        else if (MNVVanTypeID == 2 && MNVMoverTypeID == 2) minimumHours = 2;
        else if (MNVVanTypeID == 2 && MNVMoverTypeID >= 3) minimumHours = 3;
      }

      if (TierID == 2) {
        if (MNVVanTypeID == 1 && MNVMoverTypeID == 1) minimumHours = 2;
        else if (MNVVanTypeID == 1 && MNVMoverTypeID == 2) minimumHours = 2;
        else if (MNVVanTypeID == 1 && MNVMoverTypeID >= 3) minimumHours = 3;
        else if (MNVVanTypeID == 2 && MNVMoverTypeID == 1) minimumHours = 2;
        else if (MNVVanTypeID == 2 && MNVMoverTypeID == 2) minimumHours = 2;
        else if (MNVVanTypeID == 2 && MNVMoverTypeID >= 3) minimumHours = 3;
      }

      if (TierID == 3) {
        if (MNVVanTypeID == 1 && MNVMoverTypeID == 1) minimumHours = 3;
        else if (MNVVanTypeID == 1 && MNVMoverTypeID == 2) minimumHours = 3;
        else if (MNVVanTypeID == 1 && MNVMoverTypeID >= 3) minimumHours = 4;
        else if (MNVVanTypeID == 2 && MNVMoverTypeID == 1) minimumHours = 3;
        else if (MNVVanTypeID == 2 && MNVMoverTypeID == 2) minimumHours = 3;
        else if (MNVVanTypeID == 2 && MNVMoverTypeID >= 3) minimumHours = 4;
      }
    }

    // ---- SAVE MINIMUM HOURS ----
    setMNVQuote((prev: any) => ({
      ...prev,
      MinimumHours: minimumHours,
    }));

    // ---- APPLY OVERRIDE ----
    if (selectedTime < minimumHours && Override) {
      setSelectedTime(minimumHours);
      onHourChange(minimumHours);
    } else if (tierChanged) {
      onHourChange(selectedTime);
    }

    return minimumHours;
  };

  const onLongServiceTimeChange = (type: any, val: any) => {
    val = Number(val);

    if (type == 1) {
      setLoadingTimeInSeconds(val);

      setcalculations((prev: any) => ({
        ...prev,
        EstimatedLoadingTime: val,
      }));
    } else {
      setUnloadingTimeInSeconds(val);

      setcalculations((prev: any) => ({
        ...prev,
        EstimatedUnLoadingTime: val,
      }));
    }
  };

  const [ClickedItem, setClickedItem] = useState("");
  const [SlotCharge, setSlotCharge] = useState("");

  const onTagSelect = (
    item: any,
    id: number,
    slotCharge: any,
    date: any,
    sIndex: number,
    MNVTimeSlotID: number,
    slotObj: any,
  ) => {
    // reset bespoke values
    setBespokeDate("");
    setBespokeTime("");
    setBespokeTimeEnd("");

    if (slotCharge) {
      setSlotCharge(slotCharge);
    }

    // remove old selection
    if (OldIndex) {
      const oldEl = document.getElementById(OldIndex);
      if (oldEl) oldEl.classList.remove("slot-selected");
    }

    const newIndex = `${id}_${sIndex}`;
    setOldIndex(newIndex);

    // add selected class
    const newEl = document.getElementById(newIndex);
    if (newEl) newEl.classList.add("slot-selected");

    const formattedDate: any = new Date(date).toISOString().substr(0, 10);

    // update info
    setInfo((prev: any) => ({
      ...prev,
      RequestedDate: formattedDate,
      RequestedTime: item,
      SlotID: MNVTimeSlotID,
      Tier: slotObj.TierID,
    }));

    // update quote
    setMNVQuote((prev: any) => ({
      ...prev,
      RequestedDate: formattedDate,
      RequestedTime: item,
      SlotID: MNVTimeSlotID,
    }));

    setClickedItem(newIndex);

    // price calculation
    setQuoteCalculations((prev: any) => ({
      ...prev,
      Amount: slotObj.CalculatedPrice,
    }));

    setcalculations((prev: any) => ({
      ...prev,
      Tier: slotObj.TierID,
    }));

    if (MNVQuote.MNVVanTypeID != null) {
      getMinimumHoursBasedOnMoverVanAndTier(
        MNVQuote.MNVVanTypeID,
        MNVQuote.MNVMoverTypeID,
        slotObj.TierID,
        formattedDate,
        1,
      );
    }

    setShowSlotsModal(false);
  };

  const CloseBespoke = () => {
    let requestedTime = "";

    if (BespokeTime && BespokeTimeEnd) {
      requestedTime = `${BespokeTime}-${BespokeTimeEnd}`;
    } else if (BespokeTime) {
      requestedTime = `${BespokeTime}-${BespokeTime}`;
    } else if (BespokeTimeEnd) {
      requestedTime = `${BespokeTimeEnd}-${BespokeTimeEnd}`;
    }

    // Update quote and info state
    setMNVQuote((prev: any) => ({
      ...prev,
      RequestedTime: requestedTime,
      RequestedDate: BespokeDate
        ? new Date(addMinutes(new Date(BespokeDate), 540))
        : prev.RequestedDate,
    }));

    setInfo((prev: any) => ({
      ...prev,
      SlotID: 10000,
      RequestedTime: requestedTime,
      RequestedDate: BespokeDate
        ? new Date(addMinutes(new Date(BespokeDate), 540))
        : prev.RequestedDate,
    }));

    // Close modal
    setShowBespokeModal(false);
  };

  const Update = async (
    p_intManualUpdate = 1,
    p_intMNVQuoteID = 0,
    p_intAddNew = 0,
  ) => {
    if (!info) return;

    setIsCalledAfterVanDeletion(false);

    const data: any = {
      IsServiceChanged: isServiceChanged,
      serviceOption: response,
      info: { ...info },
      calculations: { ...calculations },
      distance: { ...distance },
      AdditionalServices: AdditionalServices,
      SelectedServiceID: CurrentSelectedService,
      QuoteOtherData: {},
    };

    // Bespoke time/date logic
    if (BespokeDate && (BespokeTime || BespokeTimeEnd)) {
      data.info.RequestedDate = new Date(BespokeDate);

      let l_strBespokeTime = "";
      if (BespokeTime && BespokeTimeEnd)
        l_strBespokeTime = `${BespokeTime}-${BespokeTimeEnd}`;
      else if (BespokeTime) l_strBespokeTime = `${BespokeTime}-${BespokeTime}`;
      else if (BespokeTimeEnd)
        l_strBespokeTime = `${BespokeTimeEnd}-${BespokeTimeEnd}`;

      data.info.RequestedTime = l_strBespokeTime;
      setMNVQuote((prev: any) => ({
        ...prev,
        RequestedTime: l_strBespokeTime,
      }));
    }
    
    if (!isValidDate(data.info.RequestedDate)) data.info.RequestedDate = "01/01/1900";
    if (!data.info.RequestedTime || data.info.RequestedTime == "") data.info.RequestedTime = "00:00-00:00";

    if (IsNewQuote) {
      setMNVQuote((prev: any) => ({
        ...prev,
        MNVVanTypeID: info.MNVVanTypeID,
      }));
      data.info.FromNumberOfStairs = info.FromNumberOfStairs;
      data.info.ToNoOfStairs = info.ToNoOfStairs;
    }

    // Client details
    data.info.FirstName = FirstName;
    data.info.LastName = LastName;
    data.info.ClientInstructions = ClientInstructions;
    data.info.ClientEmail = ClientEmail;
    data.info.ClientAddress = ClientAddress;
    data.info.ClientPhoneNumber = ClientPhone;
    data.info.ClientType = ClientType;
    data.info.ClientID =
      ClientData.MNVClientID > 0
        ? ClientData.MNVClientID
        : MNVQuote.MNVClientID;
    data.info.EnableNotification = MNVQuote.EnableNotification;

    // Other data
    data.calculations.DTPMilesAfterAllowance = DTPMilesAfterAllowance;
    data.calculations.DTDMilesAfterAllowance = DTDMilesAfterAllowance;
    data.info.RequiredTime = selectedTime;
    data.info.Duration = GetDurationText();
    data.info.TotalDistance = calculations.TotalDistance;
    data.info.IsLocalQuote = travelType == "Local";
    data.info.QuoteStatusId = MNVQuote.MNVQuoteStatusID;
    data.calculations.TotalDistance = MNVQuote.TotalDistance;
    data.info.MNVQuoteID = QuoteId;
    data.info.FileURL = FileURL;
    data.info.LiabilityID = LineItemsAmounts.LiabilityID;
    data.info.QuoteLoadingTime = quoteLoadingTime;
    data.info.ServiceSubID = MNVQuote.LatLngList;
    data.info.ToFloor = `${info.FromCountryCode}#PTSep#${info.ToCountryCode}`;
    data.info.Mover2ID = MNVQuote.Mover2ID;
    data.info.Mover3ID = MNVQuote.Mover3ID;
    data.calculations.VATPercentage = Vat;
    data.QuoteOtherData.IsItemsOver100KG =
      info.IsItemsOver100KG == null || info.IsItemsOver100KG == ""
        ? false
        : info.IsItemsOver100KG;
    data.QuoteOtherData.FinalDeliveryAddress = info.FinalDeliveryAddress;
    data.QuoteOtherData.MoveManagerNames = info.MoveManagerNames;
    data.QuoteOtherData.AdminNotes = info.AdminNotes;
    data.QuoteOtherData.QuoteInclusionNotes = info.QuoteInclusionNotes;
    data.QuoteOtherData.IsFirstFollowUpDone =
      info.IsFirstFollowUpDone == null || info.IsFirstFollowUpDone == ""
        ? false
        : info.IsFirstFollowUpDone;
    data.QuoteOtherData.IsSecondFollowUpDone =
      info.IsSecondFollowUpDone == null || info.IsSecondFollowUpDone == ""
        ? false
        : info.IsSecondFollowUpDone;

    data.QuoteOtherData.CourtesyCallBefore =
      info.CourtesyCallBefore == null || info.CourtesyCallBefore == ""
        ? false
        : info.CourtesyCallBefore;

    data.QuoteOtherData.CourtesyCallAfter =
      info.CourtesyCallAfter == null || info.CourtesyCallAfter == ""
        ? false
        : info.CourtesyCallAfter;

    data.QuoteOtherData.CourtesyCallBeforeNotes =
      info.CourtesyCallBeforeNotes == null ? "" : info.CourtesyCallBeforeNotes;

    data.QuoteOtherData.CourtesyCallAfterNotes =
      info.CourtesyCallAfterNotes == null ? "" : info.CourtesyCallAfterNotes;

    if (QuoteId == info.MNVQuoteID && data.info.QuoteStatusId > 0) {
      try {
        if (data.info.ClientID > 0) {
          if (p_intManualUpdate) setIsAnimation(true);

          const result = await axiosAuth.post(
            AppContext.APIURL + "api/MNVQuoteAdmin/MNVQuoteUpdate",
            data,
          );
          if (p_intManualUpdate) setIsAnimation(false);

          const l_oStatus = result.data;
          if (l_oStatus && l_oStatus.length > 0) {
            if (l_oStatus[0].Status == 1) {
              if (checkIfThereIsAnyDifferenceInBalance() != 0)
                GetInvoiceDataByQuoteID();

              RefreshLogsData();
              setQuoteLoadingTime(addMinutes(new Date(), 0.032));

              SaveAttachmentDataForObjectTypeIDObjectID();

              if (p_intManualUpdate) {
                showSuccessMessage("Quote has been updated successfully.");
              }

              setIsNewQuote(false);

              if (!p_intAddNew) {
                if (p_intMNVQuoteID > 0) {
                  GetSystemConfigurations(p_intMNVQuoteID);
                  setQuoteId(p_intMNVQuoteID);
                  MNVQuoteGetRecordForEdit(p_intMNVQuoteID);
                } else {
                  MNVQuoteGetRecordForEdit(QuoteId);
                }

                LoadAllQuotesLinkedToThisJob(JobRelatedData.MNVJobID, 0, 0);

                // setTimeout(() => {
                //   MNVQuoteGetRecordForEdit(QuoteId);
                //   GetServiceQuestionAndAnswers(QuoteId);
                //   GetDriversOfThisJob(QuoteId);
                //   GetServiceOptions(QuoteId);
                // }, 1000);
              } else {
                AddNewConfirmation(1);
              }
            } else if (p_intManualUpdate) {
              showErrorMessage(l_oStatus[0].Message);
            }
          }
        } else if (p_intManualUpdate) {
          showErrorMessage("Please select client.");
        }
      } catch (error) {
        console.error(error);
        if (p_intManualUpdate) setIsAnimation(false);
      }
    } else {
      showErrorMessage(
        "Looks like there is an issue, please refresh your screen.",
      );
    }
  };

  const SaveAttachmentDataForObjectTypeIDObjectID = async () => {
    const data = {
      ObjectType: 1,
      ObjectID: QuoteId,
      FilesData: PTFilesList,
    };

    try {
      await axiosAuth.post(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/SaveAttachmentDataForObjectTypeIDObjectID",
        data,
      );
    } catch (error) {
      console.error(error);
    }
  };

  //#endregion Quote Setup

  //#region Distance Calculations
  var DTPMiles = 0;
  var DTPSeconds = 0;

  const congestionZonePostCodes = [
    "EC1",
    "EC2",
    "EC3",
    "EC4",
    "SE1",
    "SW1",
    "W1",
    "WC1",
    "WC2",
  ];

  function IsCongestionsCharged(postCode: any): boolean {
    if (postCode != null) {
      let string = postCode.substring(0, 3);
      let string1 = postCode.substring(0, 2);

      if (congestionZonePostCodes.includes(string)) {
        return true;
      } else if (congestionZonePostCodes.includes(string1)) {
        return true;
      }
    }
    return false;
  }

  const isAddressChanged = (currentInfo: any): boolean => {
    if (!previousAddressRef.current) {
      previousAddressRef.current = structuredClone(currentInfo);
      return true;
    }

    const addressFields = [
      // "FromCountryCode",
      "FromPostalCode",
      // "FromAddress",
      // "FromCity",
      // "FromType",
      // "FromNumberOfStairs",
      // "FromAvailableLift",
      // "FromAdditionalStairs",

      // "ToCountryCode",
      "ToPostalCode",
      // "ToAddress",
      // "ToCity",
      // "ToType",
      // "ToNoOfStairs",
      // "ToAvailableLift",
      // "ToAdditionalStairs",
    ];

    const changed = addressFields.some((field) => {
      return (
        String(currentInfo?.[field] ?? "") !==
        String(previousAddressRef.current?.[field] ?? "")
      );
    });

    if(changed)
      return true;

    const postcodeChanged =
    AdditionalStopBK.length !== currentInfo.AdditionalStop.length ||
    currentInfo.AdditionalStop.some((currentItem:any) => {
        const originalItem = AdditionalStopBK.find(
            (item:any) => item.PostCode === currentItem.PostCode
        );

        // New item
        if (!originalItem) {
            return true;
        }
    });

    return postcodeChanged;
  };

  function CalculateDistance() {
    console.log(
      "Call CalculateDistance: ",
      isAddressChanged(info) == true || isAddressChangedOnce ? "Yes" : "No",
    );

    if (isAddressChanged(info) === false && isAddressChangedOnce == false) {
      return;
    }

    setIsAddressChangedOnce(true);

    const directionsService = new google.maps.DirectionsService();
    var waypts: google.maps.DirectionsWaypoint[] = [];

    waypts = [];
    waypts.push(
      {
        location: info.FromPostalCode,
        stopover: true,
      },
      {
        location: info.ToPostalCode,
        stopover: true,
      },
    );

    let AdditionalStop = [...info.AdditionalStop] as any;

    if (AdditionalStop.length > 0) {
      waypts = [];
      waypts.push({
        location: info.FromPostalCode,
        stopover: true,
      });
      for (var i = 0; i < AdditionalStop.length; i++) {
        if (AdditionalStop[i].PostCode != "") {
          waypts.push({
            location: AdditionalStop[i].PostCode,
            stopover: true,
          });
        }
      }
      waypts.push({
        location: info.ToPostalCode,
        stopover: true,
      });
    }

    let SystemConfigurationobj: any = configurations.filter(
      (x: any) => x.SystemConfigurationID == 13,
    )[0];

    var Base = SystemConfigurationobj.Value;
    directionsService.route(
      {
        origin: Base,
        destination: Base,
        travelMode: google.maps.TravelMode.DRIVING,
        waypoints: waypts,
        avoidTolls: true,
        unitSystem: google.maps.UnitSystem.IMPERIAL,
      },
      function (response: any, status) {
        let ThisObject = {
          distance: { ...distance },
          calculations: { ...calculations },
          TravelType: "Local",
          MNVQuote: { ...MNVQuote },
          IsLocalQuote: true,
          ShowTotalDistance: 0,
          PTDDurationDisplay: "",
        } as any;

        ThisObject.distance.DTP = 0;
        ThisObject.distance.DTPTimeStr = "0";
        ThisObject.distance.DTPTimeSeconds = 0;

        ThisObject.distance.PTD = 0;
        ThisObject.distance.PTDTimeStr = "0";
        ThisObject.distance.PTDTimeSeconds = 0;

        ThisObject.distance.DTD = 0;
        ThisObject.distance.DTDTimeStr = "0";
        ThisObject.distance.DTDTimeSeconds = 0;

        ThisObject.calculations.TotalDistance = 0;

        ThisObject.TravelType = "Local";
        ThisObject.MNVQuote.IsLocalQuote = true;

        ThisObject.ShowTotalDistance = 0;
        ThisObject.PTDDurationDisplay = "";

        if (status === google.maps.DirectionsStatus.OK) {
          let LocalDistanceMaxMilesobj: any = configurations.filter(
            (x: any) => x.SystemConfigurationID == 7,
          )[0];

          let LocalDistanceMaxMiles = Number(LocalDistanceMaxMilesobj.Value);
          let l_strLatLngList = "";

          if (AdditionalStop.length === 0) {
            ThisObject.distance.DTP = Number(
              response.routes[0].legs[0].distance.value / 1600,
            );
            ThisObject.distance.DTPTimeStr =
              response.routes[0].legs[0].duration.text;
            ThisObject.distance.DTPTimeSeconds =
              response.routes[0].legs[0].duration.value;

            ThisObject.distance.PTD = Number(
              response.routes[0].legs[1].distance.value / 1600,
            );
            ThisObject.distance.PTDTimeStr =
              response.routes[0].legs[1].duration.text;
            ThisObject.distance.PTDTimeSeconds =
              response.routes[0].legs[1].duration.value;

            l_strLatLngList +=
              response.routes[0].legs[1].start_location.lat() +
              "," +
              response.routes[0].legs[1].start_location.lng();

            ThisObject.distance.DTD = Number(
              response.routes[0].legs[2].distance.value / 1600,
            );
            ThisObject.distance.DTDTimeStr =
              response.routes[0].legs[2].duration.text;
            ThisObject.distance.DTDTimeSeconds =
              response.routes[0].legs[2].duration.value;

            l_strLatLngList +=
              "#" +
              response.routes[0].legs[2].start_location.lat() +
              "," +
              response.routes[0].legs[2].start_location.lng();

            ThisObject.calculations.TotalDistance = (
              ThisObject.distance.DTP +
              ThisObject.distance.PTD +
              ThisObject.distance.DTD
            ).toFixed(2);

            ThisObject.ShowTotalDistance = ThisObject.distance.PTD.toFixed(2); //only for show on front end
          } else {
            //Depo To Pickup
            ThisObject.distance.DTP = Number(
              response.routes[0].legs[0].distance.value / 1600,
            );
            ThisObject.distance.DTPTimeStr =
              response.routes[0].legs[0].duration.text;
            ThisObject.distance.DTPTimeSeconds = Number(
              response.routes[0].legs[0].duration.value,
            );

            // Pickup To Depo

            ThisObject.distance.PTD = Number(
              response.routes[0].legs[1].distance.value / 1600,
            );
            ThisObject.distance.PTDTimeStr =
              response.routes[0].legs[1].duration.text;
            ThisObject.distance.PTDTimeSeconds =
              response.routes[0].legs[1].duration.value;

            l_strLatLngList +=
              response.routes[0].legs[1].start_location.lat() +
              "," +
              response.routes[0].legs[1].start_location.lng();

            DTPMiles = 0;
            DTPSeconds = 0;
            let index = 0;
            for (var i = 1; i <= AdditionalStop.length; i++) {
              if (AdditionalStop[i - 1].PostCode != "") {
                //between stops
                index++;
                DTPMiles += Number(
                  response.routes[0].legs[i + 1].distance.value / 1600,
                );
                DTPSeconds += response.routes[0].legs[i + 1].duration.value;

                l_strLatLngList +=
                  "#" +
                  response.routes[0].legs[i + 1].start_location.lat() +
                  "," +
                  response.routes[0].legs[i + 1].start_location.lng();

                if (IsCongestionsCharged(AdditionalStop[i - 1].PostCode)) {
                  ThisObject.IsCongestion = true;
                }

                AdditionalStop[i - 1].DistanceInMiles = Number(
                  response.routes[0].legs[i + 1].distance.value / 1600,
                );
                AdditionalStop[i - 1].TimeInSeconds =
                  response.routes[0].legs[i + 1].duration.value;
              }
            }

            ThisObject.distance.PTD = ThisObject.distance.PTD + DTPMiles;

            ThisObject.distance.PTDTimeSeconds =
              ThisObject.distance.PTDTimeSeconds + DTPSeconds;

            ThisObject.distance.DTD = Number(
              response.routes[0].legs[index + 2].distance.value / 1600,
            );
            ThisObject.distance.DTDTimeStr =
              response.routes[0].legs[index + 2].duration.text;
            ThisObject.distance.DTDTimeSeconds = Number(
              response.routes[0].legs[index + 2].duration.value,
            );

            l_strLatLngList +=
              "#" +
              response.routes[0].legs[index + 2].start_location.lat() +
              "," +
              response.routes[0].legs[index + 2].start_location.lng();

            ThisObject.calculations.TotalDistance = Number(
              ThisObject.distance.DTP +
                ThisObject.distance.PTD +
                ThisObject.distance.DTD,
            ).toFixed(2);
            ThisObject.ShowTotalDistance = Number(
              ThisObject.distance.PTD + DTPMiles,
            ).toFixed(2); //only for show on front end

            setInfo((prev: any) => ({
              ...prev,
              AdditionalStop: AdditionalStop,
            }));
          }

          ThisObject.MNVQuote.LatLngList = l_strLatLngList;

          setDistance(ThisObject.distance);
          setcalculations(ThisObject.calculations);
          setMNVQuote(ThisObject.MNVQuote);
          setTravelType(ThisObject.TravelType);

          CalculateDistanceToCheckLocalLongQuote(ThisObject);
        } else {
          // console.log("Route not found response " + JSON.stringify(response));
          CalculateDistanceBasedOnAddress();
        }
      },
    );
  }

  function CalculateDistanceToCheckLocalLongQuote(ThisObject: any) {
    const directionsService = new google.maps.DirectionsService();
    var waypts: google.maps.DirectionsWaypoint[] = [];

    let SystemConfigurationobj: any = configurations.filter(
      (x: any) => x.SystemConfigurationID == 13,
    )[0];

    var Base = SystemConfigurationobj.Value;

    waypts = [];
    waypts.push(
      {
        location: info.FromPostalCode,
        stopover: true,
      },
      {
        location: info.ToPostalCode,
        stopover: true,
      },
    );

    let AdditionalStop = [...info.AdditionalStop] as any;

    if (AdditionalStop.length > 0) {
      waypts = [];
      waypts.push({
        location: info.FromPostalCode,
        stopover: true,
      });
      for (var i = 0; i < AdditionalStop.length; i++) {
        if (AdditionalStop[i].PostCode != "") {
          waypts.push({
            location: AdditionalStop[i].PostCode,
            stopover: true,
          });
        }
      }
      waypts.push({
        location: info.ToPostalCode,
        stopover: true,
      });
    }

    directionsService.route(
      {
        origin: Base,
        destination: Base,
        travelMode: google.maps.TravelMode.DRIVING,
        waypoints: waypts,
        avoidTolls: true,
        unitSystem: google.maps.UnitSystem.IMPERIAL,
      },
      function (response: any, status) {
        if (status === google.maps.DirectionsStatus.OK) {
          let LocalDistanceMaxMilesobj: any = configurations.filter(
            (x: any) => x.SystemConfigurationID == 7,
          )[0];

          let LocalDistanceMaxMiles = Number(LocalDistanceMaxMilesobj.Value);

          let IsLocalQuote = true;

          if (response.routes[0].legs && response.routes[0].legs.length > 0) {
            for (var i = 0; i < response.routes[0].legs.length; i++) {
              var distance = Number(
                response.routes[0].legs[i].distance.value / 1600,
              );
              if (distance > LocalDistanceMaxMiles) {
                ThisObject.TravelType = "Long";
                ThisObject.MNVQuote.IsLocalQuote = false;

                setMNVQuote(ThisObject.MNVQuote);
                setTravelType(ThisObject.TravelType);
                break;
              }
            }
          }
          //props.setCalculateDistanceObject(ThisObject);
        } else {
          //console.log("Route not found response " + JSON.stringify(response));
        }
      },
    );
  }

  function CalculateDistanceBasedOnAddress() {
    const directionsService = new google.maps.DirectionsService();
    var waypts: google.maps.DirectionsWaypoint[] = [];

    waypts = [];
    waypts.push(
      {
        location:
          info.FromPostalCode + " " + info.FromAddress + " " + info.FromCity,
        stopover: true,
      },
      {
        location: info.ToPostalCode + " " + info.ToAddress + " " + info.ToCity,
        stopover: true,
      },
    );

    let AdditionalStop = [...info.AdditionalStop] as any;

    if (AdditionalStop.length > 0) {
      waypts = [];
      waypts.push({
        location:
          info.FromPostalCode + " " + info.FromAddress + " " + info.FromCity,
        stopover: true,
      });
      for (var i = 0; i < AdditionalStop.length; i++) {
        if (AdditionalStop[i].PostCode != "") {
          waypts.push({
            location:
              AdditionalStop[i].PostCode + " " + info.Address + " " + info.City,
            stopover: true,
          });
        }
      }
      waypts.push({
        location: info.ToPostalCode + " " + info.ToAddress + " " + info.ToCity,
        stopover: true,
      });
    }

    let SystemConfigurationobj: any = configurations.filter(
      (x: any) => x.SystemConfigurationID == 13,
    )[0];

    var Base = SystemConfigurationobj.Value;
    directionsService.route(
      {
        origin: Base,
        destination: Base,
        travelMode: google.maps.TravelMode.DRIVING,
        waypoints: waypts,
        avoidTolls: true,
        unitSystem: google.maps.UnitSystem.IMPERIAL,
      },
      function (response: any, status) {
        let ThisObject = {
          distance: { ...distance },
          calculations: { ...calculations },
          TravelType: "Local",
          MNVQuote: { ...MNVQuote },
          IsLocalQuote: true,
          ShowTotalDistance: 0,
          PTDDurationDisplay: "",
        } as any;

        ThisObject.distance.DTP = 0;
        ThisObject.distance.DTPTimeStr = "0";
        ThisObject.distance.DTPTimeSeconds = 0;

        ThisObject.distance.PTD = 0;
        ThisObject.distance.PTDTimeStr = "0";
        ThisObject.distance.PTDTimeSeconds = 0;

        ThisObject.distance.DTD = 0;
        ThisObject.distance.DTDTimeStr = "0";
        ThisObject.distance.DTDTimeSeconds = 0;

        ThisObject.calculations.TotalDistance = 0;

        ThisObject.TravelType = "Local";
        ThisObject.MNVQuote.IsLocalQuote = true;

        ThisObject.ShowTotalDistance = 0;
        ThisObject.PTDDurationDisplay = "";

        if (status === google.maps.DirectionsStatus.OK) {
          let LocalDistanceMaxMilesobj: any = configurations.filter(
            (x: any) => x.SystemConfigurationID == 7,
          )[0];

          let LocalDistanceMaxMiles = Number(LocalDistanceMaxMilesobj.Value);
          let l_strLatLngList = "";

          if (AdditionalStop.length === 0) {
            ThisObject.distance.DTP = Number(
              response.routes[0].legs[0].distance.value / 1600,
            );
            ThisObject.distance.DTPTimeStr =
              response.routes[0].legs[0].duration.text;
            ThisObject.distance.DTPTimeSeconds =
              response.routes[0].legs[0].duration.value;

            ThisObject.distance.PTD = Number(
              response.routes[0].legs[1].distance.value / 1600,
            );
            ThisObject.distance.PTDTimeStr =
              response.routes[0].legs[1].duration.text;
            ThisObject.distance.PTDTimeSeconds =
              response.routes[0].legs[1].duration.value;

            l_strLatLngList +=
              response.routes[0].legs[1].start_location.lat() +
              "," +
              response.routes[0].legs[1].start_location.lng();

            ThisObject.distance.DTD = Number(
              response.routes[0].legs[2].distance.value / 1600,
            );
            ThisObject.distance.DTDTimeStr =
              response.routes[0].legs[2].duration.text;
            ThisObject.distance.DTDTimeSeconds =
              response.routes[0].legs[2].duration.value;

            l_strLatLngList +=
              "#" +
              response.routes[0].legs[2].start_location.lat() +
              "," +
              response.routes[0].legs[2].start_location.lng();

            ThisObject.calculations.TotalDistance = (
              ThisObject.distance.DTP +
              ThisObject.distance.PTD +
              ThisObject.distance.DTD
            ).toFixed(2);

            ThisObject.ShowTotalDistance = ThisObject.distance.PTD.toFixed(2); //only for show on front end
          } else {
            //Depo To Pickup
            ThisObject.distance.DTP = Number(
              response.routes[0].legs[0].distance.value / 1600,
            );
            ThisObject.distance.DTPTimeStr =
              response.routes[0].legs[0].duration.text;
            ThisObject.distance.DTPTimeSeconds = Number(
              response.routes[0].legs[0].duration.value,
            );

            // Pickup To Depo

            ThisObject.distance.PTD = Number(
              response.routes[0].legs[1].distance.value / 1600,
            );
            ThisObject.distance.PTDTimeStr =
              response.routes[0].legs[1].duration.text;
            ThisObject.distance.PTDTimeSeconds =
              response.routes[0].legs[1].duration.value;

            l_strLatLngList +=
              response.routes[0].legs[1].start_location.lat() +
              "," +
              response.routes[0].legs[1].start_location.lng();

            DTPMiles = 0;
            DTPSeconds = 0;
            let index = 0;
            for (var i = 1; i <= AdditionalStop.length; i++) {
              if (AdditionalStop[i - 1].PostCode != "") {
                //between stops
                index++;
                DTPMiles += Number(
                  response.routes[0].legs[i + 1].distance.value / 1600,
                );
                DTPSeconds += response.routes[0].legs[i + 1].duration.value;

                l_strLatLngList +=
                  "#" +
                  response.routes[0].legs[i + 1].start_location.lat() +
                  "," +
                  response.routes[0].legs[i + 1].start_location.lng();

                if (IsCongestionsCharged(AdditionalStop[i - 1].PostCode)) {
                  ThisObject.IsCongestion = true;
                }

                AdditionalStop[i - 1].DistanceInMiles = Number(
                  response.routes[0].legs[i + 1].distance.value / 1600,
                );
                AdditionalStop[i - 1].TimeInSeconds =
                  response.routes[0].legs[i + 1].duration.value;
              }
            }

            ThisObject.distance.PTD = ThisObject.distance.PTD + DTPMiles;

            ThisObject.distance.PTDTimeSeconds =
              ThisObject.distance.PTDTimeSeconds + DTPSeconds;

            ThisObject.distance.DTD = Number(
              response.routes[0].legs[index + 2].distance.value / 1600,
            );
            ThisObject.distance.DTDTimeStr =
              response.routes[0].legs[index + 2].duration.text;
            ThisObject.distance.DTDTimeSeconds = Number(
              response.routes[0].legs[index + 2].duration.value,
            );

            l_strLatLngList +=
              "#" +
              response.routes[0].legs[index + 2].start_location.lat() +
              "," +
              response.routes[0].legs[index + 2].start_location.lng();

            ThisObject.calculations.TotalDistance = Number(
              ThisObject.distance.DTP +
                ThisObject.distance.PTD +
                ThisObject.distance.DTD,
            ).toFixed(2);
            ThisObject.ShowTotalDistance = Number(
              ThisObject.distance.PTD + DTPMiles,
            ).toFixed(2); //only for show on front end

            setInfo((prev: any) => ({
              ...prev,
              AdditionalStop: AdditionalStop,
            }));
          }

          ThisObject.MNVQuote.LatLngList = l_strLatLngList;

          setDistance(ThisObject.distance);
          setcalculations(ThisObject.calculations);
          setMNVQuote(ThisObject.MNVQuote);
          setTravelType(ThisObject.TravelType);

          CalculateDistanceToCheckLocalLongQuoteBasedOnAddress(ThisObject);
        } else {
          console.log("Route not found response " + JSON.stringify(response));
        }
      },
    );
  }

  function CalculateDistanceToCheckLocalLongQuoteBasedOnAddress(
    ThisObject: any,
  ) {
    const directionsService = new google.maps.DirectionsService();
    var waypts: google.maps.DirectionsWaypoint[] = [];

    let SystemConfigurationobj: any = configurations.filter(
      (x: any) => x.SystemConfigurationID == 13,
    )[0];

    var Base = SystemConfigurationobj.Value;

    waypts = [];
    waypts.push(
      {
        location:
          info.FromPostalCode + " " + info.FromAddress + " " + info.FromCity,
        stopover: true,
      },
      {
        location: info.ToPostalCode + " " + info.ToAddress + " " + info.ToCity,
        stopover: true,
      },
    );

    let AdditionalStop = [...info.AdditionalStop] as any;

    if (AdditionalStop.length > 0) {
      waypts = [];
      waypts.push({
        location:
          info.FromPostalCode + " " + info.FromAddress + " " + info.FromCity,
        stopover: true,
      });
      for (var i = 0; i < AdditionalStop.length; i++) {
        if (AdditionalStop[i].PostCode != "") {
          waypts.push({
            location:
              AdditionalStop[i].PostCode + " " + info.Address + " " + info.City,
            stopover: true,
          });
        }
      }
      waypts.push({
        location: info.ToPostalCode + " " + info.ToAddress + " " + info.ToCity,
        stopover: true,
      });
    }

    directionsService.route(
      {
        origin: Base,
        destination: Base,
        travelMode: google.maps.TravelMode.DRIVING,
        waypoints: waypts,
        avoidTolls: true,
        unitSystem: google.maps.UnitSystem.IMPERIAL,
      },
      function (response: any, status) {
        if (status === google.maps.DirectionsStatus.OK) {
          let LocalDistanceMaxMilesobj: any = configurations.filter(
            (x: any) => x.SystemConfigurationID == 7,
          )[0];

          let LocalDistanceMaxMiles = Number(LocalDistanceMaxMilesobj.Value);

          let IsLocalQuote = true;

          if (response.routes[0].legs && response.routes[0].legs.length > 0) {
            for (var i = 0; i < response.routes[0].legs.length; i++) {
              var distance = Number(
                response.routes[0].legs[i].distance.value / 1600,
              );
              if (distance > LocalDistanceMaxMiles) {
                ThisObject.TravelType = "Long";
                ThisObject.MNVQuote.IsLocalQuote = false;

                setMNVQuote(ThisObject.MNVQuote);
                setTravelType(ThisObject.TravelType);
                break;
              }
            }
          }
          //props.setCalculateDistanceObject(ThisObject);
        } else {
          //console.log("Route not found response " + JSON.stringify(response));
        }
      },
    );
  }
  //#endregion Distance Calculations

  //#region Logs Data
  const [quoteDetailedLogs, setQuoteDetailedLogs] = useState<any>(null);
  const [showLogModal, setShowLogModal] = useState(false);
  const [modalContentType, setModalContentType] = useState<
    "simple" | "detailed"
  >("simple");

  function RefreshLogsData() {
    setTimeout(() => {
      LoadLogsData();
    }, 4000);
  }

  const ClearLogsFilters = (loadData: number) => {
    setLogFilters((prev: any) => ({
      ...prev,
      LogSelectedIndex: 0,
      MNVQuoteID: -1,
      TypeIDs: 0,
      StartDate: "",
      EndDate: "",
      ShowChangesOnly: 1,
      LoadingDetails: false,
      LoadDetailsPID: 0,
      LoadDetailsObject: {},
    }));

    if (loadData == 1) {
      LoadLogsData();
    }
  };

  function LoadLogsData() {
    setIsAnimation(true); // optional loader

    const data = {
      MNVJobID: GetMainJobID(), // your existing function
      MNVQuoteID: LogFilters.MNVQuoteID,
      TypeIDs: LogFilters.TypeIDs == 0 ? "" : LogFilters.TypeIDs,
      StartDate: LogFilters.StartDate,
      EndDate: LogFilters.EndDate,
    };

    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuoteAdmin/GetQuoteLogsV2", data)
      .then((response) => {
        const result = response.data;
        setQuoteLogs(result[0]); // React state
        setQuoteLogTypes(result[1]); // React state
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  const openLogsDetailsPopup = (MNVJobActivityLogID: number, Index: number) => {
    setLogFilters((prev: any) => ({ ...prev, LogSelectedIndex: Index }));

    const selectedLog = QuoteLogs[Index];

    if (selectedLog.ShowMoreDetails == 1) {
      // Load detailed data
      setLogFilters((prev: any) => ({
        ...prev,
        LoadingDetails: true,
        LoadDetailsPID: MNVJobActivityLogID,
      }));

      loadLogsDetailsData(MNVJobActivityLogID);

      setLogFilters((prev: any) => ({
        ...prev,
        LoadDetailsObject:
          QuoteLogs.find(
            (log) => log.MNVJobActivityLogID == MNVJobActivityLogID,
          ) || null,
      }));

      setModalContentType("detailed");
    } else {
      setModalContentType("simple");
    }

    setShowLogModal(true);
  };

  const loadLogsDetailsData = async (MNVJobActivityLogID: number) => {
    try {
      const { data } = await axiosAuth.post(
        AppContext.APIURL + "api/MNVQuoteAdmin/GetQuoteLogsDetails",
        {
          MNVJobActivityLogID,
        },
      );

      setQuoteDetailedLogs(data[0]);
      setLogFilters((prev: any) => ({
        ...prev,
        LoadingDetails: false,
        ShowChangesOnly: 1,
      }));
      // Call any additional function here if needed
      MakeQouteChangesSectionVisibility(data[0]);
    } catch (error) {
      console.error(error);
      setLogFilters((prev: any) => ({ ...prev, LoadingDetails: false }));
    }
  };

  function MakeQouteChangesSectionVisibility(p_QuoteDetailedLogs: any[]) {
    let QuoteDetailedLogs = [...p_QuoteDetailedLogs];
    if (QuoteDetailedLogs.length == 2) {
      for (var i = 0; i < QuoteDetailedLogs.length; i++) {
        if (
          QuoteDetailedLogs[0].ClientName != QuoteDetailedLogs[1].ClientName
        ) {
          QuoteDetailedLogs[0].ShowClientDetails = true;
        }

        if (
          QuoteDetailedLogs[0].FromPostalCode !=
            QuoteDetailedLogs[1].FromPostalCode ||
          QuoteDetailedLogs[0].FromAddress !=
            QuoteDetailedLogs[1].FromAddress ||
          QuoteDetailedLogs[0].FromCity != QuoteDetailedLogs[1].FromCity ||
          QuoteDetailedLogs[0].FromType != QuoteDetailedLogs[1].FromType ||
          QuoteDetailedLogs[0].FromFloorText !=
            QuoteDetailedLogs[1].FromFloorText ||
          QuoteDetailedLogs[0].FromLiftAvailable !=
            QuoteDetailedLogs[1].FromLiftAvailable
        ) {
          QuoteDetailedLogs[0].ShowCollectionPoint = true;
        }

        if (
          QuoteDetailedLogs[0].ToPostalCode !=
            QuoteDetailedLogs[1].ToPostalCode ||
          QuoteDetailedLogs[0].ToAddress != QuoteDetailedLogs[1].ToAddress ||
          QuoteDetailedLogs[0].ToCity != QuoteDetailedLogs[1].ToCity ||
          QuoteDetailedLogs[0].ToType != QuoteDetailedLogs[1].ToType ||
          QuoteDetailedLogs[0].ToFloorText !=
            QuoteDetailedLogs[1].ToFloorText ||
          QuoteDetailedLogs[0].ToLiftAvailable !=
            QuoteDetailedLogs[1].ToLiftAvailable
        ) {
          QuoteDetailedLogs[0].ShowDeliveryPoint = true;
        }

        if (
          QuoteDetailedLogs[0].ServiceName != QuoteDetailedLogs[1].ServiceName
        ) {
          QuoteDetailedLogs[0].ShowServiceName = true;
        }

        if (
          QuoteDetailedLogs[0].VanAndMoversDetails !=
            QuoteDetailedLogs[1].VanAndMoversDetails ||
          QuoteDetailedLogs[0].QuoteStatus !=
            QuoteDetailedLogs[1].QuoteStatus ||
          QuoteDetailedLogs[0].IsLocalQuoteText !=
            QuoteDetailedLogs[1].IsLocalQuoteText ||
          (QuoteDetailedLogs[1].IsLocalQuote &&
            QuoteDetailedLogs[0].RequiredVanTimeText !=
              QuoteDetailedLogs[1].RequiredVanTimeText) ||
          (!QuoteDetailedLogs[1].IsLocalQuote &&
            QuoteDetailedLogs[0].LoadingUnLoadingTimeInMinutes !=
              QuoteDetailedLogs[1].LoadingUnLoadingTimeInMinutes) ||
          (!QuoteDetailedLogs[1].IsLocalQuote &&
            QuoteDetailedLogs[0].LoadingTime !=
              QuoteDetailedLogs[1].LoadingTime) ||
          (!QuoteDetailedLogs[1].IsLocalQuote &&
            QuoteDetailedLogs[0].UnloadingTime !=
              QuoteDetailedLogs[1].UnloadingTime) ||
          QuoteDetailedLogs[0].RequestedDate !=
            QuoteDetailedLogs[1].RequestedDate ||
          QuoteDetailedLogs[0].RequestedTime !=
            QuoteDetailedLogs[1].RequestedTime ||
          QuoteDetailedLogs[0].Duration != QuoteDetailedLogs[1].Duration ||
          QuoteDetailedLogs[0].TotalDistance !=
            QuoteDetailedLogs[1].TotalDistance ||
          QuoteDetailedLogs[0].ClientInstructions !=
            QuoteDetailedLogs[1].ClientInstructions ||
          QuoteDetailedLogs[0].FromFloor != QuoteDetailedLogs[1].FromFloor
        ) {
          QuoteDetailedLogs[0].ShowQuoteDetail = true;
        }

        if (
          QuoteDetailedLogs[0].IncludeInsurance !=
            QuoteDetailedLogs[1].IncludeInsurance ||
          QuoteDetailedLogs[0].ValueOfGoods !=
            QuoteDetailedLogs[1].ValueOfGoods ||
          QuoteDetailedLogs[0].FullName != QuoteDetailedLogs[1].FullName ||
          QuoteDetailedLogs[0].Initials != QuoteDetailedLogs[1].Initials
        ) {
          QuoteDetailedLogs[0].ShowInsurance = true;
        }

        if (
          QuoteDetailedLogs[0].InitialAmount !=
            QuoteDetailedLogs[1].InitialAmount ||
          QuoteDetailedLogs[0].Discount != QuoteDetailedLogs[1].Discount ||
          QuoteDetailedLogs[0].PayableAmount !=
            QuoteDetailedLogs[1].PayableAmount
        ) {
          QuoteDetailedLogs[0].ShowQuoteAmountDetails = true;
        }
      }
      setQuoteDetailedLogs(QuoteDetailedLogs);
    }
  }

  //#endregion Logs Data

  //#region Storage
  const [IsStorageOkToGoLive, setIsStorageOkToGoLive] = useState(true);
  const [IsStorageType, setIsStorageType] = useState(false);

  const [StorageList, setStorageList] = useState<any>([]);
  const [StoragePrice, setStoragePrice] = useState([]);
  const [StorageData, setStorageData] = useState<any>([]);
  const [FuturePaymentData, setFuturePaymentData] = useState([]);

  const [StoragePriceObject, setStoragePriceObject] = useState({
    PID: 0,
    mnvstoragepriceid: 0,
    mnvquotefuturepaymentid: 0,
    mnvquotestoragedataid: 0,
    paymentpaiduntil: "",
    AddBespoke: false,
    AddFuturePayment: false,
    pricepersqft: -1,
    areasquarefeet: 0,
    ratepercentageweekly: 0,
    ratepercentagemonthly: 0,
    Title: "",
    Amount: 0,
    Date: "",
    RepeatType: 0,
    RepeatStartFrom: "",
    RepeatUntil: "",
    PaymentPaidUntil: "",
  });

  const [PreFillData, setPreFillData] = useState({
    Type: 1,
    Title: "",
    RefID: "",
    Amount: 0,
    Note: "",
    HideOnInvoice: false,
    PTPaymentInvoiceLineItemID: 0,
    ObjectType: 0,
  });

  const [isPaidUnitChanged, setIsPaidUnitChanged] = useState(false);

  useEffect(() => {
    if (QuoteId && QuoteId > 0 && IsStorageType) {
      MNVQuoteStorageAndFuturePaymentGetCompleteGridDataCustom(true);
      MNVAddressUnitGetCompleteGridDataCustom();
    }
  }, [QuoteId, IsStorageType]);

  useEffect(() => {
    if (QuoteId && QuoteId > 0) {
      GetSelectPricePerSQFTFromPID();
      MNVQuoteStorageDataSave();
    }
  }, [StorageList, StoragePriceObject.PID]);

  useEffect(() => {
    if (QuoteId && QuoteId > 0 && isPaidUnitChanged) {
      setIsPaidUnitChanged(false);
      MNVQuoteStorageDataSave();
    }
  }, [isPaidUnitChanged]);

  // ----------------------------------------
  // ADD LINE ITEM
  // ----------------------------------------

  const addLineItem = (Item: any) => {
    setStoragePriceObject((p) => ({
      ...p,
      mnvstoragepriceid: Item.MNVStoragePriceID,
      areasquarefeet: Item.AreaSquareFeet,
      ratepercentageweekly: Item.RatePercentageWeekly,
      ratepercentagemonthly: Item.RatePercentageMonthly,
    }));

    setPreFillData({
      Title: "Storage Charges - 1st Payment",
      RefID: "Storage Charges",
      Amount: Item.ClientPricePerMonthWithoutVAT,
      Note: "",
      HideOnInvoice: false,
      ObjectType: 0,
      PTPaymentInvoiceLineItemID: 0,
      Type: 1,
    });

    StoragePriceObject.mnvstoragepriceid = Item.MNVStoragePriceID;

    StoragePriceObject.areasquarefeet = Item.AreaSquareFeet;
    StoragePriceObject.ratepercentageweekly = Item.RatePercentageWeekly;
    StoragePriceObject.ratepercentagemonthly = Item.RatePercentageMonthly;

    PreFillData.Title = "Storage Charges - 1st Payment";
    PreFillData.RefID = "Storage Charges";
    PreFillData.Amount = Item.ClientPricePerMonthWithoutVAT;

    MNVQuoteStorageDataSave();
  };

  // ----------------------------------------
  // STORAGE LIST LOAD
  // ----------------------------------------
  function MNVAddressUnitGetCompleteGridDataCustom() {
    setIsAnimation(true);

    const data = {};

    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/MNVAddressUnitGetCompleteGridDataCustom",
        data,
      )
      .then((response) => {
        const l_arrResponse = response.data.Data[1];
        setStorageList(l_arrResponse); // React state setter
        setIsAnimation(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setIsAnimation(false);
      });
  }

  // ----------------------------------------
  // GET PRICE PER SQFT
  // ----------------------------------------

  const GetSelectPricePerSQFTFromPID = () => {
    const item: any = StorageList.find(
      (x: any) => x.PID == StoragePriceObject.PID,
    );
    if (item) {
      setStoragePriceObject((p) => ({
        ...p,
        pricepersqft: item.SelectPricePerSQFT,
      }));
      MNVStoragePriceGetCompleteGridDataCustom(item.SelectPricePerSQFT);
    }
  };

  // ----------------------------------------
  // STORAGE PRICE GRID
  // ----------------------------------------

  const MNVStoragePriceGetCompleteGridDataCustom = (price: any) => {
    const data = {
      pricepersqft: price ?? StoragePriceObject.pricepersqft,
      areasquarefeet: StoragePriceObject.areasquarefeet,
      ratepercentageweekly: StoragePriceObject.ratepercentageweekly,
      ratepercentagemonthly: StoragePriceObject.ratepercentagemonthly,
    };

    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/MNVStoragePriceGetCompleteGridDataCustom",
        data,
      )
      .then((res) => {
        setStoragePrice(res.data[0]);
      });
  };

  // ----------------------------------------
  // SAVE STORAGE DATA
  // ----------------------------------------

  const MNVQuoteStorageDataSave = () => {
    const data = {
      mnvquotestoragedataid: StoragePriceObject.mnvquotestoragedataid,
      mnvquoteid: QuoteId,
      mnvaddressunitid: StoragePriceObject.PID,
      mnvstoragepriceid: StoragePriceObject.mnvstoragepriceid,
      areasquarefeet: StoragePriceObject.areasquarefeet,
      ratepercentageweekly: StoragePriceObject.ratepercentageweekly,
      ratepercentagemonthly: StoragePriceObject.ratepercentagemonthly,
      paymentpaiduntil: StoragePriceObject.paymentpaiduntil,
      objecttype: 1,
      ObjectID: 1,
    };

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/MNVQuoteStorageDataSave",
        data,
      )
      .then(() => {
        setStoragePriceObject((p) => ({
          ...p,
          mnvquotefuturepaymentid: 0,
          mnvstoragepriceid: 0,
        }));
        MNVQuoteStorageAndFuturePaymentGetCompleteGridDataCustom(false);
      });
  };

  // ----------------------------------------
  // SAVE FUTURE PAYMENT
  // ----------------------------------------

  const MNVQuoteFuturePaymentSave = () => {
    if (StoragePriceObject.Title !== "" && StoragePriceObject.Amount > 0) {
      const data = {
        mnvquotefuturepaymentid: StoragePriceObject.mnvquotefuturepaymentid,
        title: StoragePriceObject.Title,
        totalamount: StoragePriceObject.Amount,
        paymentdate: StoragePriceObject.Date || null,
        repeattype: StoragePriceObject.RepeatType || 0,
        repeatstartfrom: StoragePriceObject.RepeatStartFrom || null,
        repeatuntil: StoragePriceObject.RepeatUntil || null,
        paymentpaiduntil: StoragePriceObject.PaymentPaidUntil || null,
        mnvquoteid: QuoteId,
        objecttype: 1,
        ObjectID: 1,
      };

      axiosAuth
        .post(
          AppContext.APIURL + "api/MNVQuoteAdmin/MNVQuoteFuturePaymentSave",
          data,
        )
        .then(() => {
          clearAddFuturePayments();
          MNVQuoteStorageAndFuturePaymentGetCompleteGridDataCustom(false);
        });
    } else {
      showErrorMessage("Title and Amount is required.");
    }
  };

  // ----------------------------------------
  // GET STORAGE + FUTURE PAYMENT
  // ----------------------------------------

  const MNVQuoteStorageAndFuturePaymentGetCompleteGridDataCustom = (
    IsFirstTime: any,
  ) => {
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/MNVQuoteStorageAndFuturePaymentGetCompleteGridDataCustom",
        {
          mnvquoteid: QuoteId,
        },
      )
      .then((res) => {
        const storage = res.data[0];
        const future = res.data[1];

        setStorageData(storage);
        setFuturePaymentData(future);

        if (storage?.length > 0) {
          const s = storage[0];
          setStoragePriceObject((prev) => ({
            ...prev,
            mnvquotestoragedataid: s.MNVQuoteStorageDataID,
            PID: s.MNVAddressUnitID,
            mnvstoragepriceid: s.MNVStoragePriceID,
            paymentpaiduntil: s.PaymentPaidUntil,
            ratepercentageweekly: s.RatePercentageWeekly,
            ratepercentagemonthly: s.RatePercentageMonthly,
            areasquarefeet: s.AreaSquareFeet,
            AddBespoke: s.MNVStoragePriceID == 10000001,
          }));
        }

        if (IsFirstTime) GetSelectPricePerSQFTFromPID();
      });
  };

  // ----------------------------------------
  // EDIT FUTURE PAYMENT
  // ----------------------------------------

  const EditFuturePaymentData = (item: any) => {
    setStoragePriceObject((p) => ({
      ...p,
      mnvquotefuturepaymentid: item.MNVQuoteFuturePaymentID,
      Title: item.Title,
      Amount: item.TotalAmount,
      Date: item.PaymentDate,
      RepeatType: item.RepeatType,
      RepeatUntil: item.RepeatUntil,
      RepeatStartFrom: item.RepeatStartFrom,
      PaymentPaidUntil: item.PaymentPaidUntil,
      AddFuturePayment: true,
    }));
  };

  // ----------------------------------------
  // DELETE PAYMENT
  // ----------------------------------------

  const DeleteFuturePaymentData = (ID: any) => {
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/MNVQuoteFuturePaymentDeleteRecord",
        {
          mnvquotefuturepaymentid: ID,
        },
      )
      .then(() => {
        MNVQuoteStorageAndFuturePaymentGetCompleteGridDataCustom(false);
      });
  };

  // ----------------------------------------
  // CLEAR OBJECTS
  // ----------------------------------------

  const clearObject = () => {
    setStoragePriceObject((p) => ({
      ...p,
      AddBespoke: false,
      areasquarefeet: 0,
      ratepercentageweekly: 0,
      ratepercentagemonthly: 0,
    }));
  };

  const clearAddFuturePayments = () => {
    setStoragePriceObject((p) => ({
      ...p,
      AddFuturePayment: !p.AddFuturePayment,
      mnvquotefuturepaymentid: 0,
      Title: "",
      Amount: 0,
      Date: "",
      RepeatType: 0,
      RepeatUntil: "",
      RepeatStartFrom: "",
      PaymentPaidUntil: "",
    }));
  };

  function ClosePopupAndLoadLineItem(p_oValue: any) {
    setQuoteLoadingTime(addMinutes(new Date(), 0.016 * 2));
    GetInvoiceDataByQuoteID(1);
    setShowLineItemModal(false);
  }

  function OpenLineItemsPopupForJob(content: any, Type: any, calledFrom: any) {
    if (calledFrom != 1) {
      PreFillData.Type = 1;
      PreFillData.Title = "";
      PreFillData.RefID = "";
      PreFillData.Amount = 0;
      PreFillData.Note = "";
      PreFillData.HideOnInvoice = false;
      PreFillData.PTPaymentInvoiceLineItemID = 0;
      PreFillData.ObjectType = 0;
    }

    // LineItemType = Type;
    setShowLineItemModal(true);
  }

  function EditLineItem(item: any) {
    PreFillData.Title = item.Title;
    PreFillData.Type = item.TransactionType;
    PreFillData.RefID = item.RefferenceNumber;
    PreFillData.Amount = item.Amount;
    PreFillData.Note = item.Notes;
    PreFillData.HideOnInvoice = item.Description == "True" ? true : false;
    PreFillData.PTPaymentInvoiceLineItemID = item.PTPaymentInvoiceLineItemID;
    PreFillData.ObjectType = item.ObjectType;
    setShowLineItemModal(true);
  }

  //#endregion Storage

  //#region Action Buttons
  const MNVQuoteUpdateOrderForService = (
    MNVQuoteID: number,
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const NewPosition = parseInt(event.target.value);

    if (NewPosition <= 0 || !NewPosition) {
      showErrorMessage("Please enter position greater than 0.");
      return;
    }

    if (NewPosition > AllLinkedQuotes.length) {
      showErrorMessage("Position can not be greater than total services.");
      return;
    }

    const data: any = {};
    data.MNVQuoteID = MNVQuoteID;
    data.NewPosition = NewPosition;

    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/MNVQuoteUpdateOrderForService",
        data,
      )
      .then((response) => {
        setIsAnimation(false);

        const l_oResponse = response.data?.[0];

        LoadAllQuotesLinkedToThisJob(JobRelatedData.MNVJobID, 0, 1, 0);
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  const updateServiceName = (
    MNVQuoteID: number,
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const Name = event.target.value;

    if (Name == "" || !Name) {
      showErrorMessage("Service name can't be empty.");
      return;
    }

    const data: any = {};
    data.MNVQuoteID = MNVQuoteID;
    data.ServiceName = Name;

    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/MNVQuoteUpdateNameForService",
        data,
      )
      .then((response) => {
        setIsAnimation(false);
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  const DeleteLineItemDB = (PTPaymentInvoiceLineItemID: number) => {
    const data: any = {};
    data.QuoteID = GetMainJobID();
    data.MNVServiceID = QuoteId;
    data.PTPaymentInvoiceLineItemID = PTPaymentInvoiceLineItemID;
    setIsAnimation(true);

    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuoteAdmin/AjaxDeleteLineItem", data)
      .then((response) => {
        setIsAnimation(false);

        const l_arrResponse = response.data?.[0]?.[0];

        if (l_arrResponse?.Status == 1) {
          GetInvoiceDataByQuoteID(1);
          showSuccessMessage("Line item has been deleted successfully.");
        } else {
          showErrorMessage(l_arrResponse?.Message);
        }
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  const ChangeStatusForQuoteOrAllQuotesInOneJob = (
    MNVQuoteID: number,
    MNVQuoteStatusID: number,
  ) => {
    const data: any = {};
    data.MNVJobID = GetMainJobID();
    data.MNVQuoteID = MNVQuoteID;
    data.MNVQuoteStatusID = MNVQuoteStatusID;

    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/MNVQuoteChangeStatusForQuoteOrAllQuotesInOneJob",
        data,
      )
      .then((response) => {
        setIsAnimation(false);
        const l_oResponse = response.data?.[0];

        if (l_oResponse?.[0]?.Status == 0) {
          showErrorMessage(l_oResponse[0]?.Message);
        } else {
          showSuccessMessage("Status has been changed.");
          MNVQuoteGetRecordForEdit(QuoteId);
        }
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  function SendTrustPilotEmail() {
    setConfirmationModalObject({
      ShowPopup: true,
      Heading: "Alert",
      Message: "Are you sure you want to send the email?",
      ID: 20,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  const AjaxSendTrustPilotEmail = () => {
    const data: any = {};
    data.MNVJobID = GetMainJobID();

    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/AjaxSendTrustPilotEmail",
        data,
      )
      .then((response) => {
        setIsAnimation(false);

        const l_arrResponse = response.data?.[0]?.[0];

        if (l_arrResponse?.Status == 1) {
          showSuccessMessage("Email has been sent.");

          setTrustPilotEmail(false); // replaces this.TrustPilotEmail = false
          RefreshLogsData();
        } else {
          showErrorMessage(l_arrResponse?.Message);
        }
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  function GenerateInvoice() {
    setConfirmationModalObject({
      ShowPopup: true,
      Heading: "Alert",
      Message: "Are you sure you want to generate this invoice?",
      ID: 21,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  const AjaxGenerateInvoice = () => {
    const data: any = {};
    data.MNVJoID = GetMainJobID();

    setIsAnimation(true);

    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuoteAdmin/AjaxGenerateInvoice", data)
      .then((response) => {
        setIsAnimation(false);

        const l_arrResponse = response.data?.[0]?.[0];

        if (l_arrResponse?.Status == 1) {
          LineItemsAmounts.PendingLineItemCount = 0;
          GetInvoiceDataByQuoteID();
          showSuccessMessage("Invoice has been generated successfully.");
        } else {
          showErrorMessage(l_arrResponse?.Message);
        }
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  function SendQuotationStatusChangeEmail(TypeID: any) {
    var Message = "Are you sure you want to send Booking Cancellation email?";
    if (TypeID == 21)
      Message = "Are you sure you want to send Booking Rescheduling email?";
    if (TypeID == 4)
      Message = "Are you sure you want to send Booking Confirmation email?";

    setConfirmationModalObject({
      ShowPopup: true,
      Heading: "Alert",
      Message: Message,
      ID: 22,
      SelectedID: TypeID,
      OtherID: 0,
    });
  }

  const AjaxSendQuotationStatusChangeEmail = (TypeID: any) => {
    const data: any = {};
    data.TypeID = TypeID;
    data.MNVQuoteID = QuoteId;

    if (TypeID == 21 || TypeID == 4) {
      data.MNVQuoteID = GetMainJobID();
    }

    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteAdmin/AjaxSendQuotationStatusChangeEmail",
        data,
      )
      .then((response) => {
        setIsAnimation(false);

        const StatusData = response.data?.[0];

        if (StatusData?.Status == 1) {
          showSuccessMessage(StatusData.Message);

          RefreshLogsData();
        } else {
          showErrorMessage(StatusData.Message);
        }
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  function SendQuotationLinkEmail(IsBankTransfer: any) {
    setConfirmationModalObject({
      ShowPopup: true,
      Heading: "Alert",
      Message:
        "Are you sure you want to send quotation link via email and SMS?",
      ID: 23,
      SelectedID: IsBankTransfer,
      OtherID: 0,
    });
  }

  const AjaxSendQuotationLinkEmail = (Type: any, IsBankTransfer: any) => {
    const data: any = {};
    data.MNVJobID = GetMainJobID();
    data.Type = Type;
    data.IsBankTransfer = IsBankTransfer;
    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/SendQuotationLinkEmail",
        data,
      )
      .then((response) => {
        setIsAnimation(false);

        const StatusData = response.data?.[0];

        if (StatusData?.Status == 1) {
          showSuccessMessage(StatusData.Message);

          RefreshLogsData();
        } else {
          showErrorMessage(StatusData.Message);
        }
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  const GetQuotationLinkForCopy = (IsBankTransfer: any) => {
    const data: any = {};
    data.MNVJobID = GetMainJobID();
    data.IsBankTransfer = IsBankTransfer;

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/GetQuotationLinkForCopy",
        data,
      )
      .then((response) => {
        const StatusData = response.data?.[0];

        if (StatusData?.Status == 1) {
          const quoteURL = StatusData.LinkURL;
          copyToclipBoard(quoteURL);
          showSuccessMessage("Copied to clipboard");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  function copyToclipBoard(linkToCopy: any) {
    navigator.clipboard
      .writeText(linkToCopy)
      .then(function () {})
      .catch(function (err) {
        console.error("Could not copy text: ", err);
      });
  }

  function SendConfirmationEmail() {
    setConfirmationModalObject({
      ShowPopup: true,
      Heading: "Alert",
      Message: "Are you sure you want to send confirmation email?",
      ID: 24,
      SelectedID: 0,
      OtherID: 0,
    });
  }

  const AjaxSendConfirmationEmail = () => {
    const data: any = {};
    data.MNVQuoteID = QuoteId;
    data.MNVJobID = GetMainJobID();
    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/SendQuoteConfirmationEmail",
        data,
      )
      .then((response) => {
        setIsAnimation(false);

        const StatusData = response.data?.[0];

        if (StatusData?.Status == 1) {
          showSuccessMessage(StatusData.Message);

          RefreshLogsData();
        } else {
          showErrorMessage(StatusData.Message);
        }
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  function TakeOrRefundAmount(p_intType: any) {
    var Message = "Are you sure you want to go for this refund";
    if (p_intType == 1) {
      Message = "Are you sure you want to go for this charge";
    }

    setConfirmationModalObject({
      ShowPopup: true,
      Heading: "Alert",
      Message: Message,
      ID: 25,
      SelectedID: p_intType,
      OtherID: 0,
    });
  }

  function DeleteLineItem(PTPaymentInvoiceLineItemID: number) {
    let Message = "You won't be able to revert this!";

    setConfirmationModalObject({
      ShowPopup: true,
      Heading: "Are you sure?",
      Message: Message,
      ID: 27,
      SelectedID: PTPaymentInvoiceLineItemID,
      OtherID: 0,
    });
  }

  function AjaxTakeOrRefundAmount(p_intType: any) {
    if (p_intType == -1) RefundQuoteExtraPayment(p_intType);
    else if (p_intType == 0) RefundQuoteExtraPayment(p_intType);
    else if (p_intType == 1) TakeQuoteExtraPayment();
  }

  const RefundQuoteExtraPayment = (p_intType: number) => {
    const data: any = {};
    data.MNVQuoteID = QuoteId;
    data.MNVJobID = GetMainJobID();
    data.Type = p_intType;
    data.Balance = Math.abs(calculations.Balance);
    data.RefundMessage = "";

    if (p_intType == -1) data.RefundMessage = "Manual Refund";

    setIsAnimation(true);

    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteAdmin/RefundQuoteExtraPayment",
        data,
      )
      .then((response) => {
        setIsAnimation(false);

        const l_arrResponse = response.data?.[0];

        if (l_arrResponse?.Status == 1) {
          GetInvoiceDataByQuoteID();
          showSuccessMessage("Refund has been made successfully");
        } else {
          showErrorMessage(l_arrResponse?.Message);
        }
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  const TakeQuoteExtraPayment = () => {
    const data: any = {};
    data.MNVJoID = GetMainJobID();
    data.MNVQuoteID = QuoteId;
    data.Balance = calculations.Balance;

    setIsAnimation(true);

    axiosAuth
      .post(AppContext.APIURL + "api/MNVQuoteAdmin/TakeQuoteExtraPayment", data)
      .then((response) => {
        setIsAnimation(false);

        const l_arrResponse = response.data?.[0];

        if (l_arrResponse?.Status == 1) {
          if (l_arrResponse.RequiredAction) {
            showInfoMessage(
              "The card was declined. This transaction requires further authentication.",
            );
          } else {
            if (
              MNVQuote.MNVQuoteStatusID == 0 ||
              MNVQuote.MNVQuoteStatusID == 6
            )
              MNVQuote.MNVQuoteStatusID = 1;

            GetInvoiceDataByQuoteID();
            showSuccessMessage("Payment has been taken successfully");
          }
        } else {
          if (l_arrResponse.RequiredAction) {
            showInfoMessage(
              "The card was declined. This transaction requires further authentication.",
            );
          } else {
            showErrorMessage(l_arrResponse?.Message);
          }
        }
      })
      .catch((error) => {
        setIsAnimation(false);
        console.error(error);
      });
  };

  function OpenSendPaymentLinkPopup() {
    setClientData((prev: any) => ({
      ...prev,
      EnteredEmailAddress: ClientData.EmailAddress,
      EnteredMobile: ClientData.Mobile,
    }));

    setMNVQuote({
      ...MNVQuote,
      LineItemType: 0,
    });
    setShowSendPaymentLink(true);
  }

  const SendPaymentLink = (TypeID: number) => {
    const client = ClientData;
    const balance = LineItemsAmounts.Balance;

    // Validate input
    if (
      (TypeID == 1 && client.EmailAddress !== "") ||
      (TypeID == 2 && client.Mobile !== "") ||
      (TypeID == 3 && client.EmailAddress !== "" && client.Mobile !== "")
    ) {
      const data: any = {};
      data.MNVJobID = GetMainJobID();
      data.EmailAddress = client.EmailAddress;
      data.Mobile = client.Mobile;
      data.EnteredEmailAddress = client.EnteredEmailAddress;
      data.EnteredMobile = client.EnteredMobile;
      data.TypeID = TypeID;
      data.Amount = Number((balance / 1.2).toFixed(2));
      data.VAT = Number((balance - data.Amount).toFixed(2));

      setIsAnimation(true);

      axiosAuth
        .post(AppContext.APIURL + "api/MNVQuoteAdmin/SendPaymentLink", data)
        .then((response) => {
          setIsAnimation(false);

          const l_arrResponse = response.data[0][0];

          if (l_arrResponse.Status == 1) {
            showSuccessMessage("Link has been sent.");
          } else {
            showErrorMessage(l_arrResponse.Message);
          }
        })
        .catch((error) => {
          setIsAnimation(false);
          console.error(error);
        });
    } else {
      showErrorMessage("Please enter the valid mobile number and email.");
    }
  };

  function OpenConfirmationForLiabilityChanges() {
    if (infoBackup.ValueOfGoods != info.ValueOfGoods) {
      setShowLiabilityChangesPopup(true);
    }
  }

  function RevertLiabilityChanges() {
    let infoBackupLocal = { ...infoBackup };
    setInfo({
      ...info,
      ValueOfGoods: infoBackupLocal.ValueOfGoods,
    });
  }

  const [error, setError] = useState<any>({});
  const [paymentObject, setPaymentObject] = useState<any>({
    CardNumber: "",
    CardName: "",
    ExpMonth: "",
    ExpYear: "",
    CVV: "",
  });

  const handleChange = (field: any, value: string) => {
    setPaymentObject((prev: any) => ({ ...prev, [field]: value }));
  };

  function OpenLineItemsPopup() {
    setShowAddPaymentMethods(true);
  }

  const savePaymentMethod = () => {
    updateQuotePaymentMethod(
      QuoteId,
      paymentObject.CardName,
      paymentObject.CardNumber,
      paymentObject.ExpYear,
      paymentObject.ExpMonth,
      paymentObject.CVV,
    );
  };

  const updateQuotePaymentMethod = async (
    QuoteID: number,
    CardName: string,
    CardNumber: string,
    ExpYear: string,
    ExpMonth: string,
    CVV: string,
  ) => {
    let data = {
      MNVQuoteID: QuoteID,
      NameOnCard: CardName,
      CreditCard: CardNumber,
      Year: ExpYear,
      Month: ExpMonth,
      Cvv: CVV,
    };

    // Reset error states
    let newError = {
      CardName: true,
      CardNumber: true,
      ExpYear: true,
      ExpMonth: true,
      CVV: true,
    };

    let isOkay = true;

    if (!CardName) {
      newError.CardName = false;
      isOkay = false;
    }
    if (!CardNumber) {
      newError.CardNumber = false;
      isOkay = false;
    }
    if (!ExpYear) {
      newError.ExpYear = false;
      isOkay = false;
    }
    if (!ExpMonth) {
      newError.ExpMonth = false;
      isOkay = false;
    }
    if (!CVV) {
      newError.CVV = false;
      isOkay = false;
    }

    setError(newError);

    if (!isOkay) {
      showErrorMessage("All fields required");
      return;
    }

    try {
      // Show loader
      setIsAnimation(true);

      const response = await axiosAuth.post(
        AppContext.APIURL + "api/MNVQuoteAdmin/UpdateQuotePaymentMethod",
        data,
      );
      setIsAnimation(false);

      const l_arrResponse = response.data[0];
      if (l_arrResponse.Status == 1) {
        GetQuoteRelatedPaymentAccountDetails(QuoteID);
        setShowAddPaymentMethods(false);

        showSuccessMessage("Payment method has been updated successfully");
      } else {
        showErrorMessage(l_arrResponse.Message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  function ChangetoConfirmationQuote(status: any) {
    setConfirmationModalObject({
      ShowPopup: true,
      Heading: "Alert",
      Message: "Are you sure you want to change?",
      ID: 26,
      SelectedID: status,
      OtherID: 0,
    });
  }

  const [MoverQuoteID, setMoverQuoteID] = useState<any>(0);
  const [MoverMobile, setMoverMobile] = useState<any>("");
  const [MoverEmailAddress, setMoverEmailAddress] = useState<any>("");

  function OpenPopup(
    type: any,
    p_intTypeID = 0,
    p_strValue = "",
    p_intMNVQuoteID = 0,
  ) {
    setMoverQuoteID(QuoteId);
    if (p_intTypeID > 0) {
      if (p_intTypeID == 1) {
        setMoverEmailAddress(p_strValue);
      } else {
        setMoverMobile(p_strValue ? p_strValue : "");
        setMoverQuoteID(p_intMNVQuoteID);
      }
    } else {
      setMoverEmailAddress(selectedMovers.DriverEmail);
      setMoverMobile(
        selectedMovers.DriverMobile ? selectedMovers.DriverMobile : "",
      );
    }

    if (type == 1) {
      setEmailModal(true);
    }

    if (type == 2) {
      setSendWAModal(true);
    }
  }

  const sendEmailToMover = () => {
    if (MoverEmailAddress && MoverEmailAddress !== "") {
      if (isValidEmail(MoverEmailAddress)) {
        sendQuotationEmailToMover();
      } else {
        showErrorMessage("Please enter mover valid email address");
      }
    } else {
      showErrorMessage("Please enter mover email address");
    }
  };

  const sendQuotationEmailToMover = async () => {
    const data = {
      MNVQuoteID: MoverQuoteID,
      EmailAddress: MoverEmailAddress,
    };

    try {
      setIsAnimation(true);

      const response = await axiosAuth.post(
        AppContext.APIURL + "api/MNVQuoteAdmin/SendQuotationEmailToMover",
        data,
      );

      setIsAnimation(false);

      const statusData = response.data[0];

      if (statusData.Status === 1) {
        setEmailModal(true);
        showSuccessMessage(statusData.Message);
      } else {
        showErrorMessage(statusData.Message);
      }
    } catch (error) {
      setIsAnimation(false);
      console.error(error);
    }
  };

  const sendWhatsAppToMover = () => {
    if (MoverMobile && MoverMobile !== "") {
      ajaxSendJobDetailsToMovers();
    } else {
      showErrorMessage("Please enter mover valid Mobile Number.");
    }
  };

  const ajaxSendJobDetailsToMovers = async () => {
    const data: any = {
      MNVQuoteID: MoverQuoteID,
      MoverMobile: MoverMobile,
    };

    try {
      setIsAnimation(true);

      const response = await axiosAuth.post(
        AppContext.APIURL + "api/MNVQuoteAdmin/AjaxSendJobDetailsToMovers",
        data,
      );

      setIsAnimation(false);

      const statusData = response.data[0];

      if (statusData.Status === 1) {
        showSuccessMessage("Job Details sent to mover WhatsApp.");

        setSendWAModal(false);
      } else {
        showErrorMessage(statusData.Message);
      }
    } catch (error) {
      setIsAnimation(false);
      console.error(error);
    }
  };

  function ResponseFromPTUploader(data: any) {
    setPTFilesList(data.PTFilesList);
  }

  function ConfirmationModalCallBack(obj: any) {
    if (obj.ID == 1) {
      if (obj.isConfirm == true) {
        AddNew(QuoteId);
      } else {
        AddNew(0);
      }
    }

    if (obj.ID == 20) {
      if (obj.isConfirm == true) {
        AjaxSendTrustPilotEmail();
      }
    }

    if (obj.ID == 21) {
      if (obj.isConfirm == true) {
        AjaxGenerateInvoice();
      }
    }

    if (obj.ID == 22) {
      if (obj.isConfirm == true) {
        AjaxSendQuotationStatusChangeEmail(obj.SelectedID);
      }
    }

    if (obj.ID == 23) {
      if (obj.isConfirm == true) {
        AjaxSendQuotationLinkEmail(2, obj.SelectedID);
      }
    }

    if (obj.ID == 24) {
      if (obj.isConfirm == true) {
        AjaxSendConfirmationEmail();
      }
    }
    if (obj.ID == 25) {
      if (obj.isConfirm == true) {
        AjaxTakeOrRefundAmount(obj.SelectedID);
      }
    }
    if (obj.ID == 26) {
      if (obj.isConfirm == true) {
        MNVQuote.MNVQuoteStatusID = obj.SelectedID;
        Update(1);
      }
    }

    if (obj.ID == 27) {
      if (obj.isConfirm == true) {
        DeleteLineItemDB(obj.SelectedID);
      }
    }

    if (obj.ID == 9999) {
      if (obj.isConfirm == true) {
        if (obj.SelectedID > 0) Update(1, obj.SelectedID, 0);
        else Update(1, 0, 1);
      } else {
        if (obj.SelectedID > 0) {
          LoadDataForSpecificQuote(obj.SelectedID);
        } else {
          AddNewConfirmation(1);
        }
      }
    }

    if (obj.ID == 101) {
      if (obj.isConfirm == true) {
        swapLocations();
      } else {
        setDraggingId(null);
      }
    }

    if (obj.ID == 102) {
      if (obj.isConfirm == true) {
        swapLocationsWhenDropFromAdditionalToMainAddress();
      } else {
        setDraggingId(null);
      }
    }

    if (obj.ID == 103) {
      if (obj.isConfirm == true) {
        swapLocationsWhenDropFromMainAddressToAdditional();
      } else {
        setDraggingId(null);
      }
    }
    if (obj.ID == 104) {
      if (obj.isConfirm == true) {
        swapLocationsbetweenAdditionalStops();
      } else {
        setDraggingId(null);
      }
    }

    setConfirmationModalObject({
      ShowPopup: false,
      Heading: "",
      Message: "",
      ID: 0,
      SelectedID: 0,
      OtherID: 0,
    });
  }
  //#endregion Action Buttons

  const GetDirections1 = () => {
    setIsCongestion(false);

    if (info.AdditionalStop.length === 0) {
      setDistance((prev: any) => ({
        ...prev,
        DTPWithStops: 0,
      }));

      CalculateDistance();

      if (IsCongestionsCharged(info.FromPostalCode)) {
        setIsCongestion(true);
      }

      if (IsCongestionsCharged(info.ToPostalCode)) {
        setIsCongestion(true);
      }
    } else {
      DTPMiles = 0;
      DTPSeconds = 0;
      CalculateDistance();
    }
  };

  function GetDetailsForLineItem(LineItem: any) {
    var l_strDoNotShow = "";
    if (LineItem.Description.toLowerCase() == "true")
      l_strDoNotShow = "Do Not Itemise On Invoice PDF - ";

    if (LineItem.TransactionType == 1)
      return (
        l_strDoNotShow +
        "Credit (Quote Price, Other Charges, Extra Charges etc)"
      );
    else if (LineItem.TransactionType == 2)
      return l_strDoNotShow + "Debit (Cash Payment, Bank Deposit etc)";
    else if (LineItem.TransactionType == 3)
      return (
        l_strDoNotShow +
        "Debit (Write off,Refund Adjustment,Absolute Discount, Other Adjustment etc)"
      );
    else if (LineItem.TransactionType == 4)
      return l_strDoNotShow + "Cancellation / Manual Refund etc";
    else if (LineItem.TransactionType == 100)
      return (
        l_strDoNotShow +
        "Credit NO VAT (Quote Price, Other Charges, Extra Charges etc)"
      );
    return "";
  }

  const addAdditionalChargesLineItem = (p_intType: number) => {
    const hasAdditionalServices = AdditionalServices.length > 0;

    // ---------- TYPE 1 : Additional Time ----------
    if (p_intType === 1) {
      const reference = "Additional Time";

      const baseTitle = `Additional ${GetDurationTextForSeconds(
        MNVQuote.Mover2ID * 60,
      )} charge`;

      const title = hasAdditionalServices ? `${baseTitle} - Van 1` : baseTitle;

      ajaxSaveLineItem(
        1,
        MNVQuote.AdditionalTimeCharges,
        title,
        reference,
        QuoteId,
        0,
      );
    }

    // ---------- TYPE 2 : Additional / Reduced Stairs ----------
    if (p_intType === 2) {
      const reference = "Additional Stairs";
      const stairs = Math.abs(MNVQuote.Mover3ID);
      const stairText = stairs > 1 ? "Stairs" : "Stair";

      // POSITIVE stairs charge
      if (MNVQuote.AdditionalStairsCharges > 0) {
        const baseTitle = `Additional ${stairs} ${stairText} charge`;

        const title = hasAdditionalServices
          ? `${baseTitle} - Van 1`
          : baseTitle;

        ajaxSaveLineItem(
          1,
          MNVQuote.AdditionalStairsCharges,
          title,
          reference,
          QuoteId,
          0,
        );
      }

      // NEGATIVE stairs charge (reduction)
      if (MNVQuote.AdditionalStairsCharges < 0) {
        const baseTitle = hasAdditionalServices
          ? `Reduced ${stairs} ${stairText} charge - Van 1`
          : `Additional ${stairs} ${stairText} charge`;

        ajaxSaveLineItem(
          3,
          MNVQuote.AdditionalStairsCharges,
          baseTitle,
          reference,
          QuoteId,
          0,
        );
      }
    }
  };

  const addAdditionalChargesLineItemForAdditionalVan = (
    p_intType: number,
    p_intIndex: number,
  ) => {
    const service = AdditionalServices[p_intIndex];
    const vanNumber = Number(p_intIndex) + 2;

    if (p_intType === 1) {
      const reference = "Additional Time";
      const title =
        "Additional " +
        GetDurationTextForSeconds(service.Mover2ID * 60) +
        " charge - Van " +
        vanNumber;

      ajaxSaveLineItem(
        1,
        service.AdditionalTimeCharges,
        title,
        reference,
        service.MNVQuoteID,
        0,
      );
    } else if (p_intType === 2 && service.AdditionalStairsCharges > 0) {
      const reference = "Additional Stairs";
      const title =
        "Additional " +
        service.Mover3ID +
        (service.Mover3ID > 1 ? " Stairs" : " Stair") +
        " charge - Van " +
        vanNumber;

      ajaxSaveLineItem(
        1,
        service.AdditionalStairsCharges,
        title,
        reference,
        service.MNVQuoteID,
        0,
      );
    } else if (p_intType === 2 && service.AdditionalStairsCharges < 0) {
      const reference = "Additional Stairs";
      const title =
        "Reduced " +
        service.Mover3ID +
        (Math.abs(service.Mover3ID) > 1 ? " Stairs" : " Stair") +
        " charge - Van " +
        vanNumber;

      ajaxSaveLineItem(
        3,
        service.AdditionalStairsCharges,
        title,
        reference,
        service.MNVQuoteID,
        0,
      );
    }
  };

  const ajaxSaveLineItem = async (
    Type: number,
    Amount: number,
    Note: string,
    RefID: string,
    QuoteID: number,
    MarkPaid: number,
  ) => {
    const data = {
      Type,
      Amount,
      Note,
      RefID: Note,
      MNVJobID: GetMainJobID(),
      QuoteID: QuoteId,
      MarkPaid,
      LineItemType: 1,
    };

    try {
      setIsAnimation(true);

      const response = await axiosAuth.post(
        AppContext.APIURL + "api/MNVQuoteAdmin/AjaxSaveLineItem",
        data,
      );

      const statusData = response.data?.[0]?.[0];

      if (statusData?.Status === 1) {
        RefreshLogsData();

        showSuccessMessage("Line item has been added successfully.");
        setQuoteLoadingTime(addMinutes(new Date(), 0.016 * 2));

        GetInvoiceDataByQuoteID(1);
      } else {
        showErrorMessage(statusData?.Message);
      }
    } catch (error) {
    } finally {
      setIsAnimation(false);
    }
  };

  function UpdateVAT() {
    if (VatCopy >= 0) {
      setVat(VatCopy);
      setIsVATEditable(false);
      setupdateVatFunction(VatCopy);
    } else {
      showErrorMessage("VAT can not be in negative.");
    }
  }

  const [draggingId, setDraggingId] = useState<string | null>(null);
  const [draggingIndex, setDraggingIndex] = useState<number | null>(null);

  const [selectedAdditionalIndex, setSelectedAdditionalIndex] = useState<
    string | null
  >(null);
  const [selectedDropTarget, setSelectedDropTarget] = useState<string | null>(
    null,
  );

  const handleDragStart = (
    e: React.DragEvent<HTMLDivElement>,
    type: "collection" | "delivery",
  ) => {
    e.dataTransfer.setData("section", type);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault(); // important for drop to work
  };

  const handleDrop = (
    e: React.DragEvent<HTMLDivElement>,
    dropTarget: string,
  ) => {
    e.preventDefault();

    const draggedSection: any = e.dataTransfer.getData("section") as
      | "collection"
      | "delivery";
    if (draggedSection === dropTarget) return;
    if (draggedSection !== "") {
      setConfirmationModalObject({
        ShowPopup: true,
        Heading: "Confirmation",
        Message: "Confirm swap of addresses?",
        ID: 101,
        SelectedID: 0,
        OtherID: 0,
      });

      // swapLocations();
    } else {
      const additionalIndex = e.dataTransfer.getData("additionalIndex");
      setSelectedAdditionalIndex(additionalIndex);
      setSelectedDropTarget(dropTarget);
      setConfirmationModalObject({
        ShowPopup: true,
        Heading: "Confirmation",
        Message: "Confirm swap of addresses?",
        ID: 102,
        SelectedID: 0,
        OtherID: 0,
      });
    }

    setIsCalculateDistance(1);
  };
  const swapLocations = () => {
    setInfo((prev: any) => ({
      ...prev,

      FromCountryCode: prev.ToCountryCode,
      ToCountryCode: prev.FromCountryCode,

      FromPostalCode: prev.ToPostalCode,
      ToPostalCode: prev.FromPostalCode,

      FromAddress: prev.ToAddress,
      ToAddress: prev.FromAddress,

      FromCity: prev.ToCity,
      ToCity: prev.FromCity,

      FromType: prev.ToType,
      ToType: prev.FromType,

      FromNumberOfStairs: prev.ToNoOfStairs,
      ToNoOfStairs: prev.FromNumberOfStairs,

      FromAvailableLift: prev.ToAvailableLift,
      ToAvailableLift: prev.FromAvailableLift,

      FromAdditionalStairs: prev.ToAdditionalStairs,
      ToAdditionalStairs: prev.FromAdditionalStairs,
    }));
    setIsCalculateDistance(1);
  };

  const swapLocationsWhenDropFromAdditionalToMainAddress = () => {
    if (selectedAdditionalIndex !== "") {
      const index = Number(selectedAdditionalIndex);

      setInfo((prev: any) => {
        const updated = { ...prev };
        const additionalStops = [...prev.AdditionalStop];

        const draggedStop = { ...additionalStops[index] }; // clone stop
        if (selectedDropTarget === "collection") {
          const newStop = {
            CountryCode: prev.FromCountryCode,
            PostCode: prev.FromPostalCode,
            Address: prev.FromAddress,
            City: prev.FromCity,
            AdditionalStopType: prev.FromType,
            NoOfStairs: prev.FromNumberOfStairs,
            AdditionalStopAvailableLift: prev.FromAvailableLift,
            WaitingTimeInSeconds: prev.FromAdditionalStairs,
          };
          updated.FromCountryCode = draggedStop.CountryCode;
          updated.FromPostalCode = draggedStop.PostCode;
          updated.FromAddress = draggedStop.Address;
          updated.FromCity = draggedStop.City;
          updated.FromType = draggedStop.AdditionalStopType;
          updated.FromNumberOfStairs = draggedStop.NoOfStairs;
          updated.FromAvailableLift = draggedStop.AdditionalStopAvailableLift;
          updated.FromAdditionalStairs = draggedStop.WaitingTimeInSeconds;

          additionalStops[index] = newStop;
        }

        if (selectedDropTarget === "delivery") {
          const newStop = {
            CountryCode: prev.ToCountryCode,
            PostCode: prev.ToPostalCode,
            Address: prev.ToAddress,
            City: prev.ToCity,
            AdditionalStopType: prev.ToType,
            NoOfStairs: prev.ToNoOfStairs,
            AdditionalStopAvailableLift: prev.ToAvailableLift,
            WaitingTimeInSeconds: prev.ToAdditionalStairs,
          };

          updated.ToCountryCode = draggedStop.CountryCode;
          updated.ToPostalCode = draggedStop.PostCode;
          updated.ToAddress = draggedStop.Address;
          updated.ToCity = draggedStop.City;
          updated.ToType = draggedStop.AdditionalStopType;
          updated.ToNoOfStairs = draggedStop.NoOfStairs;
          updated.ToAvailableLift = draggedStop.AdditionalStopAvailableLift;
          updated.ToAdditionalStairs = draggedStop.WaitingTimeInSeconds;
          additionalStops[index] = newStop;
        }

        updated.AdditionalStop = additionalStops;
        return updated;
      });
    }
    setIsCalculateDistance(1);
  };

  const [dragIndex, setDragIndex] = useState<number | null | any>(null);
  const [dropIndex, setDropIndex] = useState<number | null | any>(null);

  const handleDragStart_Additional = (
    e: React.DragEvent<HTMLDivElement>,
    index: number,
  ) => {
    setDragIndex(index);
    e.dataTransfer.setData("additionalIndex", index.toString());
  };

  const handleDragOver_Additional = (
    e: React.DragEvent<HTMLTableRowElement>,
    index: number,
  ) => {
    e.preventDefault(); // allow drop
    if (dragIndex === null || dragIndex === index) return;

    setDropIndex(index);

    setConfirmationModalObject({
      ShowPopup: true,
      Heading: "Confirmation",
      Message: "Confirm swap of addresses?",
      ID: 104,
      SelectedID: 0,
      OtherID: 0,
    });
  };
  const swapLocationsbetweenAdditionalStops = () => {
    const updatedInfo = { ...info };

    const draggedRow = updatedInfo.AdditionalStop[dragIndex];
    updatedInfo.AdditionalStop.splice(dragIndex, 1);
    updatedInfo.AdditionalStop.splice(dropIndex, 0, draggedRow);

    setDragIndex(dropIndex);
    setInfo(updatedInfo);
    setIsCalculateDistance(1);
  };

  const [selectedDraggedAdditionalIndex, setSelectedDraggedAdditionalIndex] =
    useState<number>(0);
  const [selectedDraggedSection, setSelectedDraggedSection] = useState<
    string | null
  >(null);

  const handleDragEnd_Additional = (
    e: React.DragEvent<HTMLDivElement>,
    index: number,
  ) => {
    e.preventDefault();
    setDragIndex(null);

    const draggedSection = e.dataTransfer.getData("section");
    if (!draggedSection) return;

    setSelectedDraggedAdditionalIndex(index);
    setSelectedDraggedSection(draggedSection);

    setConfirmationModalObject({
      ShowPopup: true,
      Heading: "Confirmation",
      Message: "Confirm swap of addresses?",
      ID: 103,
      SelectedID: 0,
      OtherID: 0,
    });
  };

  const swapLocationsWhenDropFromMainAddressToAdditional = () => {
    setInfo((prev: any) => {
      const updated = { ...prev };
      const additionalStops = [...prev.AdditionalStop];

      const targetStop = { ...additionalStops[selectedDraggedAdditionalIndex] };

      if (selectedDraggedSection === "collection") {
        const newStop = {
          CountryCode: prev.FromCountryCode,
          PostCode: prev.FromPostalCode,
          Address: prev.FromAddress,
          City: prev.FromCity,
          AdditionalStopType: prev.FromType,
          NoOfStairs: prev.FromNumberOfStairs,
          AdditionalStopAvailableLift: prev.FromAvailableLift,
          WaitingTimeInSeconds: prev.FromAdditionalStairs,
        };

        // Replace collection with additional stop
        updated.FromCountryCode = targetStop.CountryCode;
        updated.FromPostalCode = targetStop.PostCode;
        updated.FromAddress = targetStop.Address;
        updated.FromCity = targetStop.City;
        updated.FromType = targetStop.AdditionalStopType;
        updated.FromNumberOfStairs = targetStop.NoOfStairs;
        updated.FromAvailableLift = targetStop.AdditionalStopAvailableLift;
        updated.FromAdditionalStairs = targetStop.WaitingTimeInSeconds;
        // Replace additional stop with old collection
        additionalStops[selectedDraggedAdditionalIndex] = newStop;
      }

      if (selectedDraggedSection === "delivery") {
        const newStop = {
          CountryCode: prev.ToCountryCode,
          PostCode: prev.ToPostalCode,
          Address: prev.ToAddress,
          City: prev.ToCity,
          AdditionalStopType: prev.ToType,
          NoOfStairs: prev.ToNoOfStairs,
          AdditionalStopAvailableLift: prev.ToAvailableLift,
          WaitingTimeInSeconds: prev.ToAdditionalStairs,
        };

        updated.ToCountryCode = targetStop.CountryCode;
        updated.ToPostalCode = targetStop.PostCode;
        updated.ToAddress = targetStop.Address;
        updated.ToCity = targetStop.City;
        updated.ToType = targetStop.AdditionalStopType;
        updated.ToNoOfStairs = targetStop.NoOfStairs;
        updated.ToAvailableLift = targetStop.AdditionalStopAvailableLift;
        updated.ToAdditionalStairs = targetStop.WaitingTimeInSeconds;
        additionalStops[selectedDraggedAdditionalIndex] = newStop;
      }

      updated.AdditionalStop = additionalStops;

      return updated;
    });

    setIsCalculateDistance(1);
  };

  const [selectedMoveManagerIds, setSelectedMoveManagerIds] = useState<any>("");
  const [moveManagerList, setMoveManagerList] = useState<any>([]);

  function getMoveManagerUserList(mnvquoteid: any) {
    let object: any = {};
    object.mnvquoteid = mnvquoteid;
    axiosAuth
      .post(
        AppContext.APIURL + "api/MNVQuoteMoveManager/GetMoveManagerUserList",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_oResponse = response.data.Data;
          setMoveManagerList(l_oResponse[0]);

          let selectedIds = "";
          for (let i = 0; i < l_oResponse[1].length; i++) {
            selectedIds += l_oResponse[1][i].MoveManagerID + ",";
          }
          if (selectedIds != "") {
            selectedIds = selectedIds.replace(/,$/, "");
          }
          setSelectedMoveManagerIds(selectedIds);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function updateSelectedPIDForParent(type: any, value: any, name: any) {
    if (type == 1) {
      setSelectedMoveManagerIds(value);
      setInfo({ ...info, MoveManagerNames: name });
      moveManagerAddAndUpdateData(QuoteId, value, name);
    }
  }

  function moveManagerAddAndUpdateData(
    mnvquoteid: any,
    selecteduserids: any,
    selectedname: any,
  ) {
    let object: any = {};
    object.mnvquoteid = mnvquoteid;
    object.selecteduserids = selecteduserids;
    object.selectedname = selectedname;
    setIsAnimation(true);
    axiosAuth
      .post(
        AppContext.APIURL +
          "api/MNVQuoteMoveManager/MNVQuoteMoveManagerAddAndUpdateData",
        object,
      )
      .then((response) => {
        if (response.data.Status === 1) {
          setIsAnimation(false);
          // let l_oResponse = response.data.Data[0];
          // setMoveManagerList(l_oResponse);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  return (
    <>
      {isAnimation && <LoadingAnimation />}

      <ConfirmationModal
        ConfirmationObject={ConfirmationModalObject}
        ConfirmationModalCallBack={ConfirmationModalCallBack}
      />
      <div className="accordion-top flex-da mt-0 justify-btw grey-accord">
        Update Quote
      </div>

      <div className="inline-block-d width-100 p-all10">
        <div className="inline-block-d text-center width-100 reuse-border p-all20">
          <div className="flex-da flex-gap5 font-16 font-mont">
            Quote#: <b> {MNVQuote?.JobID}</b>
          </div>
          <div className="accordion-top flex-da justify-btw grey-accord">
            Client Details
          </div>
          <div className="flex-da justify-btw">
            <div className="flex-da flex-gap10">
              <SingleSelectSearchableDropdown
                listData={ClientsList}
                selectName={"Search by name"}
                updateSelectedPIDForParent={
                  updateSelectedPIDForParentSingleSelect
                }
                type={1}
                selectedPID={ClientID}
                otherID={0}
                AllowAddNew={false}
                KeyUpInputData={KeyUpInputData}
              ></SingleSelectSearchableDropdown>
              {ClientID > 0 && (
                <a
                  onClick={() => {
                    setClientData((prev: any) => ({
                      ...prev,
                      Mobile: ClientMobile,
                      MobileWA: ClientMobile.replace("-", ""),
                    }));
                    SetSelectedMobileNumber(ClientMobile);
                    setIsClientAddClicked(false);
                    setShowUpdateClientModal(true);
                  }}
                  className="flex-d"
                >
                  <img
                    src="/images/edit.svg"
                    width="24px"
                    height="24px"
                    alt="Edit"
                  />
                </a>
              )}
            </div>
            <div className="btn-start flex-daj">
              <a
                className="btn-primary flex-daj"
                onClick={() => {
                  ClearClient();
                  setIsClientAddClicked(true);
                  setShowUpdateClientModal(true);
                }}
              >
                Add New Client
              </a>
            </div>
          </div>
          <div className="grid-d fr-111 gap-20 mt-20">
            <>
              <div className="grid-d flex-gap5">
                <span className="txt-compare font-16 flex-d">Type:</span>
                {ClientData.TypeID == 1 && (
                  <span className="txt-compare font-16 flex-d">Business</span>
                )}
                {ClientData.TypeID == 2 && (
                  <span className="txt-compare font-16 flex-d">
                    Residential
                  </span>
                )}
              </div>

              {ClientData.TypeID == 1 && (
                <div className="grid-d flex-gap5">
                  <span className="txt-compare font-16 flex-d">
                    Business Name:
                  </span>
                  <span className="txt-compare font-16 flex-d">
                    {ClientData.BusinessName}
                  </span>
                </div>
              )}

              <div className="grid-d flex-gap5">
                <span className="txt-compare font-16 flex-d">First Name:</span>
                <span className="txt-compare font-16 flex-d">
                  {ClientData.FirstName}
                </span>
              </div>

              <div className="grid-d flex-gap5">
                <span className="txt-compare font-16 flex-d">Last Name:</span>
                <span className="txt-compare font-16 flex-d">
                  {ClientData.LastName}
                </span>
              </div>

              <div className="grid-d flex-gap5">
                <span className="txt-compare font-16 flex-d">Email:</span>
                <span className="txt-compare font-16 flex-d">
                  {ClientData.EmailAddress}
                </span>
              </div>

              <div className="grid-d flex-gap5">
                <span className="txt-compare font-16 flex-d">Mobile:</span>

                <div className="flex-da flex-gap10">
                  <span className="txt-compare font-16 flex-d">
                    {ClientData.Mobile}
                  </span>

                  <a
                    href={`https://wa.me/${ClientData.MobileWA}`}
                    target="_blank"
                    rel="noreferrer"
                    title="Open in WhatsApp"
                    className="flex-d"
                  >
                    <img
                      src="/images/whatsapp.svg"
                      width="20px"
                      height="20px"
                      alt="Edit"
                    />
                  </a>
                </div>
              </div>

              <div className="grid-d flex-gap5">
                <span className="txt-compare font-16 flex-d">Telephone:</span>
                <span className="txt-compare font-16 flex-d">
                  {ClientData.Telephone}
                </span>
              </div>

              <div className="grid-d flex-gap5">
                <span className="txt-compare font-16 flex-d">Postcode:</span>
                <span className="txt-compare font-16 flex-d">
                  {ClientData.PostCode}
                </span>
              </div>

              <div className="grid-d flex-gap5">
                <span className="txt-compare font-16 flex-d">
                  Address Line 1:
                </span>
                <span className="txt-compare font-16 flex-d">
                  {ClientData.Address}
                </span>
              </div>

              <div className="grid-d flex-gap5">
                <span className="txt-compare font-16 flex-d">
                  Address Line 2:
                </span>
                <span className="txt-compare font-16 flex-d">
                  {ClientData.AddressLine2}
                </span>
              </div>

              {ClientData.TypeID == 1 && (
                <div className="grid-d flex-gap5">
                  <span className="txt-compare font-16 flex-d">
                    VAT Number:
                  </span>
                  <span className="txt-compare font-16 flex-d">
                    {ClientData.VATNumber}
                  </span>
                </div>
              )}

              {ClientData.TypeID == 1 && (
                <div className="grid-d flex-gap5">
                  <span className="txt-compare font-16 flex-d">
                    Company Number:
                  </span>
                  <span className="txt-compare font-16 flex-d">
                    {ClientData.CompanyNumber}
                  </span>
                </div>
              )}

              <div className="grid-d flex-gap5">
                <span className="txt-compare font-16 flex-d">
                  Other Emails:
                </span>
                <span className="txt-compare font-16 flex-d">
                  {ClientData.OtherEmails}
                </span>
              </div>
            </>
          </div>

          <>
            <div className="accordion-top flex-da justify-btw grey-accord">
              Client Other Detail
            </div>

            <div className="grid-d fr-111 gap-20 mt-20">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Notes</span>

                <textarea
                  value={ClientData.Notes}
                  onChange={(e) => {
                    ClientData.Notes = e.target.value;

                    setClientData((prev: any) => ({
                      ...prev,
                      Notes: e.target.value,
                    }));
                  }}
                  onBlur={() => UpdateClient(false)}
                  className="input-field w-100"
                />
              </div>

              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Promo Code
                </span>

                <input
                  value={ClientData.DefaultPromoCode}
                  onChange={(e) => {
                    ClientData.DefaultPromoCode = e.target.value;

                    setClientData((prev: any) => ({
                      ...prev,
                      DefaultPromoCode: e.target.value,
                    }));
                  }}
                  onBlur={() => UpdateClient(false)}
                  className="input-field w-100"
                />
              </div>

              <div className="grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  VIP Client
                </span>

                <div className="flex-d">
                  <input
                    type="checkbox"
                    checked={ClientData.IsVIPClient}
                    onChange={(e) => {
                      ClientData.IsVIPClient = e.target.checked;

                      setClientData((prev: any) => ({
                        ...prev,
                        IsVIPClient: e.target.checked,
                      }));

                      UpdateClient(false);
                    }}
                    className="input-field"
                  />
                </div>
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  How did you hear about us?
                </span>

                <select
                  value={ClientData.ReferencedByID}
                  onChange={(e) => {
                    ClientData.ReferencedByID = e.target.value;

                    setClientData((prev: any) => ({
                      ...prev,
                      ReferencedByID: e.target.value,
                    }));
                    UpdateClient(false);
                  }}
                  className="input-field w-100"
                >
                  <option value={0}>Please select</option>
                  <option value={1}>Repeat Client</option>
                  <option value={2}>Recommended (word of mouth)</option>
                  <option value={3}>Referred (referral)</option>
                  <option value={4}>Google Search</option>
                  <option value={5}>Review Website or Blog</option>
                  <option value={6}>Leaflet</option>
                  <option value={7}>Social Media</option>
                  <option value={8}>Other</option>
                </select>
              </div>
            </div>
          </>

          {damageClaimClientDetailData &&
            damageClaimClientDetailData.length > 0 && (
              <>
                <div className="accordion-top flex-da justify-btw grey-accord">
                  Damage Claims
                </div>

                <div className="flow-auto mt-10 auto-height">
                  <table className="reuse-table fixed-table">
                    <thead>
                      <tr>
                        <th>Job ID</th>
                        <th>Service Data</th>
                        <th>Movers</th>
                        <th>Claim Date</th>
                        <th>Description</th>
                        <th>Damage Done By</th>
                        <th>Outcome</th>
                        <th>Cost</th>
                        <th>Insurance Claim Ref</th>
                      </tr>
                    </thead>

                    <tbody>
                      {damageClaimClientDetailData.map(
                        (Item: any, index: number) => (
                          <tr key={index}>
                            <td className="text-left">{Item.JobID}</td>
                            <td className="text-left">
                              {formateDate(Item.ServiceDate)}
                            </td>
                            <td className="text-left">{Item.MoversList}</td>
                            <td className="text-left">
                              {formateDate(Item.ClaimDate)}
                            </td>
                            <td className="text-left" title={Item.Description}>
                              {Item.Description}
                            </td>
                            <td className="text-left">
                              {Item.DamageDoneByName}
                            </td>
                            <td className="text-left">{Item.Outcome}</td>
                            <td className="text-left">
                              £
                              {Item.Cost?.toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td className="text-left">
                              {Item.InsuranceClaimRef}
                            </td>
                          </tr>
                        ),
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          {clientJobData && clientJobData.length > 0 && (
            <>
              <div
                className="accordion-top flex-da justify-btw grey-accord pointer "
                onClick={() => setPreviousJobs(!previousJobs)}
              >
                Previous Jobs
                <img
                  className={` ${previousJobs ? "rotate-180" : ""}`}
                  src="/images/chev-down.svg"
                  width={16}
                  height={16}
                />
              </div>

              {previousJobs == true && (
                <div className="flow-auto mt-10 auto-height">
                  <table className="reuse-table fixed-table">
                    <thead>
                      <tr>
                        <th>Job ID</th>
                        <th> Van Type</th>
                        <th> Mover Type</th>
                        <th> Status</th>
                        <th> Date</th>
                        <th> Hrs</th>
                        <th> From</th>
                        <th>To</th>
                        <th>Amount</th>
                        <th>Action</th>
                      </tr>
                    </thead>

                    <tbody>
                      {clientJobData.map((Item: any, index: number) => (
                        <tr key={index}>
                          <td className="reuse-tdxs">
                            <a
                              href={"/quote_detail/" + Item.MNVJobID}
                              target="_blank"
                            >
                              {Item.JobID}
                            </a>{" "}
                          </td>
                          <td className="reuse-tdxs">{Item.MNVVanTypeName}</td>
                          <td>{Item.MNVMoverTypeName}</td>
                          <td>{Item.MNVQuoteStatusName}</td>
                          <td>{formateDate(Item.RequestedDate)}</td>
                          <td className="reuse-tdxs text-right">
                            {Item.RequiredVanTime}
                          </td>
                          <td>{Item.FromPostalCode}</td>
                          <td>{Item.ToPostalCode}</td>
                          <td className="reuse-tdxs text-right">
                            £
                            {Item.PayableAmount?.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                          <td className="reuse-xxxs">
                            <a
                              title="Copy to current job or add new job?"
                              onClick={() => {
                                setSelectedClientJobObject(Item);
                                setShowClientJobModal(true);
                              }}
                            >
                              <img
                                src="/images/clipboard.svg"
                                width="18px"
                                height="18px"
                                alt="copy"
                              />
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </>
          )}
          <div className="accordion-top flex-da justify-btw grey-accord">
            Services
          </div>
          <div className="service-tabs-head mt-10">
            {/* Tabs Header */}
            <ul className="nav nav-tabs" role="tablist">
              {AllLinkedQuotes.map((quote, index) => (
                <li
                  key={quote.MNVQuoteID}
                  role="presentation"
                  className="nav-item"
                >
                  <span
                    className={`nav-link flex-dam flex-gap10 ${
                      quote.MNVQuoteID == QuoteId ? "active" : ""
                    }`}
                    role="tab"
                    data-toggle="tab"
                  >
                    {/* Input shown when ShowPosition = true */}
                    {quote.ShowPosition && (
                      <div className="field-input">
                        <input
                          placeholder="Enter position"
                          type="number"
                          min="0"
                          onBlur={(e) =>
                            MNVQuoteUpdateOrderForService(quote.MNVQuoteID, e)
                          }
                          className="input-field"
                        />
                      </div>
                    )}

                    {/* Move Position Icon */}
                    {quote.MNVQuoteID == QuoteId &&
                      AllLinkedQuotes.length > 1 && (
                        <a
                          title="Move Position"
                          className="flex-d"
                          onClick={() => {
                            const updated = [...AllLinkedQuotes];
                            updated[index].ShowPosition =
                              !updated[index].ShowPosition;
                            setAllLinkedQuotes(updated);
                          }}
                        >
                          <img
                            src="/images/move.svg"
                            width="14px"
                            height="14px"
                            alt="move"
                          />
                        </a>
                      )}
                    {/* Service Label  Service {index + 1}*/}
                    {!quote.EditServiceName && (
                      <a
                        onClick={() =>
                          LoadDataForSpecificQuote(quote.MNVQuoteID, false)
                        }
                      >
                        {" "}
                        {quote.Name}
                      </a>
                    )}

                    {/* Input shown when EditServiceName = true */}
                    {quote.EditServiceName && (
                      <div className="field-input">
                        <input
                          placeholder="Enter Service Name"
                          value={quote.Name}
                          type="text"
                          onChange={(e: any) => {
                            const updated = [...AllLinkedQuotes];
                            updated[index].Name = e.target.value;
                            setAllLinkedQuotes(updated);
                          }}
                          onBlur={(e) => {
                            updateServiceName(quote.MNVQuoteID, e);
                            const updated = [...AllLinkedQuotes];
                            updated[index].EditServiceName =
                              !updated[index].EditServiceName;
                            setAllLinkedQuotes(updated);
                          }}
                          className="input-field"
                        />
                      </div>
                    )}

                    {/* Edit Icon */}

                    {quote.MNVQuoteID == QuoteId &&
                      AllLinkedQuotes.length > 1 && (
                        <a
                          title="Edit service name"
                          className="flex-d"
                          onClick={() => {
                            const updated = [...AllLinkedQuotes];
                            updated[index].EditServiceName =
                              !updated[index].EditServiceName;
                            setAllLinkedQuotes(updated);
                          }}
                        >
                          <img
                            src="/images/edit.svg"
                            width="14px"
                            height="14px"
                            alt="move"
                          />
                        </a>
                      )}
                    {/* Delete Icon */}
                    {quote.MNVQuoteID == QuoteId &&
                      AllLinkedQuotes.length > 1 && (
                        <a
                          onClick={(e) => {
                            e.stopPropagation();
                            UnlinkQuoteFromJob(quote.MNVQuoteID, 1, index);
                          }}
                          className="flex-d"
                        >
                          <img
                            src="/images/delete.png"
                            width="14px"
                            height="14px"
                            alt="Delete"
                          />
                        </a>
                      )}
                  </span>
                </li>
              ))}

              {/* Add Service Tab */}
              {MNVQuote.MNVQuoteStatusID == 6 && (
                <li
                  role="presentation"
                  className="nav-item"
                  onClick={() => AddNewConfirmation(1)}
                >
                  <a className="nav-link c-theme" role="tab" data-toggle="tab">
                    + Add Another Service
                  </a>
                </li>
              )}
            </ul>

            {/* Tab Content */}
            <div className="tab-content">
              <div role="tabpanel" className="tab-pane" id="addservice">
                <div className="add-service">
                  <a className="btn btn-primary">Add New Service</a>
                </div>
              </div>
            </div>
          </div>
          <div
            className={draggingId === "collection" ? "dragging" : ""}
            draggable
            onDragStart={(e) => {
              setDraggingId("collection");
              handleDragStart(e, "collection");
              setDraggingIndex(null);
            }}
            onDragOver={(e) => handleDragOver(e)}
            onDrop={(e) => handleDrop(e, "collection")}
            onDragEnd={() => setDraggingId(null)}
          >
            <div className="accordion-top flex-da justify-btw grey-accord">
              Collection Point
            </div>
            <div className="grid-d fr-111 gap-20 mt-20">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Country</span>
                <select
                  value={info.FromCountryCode}
                  onChange={(e) => {
                    setInfo({ ...info, FromCountryCode: e.target.value });
                    isAddressChangedRef.current.FromCountryCode = true;
                  }}
                  className="input-field w-100"
                >
                  {countries.map((country) => (
                    <option key={country.code} value={country.code}>
                      {`${country.name} (${country.code})`}
                    </option>
                  ))}
                </select>
              </div>

              {/* Post Code */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Post Code</span>

                <div className="flex-da flex-gap10">
                  {/* GB Autocomplete */}
                  {info.FromCountryCode == "GB" && (
                    <>
                      <input
                        name="x_x"
                        autoComplete="new-password"
                        type="text"
                        value={info.FromPostalCode}
                        onChange={(e) => {
                          setInfo({
                            ...info,
                            FromPostalCode: e.target.value,
                          });
                          isAddressChangedRef.current.FromPostalCode = true;
                          setMNVQuote({
                            ...MNVQuote,
                            FromPostalCode: e.target.value,
                          });
                          setShowSuggesstions(true);
                        }}
                        onBlur={(e) => markCalculateDistance(0, "", 0)}
                        className="input-field w-100"
                      />

                      {showSuggesstions && (
                        <LocationsSuggestions
                          locationCode={info.FromPostalCode}
                          setLocationDetails={setPickupDetails}
                          setSelectedLocation={setPickupLocation}
                        />
                      )}
                    </>
                  )}

                  {/* NON-GB Autocomplete */}
                  {info.FromCountryCode !== null &&
                    info.FromCountryCode !== "GB" && (
                      <>
                        <input
                          name="x_x"
                          autoComplete="new-password"
                          type="text"
                          value={info.FromPostalCode}
                          onChange={(e) => {
                            setInfo({
                              ...info,
                              FromPostalCode: e.target.value,
                            });
                            isAddressChangedRef.current.FromPostalCode = true;
                            setMNVQuote({
                              ...MNVQuote,
                              FromPostalCode: e.target.value,
                            });
                            setShowSuggesstions(true);
                          }}
                          onBlur={(e) => markCalculateDistance(0, "", 0)}
                          className="input-field w-100"
                        />

                        {showSuggesstions && (
                          <LocationsSuggestions
                            locationCode={info.FromPostalCode}
                            setLocationDetails={setPickupDetails}
                            setSelectedLocation={setPickupLocation}
                          />
                        )}
                      </>
                    )}

                  {/* NON-GB Autocomplete */}
                  {info.FromCountryCode !== null &&
                    info.FromCountryCode !== "GB" && (
                      <>
                        {info.FromCountryCode && (
                          <AutocompleteComponent
                            adressType="address"
                            country={info.FromCountryCode}
                            value={info.FromPostalCode}
                            onSelect={(place: any) => {
                              getAddress(place, 1, 0);
                            }}
                          />
                        )}

                        {/* <input
                        type="text"
                        value={MNVQuote.FromPostalCode}
                        onChange={(e) => {
                          setMNVQuote({
                            ...MNVQuote,
                            FromPostalCode: e.target.value,
                          });
                        }}
                        className="input-field w-100"
                      /> */}
                      </>
                    )}

                  {/* Map Marker */}
                  <a
                    onClick={() => openPopupForLocationOnMap(-1, -1)}
                    className="flex-d"
                  >
                    <img
                      src="/images/marker.svg"
                      width="18px"
                      height="20px"
                      alt="Map"
                    />
                  </a>
                </div>
              </div>
              {/* Address */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Address</span>
                <textarea
                  name="x_xx"
                  autoComplete="new-password"
                  className="input-field w-100"
                  // disabled={LineItemsAmounts.OverAllPaid > 0}
                  value={info.FromAddress}
                  onChange={(e) => {
                    setInfo({ ...info, FromAddress: e.target.value });
                    isAddressChangedRef.current.FromAddress = true;
                  }}
                />
              </div>

              {/* City */}
              <div className="field-input grid-d flex-gap3">
                <>
                  <span className="font-12 text-left label-color">City</span>
                  <input
                    name="x_xxx"
                    autoComplete="new-password"
                    // disabled={LineItemsAmounts.OverAllPaid > 0}
                    type="text"
                    value={info.FromCity}
                    onChange={(e) => {
                      setInfo({ ...info, FromCity: e.target.value });
                      isAddressChangedRef.current.FromCity = true;
                    }}
                    className="input-field w-100"
                  />
                </>
              </div>

              {/* Type */}
              <div className="field-input grid-d flex-gap3">
                <>
                  <span className="font-12 text-left label-color">Type</span>
                  <select
                    className="input-field w-100"
                    value={info.FromType}
                    onChange={(e) => {
                      setInfo({ ...info, FromType: e.target.value });
                      isAddressChangedRef.current.FromType = true;
                    }}
                  >
                    <option value="">Please Select</option>
                    <option value="House">House</option>
                    <option value="Flat">Flat</option>
                    <option value="Office">Office</option>
                    <option value="Studio">Studio</option>
                    <option value="Warehouse">Warehouse</option>
                    <option value="Exhibition">Exhibition</option>
                    <option value="Storage">Storage</option>
                    <option value="Our Storage">Our Storage</option>
                    <option value="Other">Other</option>
                  </select>
                </>
              </div>

              {/* Floor */}
              <div className="field-input grid-d flex-gap3">
                <>
                  <span className="font-12 text-left label-color">Floor</span>
                  <select
                    className="input-field w-100"
                    value={info.FromNumberOfStairs}
                    onChange={(e) => {
                      // onFromFloorChange(e.target.value);
                      setInfo({
                        ...info,
                        FromNumberOfStairs: e.target.value,
                      });
                      isAddressChangedRef.current.FromNumberOfStairs = true;
                      setIsCalculateStairs(1);
                    }}
                  >
                    <option value="0">Please Select</option>
                    <option value="-2">Basement</option>
                    <option value="-1">Ground Floor</option>
                    <option value="1">Ist Floor</option>
                    <option value="2">2nd Floor</option>
                    <option value="3">3rd Floor</option>
                    <option value="4">4th Floor</option>
                    <option value="5">5th Floor</option>
                    <option value="6">6th Floor</option>
                    <option value="7">7th Floor</option>
                    <option value="8">8th Floor</option>
                    <option value="9">9th Floor</option>
                    <option value="10">10th Floor</option>
                    <option value="11">11th Floor</option>
                    <option value="12">12th Floor</option>
                    <option value="13">13th Floor</option>
                    <option value="14">14th Floor</option>
                    <option value="15">15th Floor</option>
                    <option value="16">16th Floor</option>
                    <option value="17">17th Floor</option>
                    <option value="18">18th Floor</option>
                    <option value="19">19th Floor</option>
                    <option value="20">20th Floor</option>
                    <option value="21">20th Floor+</option>
                  </select>
                </>
              </div>

              {/* Lift Availability */}
              <div className="field-input grid-d flex-gap3">
                <>
                  <span className="font-12 text-left label-color">
                    Lift Available
                  </span>

                  <select
                    className="input-field w-100"
                    value={info.FromAvailableLift}
                    onChange={(e) => {
                      setInfo({ ...info, FromAvailableLift: e.target.value });
                      isAddressChangedRef.current.FromAvailableLift = true;
                      setIsCalculateStairs(1);
                    }}
                  >
                    <option value="">Please Select</option>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>

                    {/* Hidden option condition applied */}
                    {!(
                      info.FromNumberOfStairs >= 1 ||
                      info.FromNumberOfStairs == -2
                    ) && <option value="N/A">N/A</option>}
                  </select>
                </>
              </div>

              {/* Additional Stairs */}
              <div className="field-input grid-d flex-gap3">
                <>
                  <span className="font-12 text-left label-color">
                    Any Additional Stairs
                  </span>

                  <select
                    className="input-field w-100"
                    value={info.FromAdditionalStairs}
                    onChange={(e) => {
                      setInfo({
                        ...info,
                        FromAdditionalStairs: e.target.value,
                      });
                      isAddressChangedRef.current.FromAdditionalStairs = true;
                      setIsCalculateStairs(1);
                    }}
                  >
                    <option value="">Please Select</option>
                    <option value="1">None</option>
                    <option value="2">Raised floor</option>
                    <option value="3">1 flight of stairs</option>
                    <option value="4">2 flight of stairs</option>
                    <option value="5">3 flight of stairs</option>
                    <option value="6">4 flight of stairs</option>
                    <option value="7">5 flight of stairs</option>
                  </select>
                </>
              </div>
            </div>
          </div>
          <>
            {info.AdditionalStop && info.AdditionalStop.length > 0 && (
              <div>
                <div className="accordion-top flex-da justify-btw grey-accord">
                  Additional Stop(s)
                </div>

                {info.AdditionalStop.map((stop: any, index: any) => (
                  <React.Fragment key={index}>
                    <div
                      className={` ${
                        draggingIndex === index ? "dragging" : ""
                      }`}
                    >
                      <div
                        className={`accordion-top flex-da justify-btw grey-accord ${
                          draggingIndex === index ? "" : ""
                        }`}
                        draggable
                        onDragStart={(e: any) => {
                          setDraggingIndex(index);
                          handleDragStart_Additional(e, index);
                        }}
                        onDragEnd={() => {
                          setDraggingIndex(null);
                        }}
                        onDragOver={(e: any) =>
                          handleDragOver_Additional(e, index)
                        }
                        onDrop={(e: any) => {
                          handleDragEnd_Additional(e, index);
                          setDraggingIndex(null);
                        }}
                      >
                        Stop {index + 1}
                        {/* Delete Button */}
                        <a
                          className="flex-d"
                          onClick={() => RemoveAdditionalStop(index)}
                        >
                          <img
                            src="/images/delete.png"
                            width={20}
                            height={20}
                          />
                        </a>
                      </div>

                      {/* Country */}
                      <div className="grid-d fr-111 gap-20 mt-20">
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Country
                          </span>

                          <select
                            className="input-field w-100"
                            value={info.AdditionalStop[index].CountryCode}
                            onChange={(e) =>
                              updateAdditionalStop(
                                index,
                                "CountryCode",
                                e.target.value,
                              )
                            }
                          >
                            {countries.map((country, i) => (
                              <option key={i} value={country.code}>
                                {country.name + " (" + country.code + ")"}
                              </option>
                            ))}
                          </select>
                        </div>
                        {/* Post Code */}
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            {" "}
                            Post Code
                          </span>
                          <div className="flex-da flex-gap10">
                            {/* GB Autocomplete */}
                            {info.AdditionalStop[index].CountryCode == "GB" && (
                              <>
                                <input
                                  type="text"
                                  name="x_xx2"
                                  autoComplete="new-password"
                                  value={info.AdditionalStop[index].PostCode}
                                  onChange={(e) => {
                                    updateAdditionalStop(
                                      index,
                                      "PostCode",
                                      e.target.value,
                                    );
                                    info.AdditionalStop[
                                      index
                                    ].LocationsSuggestions = true;
                                    setShowAdditionalSuggesstions(true);
                                  }}
                                  onBlur={(e) =>
                                    markCalculateDistance(0, "", 0)
                                  }
                                  className="input-field w-100"
                                />

                                {info.AdditionalStop[index]
                                  .LocationsSuggestions && (
                                  <LocationsSuggestions
                                    locationCode={
                                      info.AdditionalStop[index].PostCode
                                    }
                                    setLocationDetails={(e: any) =>
                                      setPickupDetails_Additional(e, index)
                                    }
                                    setSelectedLocation={setPickupLocation}
                                  />
                                )}
                              </>
                            )}

                            {/* NON-GB Autocomplete */}
                            {info.AdditionalStop[index].CountryCode !== null &&
                              info.AdditionalStop[index].CountryCode !==
                                "GB" && (
                                <>
                                  <AutocompleteComponent
                                    adressType="address"
                                    country={
                                      info.AdditionalStop[index].CountryCode
                                    }
                                    value={info.AdditionalStop[index].PostCode}
                                    onSelect={(place: any) => {
                                      getAddress(place, 2, index);
                                    }}
                                  />

                                  {/* <input
                                  type="text"
                                  value={info.AdditionalStop[index].PostCode}
                                  onChange={(e) =>
                                    updateAdditionalStop(
                                      index,
                                      "PostCode",
                                      e.target.value
                                    )
                                  }
                                  className="input-field w-100"
                                /> */}
                                </>
                              )}

                            {/* Map Marker */}
                            <a
                              onClick={() =>
                                openPopupForLocationOnMap(-3, index)
                              }
                              className="flex-d"
                            >
                              <img
                                src="/images/marker.svg"
                                width="18px"
                                height="20px"
                                alt="Map"
                              />
                            </a>
                          </div>
                        </div>
                        {/* Address */}
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Address
                          </span>
                          <textarea
                            name="x_xx22"
                            autoComplete="new-password"
                            disabled={
                              LineItemsAmounts.OverAllPaid > 0 ? false : false
                            }
                            value={info.AdditionalStop[index].Address}
                            onChange={(e) =>
                              updateAdditionalStop(
                                index,
                                "Address",
                                e.target.value,
                              )
                            }
                            className="input-field w-100"
                          />
                        </div>

                        {/* City */}
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            {" "}
                            City{" "}
                          </span>
                          <input
                            name="x_xx23"
                            autoComplete="new-password"
                            disabled={
                              LineItemsAmounts.OverAllPaid > 0 ? false : false
                            }
                            type="text"
                            value={info.AdditionalStop[index].City}
                            onChange={(e) =>
                              updateAdditionalStop(
                                index,
                                "City",
                                e.target.value,
                              )
                            }
                            className="input-field w-100"
                          />
                        </div>
                        {/* Type */}
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Type
                          </span>
                          <select
                            className="input-field w-100"
                            value={
                              info.AdditionalStop[index].AdditionalStopType
                            }
                            onChange={(e) => {
                              updateAdditionalStop(
                                index,
                                "AdditionalStopType",
                                e.target.value,
                              );
                            }}
                            onBlur={() => {
                              CheckStorageType();
                            }}
                          >
                            <option value="">Please Select</option>
                            <option value="House">House</option>
                            <option value="Flat">Flat</option>
                            <option value="Office">Office</option>
                            <option value="Studio">Studio</option>
                            <option value="Warehouse">Warehouse</option>
                            <option value="Exhibition">Exhibition</option>
                            <option value="Storage">Storage</option>
                            <option value="Our Storage">Our Storage</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                        {/* Floor */}
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Floor
                          </span>
                          <select
                            className="input-field w-100"
                            value={info.AdditionalStop[index].NoOfStairs}
                            onChange={(e) => {
                              updateAdditionalStop(
                                index,
                                "NoOfStairs",
                                e.target.value,
                              );
                              setIsCalculateStairs(1);
                            }}
                          >
                            <option value="0">Please Select</option>
                            <option value="-2">Basement</option>
                            <option value="-1">Ground Floor</option>
                            <option value="1">Ist Floor</option>
                            <option value="2">2nd Floor</option>
                            <option value="3">3rd Floor</option>
                            <option value="4">4th Floor</option>
                            <option value="5">5th Floor</option>
                            <option value="6">6th Floor</option>
                            <option value="7">7th Floor</option>
                            <option value="8">8th Floor</option>
                            <option value="9">9th Floor</option>
                            <option value="10">10th Floor</option>
                            <option value="11">11th Floor</option>
                            <option value="12">12th Floor</option>
                            <option value="13">13th Floor</option>
                            <option value="14">14th Floor</option>
                            <option value="15">15th Floor</option>
                            <option value="16">16th Floor</option>
                            <option value="17">17th Floor</option>
                            <option value="18">18th Floor</option>
                            <option value="19">19th Floor</option>
                            <option value="20">20th Floor</option>
                            <option value="21">20th Floor+</option>
                          </select>
                        </div>

                        {/* Lift */}
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Lift Available
                          </span>
                          <select
                            className="input-field w-100"
                            value={
                              info.AdditionalStop[index]
                                .AdditionalStopAvailableLift
                            }
                            onChange={(e) => {
                              updateAdditionalStop(
                                index,
                                "AdditionalStopAvailableLift",
                                e.target.value,
                              );
                              setIsCalculateStairs(1);
                            }}
                          >
                            <option value="">Please Select</option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                            {!(
                              stop.NoOfStairs >= 1 || stop.NoOfStairs == -2
                            ) && <option value="N/A">N/A</option>}
                          </select>
                        </div>

                        {/* Additional Stairs */}
                        <div className="field-input grid-d flex-gap3">
                          <>
                            <span className="font-12 text-left label-color">
                              Any Additional Stairs
                            </span>

                            <select
                              className="input-field w-100"
                              value={
                                info.AdditionalStop[index].WaitingTimeInSeconds
                              }
                              onChange={(e) => {
                                updateAdditionalStop(
                                  index,
                                  "WaitingTimeInSeconds",
                                  e.target.value,
                                );
                                setIsCalculateStairs(1);
                              }}
                            >
                              <option value="">Please Select</option>
                              <option value="1">None</option>
                              <option value="2">Raised floor</option>
                              <option value="3">1 flight of stairs</option>
                              <option value="4">2 flight of stairs</option>
                              <option value="5">3 flight of stairs</option>
                              <option value="6">4 flight of stairs</option>
                              <option value="7">5 flight of stairs</option>
                            </select>
                          </>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                ))}
              </div>
            )}
            <div className="grid-d fr-111 gap-20 mt-20">
              <div className="btn-start flex-daj">
                <button
                  className="btn-primary flex-daj w-100"
                  onClick={AddStop}
                  disabled={LineItemsAmounts.OverAllPaid > 0 ? false : false}
                >
                  + Add Additional Stop
                </button>
              </div>
            </div>
          </>

          <div
            className={draggingId === "delivery" ? "dragging" : ""}
            draggable
            onDragStart={(e) => {
              setDraggingId("delivery");
              handleDragStart(e, "delivery");
              setDraggingIndex(null);
            }}
            onDragOver={(e) => handleDragOver(e)}
            onDrop={(e) => handleDrop(e, "delivery")}
            onDragEnd={() => setDraggingId(null)}
          >
            <div className="accordion-top flex-da justify-btw grey-accord">
              Delivery Point
            </div>
            <div className="grid-d fr-111 gap-20 mt-20">
              {/* Country */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Country</span>

                <select
                  className="input-field w-100"
                  value={info.ToCountryCode}
                  onChange={(e) => {
                    setInfo({ ...info, ToCountryCode: e.target.value });
                    isAddressChangedRef.current.ToCountryCode = true;
                  }}
                >
                  {countries.map((country, i) => (
                    <option key={i} value={country.code}>
                      {country.name + " (" + country.code + ")"}
                    </option>
                  ))}
                </select>
              </div>

              {/* Post Code */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  {" "}
                  Post Code{" "}
                </span>
                <div className="flex-da flex-gap10">
                  {/* GB Autocomplete */}
                  {info.ToCountryCode == "GB" && (
                    <>
                      <input
                        name="x_xx0"
                        autoComplete="autoComplete"
                        type="text"
                        value={info.ToPostalCode}
                        onChange={(e) => {
                          setInfo({
                            ...info,
                            ToPostalCode: e.target.value,
                          });
                          isAddressChangedRef.current.ToPostalCode = true;
                          setMNVQuote({
                            ...MNVQuote,
                            ToPostalCode: e.target.value,
                          });
                          setShowToSuggesstions(true);
                        }}
                        onBlur={(e) => markCalculateDistance(0, "", 0)}
                        className="input-field w-100"
                      />

                      {showToSuggesstions && (
                        <LocationsSuggestions
                          locationCode={info.ToPostalCode}
                          setLocationDetails={setPickupDetails_To}
                          setSelectedLocation={setPickupLocation}
                        />
                      )}
                    </>
                  )}

                  {/* NON-GB Autocomplete */}
                  {info.ToCountryCode !== null &&
                    info.ToCountryCode !== "GB" && (
                      <>
                        <AutocompleteComponent
                          adressType="address"
                          country={info.ToCountryCode}
                          value={info.ToPostalCode}
                          onSelect={(place: any) => {
                            getAddress(place, 3, 0);
                          }}
                        />

                        {/* <input
                      type="text"
                      value={MNVQuote.FromPostalCode}
                      onChange={(e) =>
                        setMNVQuote({
                          ...MNVQuote,
                          FromPostalCode: e.target.value,
                        })
                      }
                      className="input-field w-100"
                    /> */}
                      </>
                    )}

                  {/* Map Marker */}
                  <a
                    onClick={() => openPopupForLocationOnMap(-2, -1)}
                    className="flex-d"
                  >
                    <img
                      src="/images/marker.svg"
                      width="18px"
                      height="20px"
                      alt="Map"
                    />
                  </a>
                </div>
              </div>

              {/* Address */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color"> Address </span>

                <textarea
                  name="x_xx11"
                  autoComplete="new-password"
                  className="input-field w-100"
                  disabled={LineItemsAmounts.OverAllPaid > 0 ? false : false}
                  value={info.ToAddress}
                  onChange={(e) => {
                    setInfo({
                      ...info,
                      ToAddress: e.target.value,
                    });
                    isAddressChangedRef.current.ToAddress = true;
                  }}
                />
              </div>

              {/* City */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color"> City </span>

                <input
                  name="x_xx12"
                  autoComplete="new-password"
                  className="input-field w-100"
                  disabled={LineItemsAmounts.OverAllPaid > 0 ? false : false}
                  type="text"
                  value={info.ToCity}
                  onChange={(e) => {
                    setInfo({
                      ...info,
                      ToCity: e.target.value,
                    });
                    isAddressChangedRef.current.ToCity = true;
                  }}
                />
              </div>

              {/* Type */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Type</span>

                <select
                  className="input-field w-100"
                  value={info.ToType}
                  onChange={(e) => {
                    setInfo({ ...info, ToType: e.target.value });
                    isAddressChangedRef.current.ToType = true;
                  }}
                >
                  <option value="">Please Select</option>
                  <option value="House">House</option>
                  <option value="Flat">Flat</option>
                  <option value="Office">Office</option>
                  <option value="Studio">Studio</option>
                  <option value="Warehouse">Warehouse</option>
                  <option value="Exhibition">Exhibition</option>
                  <option value="Storage">Storage</option>
                  <option value="Our Storage">Our Storage</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              {/* Floor */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Floor</span>

                <select
                  className="input-field w-100"
                  value={info.ToNoOfStairs}
                  onChange={(e) => {
                    setInfo({ ...info, ToNoOfStairs: e.target.value });
                    // onToFloorChange(e.target.value);

                    isAddressChangedRef.current.ToNoOfStairs = true;
                    setIsCalculateStairs(1);
                  }}
                >
                  <option value="0">Please Select</option>
                  <option value="-2">Basement</option>
                  <option value="-1">Ground Floor</option>
                  <option value="1">Ist Floor</option>
                  <option value="2">2nd Floor</option>
                  <option value="3">3rd Floor</option>
                  <option value="4">4th Floor</option>
                  <option value="5">5th Floor</option>
                  <option value="6">6th Floor</option>
                  <option value="7">7th Floor</option>
                  <option value="8">8th Floor</option>
                  <option value="9">9th Floor</option>
                  <option value="10">10th Floor</option>
                  <option value="11">11th Floor</option>
                  <option value="12">12th Floor</option>
                  <option value="13">13th Floor</option>
                  <option value="14">14th Floor</option>
                  <option value="15">15th Floor</option>
                  <option value="16">16th Floor</option>
                  <option value="17">17th Floor</option>
                  <option value="18">18th Floor</option>
                  <option value="19">19th Floor</option>
                  <option value="20">20th Floor</option>
                  <option value="21">20th Floor+</option>
                </select>
              </div>

              {/* Lift Available */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Lift Available
                </span>

                <select
                  className="input-field w-100"
                  value={info.ToAvailableLift}
                  onChange={(e) => {
                    setInfo({ ...info, ToAvailableLift: e.target.value });

                    isAddressChangedRef.current.ToAvailableLift = true;

                    setIsCalculateStairs(1);
                  }}
                >
                  <option value="">Please Select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>

                  {/* N/A hidden logic stays same */}
                  {!(info.ToNoOfStairs >= 1 || info.ToNoOfStairs == -2) && (
                    <option value="N/A">N/A</option>
                  )}
                </select>
              </div>

              {/* Additional Stairs */}
              <div className="field-input grid-d flex-gap3">
                <>
                  <span className="font-12 text-left label-color">
                    Any Additional Stairs
                  </span>

                  <select
                    className="input-field w-100"
                    value={info.ToAdditionalStairs}
                    onChange={(e) => {
                      setInfo({ ...info, ToAdditionalStairs: e.target.value });
                      isAddressChangedRef.current.ToAdditionalStairs = true;
                      setIsCalculateStairs(1);
                    }}
                  >
                    <option value="">Please Select</option>
                    <option value="1">None</option>
                    <option value="2">Raised floor</option>
                    <option value="3">1 flight of stairs</option>
                    <option value="4">2 flight of stairs</option>
                    <option value="5">3 flight of stairs</option>
                    <option value="6">4 flight of stairs</option>
                    <option value="7">5 flight of stairs</option>
                  </select>
                </>
              </div>
            </div>
          </div>
          {IsStorageType && IsStorageOkToGoLive && (
            <>
              <div className="accordion-top flex-da justify-btw grey-accord">
                Storage
              </div>
              <div className="grid-d fr-111 gap-20 mt-20">
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">Storage</span>
                  <select
                    className="input-field w-100"
                    value={StoragePriceObject.PID}
                    onChange={(e) => {
                      setStoragePriceObject({
                        ...StoragePriceObject,
                        PID: Number(e.target.value),
                      });
                      // GetSelectPricePerSQFTFromPID();
                      // MNVQuoteStorageDataSave();
                    }}
                  >
                    <option value={0}>Please Select</option>
                    {StorageList?.map((item: any) => (
                      <option key={item.PID} value={item.PID}>
                        {item.Title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {StoragePriceObject.PID !== 0 && (
                <>
                  {/* Add Bespoke Block */}

                  <div className="btn-start flex-daj flex-jse mt-10">
                    <a
                      className="btn-primary flex-daj"
                      style={{ marginTop: 5 }}
                      onClick={() => {
                        setStoragePriceObject({
                          ...StoragePriceObject,
                          AddBespoke: !StoragePriceObject.AddBespoke,
                        });
                      }}
                    >
                      Add Bespoke
                    </a>
                  </div>

                  {StoragePriceObject.AddBespoke && (
                    <div className="grid-d fr-111 gap-20 mt-20">
                      <div className="field-input grid-d flex-gap3">
                        <span className="font-12 text-left label-color">
                          Rate % Monthly:
                        </span>
                        <input
                          type="text"
                          value={StoragePriceObject.ratepercentagemonthly}
                          onChange={(e: any) =>
                            setStoragePriceObject({
                              ...StoragePriceObject,
                              ratepercentagemonthly: e.target.value,
                            })
                          }
                          className="input-field w-100"
                        />
                      </div>

                      <div className="field-input grid-d flex-gap3">
                        <span className="font-12 text-left label-color">
                          Area Square feet:
                        </span>
                        <input
                          type="text"
                          value={StoragePriceObject.areasquarefeet}
                          onChange={(e: any) =>
                            setStoragePriceObject({
                              ...StoragePriceObject,
                              areasquarefeet: e.target.value,
                            })
                          }
                          className="input-field w-100"
                        />
                      </div>
                      <div className="flex-da btn-start flex-gap10 mt-18">
                        <a
                          className="btn-primary flex-daj"
                          onClick={() =>
                            MNVStoragePriceGetCompleteGridDataCustom(null)
                          }
                        >
                          Calculate
                        </a>

                        <a
                          className="flex-daj btn-primary"
                          style={{ marginTop: 5 }}
                          onClick={clearObject}
                        >
                          Cancel
                        </a>
                      </div>
                    </div>
                  )}

                  {/* TABLE */}
                  {StoragePrice && StoragePrice.length > 0 && (
                    <div className="flow-auto mt-10 auto-height">
                      <table className="reuse-table fixed-table">
                        <thead>
                          <tr>
                            <th className="white-back"></th>
                            <th className="white-back"></th>
                            <th colSpan={2}>Price per WEEK</th>
                            <th colSpan={2}>Price per MONTH</th>
                            <th>Price per WEEK after 6 months</th>
                            <th>Price per MONTH after 6 months</th>
                          </tr>

                          <tr>
                            <th>Action</th>
                            <th>Area Square Feet</th>
                            <th className="normal-font">No VAT</th>
                            <th className="normal-font">Inc. VAT</th>
                            <th className="normal-font">No VAT</th>
                            <th className="normal-font">Inc. VAT</th>
                            <th className="normal-font">Inc. VAT</th>
                            <th className="normal-font">Inc. VAT</th>
                          </tr>
                        </thead>

                        <tbody>
                          {StoragePrice.map((Item: any, index: number) => (
                            <tr
                              key={index}
                              className={
                                StorageData?.[0]?.MNVStoragePriceID ==
                                Item.MNVStoragePriceID
                                  ? "higlight"
                                  : ""
                              }
                            >
                              <td>
                                <div className="btn-start flex-daj">
                                  <a
                                    className="flex-daj btn-primary btn-grid-dec"
                                    onClick={() => {
                                      addLineItem(Item);
                                      OpenLineItemsPopupForJob(1, 1, 1);
                                    }}
                                  >
                                    Add Line Item
                                  </a>
                                </div>
                              </td>

                              <td className="text-right">
                                {Item.AreaSquareFeet}
                              </td>
                              <td className="text-right back-c1">
                                £{Item.ClientPricePerWeekWithoutVAT?.toFixed(2)}
                              </td>
                              <td className="text-right back-c2">
                                <b>£{Item.PricePerWeekWithVAT?.toFixed(2)}</b>
                              </td>
                              <td className="text-right back-c1">
                                £
                                {Item.ClientPricePerMonthWithoutVAT?.toFixed(2)}
                              </td>
                              <td className="text-right back-c2">
                                <b>£{Item.PricePerMonthWithVAT?.toFixed(2)}</b>
                              </td>
                              <td className="text-right back-c3">
                                £
                                {Item.PricePerWeekAfter6MonthsWithVAT?.toFixed(
                                  2,
                                )}
                              </td>
                              <td className="text-right back-c3">
                                £
                                {Item.PricePerMonthAfter6MonthsWithVAT?.toFixed(
                                  2,
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}

                  {/* Payment Section */}

                  <div className="flex-daj flex-gap10 flex-jse mt-10 font-mont">
                    <span className="font-12 bold-font text-left c-red">
                      Payment Paid Until:
                    </span>
                    <div className="field-input">
                      <input
                        type="date"
                        value={
                          StoragePriceObject.paymentpaiduntil
                            ? moment(
                                StoragePriceObject.paymentpaiduntil,
                              ).format("YYYY-MM-DD")
                            : ""
                        }
                        onChange={(e) => {
                          setStoragePriceObject({
                            ...StoragePriceObject,
                            paymentpaiduntil: e.target.value,
                          });
                          setIsPaidUnitChanged(true);
                        }}
                        className="input-field w-100"
                      />
                    </div>
                    <div className="flex-daj btn-start">
                      <a
                        className="flex-daj btn-primary"
                        onClick={() =>
                          setStoragePriceObject({
                            ...StoragePriceObject,
                            AddFuturePayment:
                              !StoragePriceObject.AddFuturePayment,
                          })
                        }
                      >
                        Add Future Payments
                      </a>
                    </div>
                  </div>

                  {StoragePriceObject.AddFuturePayment && (
                    <div className="flex-d flex-gap10 mt-10 input-w-auto">
                      <div className="field-input grid-d flex-gap3">
                        <span className="font-12 text-left label-color">
                          Title
                        </span>
                        <input
                          type="text"
                          value={StoragePriceObject.Title}
                          onChange={(e) =>
                            setStoragePriceObject({
                              ...StoragePriceObject,
                              Title: e.target.value,
                            })
                          }
                          className="input-field"
                        />
                      </div>

                      <div className="field-input grid-d flex-gap3">
                        <span className="font-12 text-left label-color">
                          Amount
                        </span>
                        <input
                          type="text"
                          value={StoragePriceObject.Amount}
                          onChange={(e: any) =>
                            setStoragePriceObject({
                              ...StoragePriceObject,
                              Amount: e.target.value,
                            })
                          }
                          className="input-field"
                        />
                      </div>

                      <div className="field-input grid-d flex-gap3">
                        <span className="font-12 text-left label-color">
                          Repeat Type
                        </span>

                        <select
                          className="input-field"
                          value={StoragePriceObject.RepeatType}
                          onChange={(e) =>
                            setStoragePriceObject({
                              ...StoragePriceObject,
                              RepeatType: Number(e.target.value),
                            })
                          }
                        >
                          <option value={0}>No Repeat</option>
                          <option value={1}>Weekly</option>
                          <option value={2}>Monthly</option>
                        </select>
                      </div>

                      {StoragePriceObject.RepeatType == 0 && (
                        <>
                          <div className="field-input grid-d flex-gap3">
                            <div className="flex-da flex-gap5">
                              <span className="font-12 text-left label-color">
                                Payment Date
                              </span>
                              <span className="font-12 text-left c-red font10">
                                Cut off 3pm
                              </span>
                            </div>

                            <input
                              type="date"
                              value={
                                StoragePriceObject.Date
                                  ? moment(StoragePriceObject.Date).format(
                                      "YYYY-MM-DD",
                                    )
                                  : ""
                              }
                              onChange={(e) =>
                                setStoragePriceObject({
                                  ...StoragePriceObject,
                                  Date: e.target.value,
                                })
                              }
                              className="input-field"
                            />
                          </div>

                          <div className="field-input grid-d flex-gap3">
                            <span className="font-12 text-left label-color">
                              New Paid Until Date:
                            </span>
                            <input
                              type="date"
                              value={
                                StoragePriceObject.PaymentPaidUntil
                                  ? moment(
                                      StoragePriceObject.PaymentPaidUntil,
                                    ).format("YYYY-MM-DD")
                                  : ""
                              }
                              onChange={(e) =>
                                setStoragePriceObject({
                                  ...StoragePriceObject,
                                  PaymentPaidUntil: e.target.value,
                                })
                              }
                              className="input-field"
                            />
                          </div>
                        </>
                      )}

                      {StoragePriceObject.RepeatType !== 0 && (
                        <>
                          <div className="field-input grid-d flex-gap3">
                            <span className="font-12 text-left label-color">
                              Repeat Start From
                            </span>
                            <input
                              type="date"
                              value={
                                StoragePriceObject.RepeatStartFrom
                                  ? moment(
                                      StoragePriceObject.RepeatStartFrom,
                                    ).format("YYYY-MM-DD")
                                  : ""
                              }
                              onChange={(e) =>
                                setStoragePriceObject({
                                  ...StoragePriceObject,
                                  RepeatStartFrom: e.target.value,
                                })
                              }
                              className="input-field"
                            />
                          </div>

                          <div className="field-input grid-d flex-gap3">
                            <span className="font-12 text-left label-color">
                              Repeat Until
                            </span>
                            <input
                              type="date"
                              value={
                                StoragePriceObject.RepeatUntil
                                  ? moment(
                                      StoragePriceObject.RepeatUntil,
                                    ).format("YYYY-MM-DD")
                                  : ""
                              }
                              onChange={(e) =>
                                setStoragePriceObject({
                                  ...StoragePriceObject,
                                  RepeatUntil: e.target.value,
                                })
                              }
                              className="input-field"
                            />
                          </div>
                        </>
                      )}
                      <div className="flex-da flex-gap10 btn-start mt-18">
                        <a
                          className="flex-daj btn-primary"
                          onClick={() => MNVQuoteFuturePaymentSave()}
                        >
                          Save
                        </a>

                        <a
                          className="flex-daj btn-primary"
                          onClick={() => clearAddFuturePayments()}
                        >
                          Cancel
                        </a>
                      </div>
                    </div>
                  )}

                  {/* Future Payments Table */}
                  {FuturePaymentData && FuturePaymentData.length > 0 && (
                    <div className="flow-auto mt-10 auto-height">
                      <table className="reuse-table fixed-table">
                        <thead>
                          <tr>
                            <th>Title</th>
                            <th>Amount</th>
                            <th>Payment Date</th>
                            <th>NEW Paid Until Date</th>
                            <th>Repeat Type</th>
                            <th>Repeat Start From</th>
                            <th>Repeat Until</th>
                            <th>Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          {FuturePaymentData.map((Item: any, index: number) => (
                            <tr key={index}>
                              <td className="text-left">{Item.Title}</td>
                              <td className="text-right">
                                £{Item.TotalAmount?.toFixed(2)}
                              </td>
                              <td className="text-left">
                                {Item.PaymentDate != "" &&
                                  formateDate(Item.PaymentDate)}
                              </td>
                              <td className="text-left">
                                {Item.PaymentPaidUntil != "" &&
                                  formateDate(Item.PaymentPaidUntil)}
                              </td>
                              <td className="text-left">
                                {Item.RepeatType == 0 && "No Repeat"}
                                {Item.RepeatType == 1 && "Weekly"}
                                {Item.RepeatType == 2 && "Monthly"}
                              </td>
                              <td className="text-left">
                                {Item.RepeatStartFrom != "" &&
                                  formateDate(Item.RepeatStartFrom)}
                              </td>
                              <td className="text-left">
                                {Item.RepeatUntil != "" &&
                                  formateDate(Item.RepeatUntil)}
                              </td>

                              <td>
                                <div className="flex-daj flex-gap10">
                                  <a
                                    className="flex-d"
                                    onClick={() => EditFuturePaymentData(Item)}
                                  >
                                    <img
                                      src="/images/edit.svg"
                                      width="18px"
                                      height="18px"
                                      alt="Edit"
                                    />
                                  </a>

                                  <a
                                    className="flex-d"
                                    onClick={() =>
                                      DeleteFuturePaymentData(
                                        Item.MNVQuoteFuturePaymentID,
                                      )
                                    }
                                  >
                                    <img
                                      src="/images/delete.png"
                                      width="18px"
                                      height="18px"
                                      alt="Edit"
                                    />
                                  </a>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </>
              )}
            </>
          )}
          <div className="accordion-top flex-da justify-btw grey-accord">
            Services
          </div>
          <>
            {/* Services List */}
            <div className="grid-d fr-111 gap-20 mt-20">
              {services &&
                services.map((service: any, i: any) => (
                  <div key={i}>
                    {(service.MNVMoveTypeServiceID !== 8 ||
                      (service.MNVMoveTypeServiceID == 8 &&
                        (info.FromCountryCode !== "GB" ||
                          info.ToCountryCode !== "GB"))) && (
                      <div className="flex-da flex-gap10">
                        <input
                          type="radio"
                          name="fav_language"
                          value={service.Name}
                          id={service.Name}
                          onChange={(e) =>
                            onServiceChange(e, service.MNVMoveTypeServiceID)
                          }
                          checked={service.MNVMoveTypeServiceID == ServiceID}
                        />

                        <label
                          htmlFor={service.Name}
                          className="font-12 text-left label-color"
                        >
                          {service.Name}
                        </label>
                      </div>
                    )}
                  </div>
                ))}
            </div>

            {/* Questions Section */}
            {/* {'questionsAndOptions: '+questionsAndOptions.length} */}
            <div className="grid-d fr-1 gap-20 mt-20">
              {/* {questionsAndOptions.map((item: any, index: any) => (
                <div key={item.QuestionId}>
                  <div
                    id={`row_${item.QuestionId}`}
                    className="field-input flex-da flex-gap10"
                  >
                    <span className="font-12 text-left label-color w-30p">
                      {item.Question}
                    </span>

                    <>
                      {optionsFromDB.length == 0 ? (
                        <select
                          className="input-field max-wid-input w-100"
                          onChange={(e) =>
                            onOptionChange(
                              Number(e.target.value),
                              item.QuestionId,
                            )
                          }
                        >
                          <option value="0">Please Select</option>
                          {item.QuestionOptions.map((option: any) => (
                            <option
                              key={option.OptionsId}
                              value={option.OptionsId}
                            >
                              {option.Options}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <select
                          className="input-field max-wid-input w-100"
                          defaultValue={optionsFromDB[index]}
                          onChange={(e) => {
                            onOptionChange(
                              Number(e.target.value),
                              item.QuestionId,
                            );
                          }}
                        >
                          <option value="0">Please Select</option>

                          {item.QuestionOptions.map((option: any) => (
                            <option
                              key={option.OptionsId}
                              value={option.OptionsId}
                            >
                              {option.Options}
                            </option>
                          ))}
                        </select>
                      )}
                    </>
                  </div>
                </div>
              ))}
              <hr></hr> */}
              {questions &&
                questions.map((item: any, index: number) => {
                  if (!showThisQuestion(item.MNVMoveTypeServiceQuestionID)) {
                    return null;
                  }
                  return (
                    <React.Fragment
                      key={"question" + item.MNVMoveTypeServiceQuestionID}
                    >
                      {showThisQuestion(item.MNVMoveTypeServiceQuestionID) && (
                        <>
                          <div className="field-input flex-da flex-gap10">
                            <span className="font-12 text-left label-color w-30p">
                              {item.Name}
                            </span>

                            <>
                              {optionsFromDB.length == 0 ? (
                                <select
                                  className="input-field max-wid-input w-100"
                                  onChange={(e) => {
                                    onOptionChange(
                                      Number(e.target.value),
                                      item.MNVMoveTypeServiceQuestionID,
                                    );
                                  }}
                                >
                                  <option value="0">Please Select</option>
                                  {questionOptions &&
                                    questionOptions.map((option: any) => (
                                      <React.Fragment
                                        key={
                                          option.MNVMoveTypeServiceQuestionOptionID
                                        }
                                      >
                                        {item.MNVMoveTypeServiceQuestionID ===
                                          option.MNVMoveTypeServiceQuestionID && (
                                          <option
                                            selected={option.IsChecked}
                                            value={
                                              option.MNVMoveTypeServiceQuestionOptionID
                                            }
                                          >
                                            {option.Name}
                                          </option>
                                        )}
                                      </React.Fragment>
                                    ))}
                                </select>
                              ) : (
                                <select
                                  className="input-field max-wid-input w-100"
                                  onChange={(e) => {
                                    onOptionChange(
                                      Number(e.target.value),
                                      item.MNVMoveTypeServiceQuestionID,
                                    );
                                  }}
                                >
                                  <option value="0">Please Select</option>

                                  {questionOptions &&
                                    questionOptions.map((option: any) => (
                                      <React.Fragment
                                        key={
                                          option.MNVMoveTypeServiceQuestionOptionID
                                        }
                                      >
                                        {item.MNVMoveTypeServiceQuestionID ===
                                          option.MNVMoveTypeServiceQuestionID && (
                                          <option
                                            selected={option.IsChecked}
                                            value={
                                              option.MNVMoveTypeServiceQuestionOptionID
                                            }
                                          >
                                            {option.Name}
                                          </option>
                                        )}
                                      </React.Fragment>
                                    ))}
                                </select>
                              )}
                            </>
                          </div>

                          {subQuestions &&
                            subQuestions.map((s_item: any, s_index: number) => (
                              <React.Fragment key={s_index}>
                                {showThisQuestion(
                                  s_item.MNVMoveTypeServiceQuestionID,
                                ) &&
                                  s_item.ParentID ==
                                    item.MNVMoveTypeServiceQuestionID && (
                                    <div className="field-input flex-da flex-gap10">
                                      <span className="font-12 text-left label-color w-30p pl--15">
                                        {s_item.Name}
                                      </span>

                                      <>
                                        {optionsFromDB.length == 0 ? (
                                          <select
                                            className="input-field max-wid-input w-100"
                                            onChange={(e) =>
                                              onOptionChange(
                                                Number(e.target.value),
                                                s_item.MNVMoveTypeServiceQuestionID,
                                              )
                                            }
                                          >
                                            <option value="0">
                                              Please Select
                                            </option>
                                            {questionOptions &&
                                              questionOptions.map(
                                                (option: any) => (
                                                  <React.Fragment
                                                    key={
                                                      option.MNVMoveTypeServiceQuestionOptionID
                                                    }
                                                  >
                                                    {s_item.MNVMoveTypeServiceQuestionID ===
                                                      option.MNVMoveTypeServiceQuestionID && (
                                                      <option
                                                        selected={
                                                          option.IsChecked
                                                        }
                                                        value={
                                                          option.MNVMoveTypeServiceQuestionOptionID
                                                        }
                                                      >
                                                        {option.Name}
                                                      </option>
                                                    )}
                                                  </React.Fragment>
                                                ),
                                              )}
                                          </select>
                                        ) : (
                                          <select
                                            className="input-field max-wid-input w-100"
                                            onChange={(e) =>
                                              onOptionChange(
                                                Number(e.target.value),
                                                s_item.MNVMoveTypeServiceQuestionID,
                                              )
                                            }
                                          >
                                            <option value="0">
                                              Please Select
                                            </option>

                                            {questionOptions &&
                                              questionOptions.map(
                                                (option: any) => (
                                                  <React.Fragment
                                                    key={
                                                      option.MNVMoveTypeServiceQuestionOptionID
                                                    }
                                                  >
                                                    {s_item.MNVMoveTypeServiceQuestionID ===
                                                      option.MNVMoveTypeServiceQuestionID && (
                                                      <option
                                                        selected={
                                                          option.IsChecked
                                                        }
                                                        value={
                                                          option.MNVMoveTypeServiceQuestionOptionID
                                                        }
                                                      >
                                                        {option.Name}
                                                      </option>
                                                    )}
                                                  </React.Fragment>
                                                ),
                                              )}
                                          </select>
                                        )}
                                      </>
                                    </div>
                                  )}
                              </React.Fragment>
                            ))}
                        </>
                      )}
                    </React.Fragment>
                  );
                })}

              <div className="grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Is Item Over 100 KG?
                </span>

                <div className="flex-d">
                  <input
                    type="checkbox"
                    checked={info.IsItemsOver100KG}
                    className="input-field"
                    onChange={(e) =>
                      setInfo({ ...info, IsItemsOver100KG: e.target.checked })
                    }
                  />
                </div>
              </div>
            </div>

            {/* Packing Job Component */}
            <PackingJob QuoteID={QuoteId} IsReadOnly={false} />
          </>
          <>
            {/* Quote Detail */}

            <div className="accordion-top flex-da justify-btw grey-accord">
              Quote Detail
            </div>
            <div className="grid-d flex-gap20 mt-20">
              <div className="flex-d flex-jsb w-100 reuse-border p-all10 flex-gap10">
                <div className="flex-d flex-gap40">
                  {/* Van Type */}
                  {!globalState.IsDriverLoggedIn && (
                    <div className="field-input grid-d flex-gap3 ">
                      <span className="font-12 text-left label-color">
                        Van Type
                      </span>
                      {MNVQuoteRecordDataForForeignKeys &&
                        MNVQuoteRecordDataForForeignKeys.length > 0 && (
                          <select
                            className="input-field"
                            value={MNVQuote.MNVVanTypeID}
                            onChange={(e) => {
                              SelectVan(e);
                              setMNVQuote({
                                ...MNVQuote,
                                MNVVanTypeID: e.target.value,
                              });
                            }}
                          >
                            <option value={0}>Select VAN Type</option>
                            {MNVQuoteRecordDataForForeignKeys &&
                              MNVQuoteRecordDataForForeignKeys[1] &&
                              MNVQuoteRecordDataForForeignKeys[1].map(
                                (row: any) => (
                                  <option key={row.PID} value={row.PID}>
                                    {row.Name}
                                  </option>
                                ),
                              )}
                          </select>
                        )}
                    </div>
                  )}

                  {/* Number of Movers */}
                  {!globalState.IsDriverLoggedIn && (
                    <div className="field-input grid-d flex-gap3 ">
                      <span className="font-12 text-left label-color">
                        Number of Movers
                      </span>

                      <select
                        className="input-field"
                        value={MNVQuote.MNVMoverTypeID}
                        onChange={(e) => {
                          setMNVQuote({
                            ...MNVQuote,
                            MNVMoverTypeID: e.target.value,
                          });
                          setInfo({
                            ...info,
                            MNVMoverTypeID: e.target.value,
                          });
                        }}
                      >
                        <option value="0">Select Mover Type</option>
                        {MNVQuoteRecordDataForForeignKeys &&
                          MNVQuoteRecordDataForForeignKeys[2] &&
                          MNVQuoteRecordDataForForeignKeys[2].map(
                            (row: any) => (
                              <option key={row.PID} value={row.PID}>
                                {row.Name}
                              </option>
                            ),
                          )}
                      </select>
                    </div>
                  )}

                  {/* Driver & Helpers dynamically */}
                  {MNVQuote.MNVMoverTypeID >= 1 && resources && (
                    <>
                      <div className="field-input grid-d flex-gap3 ">
                        <span className="font-12 text-left label-color">
                          Driver
                        </span>
                        <span className="font-14 text-left label-color">
                          {selectedMovers.DriverName}
                        </span>
                      </div>

                      {MNVQuote.MNVMoverTypeID >= 2 && (
                        <div className="field-input grid-d flex-gap3 ">
                          <span className="font-12 text-left label-color">
                            Helper 1
                          </span>
                          <span className="font-14 text-left label-color">
                            {selectedMovers.Helper1Name}
                          </span>
                        </div>
                      )}

                      {MNVQuote.MNVMoverTypeID >= 3 && (
                        <div className="field-input grid-d flex-gap3 ">
                          <span className="font-12 text-left label-color">
                            Helper 2
                          </span>
                          <span className="font-14 text-left label-color">
                            {selectedMovers.Helper2Name}
                          </span>
                        </div>
                      )}
                    </>
                  )}
                </div>

                {/* Buttons */}
                <div className="flex-d flex-ac flex-gap20 mt-20">
                  {MNVQuote.MNVQuoteStatusID == 1 && (
                    <a
                      className="flex-d"
                      onClick={() =>
                        ChangeStatusForQuoteOrAllQuotesInOneJob(
                          MNVQuote.MNVQuoteID,
                          4,
                        )
                      }
                      title="Mark as Completed"
                    >
                      <img
                        src="/images/check.svg"
                        width={25}
                        height={25}
                        alt="check"
                      />
                    </a>
                  )}

                  {MNVQuote.MNVQuoteStatusID !== 0 &&
                    MNVQuote.MNVQuoteStatusID !== 5 &&
                    MNVQuote.MNVQuoteStatusID !== 6 && (
                      <>
                        <a
                          className="flex-d"
                          // onClick={() => OpenLineItemsPopup(sendemailtomover)}
                          onClick={() => OpenPopup(1)}
                          title="Send Email to Mover"
                        >
                          <img
                            src="/images/envelopen.svg"
                            width={25}
                            height={25}
                            alt="check"
                          />
                        </a>

                        <a
                          className="flex-d"
                          // onClick={() => OpenLineItemsPopup(sendwhatsapptomover)}
                          onClick={() => OpenPopup(2)}
                          title="WhatsApp Job Details to Mover"
                        >
                          <img
                            src="/images/whatsapp.svg"
                            width={25}
                            height={25}
                            alt="check"
                          />
                        </a>
                      </>
                    )}

                  {MNVQuote.MNVQuoteStatusID == 6 && (
                    <a
                      className="flex-d"
                      title="Add Van and Mover"
                      onClick={() => AddNew(QuoteId, true)}
                    >
                      <img
                        src="/images/add.svg"
                        width={25}
                        height={25}
                        alt="check"
                      />
                    </a>
                  )}
                </div>
              </div>

              {/* Additional Services Loop */}
              {/* {'AdditionalServices.length '+AdditionalServices.length} */}
              {AdditionalServices &&
                AdditionalServices.map((Service, index) => (
                  <div
                    className="flex-d flex-jsb w-100 reuse-border p-all10 flex-gap10"
                    key={index}
                  >
                    <div className="flex-d flex-gap40">
                      {/* Van Type */}
                      <div className="field-input grid-d flex-gap3 ">
                        <span className="font-12 text-left label-color">
                          Van Type
                        </span>

                        <select
                          className="input-field"
                          value={AdditionalServices[index].MNVVanTypeID}
                          onChange={(e) =>
                            SelectVanForAdditional(
                              e.target.value,
                              index,
                              "MNVVanTypeID",
                            )
                          }
                        >
                          <option value="0">Select Van Type</option>
                          {MNVQuoteRecordDataForForeignKeys &&
                            MNVQuoteRecordDataForForeignKeys[1] &&
                            MNVQuoteRecordDataForForeignKeys[1].map(
                              (row: any) => (
                                <option key={row.PID} value={row.PID}>
                                  {row.Name}
                                </option>
                              ),
                            )}
                        </select>
                      </div>

                      {/* Movers */}
                      <div className="field-input grid-d flex-gap3 ">
                        <span className="font-12 text-left label-color">
                          Number of Movers
                        </span>

                        <select
                          className="input-field"
                          value={AdditionalServices[index].MNVMoverTypeID}
                          onChange={(e) =>
                            SelectVanForAdditional(
                              e.target.value,
                              index,
                              "MNVMoverTypeID",
                            )
                          }
                        >
                          <option value="0">Select Mover Type</option>
                          {MNVQuoteRecordDataForForeignKeys &&
                            MNVQuoteRecordDataForForeignKeys[2] &&
                            MNVQuoteRecordDataForForeignKeys[2].map(
                              (row: any) => (
                                <option key={row.PID} value={row.PID}>
                                  {row.Name}
                                </option>
                              ),
                            )}
                        </select>
                      </div>

                      {/* Driver */}
                      {AdditionalServices[index].MNVMoverTypeID > 0 && (
                        <div className="field-input grid-d flex-gap3 ">
                          <span className="font-12 text-left label-color">
                            Driver
                          </span>
                          <span className="font-14 text-left label-color">
                            {Service.DriverName}
                          </span>
                        </div>
                      )}

                      {/* Helpers */}
                      {AdditionalServices[index].MNVMoverTypeID > 1 && (
                        <div className="field-input grid-d flex-gap3 ">
                          <span className="font-12 text-left label-color">
                            Helper 1
                          </span>
                          <span className="font-14 text-left label-color">
                            {Service.Helper1Name}
                          </span>
                        </div>
                      )}

                      {AdditionalServices[index].MNVMoverTypeID > 2 && (
                        <div className="field-input grid-d flex-gap3 ">
                          <span className="font-12 text-left label-color">
                            Helper 2
                          </span>
                          <span className="font-14 text-left label-color">
                            {Service.Helper2Name}
                          </span>
                        </div>
                      )}
                    </div>

                    {/* Buttons */}
                    <div className="flex-d flex-ac flex-gap20 mt-20">
                      {Service.MNVQuoteStatusID == 1 && (
                        <a
                          className="flex-d"
                          onClick={() =>
                            ChangeStatusForQuoteOrAllQuotesInOneJob(
                              Service.MNVQuoteID,
                              4,
                            )
                          }
                          title="Mark as Completed"
                        >
                          <img
                            src="/images/check.svg"
                            width={25}
                            height={25}
                            alt="check"
                          />
                        </a>
                      )}

                      {MNVQuote.MNVQuoteStatusID !== 0 &&
                        MNVQuote.MNVQuoteStatusID !== 5 &&
                        MNVQuote.MNVQuoteStatusID !== 6 && (
                          <>
                            <a
                              className="flex-d"
                              // onClick={() =>
                              //   OpenLineItemsPopup(sendemailtomover, 1, Service.DriverEmail, Service.MNVQuoteID)
                              // }
                              onClick={() =>
                                OpenPopup(
                                  1,
                                  1,
                                  Service.DriverEmail,
                                  Service.MNVQuoteID,
                                )
                              }
                              title="Send Email to Mover"
                            >
                              <img
                                src="/images/envelopen.svg"
                                width={25}
                                height={25}
                                alt="check"
                              />
                            </a>

                            <a
                              className="flex-d"
                              // onClick={() =>
                              //   OpenLineItemsPopup(sendwhatsapptomover, 2, Service.DriverMobile, Service.MNVQuoteID)
                              // }
                              onClick={() =>
                                OpenPopup(
                                  1,
                                  2,
                                  Service.DriverEmail,
                                  Service.MNVQuoteID,
                                )
                              }
                              title="WhatsApp Job Details to Mover"
                            >
                              <img
                                src="/images/whatsapp.svg"
                                width={25}
                                height={25}
                                alt="check"
                              />
                            </a>
                          </>
                        )}

                      <a
                        onClick={() =>
                          UnlinkQuoteFromJob(Service.MNVQuoteID, 0, -1)
                        }
                        className="flex-d"
                      >
                        <img
                          src="/images/delete.png"
                          width={25}
                          height={25}
                          alt="check"
                        />
                      </a>
                    </div>
                  </div>
                ))}
            </div>
            <div className="grid-d fr-111 gap-20 mt-20 flex-jas">
              {/* Status */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Status</span>

                <select
                  value={MNVQuote.MNVQuoteStatusID}
                  disabled
                  className="input-field w-100"
                >
                  <option value={0}>Select Status</option>
                  {MNVQuoteRecordDataForForeignKeys &&
                    MNVQuoteRecordDataForForeignKeys[4] &&
                    MNVQuoteRecordDataForForeignKeys[4].map((row: any) => (
                      <option key={row.PID} value={row.PID}>
                        {row.Name}
                      </option>
                    ))}
                </select>
                <div className="btn-start flex-da">
                  {(MNVQuote.MNVQuoteStatusID == 1 ||
                    MNVQuote.MNVQuoteStatusID == 2) &&
                    AllLinkedQuotes.length == 1 && (
                      <a
                        className="flex-daj btn-primary relative-btn"
                        style={{ marginTop: 5, marginRight: 10 }}
                        onClick={() => ChangetoConfirmationQuote(6)}
                      >
                        Change to Quote
                      </a>
                    )}
                  {/* 
  {(MNVQuote.MNVQuoteStatusID == 1 ||
                    MNVQuote.MNVQuoteStatusID == 2) &&
                    AllLinkedQuotes.length == 1 && (
                      <a
                        className="flex-daj btn-primary relative-btn"
                        style={{ marginTop: 5, marginRight: 10 }}
                        onClick={() => ChangetoConfirmationQuote(3)}
                      >
                        Change to On Hold
                      </a>
                    )} */}

                  {(MNVQuote.MNVQuoteStatusID == 1 ||
                    MNVQuote.MNVQuoteStatusID == 2) && (
                    <a
                      className="flex-daj btn-primary relative-btn"
                      onClick={() => ChangetoConfirmationQuote(5)}
                    >
                      Change to Cancellation
                    </a>
                  )}
                </div>
              </div>
              {!globalState.IsDriverLoggedIn && (
                <div className="grid-d flex-gap3">
                  <span className="font-12 text-left label-color">
                    Local Quote
                  </span>

                  <div className="flex-d">
                    <input
                      type="checkbox"
                      checked={MNVQuote.IsLocalQuote}
                      onChange={(e) => {
                        setMNVQuote({
                          ...MNVQuote,
                          IsLocalQuote: e.target.checked,
                        });
                        ChangeQuoteType();
                      }}
                      className="input-field"
                    />
                  </div>
                </div>
              )}
              {/* Local Quote */}

              {!MNVQuote.IsLocalQuote && (
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">
                    Loading Unloading Minutes
                  </span>
                  <span className="font-14 text-left label-color">
                    {info.LoadingUnLoadingTimeInMinutes}
                  </span>
                </div>
              )}

              {/* Hours & Service Timer Block */}
              <div className="field-input grid-d flex-gap3">
                {MNVQuote.IsLocalQuote ? (
                  <span className="font-12 text-left label-color">
                    Van Booked for (Hours)
                  </span>
                ) : (
                  <span className="font-12 text-left label-color">
                    Service Time
                  </span>
                )}
                <div className="flex-d flex-gap10">
                  {/* Local Time */}
                  {MNVQuote.IsLocalQuote && (
                    <select
                      className="input-field w-100"
                      value={selectedTime}
                      onChange={(e) => setSelectedTime(e.target.value)}
                    >
                      {/* {[
                        1.5, 2, 2.5, 3, 3.5, 4, 4.5, 5, 5.5, 6, 6.5, 7, 7.5, 8,
                        8.5, 9, 9.5, 10, 10.5, 11, 11.5, 12, 12.5, 13, 13.5, 14,
                        14.5, 15, 15.5, 16, 16.5, 17, 17.5, 18, 18.5, 19, 19.5,
                        20, 20.5, 21,
                      ].map((t) => (
                        <option key={t} value={t}>
                          {t} hours
                        </option>
                      ))} */}
                      <option value="1.5">1.5 hours</option>
                      <option value="2">2 hours</option>
                      <option value="2.5">2 and a half hours</option>
                      <option value="3">3 hours</option>
                      <option value="3.5">3 and a half hours</option>
                      <option value="4">4 hours</option>
                      <option value="4.5">4 and a half hours</option>
                      <option value="5">5 hours</option>
                      <option value="5.5">5 and a half hours</option>
                      <option value="6">6 hours</option>
                      <option value="6.5">6 and a half hours</option>
                      <option value="7">7 hours</option>
                      <option value="7.5">7 and a half hours</option>
                      <option value="8">8 hours</option>
                      <option value="8.5">8 and a half hours</option>
                      <option value="9">9 hours</option>
                      <option value="9.5">9 and a half hours</option>
                      <option value="10">10 hours</option>
                      <option value="10.5">10 and a half hours</option>
                      <option value="11">11 hours</option>
                      <option value="11.5">11 and a half hours</option>
                      <option value="12">12 hours</option>
                      <option value="12.5">12 hours and a half</option>
                      <option value="13">13 hours</option>
                      <option value="13.5">13 and a half hours</option>
                      <option value="14">14 hours</option>
                      <option value="14.5">14 and a half hours</option>
                      <option value="15">15 hours</option>
                      <option value="15.5">15 and a half hours</option>
                      <option value="16">16 hours</option>
                      <option value="16.5">16 and a half hours</option>
                      <option value="17">17 hours</option>
                      <option value="17.5">17 and a half hours</option>
                      <option value="18">18 hours</option>
                      <option value="18.5">18 and a half hours</option>
                      <option value="19">19 hours</option>
                      <option value="19.5">19 and a half hours</option>
                      <option value="20">20 hours</option>
                      <option value="20.5">20 and a half hours</option>
                      <option value="21">21 hours</option>
                    </select>
                  )}

                  {/* Long Service Time */}
                  {!MNVQuote.IsLocalQuote && (
                    <>
                      <select
                        className="input-field w-100"
                        value={loadingTimeInSeconds}
                        onChange={(e: any) => {
                          setLoadingTimeInSeconds(e.target.value);
                          onLongServiceTimeChange(1, e.target.value);
                        }}
                      >
                        {/* {[
                          15, 30, 45, 60, 90, 120, 150, 180, 210, 240, 270, 300,
                        ].map((v) => (
                          <option key={v} value={v}>
                            {v} mins
                          </option>
                        ))} */}

                        <option value="15">15mins</option>
                        <option value="30">30mins</option>
                        <option value="45">45mins</option>
                        <option value="60">1hr</option>
                        <option value="90">1hr & 30mins</option>
                        <option value="120">2hrs</option>
                        <option value="150">2hrs & 30mins</option>
                        <option value="180">3hrs</option>
                        <option value="210">3hrs & 30mins</option>
                        <option value="240">4hrs</option>
                        <option value="270">4hrs & 30mins</option>
                        <option value="300">5hrs</option>
                      </select>

                      <select
                        className="input-field w-100"
                        value={unloadingTimeInSeconds}
                        onChange={(e: any) => {
                          setUnloadingTimeInSeconds(e.target.value);
                          onLongServiceTimeChange(2, e.target.value);
                        }}
                      >
                        {/* {[
                          15, 30, 45, 60, 90, 120, 150, 180, 210, 240, 270, 300,
                        ].map((v) => (
                          <option key={v} value={v}>
                            {v} mins
                          </option>
                        ))} */}
                        <option value="15">15mins</option>
                        <option value="30">30mins</option>
                        <option value="45">45mins</option>
                        <option value="60">1hr</option>
                        <option value="90">1hr & 30mins</option>
                        <option value="120">2hrs</option>
                        <option value="150">2hrs & 30mins</option>
                        <option value="180">3hrs</option>
                        <option value="210">3hrs & 30mins</option>
                        <option value="240">4hrs</option>
                        <option value="270">4hrs & 30mins</option>
                        <option value="300">5hrs</option>
                      </select>
                    </>
                  )}
                </div>

                {MNVQuote.IsLocalQuote &&
                  selectedTime <= MNVQuote.MinimumHours && (
                    <span className="font-10 text-left c-red">
                      Minimum charge is: {MNVQuote.MinimumHours}hrs.
                    </span>
                  )}
              </div>

              {/* Requested Date */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Requested Date
                </span>
                <input
                  className="input-field w-100"
                  disabled
                  type="date"
                  value={moment(MNVQuote.RequestedDate).format("YYYY-MM-DD")}
                />
              </div>

              {/* Requested Time Slot */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Requested Time Slot
                </span>
                <input
                  className="input-field w-100"
                  type="text"
                  value={MNVQuote.RequestedTime}
                  onChange={(e) =>
                    setMNVQuote({
                      ...MNVQuote,
                      RequestedTime: e.target.value,
                    })
                  }
                  disabled
                />
                <div className="flex-da flex-gap10 btn-start">
                  {!globalState.IsDriverLoggedIn && (
                    <>
                      <a
                        className="flex-daj btn-primary relative-btn"
                        onClick={() => {
                          GetVanSlots(true);
                          setShowSlotsModal(true);
                        }}
                      >
                        Change Slots
                      </a>

                      <a
                        className="flex-daj btn-primary relative-btn"
                        onClick={() => {
                          setShowBespokeModal(true);
                          clearObject();
                        }}
                      >
                        Add Bespoke Booking
                      </a>
                    </>
                  )}
                </div>
              </div>

              {/* Duration, Additional Time, Distance - driver only */}
              {!globalState.IsDriverLoggedIn && (
                <>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Duration
                    </span>
                    <input
                      type="text"
                      value={PTDDurationDisplay}
                      disabled
                      className="input-field w-100"
                    />
                  </div>

                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Additional Time in Minutes
                    </span>
                    <input
                      className="input-field w-100"
                      type="number"
                      value={info.Name}
                      onChange={(e) => {
                        setInfo({ ...info, Name: e.target.value });
                      }}
                    />
                  </div>

                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Distance
                    </span>
                    <input
                      type="text"
                      value={ShowTotalDistance}
                      className="input-field w-100"
                      disabled
                    />
                  </div>
                </>
              )}

              {/* Client Instructions */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Client Instructions
                </span>
                <textarea
                  className="input-field w-100"
                  value={ClientInstructions}
                  onChange={(e) => setClientInstructions(e.target.value)}
                ></textarea>
              </div>
            </div>
            {/* Driver Instructions */}
            <div className="field-input grid-d flex-gap3 mt-20">
              <span className="font-12 text-left label-color">
                Driver Instructions
              </span>
              {/* <textarea
                  value={info.FromFloor}
                  onChange={(e) =>
                    setInfo({ ...info, FromFloor: e.target.value })
                  }
                  className="input-field w-100"
                ></textarea> */}

              <div className="ck-editor-container driver-inst-editor">
                <QuillEditor
                  value={info.FromFloor}
                  onChange={(value: string) =>
                    setInfo((prev: any) => ({
                      ...prev,
                      FromFloor: value,
                    }))
                  }
                />
              </div>
            </div>
          </>

          <>
            <div className="accordion-top flex-da justify-btw grey-accord">
              Admin Section
            </div>
            <div className="grid-d fr-111 gap-20 mt-20 flex-jas">
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Admin Notes
                </span>
                <textarea
                  value={info.AdminNotes}
                  onChange={(e) =>
                    setInfo({ ...info, AdminNotes: e.target.value })
                  }
                  className="input-field w-100"
                ></textarea>
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Quote Inclusion Notes
                </span>
                <textarea
                  value={info.QuoteInclusionNotes}
                  onChange={(e) =>
                    setInfo({ ...info, QuoteInclusionNotes: e.target.value })
                  }
                  className="input-field w-100"
                ></textarea>
              </div>
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Final Delivery Address
                </span>
                <textarea
                  value={info.FinalDeliveryAddress}
                  onChange={(e) =>
                    setInfo({ ...info, FinalDeliveryAddress: e.target.value })
                  }
                  className="input-field w-100"
                ></textarea>
              </div>
              <div className="field-input grid-d flex-gap3 no-absolute">
                <span className="font-12 text-left label-color">
                  Move Manager Names: {info.MoveManagerNames}
                </span>
                {/* <textarea
                  value={info.MoveManagerNames}
                  onChange={(e) =>
                    setInfo({ ...info, MoveManagerNames: e.target.value })
                  }
                  className="input-field w-100"
                ></textarea> */}

                <MultiSelectionDropdownWithSave
                  listData={moveManagerList}
                  selectAllName={"Select Move Manager"}
                  selectFewName={"Select Move Manager"}
                  updateSelectedPIDForParent={updateSelectedPIDForParent}
                  type={1}
                  selectedPID={selectedMoveManagerIds}
                ></MultiSelectionDropdownWithSave>
              </div>
              <div className="grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  1st follow up done
                </span>

                <div className="flex-d">
                  <input
                    type="checkbox"
                    checked={info.IsFirstFollowUpDone}
                    className="input-field"
                    onChange={(e) =>
                      setInfo({
                        ...info,
                        IsFirstFollowUpDone: e.target.checked,
                      })
                    }
                  />
                </div>
              </div>
              <div className="grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  2nd follow up done
                </span>

                <div className="flex-d">
                  <input
                    type="checkbox"
                    checked={info.IsSecondFollowUpDone}
                    className="input-field"
                    onChange={(e) =>
                      setInfo({
                        ...info,
                        IsSecondFollowUpDone: e.target.checked,
                      })
                    }
                  />
                </div>
              </div>
            </div>
          </>

          <div className="accordion-top flex-da justify-btw grey-accord">
            Media
          </div>
          <PTDragDropUpload
            ObjectType={1}
            ObjectID={QuoteId}
            UploadType={1}
            MaxNumberOfFiles={100}
            CanEditFiles={true}
            onResponse={ResponseFromPTUploader}
          />

          <div className="accordion-top flex-da justify-btw grey-accord">
            Insurance
          </div>
          <div className="grid-d fr-21 flex-gap20 mt-20 flex-as">
            <div className="grid-d fr-1 gap-20 dclaim-box">
              {/* Include Insurance checkbox */}
              {FileURL !== "false" && (
                <div className="flex-da flex-gap10">
                  <input
                    type="checkbox"
                    defaultChecked={true}
                    onClick={() => setFileURL("false")}
                  />
                  <span className="font-12 text-left label-color">
                    Include Insurance
                  </span>
                </div>
              )}

              {FileURL == "false" && (
                <div
                  className="flex-da flex-gap10"
                  onClick={() => setFileURL("true")}
                >
                  <input type="checkbox" defaultChecked={false} readOnly />
                  <span className="font-12 text-left label-color">
                    Include Insurance
                  </span>
                </div>
              )}

              {/* Terms & Conditions */}
              <div className="flex-da flex-gap10">
                <input
                  type="checkbox"
                  checked={info.IsTermsAndConditionsAccepted}
                  onChange={(e) =>
                    setInfo({
                      ...info,
                      IsTermsAndConditionsAccepted: e.target.checked,
                    })
                  }
                />
                <span className="font-12 text-left label-color">
                  By proceeding you authorise Finest Removals to take additional
                  payment for time or parking costs if applicable.
                </span>
              </div>

              {/* Payment Authorised */}
              <div className="flex-da flex-gap10">
                <input
                  type="checkbox"
                  checked={info.IsPaymentAuthorised}
                  onChange={(e) =>
                    setInfo({
                      ...info,
                      IsPaymentAuthorised: e.target.checked,
                    })
                  }
                />
                <span className="font-12 text-left label-color">
                  I have read and accept the terms and conditions.
                </span>
              </div>

              {/* Read & Understood */}
              <div className="flex-da flex-gap10">
                <input
                  type="checkbox"
                  checked={info.IsReadAndUnderstood}
                  onChange={(e) =>
                    setInfo({
                      ...info,
                      IsReadAndUnderstood: e.target.checked,
                    })
                  }
                />
                <span className="font-12 text-left label-color">
                  I have read and understood.
                </span>
              </div>

              {/* Value Declared */}
              <div className="flex-da flex-gap10">
                <input
                  type="checkbox"
                  checked={info.IsValueOfGoodsDeclared}
                  onChange={(e) => {
                    setInfo({
                      ...info,
                      IsValueOfGoodsDeclared: e.target.checked,
                    });
                  }}
                />
                <span className="font-12 text-left label-color">
                  Would you like to declare the value of goods.
                </span>
              </div>

              {/* Value of Goods */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">
                  Value of Goods
                </span>

                <div className="p-relative flex-d">
                  <span className="pound-absolute">£</span>

                  <input
                    className="input-field w-100 max-w-300"
                    placeholder="00.00"
                    value={info.ValueOfGoods}
                    onBlur={() => OpenConfirmationForLiabilityChanges()}
                    onChange={(e) =>
                      setInfo({
                        ...info,
                        ValueOfGoods: Number(e.target.value),
                      })
                    }
                  />
                </div>
              </div>

              {/* Additional Liability Charge */}
              {info.ValueOfGoods > 15000 && (
                <div className="field-input grid-d flex-gap3">
                  <span className="font-12 text-left label-color">
                    Additional liability charge is £
                    {((info.ValueOfGoods - 15000) * 0.009)?.toLocaleString(
                      undefined,
                      {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      },
                    )}
                  </span>
                </div>
              )}

              {/* Full Name */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Full Name</span>

                <input
                  type="text"
                  className="input-field w-100 max-w-300"
                  value={info.FullName}
                  onChange={(e) =>
                    setInfo({ ...info, FullName: e.target.value })
                  }
                />
              </div>

              {/* Initials */}
              <div className="field-input grid-d flex-gap3">
                <span className="font-12 text-left label-color">Initials</span>

                <input
                  type="text"
                  className="input-field w-100 max-w-300"
                  value={info.Initials}
                  onChange={(e) =>
                    setInfo({ ...info, Initials: e.target.value })
                  }
                />
              </div>
            </div>
            {/* Damage Claim Section */}
            {damageClaimJobData && damageClaimJobData.length > 0 && (
              <div className="grid-d fr-1 gap-20 font-mont gap-20">
                <span className="font-16 bold-font flex-d d-claim-bor">
                  Damage Claim
                </span>

                <div className="flex-d flex-ac flex-gap5 font-12">
                  Claim Date:
                  <span className="bold-font">
                    {new Date(
                      damageClaimJobData[0].ClaimDate,
                    ).toLocaleDateString("en-GB")}
                  </span>
                </div>

                <div className="flex-d flex-ac flex-gap5 font-12">
                  Movers List:
                  <span className="bold-font">
                    {damageClaimJobData[0].MoversList}
                  </span>
                </div>

                <div className="flex-d flex-ac flex-gap5 font-12">
                  Description:
                  <span
                    className="bold-font"
                    title={damageClaimJobData[0].Description}
                  >
                    {damageClaimJobData[0].Description}
                  </span>
                </div>

                <div className="flex-d flex-ac flex-gap5 font-12">
                  Damage Done By:
                  <span className="bold-font">
                    {damageClaimJobData[0].DamageDoneByName}
                  </span>
                </div>

                <div className="flex-d flex-ac flex-gap5 font-12">
                  Outcome:
                  <span className="bold-font">
                    {damageClaimJobData[0].Outcome}
                  </span>
                </div>

                <div className="flex-d flex-ac flex-gap5 font-12">
                  Cost:
                  <span className="bold-font">
                    £{Number(damageClaimJobData[0].Cost).toFixed(2)}
                  </span>
                </div>

                <div className="flex-d flex-ac flex-gap5 font-12">
                  Insurance Claim Ref:
                  <span className="bold-font">
                    {damageClaimJobData[0].InsuranceClaimRef}
                  </span>
                </div>
              </div>
            )}
          </div>
          <div className="accordion-top flex-da justify-btw grey-accord">
            Summary
          </div>
          <div className="flex-da gap-10 mt-20 field-input">
            <input
              className="input-field"
              value={coupenCode}
              disabled={AlreadyAppliedDiscount}
              onChange={(e) => setCoupenCode(e.target.value)}
              placeholder="Promo Code"
              type="text"
              id="txtDiscode"
            />
            <div className="flex-da btn-start">
              {!AlreadyAppliedDiscount && (
                <a
                  className="flex-daj btn-primary relative-btn"
                  id="btnApply"
                  onClick={() => {
                    VerifyCode(coupenCode);
                  }}
                >
                  Apply
                </a>
              )}

              {AlreadyAppliedDiscount && (
                <a
                  title="Cancel already applied discount"
                  className="flex-daj btn-primary relative-btn"
                  id="btnApply2"
                  onClick={CancelAlreadyAppliedDiscount}
                >
                  Cancel
                </a>
              )}
            </div>
          </div>

          {/* Mover Boxes section */}
          {AdditionalServices.length == 0 && MNVQuote.MNVMoverTypeID <= 3 && (
            <div className="grid-d fr-111 flex-gap20 mt-20">
              {/* ---------------- ONE MOVER ---------------- */}

              <div
                className={
                  MNVQuote.MNVMoverTypeID == 1
                    ? "box-mov-cont selected-cont"
                    : "box-mov-cont"
                }
                onClick={(e) => {
                  setMNVQuote({
                    ...MNVQuote,
                    MNVMoverTypeID: 1,
                  });
                  setInfo({
                    ...info,
                    MNVMoverTypeID: 1,
                  });
                }}
              >
                <div className="flex-da justify-btw">
                  <span className="font-16 bold-font text-left c-theme">
                    One Mover
                  </span>
                  <img
                    alt="img"
                    src="/images/movers1.png"
                    width="100"
                    height="70"
                  />
                </div>

                <div className="flex-da flex-jsb ser-prc">
                  <span className="font-12 text-left label-color bold-font">
                    Services
                  </span>
                  <span className="font-12 text-left label-color bold-font">
                    Price
                  </span>
                </div>
                <div className="flex-d flex-jse">
                  <div className="grid-d flex-gap10 srv-tols">
                    <div className="flex-d flex-jse flex-gap5">
                      <span className="c-theme font-13 bold-font">
                        £{Number(MoversCalculation.Mover1Amount).toFixed(2)}
                      </span>
                    </div>

                    {ShowDiscount && (
                      <div className="flex-d flex-jse flex-gap5">
                        <span className="c-theme font-13 bold-font">
                          Discount: - £
                          {Number(MoversCalculation.Mover1Discount).toFixed(2)}
                        </span>
                      </div>
                    )}

                    <div className="flex-d flex-jse flex-gap5">
                      <span className="c-theme font-13 bold-font">
                        Subtotal: £
                        {Number(
                          MoversCalculation.Mover1AmountAfterDiscount,
                        ).toFixed(2)}
                      </span>
                    </div>

                    <div className="flex-d flex-jse flex-gap5">
                      <span className="c-theme font-13 bold-font">
                        VAT: £
                        {Number(MoversCalculation.Mover1VATAmount).toFixed(2)}
                      </span>
                    </div>

                    <div className="flex-d flex-jse flex-gap5">
                      <span className="c-theme font-13 bold-font">
                        Total: £
                        {Number(MoversCalculation.Mover1AmountWithVAT).toFixed(
                          2,
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="grid-d mt-10 font-12 label-color text-left">
                  * Any additional time will be charged at £
                  {Number(MoversCalculation.Mover1AdditionalRateAndVAT).toFixed(
                    2,
                  )}{" "}
                  + VAT (total £
                  {(
                    MoversCalculation.Mover1AdditionalRateAndVAT +
                    (MoversCalculation.Mover1AdditionalRateAndVAT / 100) * Vat
                  ).toFixed(2)}
                  ) per 30mins. Please keep additional time up to 1hr maximum.
                </div>
              </div>

              {/* ---------------- TWO MOVERS ---------------- */}

              <div
                className={
                  MNVQuote.MNVMoverTypeID == 2
                    ? "box-mov-cont selected-cont"
                    : "box-mov-cont"
                }
                onClick={(e) => {
                  setMNVQuote({
                    ...MNVQuote,
                    MNVMoverTypeID: 2,
                  });
                  setInfo({
                    ...info,
                    MNVMoverTypeID: 2,
                  });
                }}
              >
                <div className="flex-da justify-btw">
                  <span className="font-16 bold-font text-left c-theme">
                    Two Movers
                  </span>
                  <img
                    alt="img"
                    src="/images/movers2.png"
                    width="100"
                    height="70"
                  />
                </div>

                <div className="flex-da flex-jsb ser-prc">
                  <span className="font-12 text-left label-color bold-font">
                    Services
                  </span>
                  <span className="font-12 text-left label-color bold-font">
                    Price
                  </span>
                </div>
                <div className="flex-d flex-jse">
                  <div className="grid-d flex-gap10 srv-tols">
                    <div className="flex-d flex-jse flex-gap5">
                      <span className="c-theme font-13 bold-font">
                        £{Number(MoversCalculation.Mover2Amount).toFixed(2)}
                      </span>
                    </div>

                    {ShowDiscount && (
                      <div className="flex-d flex-jse flex-gap5">
                        <span className="c-theme font-13 bold-font">
                          Discount: - £
                          {Number(MoversCalculation.Mover2Discount).toFixed(2)}
                        </span>
                      </div>
                    )}

                    <div className="flex-d flex-jse flex-gap5">
                      <span className="c-theme font-13 bold-font">
                        Subtotal: £
                        {Number(
                          MoversCalculation.Mover2AmountAfterDiscount,
                        ).toFixed(2)}
                      </span>
                    </div>

                    <div className="flex-d flex-jse flex-gap5">
                      <span className="c-theme font-13 bold-font">
                        VAT: £
                        {Number(MoversCalculation.Mover2VATAmount).toFixed(2)}
                      </span>
                    </div>

                    <div className="flex-d flex-jse flex-gap5">
                      <span className="c-theme font-13 bold-font">
                        Total: £
                        {Number(MoversCalculation.Mover2AmountWithVAT).toFixed(
                          2,
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="grid-d mt-10 font-12 label-color text-left">
                  * Any additional time will be charged at £
                  {Number(MoversCalculation.Mover2AdditionalRateAndVAT).toFixed(
                    2,
                  )}{" "}
                  + VAT (total £
                  {(
                    MoversCalculation.Mover2AdditionalRateAndVAT +
                    (MoversCalculation.Mover2AdditionalRateAndVAT / 100) * Vat
                  ).toFixed(2)}
                  ) per 30mins. Please keep additional time up to 1hr maximum.
                </div>
              </div>

              {/* ---------------- THREE MOVERS ---------------- */}

              <div
                className={
                  MNVQuote.MNVMoverTypeID == 3
                    ? "box-mov-cont selected-cont"
                    : "box-mov-cont"
                }
                onClick={(e) => {
                  setMNVQuote({
                    ...MNVQuote,
                    MNVMoverTypeID: 3,
                  });
                  setInfo({
                    ...info,
                    MNVMoverTypeID: 3,
                  });
                }}
              >
                <div className="flex-da justify-btw">
                  <span className="font-16 bold-font text-left c-theme">
                    Three Movers
                  </span>
                  <img
                    alt="img"
                    src="/images/movers1.png"
                    width="100"
                    height="70"
                  />
                </div>

                <div className="flex-da flex-jsb ser-prc">
                  <span className="font-12 text-left label-color bold-font">
                    Services
                  </span>
                  <span className="font-12 text-left label-color bold-font">
                    Price
                  </span>
                </div>
                <div className="flex-d flex-jse">
                  <div className="grid-d flex-gap10 srv-tols">
                    <div className="flex-d flex-jse flex-gap5">
                      <span className="c-theme font-13 bold-font">
                        £{Number(MoversCalculation.Mover3Amount).toFixed(2)}
                      </span>
                    </div>

                    {ShowDiscount && (
                      <div className="flex-d flex-jse flex-gap5">
                        <span className="c-theme font-13 bold-font">
                          Discount: - £
                          {Number(MoversCalculation.Mover3Discount).toFixed(2)}
                        </span>
                      </div>
                    )}

                    <div className="flex-d flex-jse flex-gap5">
                      <span className="c-theme font-13 bold-font">
                        Subtotal: £
                        {Number(
                          MoversCalculation.Mover3AmountAfterDiscount,
                        ).toFixed(2)}
                      </span>
                    </div>

                    <div className="flex-d flex-jse flex-gap5">
                      <span className="c-theme font-13 bold-font">
                        VAT: £
                        {Number(MoversCalculation.Mover3VATAmount).toFixed(2)}
                      </span>
                    </div>

                    <div className="flex-d flex-jse flex-gap5">
                      <span className="c-theme font-13 bold-font">
                        Total: £
                        {Number(MoversCalculation.Mover3AmountWithVAT).toFixed(
                          2,
                        )}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="grid-d mt-10 font-12 label-color text-left">
                  * Any additional time will be charged at £
                  {Number(MoversCalculation.Mover3AdditionalRateAndVAT).toFixed(
                    2,
                  )}{" "}
                  + VAT (total £
                  {(
                    MoversCalculation.Mover3AdditionalRateAndVAT +
                    (MoversCalculation.Mover3AdditionalRateAndVAT / 100) * Vat
                  ).toFixed(2)}
                  ) per 30mins. Please keep additional time up to 1hr maximum.
                </div>
              </div>
            </div>
          )}

          {/* Additional services / mover type > 3 */}
          {(AdditionalServices.length > 0 || MNVQuote.MNVMoverTypeID > 3) && (
            <div className="grid-d mt-10 font-12 label-color text-left">
              * Any additional time will be charged at £
              {Number(AdditionalRateAndVATAllVans).toFixed(2)} + VAT (total £
              {(
                AdditionalRateAndVATAllVans +
                (AdditionalRateAndVATAllVans / 100) * Vat
              ).toFixed(2)}
              ) per 30mins. Please keep additional time up to 1hr maximum.
            </div>
          )}
          <div className="accordion-top flex-da justify-btw grey-accord">
            Quote Break Details
          </div>
          <div className="flow-auto mt-25 auto-height">
            <table className="reuse-table table-qbreak">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Description</th>

                  {MNVQuote.IsLocalQuote ? (
                    <th>Driver Amount</th>
                  ) : (
                    <th>Driver Minutes</th>
                  )}

                  {MaxMoversWithOneVan == 2 && MNVQuote.IsLocalQuote && (
                    <th>Helper 1 Amount</th>
                  )}
                  {MaxMoversWithOneVan == 2 && !MNVQuote.IsLocalQuote && (
                    <th>Helper 1 Minutes</th>
                  )}

                  {MaxMoversWithOneVan >= 3 && MNVQuote.IsLocalQuote && (
                    <>
                      <th>Helper 1 Amount</th>
                      <th>Helper {MaxMoversWithOneVanText} Amount</th>
                    </>
                  )}

                  {MaxMoversWithOneVan >= 3 && !MNVQuote.IsLocalQuote && (
                    <>
                      <th>Helper 1 Minutes</th>
                      <th>Helper {MaxMoversWithOneVanText} Minutes</th>
                    </>
                  )}
                </tr>
              </thead>

              <tbody>
                {/* DTP */}
                <tr>
                  <td className="text-left">1</td>
                  <td className="text-left">Depo to Pickup</td>
                  <td className="text-right">
                    {MNVQuote.IsLocalQuote ? (
                      <>
                        £{Number(QuoteCalculations.DTPDriverAmount).toFixed(2)}
                      </>
                    ) : (
                      <>
                        {Number(
                          QuoteCalculations.DriverTimeInSecondsDTP / 60,
                        ).toFixed(2)}
                      </>
                    )}
                  </td>

                  {MNVQuote.MNVMoverTypeID == 2 && (
                    <td className="text-right">
                      {MNVQuote.IsLocalQuote ? (
                        <>
                          £
                          {Number(QuoteCalculations.DTPHelperAmount).toFixed(2)}
                        </>
                      ) : (
                        <>
                          {Number(
                            QuoteCalculations.Helper1TimeInSecondsDTP / 60,
                          ).toFixed(2)}
                        </>
                      )}
                    </td>
                  )}

                  {MNVQuote.MNVMoverTypeID >= 3 && (
                    <>
                      <td className="text-right">
                        {MNVQuote.IsLocalQuote ? (
                          <>
                            £
                            {Number(QuoteCalculations.DTPHelperAmount).toFixed(
                              2,
                            )}
                          </>
                        ) : (
                          <>
                            {Number(
                              QuoteCalculations.Helper2TimeInSecondsDTP / 60,
                            ).toFixed(2)}
                          </>
                        )}
                      </td>
                      <td className="text-right">
                        {MNVQuote.IsLocalQuote ? (
                          <>
                            £
                            {Number(
                              QuoteCalculations.DTPHelperAmount *
                                (MNVQuote.MNVMoverTypeID - 2),
                            ).toFixed(2)}
                          </>
                        ) : (
                          <>
                            {Number(
                              (QuoteCalculations.Helper2TimeInSecondsDTP *
                                (MNVQuote.MNVMoverTypeID - 2)) /
                                60,
                            ).toFixed(2)}
                          </>
                        )}
                      </td>
                    </>
                  )}
                </tr>

                {/* PTD */}
                <tr>
                  <td className="text-left">2</td>
                  <td className="text-left">Pickup to Delivery</td>
                  <td className="text-right">
                    {MNVQuote.IsLocalQuote ? (
                      <>
                        £{Number(QuoteCalculations.PTDDriverAmount).toFixed(2)}
                      </>
                    ) : (
                      <>
                        {Number(
                          QuoteCalculations.DriverTimeInSecondsPTD / 60,
                        ).toFixed(2)}
                      </>
                    )}
                  </td>

                  {MNVQuote.MNVMoverTypeID == 2 && (
                    <td className="text-right">
                      {MNVQuote.IsLocalQuote ? (
                        <>
                          £
                          {Number(QuoteCalculations.PTDHelperAmount).toFixed(2)}
                        </>
                      ) : (
                        <>
                          {Number(
                            QuoteCalculations.Helper1TimeInSecondsPTD / 60,
                          ).toFixed(2)}
                        </>
                      )}
                    </td>
                  )}

                  {MNVQuote.MNVMoverTypeID >= 3 && (
                    <>
                      <td className="text-right">
                        {MNVQuote.IsLocalQuote ? (
                          <>
                            £
                            {Number(QuoteCalculations.PTDHelperAmount).toFixed(
                              2,
                            )}
                          </>
                        ) : (
                          <>
                            {Number(
                              QuoteCalculations.Helper2TimeInSecondsPTD / 60,
                            ).toFixed(2)}
                          </>
                        )}
                      </td>
                      <td className="text-right">
                        {MNVQuote.IsLocalQuote ? (
                          <>
                            £
                            {Number(
                              QuoteCalculations.PTDHelperAmount *
                                (MNVQuote.MNVMoverTypeID - 2),
                            ).toFixed(2)}
                          </>
                        ) : (
                          <>
                            {Number(
                              (QuoteCalculations.Helper2TimeInSecondsPTD *
                                (MNVQuote.MNVMoverTypeID - 2)) /
                                60,
                            ).toFixed(2)}
                          </>
                        )}
                      </td>
                    </>
                  )}
                </tr>

                {/* DTD */}
                <tr>
                  <td className="text-left">3</td>
                  <td className="text-left">Delivery to Depot</td>
                  <td className="text-right">
                    {MNVQuote.IsLocalQuote ? (
                      <>
                        £{Number(QuoteCalculations.DTDDriverAmount).toFixed(2)}
                      </>
                    ) : (
                      <>
                        {Number(
                          QuoteCalculations.DriverTimeInSecondsDTD / 60,
                        ).toFixed(2)}
                      </>
                    )}
                  </td>

                  {MNVQuote.MNVMoverTypeID == 2 && (
                    <td className="text-right">
                      {MNVQuote.IsLocalQuote ? (
                        <>
                          £
                          {Number(QuoteCalculations.DTDHelperAmount).toFixed(2)}
                        </>
                      ) : (
                        <>
                          {Number(
                            QuoteCalculations.Helper1TimeInSecondsDTD / 60,
                          ).toFixed(2)}
                        </>
                      )}
                    </td>
                  )}

                  {MNVQuote.MNVMoverTypeID >= 3 && (
                    <>
                      <td className="text-right">
                        {MNVQuote.IsLocalQuote ? (
                          <>
                            £
                            {Number(QuoteCalculations.DTDHelperAmount).toFixed(
                              2,
                            )}
                          </>
                        ) : (
                          <>
                            {Number(
                              QuoteCalculations.Helper2TimeInSecondsDTD / 60,
                            ).toFixed(2)}
                          </>
                        )}
                      </td>
                      <td className="text-right">
                        {MNVQuote.IsLocalQuote ? (
                          <>
                            £
                            {Number(
                              QuoteCalculations.DTDHelperAmount *
                                (MNVQuote.MNVMoverTypeID - 2),
                            ).toFixed(2)}
                          </>
                        ) : (
                          <>
                            {Number(
                              (QuoteCalculations.Helper2TimeInSecondsDTD *
                                (MNVQuote.MNVMoverTypeID - 2)) /
                                60,
                            ).toFixed(2)}
                          </>
                        )}
                      </td>
                    </>
                  )}
                </tr>

                {/* Loading Time (non-local) */}
                {!MNVQuote.IsLocalQuote && (
                  <tr>
                    <td className="text-left">4</td>
                    <td className="text-left">Loading Time + Unloading Time</td>
                    <td className="text-right">
                      {Number(
                        QuoteCalculations.LoadingUnLoadingTimeInMinutes,
                      ).toFixed(2)}
                    </td>

                    {MNVQuote.MNVMoverTypeID == 2 && (
                      <td className="text-right">
                        {Number(
                          QuoteCalculations.LoadingUnLoadingTimeInMinutes,
                        ).toFixed(2)}
                      </td>
                    )}

                    {MNVQuote.MNVMoverTypeID >= 3 && (
                      <>
                        <td className="text-right">
                          {Number(
                            QuoteCalculations.LoadingUnLoadingTimeInMinutes,
                          ).toFixed(2)}
                        </td>
                        <td className="text-right">
                          {Number(
                            QuoteCalculations.LoadingUnLoadingTimeInMinutes *
                              (MNVQuote.MNVMoverTypeID - 2),
                          ).toFixed(2)}
                        </td>
                      </>
                    )}
                  </tr>
                )}

                {/* Base (local) */}
                {MNVQuote.IsLocalQuote && (
                  <tr>
                    <td className="text-left">4</td>
                    <td className="text-left">Base Charge</td>
                    <td className="text-right">
                      £{Number(QuoteCalculations.BaseDriverAmount).toFixed(2)}
                    </td>

                    {MNVQuote.MNVMoverTypeID == 2 && (
                      <td className="text-right">
                        £{Number(QuoteCalculations.BaseHelperAmount).toFixed(2)}
                      </td>
                    )}

                    {MNVQuote.MNVMoverTypeID >= 3 && (
                      <>
                        <td className="text-right">
                          £
                          {Number(QuoteCalculations.BaseHelperAmount).toFixed(
                            2,
                          )}
                        </td>
                        <td className="text-right">
                          £
                          {Number(
                            QuoteCalculations.BaseHelperAmount *
                              (MNVQuote.MNVMoverTypeID - 2),
                          ).toFixed(2)}
                        </td>
                      </>
                    )}
                  </tr>
                )}

                {/* Stairs (local) */}
                {MNVQuote.IsLocalQuote && (
                  <tr>
                    <td className="text-left">5</td>
                    <td className="text-left">Stairs</td>
                    <td className="text-right">
                      £{Number(QuoteCalculations.DriverStairAmount).toFixed(2)}
                    </td>

                    {MNVQuote.MNVMoverTypeID == 2 && (
                      <td className="text-right">
                        £
                        {Number(QuoteCalculations.Helper1StairAmount).toFixed(
                          2,
                        )}
                      </td>
                    )}

                    {MNVQuote.MNVMoverTypeID >= 3 && (
                      <>
                        <td className="text-right">
                          £
                          {Number(QuoteCalculations.Helper1StairAmount).toFixed(
                            2,
                          )}
                        </td>
                        <td className="text-right">
                          £
                          {Number(
                            QuoteCalculations.Helper1StairAmount *
                              (MNVQuote.MNVMoverTypeID - 2),
                          ).toFixed(2)}
                        </td>
                      </>
                    )}
                  </tr>
                )}

                {/* Admin Charges (local) */}
                {MNVQuote.IsLocalQuote &&
                  QuoteCalculations.AdminCharges > 0 && (
                    <tr>
                      <td className="text-left">6</td>
                      <td className="text-left">Admin Charges</td>
                      <td className="text-right">
                        £{Number(QuoteCalculations.AdminCharges).toFixed(2)}
                      </td>

                      {MNVQuote.MNVMoverTypeID == 2 && (
                        <td className="text-right">
                          £
                          {Number(QuoteCalculations.AdminChargesHelper).toFixed(
                            2,
                          )}
                        </td>
                      )}

                      {MNVQuote.MNVMoverTypeID >= 3 && (
                        <>
                          <td className=" text-right">
                            £
                            {Number(
                              QuoteCalculations.AdminChargesHelper,
                            ).toFixed(2)}
                          </td>
                          <td className=" text-right">
                            £
                            {Number(
                              QuoteCalculations.AdminChargesHelper *
                                (MNVQuote.MNVMoverTypeID - 2),
                            ).toFixed(2)}
                          </td>
                        </>
                      )}
                    </tr>
                  )}

                {/* Congestion Fee (local) */}
                {MNVQuote.IsLocalQuote &&
                  QuoteCalculations.CongestionFee > 0 && (
                    <tr className="bold-font">
                      <td className="text-left" colSpan={2}>
                        Congestion Charge
                      </td>
                      <td className="text-right">
                        {Number(QuoteCalculations.CongestionFee).toFixed(2)}
                      </td>
                      {MNVQuote.MNVMoverTypeID == 2 && (
                        <td className="text-right">-</td>
                      )}
                      {MNVQuote.MNVMoverTypeID >= 3 && (
                        <>
                          <td className="text-right">-</td>
                          <td className="text-right">-</td>
                        </>
                      )}
                    </tr>
                  )}

                {/* Total Hours (non-local) */}
                {!MNVQuote.IsLocalQuote && (
                  <tr className="bold-font">
                    <td colSpan={2}>Total Hours</td>
                    <td className="text-right">
                      {Number(QuoteCalculations.TotalHours).toFixed(2)}
                    </td>
                    {MNVQuote.MNVMoverTypeID == 2 && (
                      <td className="text-right">
                        {Number(QuoteCalculations.TotalHours).toFixed(2)}
                      </td>
                    )}
                    {MNVQuote.MNVMoverTypeID >= 3 && (
                      <>
                        <td className="text-right">
                          {Number(QuoteCalculations.TotalHours).toFixed(2)}
                        </td>
                        <td className="text-right">
                          {Number(
                            QuoteCalculations.TotalHours *
                              (MNVQuote.MNVMoverTypeID - 2),
                          ).toFixed(2)}
                        </td>
                      </>
                    )}
                  </tr>
                )}

                {/* Individual Total (local) */}
                {MNVQuote.IsLocalQuote && (
                  <>
                    <tr className="bold-font">
                      <td colSpan={2}>
                        <span>Individual Total</span>
                      </td>
                      <td className="text-right">
                        £
                        {Number(
                          QuoteCalculations.IndividualDriverAmount,
                        ).toFixed(2)}
                      </td>
                      {MNVQuote.MNVMoverTypeID == 2 && (
                        <td className="text-right">
                          £
                          {Number(
                            QuoteCalculations.IndividualHelper1Amount,
                          ).toFixed(2)}
                        </td>
                      )}
                      {MNVQuote.MNVMoverTypeID >= 3 && (
                        <>
                          <td className="text-right">
                            £
                            {Number(
                              QuoteCalculations.IndividualHelper1Amount,
                            ).toFixed(2)}
                          </td>
                          <td className="text-right">
                            £
                            {Number(
                              QuoteCalculations.IndividualHelper1Amount *
                                (MNVQuote.MNVMoverTypeID - 2),
                            ).toFixed(2)}
                          </td>
                        </>
                      )}
                    </tr>

                    {AdditionalServices.map((Service, index) => (
                      <React.Fragment key={index}>
                        {Service.MNVVanTypeID == MNVQuote.MNVVanTypeID ? (
                          <tr className="bold-font">
                            <td colSpan={2}>
                              <span>Individual Total - Van {index + 2}</span>
                            </td>
                            <td className="text-right">
                              £
                              {Number(
                                QuoteCalculations.IndividualDriverAmount,
                              ).toFixed(2)}
                            </td>
                            {Service.MNVMoverTypeID == 2 && (
                              <td className="text-right">
                                £
                                {Number(
                                  QuoteCalculations.IndividualHelper1Amount,
                                ).toFixed(2)}
                              </td>
                            )}
                            {Service.MNVMoverTypeID >= 3 && (
                              <>
                                <td className="text-right">
                                  £
                                  {Number(
                                    QuoteCalculations.IndividualHelper1Amount,
                                  ).toFixed(2)}
                                </td>
                                <td className="text-right">
                                  £
                                  {Number(
                                    QuoteCalculations.IndividualHelper1Amount *
                                      (Service.MNVMoverTypeID - 2),
                                  ).toFixed(2)}
                                </td>
                              </>
                            )}
                          </tr>
                        ) : (
                          <tr className="bold-font">
                            <td colSpan={2}>
                              <span>Individual Total - Van {index + 2}</span>
                            </td>
                            <td className="text-right">
                              £
                              {Number(
                                QuoteCalculations.QuoteBaseDriverAmount +
                                  QuoteCalculations.BaseDriverAmountOtherVan,
                              ).toFixed(2)}
                            </td>
                            {Service.MNVMoverTypeID == 2 && (
                              <td className="text-right">
                                £
                                {Number(
                                  QuoteCalculations.QuoteBaseHelperAmount +
                                    QuoteCalculations.BaseHelperAmount,
                                ).toFixed(2)}
                              </td>
                            )}
                            {Service.MNVMoverTypeID >= 3 && (
                              <>
                                <td className="text-right">
                                  £
                                  {Number(
                                    QuoteCalculations.QuoteBaseHelperAmount +
                                      QuoteCalculations.BaseHelperAmount,
                                  ).toFixed(2)}
                                </td>
                                <td className="text-right">
                                  £
                                  {Number(
                                    (QuoteCalculations.QuoteBaseHelperAmount +
                                      QuoteCalculations.BaseHelperAmount) *
                                      (Service.MNVMoverTypeID - 2),
                                  ).toFixed(2)}
                                </td>
                              </>
                            )}
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </>
                )}

                {/* Cumulative Total (local) */}
                {MNVQuote.IsLocalQuote && (
                  <tr className="bold-font">
                    <td colSpan={2}>Cumulative Total</td>
                    <td className="text-right">
                      £{Number(calculations.InitialAmount).toFixed(2)}
                    </td>
                  </tr>
                )}

                {/* Line Items (local) */}
                {MNVQuote.IsLocalQuote && LineItems.length > 0 && (
                  <tr className="bold-font">
                    <td colSpan={5} className="text-uppercase">
                      Line Items
                    </td>
                  </tr>
                )}

                {LineItems.map((LineItem: any, idx: any) => (
                  <tr key={idx} className="bold-font">
                    {MNVQuote.IsLocalQuote ? (
                      <>
                        <td colSpan={2}>
                          <div className="flex-da flex-gap10">
                            <span title={LineItem.Notes}>
                              {LineItem.RefferenceNumber}
                            </span>
                            <img
                              title={GetDetailsForLineItem(LineItem)}
                              src="/images/info-red.svg"
                              width={12}
                              height={12}
                            />
                          </div>
                        </td>

                        {LineItem.TransactionType == 1 ? (
                          <td className="text-right" colSpan={1}>
                            <div className="flex-da flex-jse flex-gap10">
                              £{Number(LineItem.Amount).toFixed(2)}
                              <a
                                title="Edit Line Item"
                                onClick={() => EditLineItem(LineItem)}
                                className="flex-d"
                              >
                                <img
                                  src="/images/edit.svg"
                                  width={12}
                                  height={12}
                                />
                              </a>
                              <a
                                title="Delete"
                                onClick={() =>
                                  DeleteLineItem(
                                    LineItem.PTPaymentInvoiceLineItemID,
                                  )
                                }
                                className="flex-d"
                              >
                                <img
                                  src="/images/delete.png"
                                  width={12}
                                  height={12}
                                />
                              </a>
                            </div>
                          </td>
                        ) : (
                          <td className="text-right" colSpan={1}>
                            <div className="flex-da flex-jse flex-gap10">
                              -£{Number(LineItem.Amount).toFixed(2)}
                              <a
                                title="Edit Line Item"
                                onClick={() => EditLineItem(LineItem)}
                                className="flex-d"
                              >
                                <img
                                  src="/images/edit.svg"
                                  width={12}
                                  height={12}
                                />
                              </a>
                              <a
                                onClick={() =>
                                  DeleteLineItem(
                                    LineItem.PTPaymentInvoiceLineItemID,
                                  )
                                }
                                className="flex-d"
                              >
                                <img
                                  src="/images/delete.png"
                                  width={12}
                                  height={12}
                                />
                              </a>
                            </div>
                          </td>
                        )}
                      </>
                    ) : null}
                  </tr>
                ))}

                {/* Discount (local) */}
                {MNVQuote.IsLocalQuote && (
                  <tr className="bold-font">
                    <td colSpan={2}>Discount</td>
                    <td className="text-right">
                      £{Number(calculations.Discount).toFixed(2)}
                    </td>
                  </tr>
                )}

                {/* Subtotal, VAT, Total (local) */}
                {MNVQuote.IsLocalQuote && (
                  <>
                    <tr className="bold-font">
                      <td colSpan={2}>Subtotal</td>
                      <td className="text-right">
                        £{Number(calculations.AmountAfterDiscount).toFixed(2)}
                      </td>
                    </tr>

                    <tr className="bold-font">
                      <td colSpan={2}>VAT</td>
                      <td className="text-right">
                        £{Number(calculations.VAT).toFixed(2)}
                      </td>
                    </tr>

                    <tr className="bold-font">
                      <td colSpan={2}>Total Amount</td>
                      <td className="text-right">
                        £{Number(calculations.AmountAfterVAT).toFixed(2)}
                      </td>
                    </tr>
                  </>
                )}

                {/* Non-local sections */}
                {!MNVQuote.IsLocalQuote && (
                  <>
                    <tr className="bold-font">
                      <td colSpan={2}>Amount</td>
                      <td className="text-right">
                        £{Number(QuoteCalculations.BaseDriverAmount).toFixed(2)}
                      </td>
                      {MNVQuote.MNVMoverTypeID == 2 && (
                        <td className="text-right">
                          £
                          {Number(QuoteCalculations.BaseHelperAmount).toFixed(
                            2,
                          )}
                        </td>
                      )}
                      {MNVQuote.MNVMoverTypeID >= 3 && (
                        <>
                          <td className="text-right">
                            £
                            {Number(QuoteCalculations.BaseHelperAmount).toFixed(
                              2,
                            )}
                          </td>
                          <td className="text-right">
                            £
                            {Number(QuoteCalculations.BaseHelperAmount).toFixed(
                              2,
                            )}
                          </td>
                        </>
                      )}
                    </tr>

                    <tr className="bold-font">
                      <td colSpan={2}>Stairs Amount</td>
                      <td className="text-right">
                        £
                        {Number(QuoteCalculations.DriverStairAmount).toFixed(2)}
                      </td>
                      {MNVQuote.MNVMoverTypeID == 2 && (
                        <td className="text-right">
                          £
                          {Number(QuoteCalculations.Helper1StairAmount).toFixed(
                            2,
                          )}
                        </td>
                      )}
                      {MNVQuote.MNVMoverTypeID >= 3 && (
                        <>
                          <td className="text-right">
                            £
                            {Number(
                              QuoteCalculations.Helper1StairAmount,
                            ).toFixed(2)}
                          </td>
                          <td className="text-right">
                            £
                            {Number(
                              QuoteCalculations.Helper1StairAmount,
                            ).toFixed(2)}
                          </td>
                        </>
                      )}
                    </tr>

                    <tr className="bold-font">
                      <td colSpan={2}>Fuel Cost</td>
                      <td className="text-right">
                        £{Number(QuoteCalculations.FuelCost).toFixed(2)}
                      </td>
                      {MNVQuote.MNVMoverTypeID == 2 && (
                        <td className="text-right">-</td>
                      )}
                      {MNVQuote.MNVMoverTypeID >= 3 && (
                        <>
                          <td className="text-right">-</td>
                          <td className="text-right">-</td>
                        </>
                      )}
                    </tr>

                    <tr className="bold-font">
                      <td colSpan={2}>Congestion Charge</td>
                      <td className="text-right">
                        £{Number(QuoteCalculations.CongestionFee).toFixed(2)}
                      </td>
                      {MNVQuote.MNVMoverTypeID == 2 && (
                        <td className="text-right">-</td>
                      )}
                      {MNVQuote.MNVMoverTypeID >= 3 && (
                        <>
                          <td className="text-right">-</td>
                          <td className="text-right">-</td>
                        </>
                      )}
                    </tr>

                    {QuoteCalculations.AdminCharges > 0 && (
                      <tr className="bold-font">
                        <td colSpan={2}>Admin Charges</td>
                        <td className="text-right">
                          {Number(QuoteCalculations.AdminCharges).toFixed(2)}
                        </td>
                        {MNVQuote.MNVMoverTypeID == 2 && (
                          <td className="text-right">
                            £
                            {Number(
                              QuoteCalculations.AdminChargesHelper,
                            ).toFixed(2)}
                          </td>
                        )}
                        {MNVQuote.MNVMoverTypeID >= 3 && (
                          <>
                            <td className="text-right">
                              £
                              {Number(
                                QuoteCalculations.AdminChargesHelper,
                              ).toFixed(2)}
                            </td>
                            <td className="text-right">
                              £
                              {Number(
                                QuoteCalculations.AdminChargesHelper,
                              ).toFixed(2)}
                            </td>
                          </>
                        )}
                      </tr>
                    )}

                    <tr className="bold-font">
                      <td colSpan={5} className="text-uppercase">
                        TOTALS
                      </td>
                    </tr>

                    <tr className="bold-font">
                      <td colSpan={2}>Individual Total</td>
                      <td className="text-right">
                        £
                        {Number(
                          QuoteCalculations.IndividualDriverAmount,
                        ).toFixed(2)}
                      </td>
                      {MNVQuote.MNVMoverTypeID == 2 && (
                        <td className="text-right">
                          £
                          {Number(
                            QuoteCalculations.IndividualHelper1Amount,
                          ).toFixed(2)}
                        </td>
                      )}
                      {MNVQuote.MNVMoverTypeID >= 3 && (
                        <>
                          <td className="text-right">
                            £
                            {Number(
                              QuoteCalculations.IndividualHelper1Amount,
                            ).toFixed(2)}
                          </td>
                          <td className="text-right">
                            £
                            {Number(
                              QuoteCalculations.IndividualHelper1Amount,
                            ).toFixed(2)}
                          </td>
                        </>
                      )}
                    </tr>

                    {AdditionalServices.map((Service, index) => (
                      <React.Fragment key={`nonlocal-${index}`}>
                        {Service.MNVVanTypeID == MNVQuote.MNVVanTypeID ? (
                          <tr className="bold-font">
                            <td colSpan={2}>
                              <span>Individual Total - Van {index + 2}</span>
                            </td>
                            <td className="text-right">
                              £
                              {Number(
                                QuoteCalculations.IndividualDriverAmount,
                              ).toFixed(2)}
                            </td>
                            {Service.MNVMoverTypeID == 2 && (
                              <td className="text-right">
                                £
                                {Number(
                                  QuoteCalculations.IndividualHelper1Amount,
                                ).toFixed(2)}
                              </td>
                            )}
                            {Service.MNVMoverTypeID >= 3 && (
                              <>
                                <td className="text-right">
                                  £
                                  {Number(
                                    QuoteCalculations.IndividualHelper1Amount,
                                  ).toFixed(2)}
                                </td>
                                <td className="text-right">
                                  £
                                  {Number(
                                    QuoteCalculations.IndividualHelper1Amount,
                                  ).toFixed(2)}
                                </td>
                              </>
                            )}
                          </tr>
                        ) : (
                          <tr className="bold-font">
                            <td colSpan={2}>
                              <span>Individual Total - Van {index + 2}</span>
                            </td>
                            <td className="text-right">
                              £
                              {Number(
                                QuoteCalculations.QuoteBaseDriverAmount +
                                  QuoteCalculations.BaseDriverAmountOtherVan,
                              ).toFixed(2)}
                            </td>
                            {Service.MNVMoverTypeID == 2 && (
                              <td className="text-right">
                                £
                                {Number(
                                  QuoteCalculations.QuoteBaseHelperAmount +
                                    QuoteCalculations.BaseHelperAmount,
                                ).toFixed(2)}
                              </td>
                            )}
                            {Service.MNVMoverTypeID >= 3 && (
                              <>
                                <td className="text-right">
                                  £
                                  {Number(
                                    QuoteCalculations.QuoteBaseHelperAmount +
                                      QuoteCalculations.BaseHelperAmount,
                                  ).toFixed(2)}
                                </td>
                                <td className="text-right">
                                  £
                                  {Number(
                                    QuoteCalculations.QuoteBaseHelperAmount +
                                      QuoteCalculations.BaseHelperAmount,
                                  ).toFixed(2)}
                                </td>
                              </>
                            )}
                          </tr>
                        )}
                      </React.Fragment>
                    ))}

                    <tr className="bold-font">
                      <td colSpan={2}>Cumulative Total</td>
                      <td className="text-right" colSpan={1}>
                        £{Number(calculations.InitialAmount).toFixed(2)}
                      </td>
                    </tr>

                    {LineItems.length > 0 && (
                      <tr className="bold-font">
                        <td colSpan={5} className="text-uppercase">
                          Line Items
                        </td>
                      </tr>
                    )}

                    {LineItems.map((LineItem: any, idx: any) => (
                      <tr className="bold-font" key={`nonlocal-line-${idx}`}>
                        <td colSpan={2}>
                          <div className="flex-da flex-gap10">
                            <span title={LineItem.Notes}>
                              {LineItem.RefferenceNumber}
                            </span>
                            <img
                              title={GetDetailsForLineItem(LineItem)}
                              src="/images/info-red.svg"
                              width={12}
                              height={12}
                            />
                          </div>
                        </td>

                        {LineItem.TransactionType == 1 ? (
                          <td className="text-right" colSpan={1}>
                            <div className="flex-da flex-jse flex-gap10">
                              £{Number(LineItem.Amount).toFixed(2)}
                              <a
                                title="Edit Line Item"
                                onClick={() => EditLineItem(LineItem)}
                                className="flex-d"
                              >
                                <img
                                  src="/images/edit.svg"
                                  width={12}
                                  height={12}
                                />
                              </a>
                              <a
                                onClick={() =>
                                  DeleteLineItem(
                                    LineItem.PTPaymentInvoiceLineItemID,
                                  )
                                }
                                className="flex-d"
                              >
                                <img
                                  src="/images/delete.png"
                                  width={12}
                                  height={12}
                                />
                              </a>
                            </div>
                          </td>
                        ) : (
                          <td className="text-right" colSpan={1}>
                            <div className="flex-da flex-jse flex-gap10">
                              -£{Number(LineItem.Amount).toFixed(2)}
                              <a
                                title="Edit Line Item"
                                onClick={() => EditLineItem(LineItem)}
                                className="flex-d"
                              >
                                <img
                                  src="/images/edit.svg"
                                  width={12}
                                  height={12}
                                />
                              </a>
                              <a
                                onClick={() =>
                                  DeleteLineItem(
                                    LineItem.PTPaymentInvoiceLineItemID,
                                  )
                                }
                                className="flex-d"
                              >
                                <img
                                  src="/images/delete.png"
                                  width={12}
                                  height={12}
                                />
                              </a>{" "}
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}

                    <tr className="bold-font">
                      <td colSpan={2}>Discount</td>
                      <td className="text-right" colSpan={1}>
                        £{Number(calculations.Discount).toFixed(2)}
                      </td>
                    </tr>

                    <tr className="bold-font">
                      <td colSpan={2}>Subtotal</td>
                      <td className="text-right" colSpan={1}>
                        £{Number(calculations.AmountAfterDiscount).toFixed(2)}
                      </td>
                    </tr>

                    <tr className="bold-font">
                      <td colSpan={2}>VAT</td>
                      <td className="text-right" colSpan={1}>
                        £{Number(calculations.VAT).toFixed(2)}
                      </td>
                    </tr>

                    <tr className="bold-font">
                      <td colSpan={2}>Total Amount</td>
                      <td className="text-right" colSpan={1}>
                        £{Number(calculations.AmountAfterVAT).toFixed(2)}
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </table>
          </div>
          <>
            {/* Status == 4 additional charge UI */}
            {MNVQuote.MNVQuoteStatusID == 4 && (
              <div className="grid-d flex-gap10 mt-10">
                <span className="font-12 text-left label-color">
                  Calculate the additional amount to charge and add it as a line
                  item.
                </span>

                {AdditionalServices.length > 0 && (
                  <span className="font-14 text-left label-color bold-font">
                    Van 1
                  </span>
                )}

                <div className="grid-d fr-111 gap-20 mt-20">
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Additional Time in Hours
                    </span>
                    <input
                      type="number"
                      className="input-field w-100"
                      value={MNVQuote.AdditionalTimeInHours}
                      onChange={(e) =>
                        setMNVQuote({
                          ...MNVQuote,
                          AdditionalTimeInHours: Number(e.target.value),
                        })
                      }
                      onBlur={() => CalculateAdditionalTimeAmount()}
                    />
                  </div>

                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Additional Time in Minutes
                    </span>
                    <input
                      type="number"
                      className="input-field w-100"
                      value={MNVQuote.AdditionalTimeInMinutes}
                      onChange={(e) =>
                        setMNVQuote({
                          ...MNVQuote,
                          AdditionalTimeInMinutes: Number(e.target.value),
                        })
                      }
                      onBlur={() => CalculateAdditionalTimeAmount()}
                    />
                  </div>

                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Additional Stairs:{" "}
                    </span>
                    <input
                      type="number"
                      className="input-field w-100"
                      value={MNVQuote.Mover3ID}
                      onChange={(e) =>
                        setMNVQuote({
                          ...MNVQuote,
                          Mover3ID: Number(e.target.value),
                        })
                      }
                      onBlur={() => {
                        let temp = { ...MNVQuote };
                        CalculateAdditionalStairsAmount(temp);
                      }}
                    />
                  </div>
                </div>

                <div className="grid-d fr-111 gap-20 mt-20">
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Additional Time Charges: £
                      {Number(MNVQuote.AdditionalTimeCharges).toFixed(2)}
                    </span>
                    <div className="flex-da btn-start">
                      <a
                        type="button"
                        className="flex-daj btn-primary relative-btn"
                        onClick={() => addAdditionalChargesLineItem(1)}
                      >
                        Add Additional Time Charges
                      </a>
                    </div>
                  </div>
                  <div className="field-input grid-d flex-gap3">
                    <span className="font-12 text-left label-color">
                      Additional Stairs Charges: £
                      {Number(MNVQuote.AdditionalStairsCharges).toFixed(2)}
                    </span>
                    <div className="flex-da btn-start">
                      <a
                        type="button"
                        className="flex-daj btn-primary relative-btn"
                        onClick={() => addAdditionalChargesLineItem(2)}
                      >
                        Add Additional Stairs Charges
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Additional services - per van UI */}
            {AdditionalServices.map((Service, index) =>
              Service.MNVQuoteStatusID == 4 ? (
                <div
                  key={`addsvc-${index}`}
                  className="grid-d flex-gap10 mt-10"
                >
                  {AdditionalServices.length > 0 && (
                    <span className="font-14 text-left label-color bold-font">
                      Van {index + 2}
                    </span>
                  )}

                  <div className="grid-d fr-111 gap-20 mt-20">
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Additional Time in Hours
                      </span>
                      <input
                        type="number"
                        className="input-field w-100"
                        value={Service.AdditionalTimeInHours}
                        onChange={(e) => {
                          const tmp = [...AdditionalServices];
                          tmp[index].AdditionalTimeInHours = Number(
                            e.target.value,
                          );
                          setAdditionalServices(tmp);
                        }}
                        onBlur={() =>
                          CalculateAdditionalTimeAmountForAdditionalVan(index)
                        }
                      />
                    </div>

                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Additional Time in Minutes
                      </span>
                      <input
                        type="number"
                        className="input-field w-100"
                        value={Service.AdditionalTimeInMinutes}
                        onChange={(e) => {
                          const tmp = [...AdditionalServices];
                          tmp[index].AdditionalTimeInMinutes = Number(
                            e.target.value,
                          );
                          setAdditionalServices(tmp);
                        }}
                        onBlur={() =>
                          CalculateAdditionalTimeAmountForAdditionalVan(index)
                        }
                      />
                    </div>

                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Additional Stairs
                      </span>
                      <input
                        type="number"
                        className="input-field w-100"
                        value={Service.Mover3ID}
                        onChange={(e) => {
                          const tmp = [...AdditionalServices];
                          tmp[index].Mover3ID = Number(e.target.value);
                          setAdditionalServices(tmp);
                        }}
                        onBlur={() => {
                          let temp = [...AdditionalServices];
                          CalculateAdditionalStairsAmountForAdditionalVan(
                            index,
                            temp,
                          );
                        }}
                      />
                    </div>
                  </div>

                  <div className="grid-d fr-111 gap-20 mt-20">
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Additional Time Charges: £
                        {Number(Service.AdditionalTimeCharges).toFixed(2)}
                      </span>
                      <div className="flex-da btn-start">
                        <a
                          type="button"
                          className="flex-daj btn-primary relative-btn"
                          onClick={() =>
                            addAdditionalChargesLineItemForAdditionalVan(
                              1,
                              index,
                            )
                          }
                        >
                          Add Additional Time Charges
                        </a>
                      </div>
                    </div>
                    <div className="field-input grid-d flex-gap3">
                      <span className="font-12 text-left label-color">
                        Additional Stairs Charges: £
                        {Number(Service.AdditionalStairsCharges).toFixed(2)}
                      </span>
                      <div className="flex-da btn-start">
                        <a
                          type="button"
                          className="flex-daj btn-primary relative-btn"
                          onClick={() =>
                            addAdditionalChargesLineItemForAdditionalVan(
                              2,
                              index,
                            )
                          }
                        >
                          Add Additional Stairs Charges
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null,
            )}

            {/* Cancellation Figures (status == 5) */}
            {MNVQuote.MNVQuoteStatusID == 5 && (
              <div className="grid-d flex-gap10 mt-10">
                <span className="font-12 text-left label-color">
                  Cancellation Figures - Pick the appropriate amount to refund
                  and add it as a line item.
                </span>
                <span className="font-12 text-left label-color">
                  25%: £
                  {Number(calculations.AmountAfterDiscount * 0.25).toFixed(2)} +
                  £
                  {Number(
                    calculations.AmountAfterDiscount * 0.25 * 0.2,
                  ).toFixed(2)}{" "}
                  (VAT) = £
                  {Number(
                    calculations.AmountAfterDiscount * 0.25 +
                      calculations.AmountAfterDiscount * 0.25 * 0.2,
                  ).toFixed(2)}
                </span>
                <span className="font-12 text-left label-color">
                  50%: £
                  {Number(calculations.AmountAfterDiscount * 0.5).toFixed(2)} +
                  £
                  {Number(calculations.AmountAfterDiscount * 0.5 * 0.2).toFixed(
                    2,
                  )}{" "}
                  (VAT) = £
                  {Number(
                    calculations.AmountAfterDiscount * 0.5 +
                      calculations.AmountAfterDiscount * 0.5 * 0.2,
                  ).toFixed(2)}
                </span>
                <span className="font-12 text-left label-color">
                  75%: £
                  {Number(calculations.AmountAfterDiscount * 0.75).toFixed(2)} +
                  £
                  {Number(
                    calculations.AmountAfterDiscount * 0.75 * 0.2,
                  ).toFixed(2)}{" "}
                  (VAT) = £
                  {Number(
                    calculations.AmountAfterDiscount * 0.75 +
                      calculations.AmountAfterDiscount * 0.75 * 0.2,
                  ).toFixed(2)}
                </span>
              </div>
            )}
          </>

          <div className="flex-da btn-start flex-jse flex-gap10 mt-10">
            <a
              className="flex-daj btn-primary"
              onClick={() => OpenLineItemsPopupForJob(1, 1, 2)}
            >
              Line Items
            </a>

            <a className="flex-daj btn-primary" onClick={() => Update()}>
              Update
            </a>
          </div>

          <div className="grid-d mt-20">
            <div className="flow-auto auto-height">
              <table className="reuse-table tbl-brek-det">
                <tbody>
                  {JobRelatedData.Amounts && (
                    <>
                      {/* Subtotal */}
                      <tr className="bold-font">
                        <td colSpan={2} className="text-left">
                          Subtotal
                        </td>
                        {calculations.OverAllAmountAfterDiscount ? (
                          <td className="text-left" colSpan={2}>
                            £
                            {Number(
                              calculations.OverAllAmountAfterDiscount,
                            ).toFixed(2)}
                          </td>
                        ) : (
                          <td></td>
                        )}
                      </tr>

                      {/* VAT */}
                      <tr className="bold-font">
                        <td className="text-left" colSpan={2}>
                          VAT
                        </td>
                        <td className="text-left" colSpan={2}>
                          <div className="flex-da flex-gap10">
                            {" "}
                            £{Number(calculations.OverAllVAT).toFixed(2)} (
                            {Number(Vat).toFixed(2)}%)
                            {MNVQuote.MNVQuoteStatusID == 6 && (
                              <a
                                onClick={() => setIsVATEditable(!IsVATEditable)}
                                title="Edit VAT"
                                className="flex-d"
                              >
                                <img
                                  src="/images/edit.svg"
                                  width="12"
                                  height="12"
                                  alt="Edit"
                                />
                              </a>
                            )}
                            {IsVATEditable && (
                              <>
                                <input
                                  type="number"
                                  value={VatCopy}
                                  onChange={(e: any) =>
                                    setVatCopy(e.target.value)
                                  }
                                  className="width-auto"
                                />
                                <div className="flex-da btn-start">
                                  <a
                                    onClick={UpdateVAT}
                                    className="flex-daj btn-primary btn-grid-dec"
                                  >
                                    Update VAT
                                  </a>
                                </div>
                              </>
                            )}
                          </div>
                        </td>
                      </tr>

                      {/* Total Amount */}
                      <tr className="bold-font">
                        <td className="text-left" colSpan={2}>
                          Total Amount
                        </td>
                        <td className="text-left" colSpan={2}>
                          £
                          {Number(calculations.OverAllAmountAfterVAT).toFixed(
                            2,
                          )}
                        </td>
                      </tr>

                      {/* Line Items List */}
                      {LineItemsOverAll &&
                        LineItemsOverAll.map((LineItem: any, index) =>
                          LineItem.OtherObjectID == 0 &&
                          LineItem.ObjectType == 3 &&
                          LineItem.TransactionType == 2 &&
                          LineItem.SourceType == 2 ? (
                            <tr key={index} className="bold-font">
                              <td className="text-left" colSpan={2}>
                                <span title={LineItem.Notes}>
                                  {LineItem.RefferenceNumber}
                                </span>
                                <img
                                  title={GetDetailsForLineItem(LineItem)}
                                  src="/images/info-red.svg"
                                  width={12}
                                  height={12}
                                />
                              </td>
                              <td className="text-left" colSpan={2}>
                                -£{Number(LineItem.Amount).toFixed(2)}
                                <a
                                  title="Edit Line Item"
                                  onClick={() => EditLineItem(LineItem)}
                                  className="flex-d"
                                >
                                  <img
                                    src="/images/edit.svg"
                                    width={12}
                                    height={12}
                                  />
                                </a>
                                <a
                                  onClick={() =>
                                    DeleteLineItem(
                                      LineItem.PTPaymentInvoiceLineItemID,
                                    )
                                  }
                                  className="flex-d"
                                >
                                  <img
                                    src="/images/delete.png"
                                    width={12}
                                    height={12}
                                  />
                                </a>
                              </td>
                            </tr>
                          ) : null,
                        )}

                      {/* Other Paid */}
                      {AnyBankDeposit == 1 && ThirdPartyTotalPaid > 0 && (
                        <tr className="bold-font">
                          <td className="text-left" colSpan={2}>
                            Other Paid
                          </td>
                          <td className="text-left" colSpan={2}>
                            -£{Number(ThirdPartyTotalPaid).toFixed(2)}
                          </td>
                        </tr>
                      )}

                      {/* Paid */}
                      <tr className="bold-font">
                        <td className="text-left" colSpan={2}>
                          Paid
                        </td>
                        <td className="text-left" colSpan={2}>
                          £{Number(LineItemsAmounts.OverAllPaid).toFixed(2)}
                        </td>
                      </tr>

                      {/* Refund */}
                      {LineItemsAmounts.OverAllRefund > 0 && (
                        <tr className="bold-font">
                          <td className="text-left" colSpan={2}>
                            Refund
                          </td>
                          <td className="text-left" colSpan={2}>
                            £{Number(LineItemsAmounts.OverAllRefund).toFixed(2)}
                          </td>
                        </tr>
                      )}

                      {/* Balance */}
                      <tr className="bold-font">
                        <td className="text-left" colSpan={2}>
                          Balance
                        </td>

                        {calculations.Balance >= 0 ? (
                          <td className="text-left" colSpan={2}>
                            £{Number(calculations.Balance).toFixed(2)}
                            {checkIfThereIsAnyDifferenceInBalance() != 0 && (
                              <span className="c-red">
                                {" "}
                                Diff:{" "}
                                {Number(
                                  checkIfThereIsAnyDifferenceInBalance(),
                                ) < 0
                                  ? "-£"
                                  : "£"}
                                {Math.abs(
                                  Number(
                                    checkIfThereIsAnyDifferenceInBalance(),
                                  ),
                                ).toFixed(2)}
                              </span>
                            )}
                          </td>
                        ) : (
                          <td className="text-left" colSpan={2}>
                            -£{Number(-calculations.Balance).toFixed(2)}
                            {checkIfThereIsAnyDifferenceInBalance() != 0 && (
                              <span className="c-red">
                                {" "}
                                Diff:{" "}
                                {Number(
                                  checkIfThereIsAnyDifferenceInBalance(),
                                ) < 0
                                  ? "-£"
                                  : "£"}
                                {Math.abs(
                                  Number(
                                    checkIfThereIsAnyDifferenceInBalance(),
                                  ),
                                ).toFixed(2)}
                              </span>
                            )}
                          </td>
                        )}
                        {checkIfThereIsAnyDifferenceInBalance() != 0 && (
                          <span className="c-red">
                            Unsaved changes, please check and press Update
                            button!
                          </span>
                        )}
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>
            {/* Footer Buttons */}

            <div className="flex-da wrap-flex btn-start flex-gap10 flex-jse">
              {(MNVQuote.MNVQuoteStatusID == 2 ||
                MNVQuote.MNVQuoteStatusID == 3 ||
                MNVQuote.MNVQuoteStatusID == 6) && (
                <a
                  className="flex-daj btn-primary"
                  onClick={() => ChangeStatusForQuoteOrAllQuotesInOneJob(0, 1)}
                >
                  Change to Booking
                </a>
              )}

              {(MNVQuote.MNVQuoteStatusID == 6 ||
                MNVQuote.MNVQuoteStatusID == 3) && (
                <a
                  className="flex-daj btn-primary"
                  onClick={() => ChangeStatusForQuoteOrAllQuotesInOneJob(0, 2)}
                >
                  Change to Reserved
                </a>
              )}

              {(MNVQuote.MNVQuoteStatusID == 1 ||
                MNVQuote.MNVQuoteStatusID == 2) && (
                <a
                  className="flex-daj btn-primary"
                  onClick={() => ChangeStatusForQuoteOrAllQuotesInOneJob(0, 3)}
                >
                  Change to On Hold
                </a>
              )}

              <a
                className="flex-daj btn-primary"
                target="_blank"
                href={`/invoicedata?j=${MNVQuote.JobID}`}
              >
                View Invoice
              </a>

              {TrustPilotEmail && (
                <a
                  className="flex-daj btn-primary"
                  onClick={SendTrustPilotEmail}
                >
                  Send Review Email
                </a>
              )}

              {(LineItemsAmounts.PendingLineItemCount > 0 ||
                calculations.Balance > 0) && (
                <a className="flex-daj btn-primary" onClick={GenerateInvoice}>
                  Generate Invoice
                </a>
              )}

              {MNVQuote.MNVQuoteStatusID == 5 && (
                <a
                  className="flex-daj btn-primary"
                  onClick={() => SendQuotationStatusChangeEmail(20)}
                >
                  Send Cancellation Email
                </a>
              )}

              {MNVQuote.MNVQuoteStatusID == 1 && (
                <a
                  className="flex-daj btn-primary"
                  onClick={() => SendQuotationStatusChangeEmail(21)}
                >
                  Send Rescheduling Email
                </a>
              )}

              {MNVQuote.MNVQuoteStatusID == 6 && (
                <>
                  <a
                    className="flex-daj btn-primary"
                    onClick={() => SendQuotationLinkEmail(0)}
                  >
                    Send Quotation Link
                  </a>

                  <a
                    className="flex-daj btn-primary"
                    onClick={() => GetQuotationLinkForCopy(0)}
                  >
                    Copy Quotation Link
                  </a>

                  <a
                    className="flex-daj btn-primary"
                    onClick={() => SendQuotationLinkEmail(1)}
                  >
                    Send Bank Transfer Link
                  </a>

                  <a
                    className="flex-daj btn-primary"
                    onClick={() => GetQuotationLinkForCopy(1)}
                  >
                    Copy Bank Transfer Link
                  </a>
                </>
              )}

              {SavedClientID > 0 &&
                MNVQuote.MNVQuoteStatusID !== 0 &&
                MNVQuote.MNVQuoteStatusID !== 5 &&
                MNVQuote.MNVQuoteStatusID !== 6 && (
                  <>
                    <a
                      className="flex-daj btn-primary"
                      onClick={SendConfirmationEmail}
                    >
                      Send Confirmation Email
                    </a>

                    <a
                      className="flex-daj btn-primary"
                      href={MNVQuote.PDFURL}
                      download
                      target="_blank"
                    >
                      Download Booking PDF
                    </a>
                  </>
                )}

              {/* Line Items */}
              <a
                className="flex-daj btn-primary"
                onClick={() => OpenLineItemsPopupForJob(1, 0, 3)}
              >
                Line Items
              </a>

              {/* Refund / Charge */}
              {QuoteRelatedPaymentAccount &&
                QuoteRelatedPaymentAccount.length > 0 &&
                calculations.Balance < 0 && (
                  <a
                    className="flex-daj btn-primary"
                    onClick={() => TakeOrRefundAmount(0)}
                  >
                    Refund
                  </a>
                )}

              {calculations.Balance < 0 && (
                <a
                  className="flex-daj btn-primary"
                  onClick={() => TakeOrRefundAmount(-1)}
                >
                  Manual Refund
                </a>
              )}

              {QuoteRelatedPaymentAccount &&
                QuoteRelatedPaymentAccount.length > 0 &&
                calculations.Balance > 0 && (
                  <a
                    className="flex-daj btn-primary"
                    onClick={() => TakeOrRefundAmount(1)}
                  >
                    Charge
                  </a>
                )}

              {calculations.Balance > 0 && (
                <a
                  className="flex-daj btn-primary"
                  onClick={() => OpenSendPaymentLinkPopup()}
                >
                  Send New Card Payment Link
                </a>
              )}

              {/* Payment Methods */}
              {SavedClientID > 0 &&
                QuoteRelatedPaymentAccount &&
                QuoteRelatedPaymentAccount.length > 0 && (
                  <a
                    className="flex-daj btn-primary"
                    onClick={() => OpenLineItemsPopup()}
                  >
                    Update Payment Method
                  </a>
                )}

              {SavedClientID > 0 &&
                QuoteRelatedPaymentAccount &&
                QuoteRelatedPaymentAccount.length == 0 && (
                  <a
                    className="flex-daj btn-primary"
                    onClick={() => OpenLineItemsPopup()}
                  >
                    Add Payment Method
                  </a>
                )}
            </div>
          </div>

          <div className="accordion-top flex-da justify-btw grey-accord">
            Courtesy Call
          </div>

          <div className="grid-d fr-11 gap-30 mt-20 flex-jas">
            <div className="grid-d flex-gap3">
              <div className="flex-da gap-10">
                <span className="font-12 text-left label-color">Before</span>

                <div className="flex-d flex-gap20">
                  <input
                    type="checkbox"
                    checked={info.CourtesyCallBefore}
                    value={info.CourtesyCallBefore}
                    className="input-field"
                    onChange={(e) => {
                      info.CourtesyCallBefore = e.target.checked;

                      setInfo({
                        ...info,
                        CourtesyCallBefore: e.target.checked,
                      });
                      setTimeout(() => {
                        updateCourtesyCallData();
                      }, 300);
                    }}
                  />
                </div>

                <div className="grid-d flex-gap3 w-100">
                  <span className="font-12 text-left label-color">
                    Before Notes
                  </span>

                  <div className="flex-d flex-gap20">
                    <textarea
                      value={info.CourtesyCallBeforeNotes}
                      className="input-field w-100 h-notes"
                      onChange={(e) => {
                        info.CourtesyCallBeforeNotes = e.target.value;

                        setInfo({
                          ...info,
                          CourtesyCallBeforeNotes: e.target.value,
                        });
                      }}
                      onBlur={(e) => {
                        setTimeout(() => {
                          updateCourtesyCallData();
                        }, 300);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="grid-d flex-gap3">
              <div className="flex-da gap-10">
                <span className="font-12 text-left label-color">After</span>

                <div className="flex-d flex-gap20">
                  <input
                    type="checkbox"
                    checked={info.CourtesyCallAfter}
                    value={info.CourtesyCallAfter}
                    className="input-field"
                    onChange={(e) => {
                      info.CourtesyCallAfter = e.target.checked;
                      setInfo({
                        ...info,
                        CourtesyCallAfter: e.target.checked,
                      });
                      setTimeout(() => {
                        updateCourtesyCallData();
                      }, 300);
                    }}
                  />
                </div>
                <div className="grid-d flex-gap3 w-100">
                  <span className="font-12 text-left label-color">
                    After Notes
                  </span>

                  <div className="flex-d flex-gap20">
                    <textarea
                      value={info.CourtesyCallAfterNotes}
                      className="input-field w-100 h-notes"
                      onChange={(e) => {
                        info.CourtesyCallAfterNotes = e.target.value;

                        setInfo({
                          ...info,
                          CourtesyCallAfterNotes: e.target.value,
                        });
                      }}
                      onBlur={(e) => {
                        setTimeout(() => {
                          updateCourtesyCallData();
                        }, 300);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {MNVQuote.MNVQuoteID > 0 && (
            <div className="grid-d flex-gap10 mt-20 ">
              <Conversation
                OtherEntityID={MNVQuote.MNVQuoteID}
                MessageTypeID={4}
                ShowMoveLeader={2}
              />
            </div>
          )}

          <div className="grid-d flex-gap10 mt-20">
            <div className="flex-da flex-gap10 font-mont">
              <span className="font-14 text-left label-color">
                Job Changes Logs
              </span>
              <div className="field-input">
                {/* Start Date */}
                <input
                  type="date"
                  value={LogFilters.StartDate}
                  // onBlur={(e) => SetDateFilters(1, e)}
                  onChange={(e) =>
                    setLogFilters({
                      ...LogFilters,
                      StartDate: Number(e.target.value),
                    })
                  }
                  className="input-field"
                />
              </div>
              <div className="field-input">
                {/* End Date */}
                <input
                  type="date"
                  value={LogFilters.EndDate}
                  // onBlur={(e) => SetDateFilters(2, e)}
                  onChange={(e) =>
                    setLogFilters({
                      ...LogFilters,
                      EndDate: Number(e.target.value),
                    })
                  }
                  className="input-field"
                />
              </div>
              <div className="field-input">
                {/* Quote ID Filter */}

                <select
                  value={LogFilters.MNVQuoteID}
                  onChange={(e) =>
                    setLogFilters({
                      ...LogFilters,
                      MNVQuoteID: Number(e.target.value),
                    })
                  }
                  className="input-field"
                >
                  <option value="-1">All Logs</option>
                  <option value="0">Job Level Only</option>

                  {AllLinkedQuotes.map((Item, ThisIndex) => (
                    <option key={Item.MNVQuoteID} value={Item.MNVQuoteID}>
                      {`Service ${ThisIndex + 1}`}
                    </option>
                  ))}
                </select>
              </div>
              <div className="field-input">
                {/* Type Filter */}

                <select
                  value={LogFilters.TypeIDs}
                  onChange={(e) =>
                    setLogFilters({
                      ...LogFilters,
                      TypeIDs: Number(e.target.value),
                    })
                  }
                  className="input-field"
                >
                  <option value="0">All</option>
                  {QuoteLogTypes.map((Item, index) => (
                    <option key={index} value={Item.MNVJobActivityLogTypeID}>
                      {Item.Name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="flex-d btn-start flex-gap10">
                {/* Buttons */}
                <a className="flex-daj btn-primary" onClick={LoadLogsData}>
                  Apply Filter
                </a>

                <a
                  className="flex-daj btn-primary"
                  onClick={() => ClearLogsFilters(1)}
                >
                  Clear Filter
                </a>
              </div>
            </div>

            {/* No Logs */}
            {QuoteLogs && QuoteLogs.length == 0 && (
              <div className="flex-daj mt-20 text-uppercase font-14 label-color text-center">
                No Logs Data
              </div>
            )}

            {/* Logs Table */}
            {QuoteLogs && QuoteLogs.length > 0 && (
              <div className="flow-auto mt-25 auto-height">
                <table className="reuse-table">
                  <tbody>
                    {QuoteLogs.map((Item, index) => (
                      <tr key={index}>
                        {/* Date + User */}
                        <td className="text-left" style={{ minWidth: "200px" }}>
                          <div className="grid-d flex-gap3">
                            <span className="flex-d">
                              {Item.TransactionDate}
                            </span>
                            <span className="flex-d">{Item.UserName}</span>
                          </div>
                        </td>

                        {/* Log Text and Details */}
                        <td className="text-left">
                          <div className="flex-da flex-gap10">
                            <a
                              onClick={() =>
                                openLogsDetailsPopup(
                                  Item.MNVJobActivityLogID,
                                  index,
                                )
                              }
                              title={Item.Description}
                            >
                              {Item.Name}
                            </a>

                            {Item.ShowMoreDetails == 1 && (
                              <a
                                onClick={() =>
                                  openLogsDetailsPopup(
                                    Item.MNVJobActivityLogID,
                                    index,
                                  )
                                }
                                title="View Details"
                                className="flex-d"
                              >
                                <img
                                  src="/images/info-red.svg"
                                  width={12}
                                  height={12}
                                />
                              </a>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          {showUpdateClientModal && (
            <div className="popup-help popup-help-index">
              <div className="help-popup-display">
                <div className="help-inner">
                  {/* Modal Header */}
                  <div className="help-head flex-da justify-btw">
                    <h3 className="bold-font flex-d m-all0">
                      {IsClientAddClicked == false
                        ? "Update Client"
                        : "Add Client"}
                    </h3>

                    <a
                      className="close-help"
                      onClick={() => {
                        setShowUpdateClientModal(false);
                        // SearchByClientName(ClientEmail, true);
                        setIsClientAddClicked(false);
                      }}
                    >
                      <img
                        src="/images/close.svg"
                        width="15px"
                        height="15px"
                        alt="cross"
                      />
                    </a>
                  </div>

                  {/* Modal Body */}
                  <div className="modal-body">
                    {/* Client Type */}
                    <div className="grid-d fr-1 mt-20 ">
                      <div className="flow-popup grid-d gap-20">
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Client Type
                          </span>
                          <select
                            className="input-field w-100"
                            value={ClientData.TypeID}
                            onChange={(e) =>
                              setClientData({
                                ...ClientData,
                                TypeID: Number(e.target.value),
                              })
                            }
                          >
                            <option value="0">Please Select</option>
                            <option value="2">Residential</option>
                            <option value="1">Business</option>
                          </select>
                        </div>

                        {/* Business Name (TypeID == 1) */}
                        {ClientData.TypeID == 1 && (
                          <div className="field-input grid-d flex-gap3">
                            <span className="font-12 text-left label-color">
                              Business Name
                            </span>
                            <>
                              <input
                                type="text"
                                className="input-field w-100"
                                value={ClientData.BusinessName}
                                onChange={(e) =>
                                  setClientData({
                                    ...ClientData,
                                    BusinessName: e.target.value,
                                  })
                                }
                              />
                            </>
                          </div>
                        )}

                        {/* First Name */}
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            First Name
                          </span>
                          <>
                            <input
                              type="text"
                              className="input-field w-100"
                              value={ClientData.FirstName}
                              onChange={(e) =>
                                setClientData({
                                  ...ClientData,
                                  FirstName: e.target.value,
                                })
                              }
                            />
                          </>
                        </div>

                        {/* Last Name */}
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Last Name
                          </span>
                          <>
                            <input
                              type="text"
                              className="input-field w-100"
                              value={ClientData.LastName}
                              onChange={(e) =>
                                setClientData({
                                  ...ClientData,
                                  LastName: e.target.value,
                                })
                              }
                            />
                          </>
                        </div>

                        {/* Email */}
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Email
                          </span>
                          <>
                            <input
                              type="text"
                              className="input-field w-100"
                              value={ClientData.EmailAddress}
                              onChange={(e) =>
                                setClientData({
                                  ...ClientData,
                                  EmailAddress: e.target.value,
                                })
                              }
                            />
                          </>
                        </div>

                        {/* Mobile (Custom Component) */}
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Mobile
                          </span>
                          <>
                            {/* <input
                          type="text"
                          className="input-field w-100"
                          value={ClientData.Mobile}
                          onChange={(e) =>
                            setClientData({
                              ...ClientData,
                              Mobile: e.target.value,
                            })
                          }
                        /> */}

                            <MobileInput
                              SelectedMobileNumber={SelectedMobileNumber}
                              SetSelectedMobileNumber={SetSelectedMobileNumber}
                            />
                          </>
                        </div>

                        {/* Telephone */}
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Phone
                          </span>
                          <>
                            <input
                              type="text"
                              className="input-field w-100"
                              value={ClientData.Telephone}
                              onChange={(e) =>
                                setClientData({
                                  ...ClientData,
                                  Telephone: e.target.value,
                                })
                              }
                            />
                          </>
                        </div>

                        {/* Postcode */}
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Postcode
                          </span>
                          <>
                            <input
                              type="text"
                              className="input-field w-100"
                              value={ClientData.PostCode}
                              onChange={(e) =>
                                setClientData({
                                  ...ClientData,
                                  PostCode: e.target.value,
                                })
                              }
                            />
                          </>
                        </div>

                        {/* Address Line 1 */}
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Address Line 1
                          </span>
                          <>
                            <input
                              type="text"
                              className="input-field w-100"
                              value={ClientData.Address}
                              onChange={(e) =>
                                setClientData({
                                  ...ClientData,
                                  Address: e.target.value,
                                })
                              }
                            />
                          </>
                        </div>

                        {/* Address Line 2 */}
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Address Line 2
                          </span>
                          <>
                            <input
                              type="text"
                              className="input-field w-100"
                              value={ClientData.AddressLine2}
                              onChange={(e) =>
                                setClientData({
                                  ...ClientData,
                                  AddressLine2: e.target.value,
                                })
                              }
                            />
                          </>
                        </div>

                        {/* VAT Number (Business only) */}
                        {ClientData.TypeID == 1 && (
                          <div className="field-input grid-d flex-gap3">
                            <span className="font-12 text-left label-color">
                              VAT Number
                            </span>
                            <>
                              <input
                                type="text"
                                className="input-field w-100"
                                value={ClientData.VATNumber}
                                onChange={(e) =>
                                  setClientData({
                                    ...ClientData,
                                    VATNumber: e.target.value,
                                  })
                                }
                              />
                            </>
                          </div>
                        )}

                        {/* Company Number (Business only) */}
                        {ClientData.TypeID == 1 && (
                          <div className="field-input grid-d flex-gap3">
                            <span className="font-12 text-left label-color">
                              Company Number
                            </span>
                            <>
                              <input
                                type="text"
                                className="input-field w-100"
                                value={ClientData.CompanyNumber}
                                onChange={(e) =>
                                  setClientData({
                                    ...ClientData,
                                    CompanyNumber: e.target.value,
                                  })
                                }
                              />
                            </>
                          </div>
                        )}

                        {/* Other Emails */}
                        <div className="field-input grid-d flex-gap3">
                          <span className="font-12 text-left label-color">
                            Other Emails
                          </span>
                          <>
                            <input
                              type="text"
                              className="input-field w-100"
                              value={ClientData.OtherEmails}
                              onChange={(e) =>
                                setClientData({
                                  ...ClientData,
                                  OtherEmails: e.target.value,
                                })
                              }
                            />
                          </>
                        </div>
                      </div>
                      {/* Save Button */}
                      <div className="flex-daj gap-10 mt-20">
                        <div className="flex-daj btn-start flex-gap10">
                          {IsClientAddClicked == true && (
                            <a
                              className="btn-primary flex-daj"
                              onClick={() => SaveClient()}
                            >
                              Save
                            </a>
                          )}
                          {IsClientAddClicked == false && (
                            <a
                              className="btn-primary flex-daj"
                              onClick={() => UpdateClient()}
                            >
                              Update
                            </a>
                          )}

                          <a
                            className="btn-primary flex-daj"
                            onClick={() => setShowUpdateClientModal(false)}
                          >
                            Cancel
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showLineItemModal && (
            <div className="popup-help popup-help-index">
              <div className="help-popup-display">
                <div className="help-inner">
                  <div className="help-head flex-da justify-btw">
                    <h3 className="bold-font flex-d m-all0">Line Item</h3>
                    <a
                      className="close-help"
                      onClick={() => setShowLineItemModal(false)}
                    >
                      <img
                        src="/images/close.svg"
                        width="15px"
                        height="15px"
                        alt="cross"
                      />
                    </a>
                  </div>
                  <div className="modal-body">
                    <MNVLineItems
                      LineItemType={1}
                      VAT={Vat}
                      QuoteID={QuoteId}
                      MNVJobID={JobRelatedData?.MNVJobID}
                      PreFillData={PreFillData}
                      ClosePopupAndLoadLineItem={(e) =>
                        ClosePopupAndLoadLineItem(e)
                      }
                    />
                  </div>

                  {/* <div className="flex-daj gap-10 mt-20">
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => setShowLineItemModal(false)}
                    >
                      Cancel
                    </a>
                  </div>
                </div> */}
                </div>
              </div>
            </div>
          )}

          {showSlotsModal && (
            <div className="popup-help popup-help-index">
              <div className="help-popup-display">
                <div className="help-inner md-popup2">
                  <div className="help-head flex-da justify-btw">
                    <h3 className="bold-font flex-d m-all0">Availability</h3>
                    <a
                      className="close-help"
                      onClick={() => setShowSlotsModal(false)}
                    >
                      <img
                        src="/images/close.svg"
                        width="15px"
                        height="15px"
                        alt="cross"
                      />
                    </a>
                  </div>
                  <div className="modal-body">
                    <div className="grid-d flex-gap10 mt-20">
                      {items.map((item, index) => (
                        <div className="grid-d flex-da box-slot" key={index}>
                          {/* HEADER */}
                          {item.ClosedText == "" ? (
                            <div
                              className="slots-flex pointer"
                              onClick={() =>
                                setItems((prev) =>
                                  prev.map((it, i) =>
                                    i == index
                                      ? {
                                          ...it,
                                          ShowAccordion: !it.ShowAccordion,
                                        }
                                      : it,
                                  ),
                                )
                              }
                            >
                              <span>
                                {new Date(item.Date).toLocaleDateString(
                                  "en-GB",
                                  {
                                    weekday: "long",
                                    month: "long",
                                    day: "numeric",
                                  },
                                )}
                              </span>

                              <span className="bold-font c-theme">
                                {ExtraHours > 0 ? (
                                  <>
                                    Prices from £
                                    {AdditionalRateAndVAT * ExtraHours}*
                                  </>
                                ) : (
                                  <>
                                    Prices from £
                                    {Number(item.MinStartPrice).toFixed(2)}*
                                  </>
                                )}
                              </span>
                            </div>
                          ) : (
                            <div className="slots-flex">
                              <span>
                                {new Date(item.Date).toLocaleDateString(
                                  "en-GB",
                                  {
                                    weekday: "long",
                                    month: "long",
                                    day: "numeric",
                                  },
                                )}
                              </span>
                              <span className="bold-font c-theme">
                                {item.ClosedText}
                              </span>
                            </div>
                          )}

                          {/* ACCORDION */}
                          {item.ShowAccordion && (
                            <div className="grid-d fr-11 flex-gap10 p-all10 font-mont">
                              {item.Slots.map((slot: any, sIndex: any) => {
                                const isFullyBooked = slot.Booking >= slot.Vans;

                                return isFullyBooked ? (
                                  <a
                                    key={sIndex}
                                    id={`${index}_${sIndex}`}
                                    className={`mn-slots-5 mn-slots-5d`}
                                  >
                                    <div className="flex-da flex-gap10">
                                      <span className="mn-slots-9">
                                        {slot.StartTime == slot.EndTime
                                          ? slot.StartTime
                                          : slot.Name}
                                      </span>

                                      <span className="mn-slots-11 font-10 bold-font c-theme">
                                        Fully Booked
                                      </span>
                                    </div>
                                    <div className="flex-da flex-gap10">
                                      {slot.StartTime == slot.EndTime && (
                                        <span className="mn-slots-11 font-10 bold-font c-theme">
                                          Fixed Arrival
                                        </span>
                                      )}

                                      {slot.CalculatedPrice -
                                        item.MinStartPrice >
                                        0 && (
                                        <span className="mn-slots-11 mn-slots-11f  font-12 bold-font c-theme">
                                          +£
                                          {(
                                            slot.CalculatedPrice -
                                            item.MinStartPrice
                                          ).toFixed(2)}
                                        </span>
                                      )}
                                    </div>
                                  </a>
                                ) : (
                                  <a
                                    key={sIndex}
                                    id={`${index}_${sIndex}`}
                                    className="mn-slots-5"
                                    onClick={() =>
                                      onTagSelect(
                                        slot.Name,
                                        index,
                                        slot.SlotCharge,
                                        item.Date,
                                        sIndex,
                                        slot.SlotId,
                                        slot,
                                      )
                                    }
                                  >
                                    <div className="flex-da flex-gap10">
                                      <span className="mn-slots-9">
                                        {slot.StartTime == slot.EndTime
                                          ? slot.StartTime
                                          : slot.Name}
                                      </span>
                                      <span className="mn-slots-c">
                                        {slot.Vans - slot.Booking}
                                      </span>
                                    </div>
                                    <div className="flex-da flex-gap10">
                                      {slot.StartTime == slot.EndTime && (
                                        <span className="mn-slots-11 font-10 bold-font c-theme">
                                          Fixed Arrival
                                        </span>
                                      )}

                                      {slot.CalculatedPrice -
                                        item.MinStartPrice >
                                        0 && (
                                        <span className="mn-slots-11 mn-slots-11f  font-12 bold-font c-theme">
                                          +£
                                          {(
                                            slot.CalculatedPrice -
                                            item.MinStartPrice
                                          ).toFixed(2)}
                                        </span>
                                      )}
                                    </div>
                                  </a>
                                );
                              })}
                            </div>
                          )}
                        </div>
                      ))}

                      {/* LOAD MORE */}
                      <div className="btn-start flex-daj">
                        <a
                          className="flex-daj btn-primary w-100"
                          onClick={() => LoadMore()}
                        >
                          + Load More
                        </a>
                      </div>
                      <div className="btn-start flex-da flex-jse">
                        <span className="bold-font c-theme font-10 font-mont">
                          *Prices exclude VAT
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* <div className="flex-daj gap-10 mt-20">
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => setShowSlotsModal(false)}
                    >
                      Cancel
                    </a>
                  </div>
                </div> */}
                </div>
              </div>
            </div>
          )}

          {showBespokeModal && (
            <div className="popup-help popup-help-index">
              <div className="help-popup-display">
                <div className="help-inner">
                  <div className="help-head flex-da justify-btw">
                    <h3 className="bold-font flex-d m-all0">Bespoke Booking</h3>
                    <a
                      className="close-help"
                      onClick={() => {
                        setShowBespokeModal(false);
                        setBespokeDate("");
                        setBespokeTime("");
                        setBespokeTimeEnd("");
                      }}
                    >
                      <img
                        src="/images/close.svg"
                        width="15px"
                        height="15px"
                        alt="cross"
                      />
                    </a>
                  </div>
                  <div className="modal-body">
                    <div className="grid-d gap-20 mt-20">
                      <div className="field-input grid-d  flex-gap3">
                        <span className="font-12 text-left label-color">
                          Date
                        </span>

                        <input
                          type="date"
                          className="input-field w-100"
                          value={BespokeDate}
                          onChange={(e) => setBespokeDate(e.target.value)}
                        />
                      </div>

                      <div className="field-input grid-d  flex-gap3">
                        <span className="font-12 text-left label-color">
                          Slot start time
                        </span>

                        <input
                          type="time"
                          className="input-field w-100"
                          value={BespokeTime}
                          onChange={(e) => setBespokeTime(e.target.value)}
                        />
                      </div>

                      <div className="field-input grid-d  flex-gap3">
                        <span className="font-12 text-left label-color">
                          Slot end time
                        </span>
                        <>
                          <input
                            type="time"
                            className="input-field w-100"
                            value={BespokeTimeEnd}
                            onChange={(e) => setBespokeTimeEnd(e.target.value)}
                          />
                        </>
                      </div>

                      <div className="flex-daj btn-start">
                        <a
                          className="flex-daj btn-primary"
                          role="button"
                          onClick={CloseBespoke}
                        >
                          Save
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* <div className="flex-daj gap-10 mt-20">
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => setShowBespokeModal(false)}
                    >
                      Cancel
                    </a>
                  </div>
                </div> */}
                </div>
              </div>
            </div>
          )}

          {show && (
            <div className="popup-help popup-help-index">
              <div className="help-popup-display">
                <div className="help-inner md-popup">
                  <div className="help-head flex-da justify-btw">
                    <h3 className="bold-font flex-d m-all0">
                      {MNVQuote.LocationType == -1 && <>Collection Point</>}
                      {MNVQuote.LocationType == -2 && <>Delivery Point</>}
                      {MNVQuote.LocationType < -2 && <>Stop Off</>}
                    </h3>
                    <a className="close-help" onClick={() => setShow(false)}>
                      <img
                        src="/images/close.svg"
                        width="15px"
                        height="15px"
                        alt="cross"
                      />
                    </a>
                  </div>
                  <div className="modal-body mt--15">
                    <ShowMapMarker
                      latitude={currentLat}
                      longitude={currentLng}
                    />
                  </div>

                  {/* <div className="flex-daj gap-10 mt-20">
                  <div className="flex-daj btn-start">
                    <a
                      className="btn-primary flex-daj"
                      onClick={() => setShow(false)}
                    >
                      Cancel
                    </a>
                  </div>
                </div> */}
                </div>
              </div>
            </div>
          )}

          {showLogModal && modalContentType == "simple" && (
            <div className="popup-help popup-help-index">
              <div className="help-popup-display">
                <div className="help-inner md-popup2">
                  <div className="help-head flex-da justify-btw">
                    <h3 className="bold-font flex-d m-all0">
                      Changes made by{" "}
                      {QuoteLogs[LogFilters.LogSelectedIndex].UserName} on{" "}
                      {QuoteLogs[LogFilters.LogSelectedIndex].TransactionDate}
                    </h3>
                    <a
                      className="close-help"
                      onClick={() => setShowLogModal(false)}
                    >
                      <img
                        src="/images/close.svg"
                        width="15px"
                        height="15px"
                        alt="cross"
                      />
                    </a>
                  </div>

                  <div className="modal-body font-mont">
                    {QuoteLogs[LogFilters.LogSelectedIndex].Name !==
                      QuoteLogs[LogFilters.LogSelectedIndex].Description && (
                      <span className="flex-daj mt-20 font-16 bold-font text-center w-100">
                        {QuoteLogs[LogFilters.LogSelectedIndex].Name}
                      </span>
                    )}
                    <span className="flex-daj mt-10 font-14 text-center w-100">
                      {QuoteLogs[LogFilters.LogSelectedIndex].Description}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showLogModal && modalContentType == "detailed" && (
            <div className="popup-help popup-help-index">
              <div className="help-popup-display">
                <div className="help-inner lg-popup">
                  <div className="help-head flex-da justify-btw">
                    <h3 className="bold-font flex-d m-all0">
                      Changes made by{" "}
                      {QuoteLogs[LogFilters.LogSelectedIndex].UserName} on{" "}
                      {QuoteLogs[LogFilters.LogSelectedIndex].TransactionDate}
                    </h3>
                    <a
                      className="close-help"
                      onClick={() => setShowLogModal(false)}
                    >
                      <img
                        src="/images/close.svg"
                        width="15px"
                        height="15px"
                        alt="cross"
                      />
                    </a>
                  </div>
                  <div className="modal-body">
                    {quoteDetailedLogs &&
                      quoteDetailedLogs.length == 1 &&
                      !LogFilters.LoadingDetails && (
                        <div className="flex-daj font-mont text-uppercase font-14 mt-20 bold-font c-red">
                          No Previous record to compare.
                        </div>
                      )}

                    {LogFilters.LoadingDetails && (
                      <div className="flex-daj font-mont text-uppercase font-14 mt-20 bold-font">
                        loading....
                      </div>
                    )}

                    {quoteDetailedLogs && !LogFilters.LoadingDetails && (
                      <>
                        {quoteDetailedLogs.length == 2 && (
                          <>
                            <div className="field-input grid-d fr-111 mt-20">
                              <select
                                className="input-field"
                                value={LogFilters.ShowChangesOnly}
                                onChange={(e) =>
                                  setLogFilters((prevState: any) => ({
                                    ...prevState,
                                    ShowChangesOnly: e.target.value,
                                  }))
                                }
                              >
                                <option value="0">All</option>
                                <option value="1">Changes Only</option>
                              </select>
                            </div>
                            <div className="flow-auto mt-20">
                              <table className="reuse-table">
                                <thead>
                                  <tr>
                                    <th>Field Name</th>
                                    <th>Old Value</th>
                                    <th>New Value</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {quoteDetailedLogs &&
                                    quoteDetailedLogs.length == 2 && (
                                      <>
                                        {(quoteDetailedLogs[0]
                                          .ShowClientDetails ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td
                                              colSpan={3}
                                              className="HeadingRow"
                                            >
                                              Client
                                            </td>
                                          </tr>
                                        )}
                                        {(quoteDetailedLogs[0].ClientName !==
                                          quoteDetailedLogs[1].ClientName ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td>Client Name</td>
                                            <td>
                                              {quoteDetailedLogs[0].ClientName}
                                            </td>
                                            <td
                                              className={
                                                quoteDetailedLogs[0]
                                                  .ClientName !==
                                                quoteDetailedLogs[1].ClientName
                                                  ? "clHighlight"
                                                  : ""
                                              }
                                            >
                                              {quoteDetailedLogs[1].ClientName}
                                            </td>
                                          </tr>
                                        )}

                                        {(quoteDetailedLogs[0]
                                          .ShowCollectionPoint ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td
                                              colSpan={3}
                                              className="HeadingRow"
                                            >
                                              Collection Point
                                            </td>
                                          </tr>
                                        )}
                                        {(quoteDetailedLogs[0]
                                          .FromPostalCode !==
                                          quoteDetailedLogs[1].FromPostalCode ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td>Post Code</td>
                                            <td>
                                              {
                                                quoteDetailedLogs[0]
                                                  .FromPostalCode
                                              }
                                            </td>
                                            <td
                                              className={
                                                quoteDetailedLogs[0]
                                                  .FromPostalCode !==
                                                quoteDetailedLogs[1]
                                                  .FromPostalCode
                                                  ? "clHighlight"
                                                  : ""
                                              }
                                            >
                                              {
                                                quoteDetailedLogs[1]
                                                  .FromPostalCode
                                              }
                                            </td>
                                          </tr>
                                        )}
                                        {(quoteDetailedLogs[0].FromAddress !==
                                          quoteDetailedLogs[1].FromAddress ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td>Address</td>
                                            <td>
                                              {quoteDetailedLogs[0].FromAddress}
                                            </td>
                                            <td
                                              className={
                                                quoteDetailedLogs[0]
                                                  .FromAddress !==
                                                quoteDetailedLogs[1].FromAddress
                                                  ? "clHighlight"
                                                  : ""
                                              }
                                            >
                                              {quoteDetailedLogs[1].FromAddress}
                                            </td>
                                          </tr>
                                        )}
                                        {(quoteDetailedLogs[0].FromCity !==
                                          quoteDetailedLogs[1].FromCity ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td>City</td>
                                            <td>
                                              {quoteDetailedLogs[0].FromCity}
                                            </td>
                                            <td
                                              className={
                                                quoteDetailedLogs[0]
                                                  .FromCity !==
                                                quoteDetailedLogs[1].FromCity
                                                  ? "clHighlight"
                                                  : ""
                                              }
                                            >
                                              {quoteDetailedLogs[1].FromCity}
                                            </td>
                                          </tr>
                                        )}
                                        {(quoteDetailedLogs[0].FromType !==
                                          quoteDetailedLogs[1].FromType ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td>Type</td>
                                            <td>
                                              {quoteDetailedLogs[0].FromType}
                                            </td>
                                            <td
                                              className={
                                                quoteDetailedLogs[0]
                                                  .FromType !==
                                                quoteDetailedLogs[1].FromType
                                                  ? "clHighlight"
                                                  : ""
                                              }
                                            >
                                              {quoteDetailedLogs[1].FromType}
                                            </td>
                                          </tr>
                                        )}
                                        {(quoteDetailedLogs[0].FromFloorText !==
                                          quoteDetailedLogs[1].FromFloorText ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td>Floor</td>
                                            <td>
                                              {
                                                quoteDetailedLogs[0]
                                                  .FromFloorText
                                              }
                                            </td>
                                            <td
                                              className={
                                                quoteDetailedLogs[0]
                                                  .FromFloorText !==
                                                quoteDetailedLogs[1]
                                                  .FromFloorText
                                                  ? "clHighlight"
                                                  : ""
                                              }
                                            >
                                              {
                                                quoteDetailedLogs[1]
                                                  .FromFloorText
                                              }
                                            </td>
                                          </tr>
                                        )}
                                        {(quoteDetailedLogs[0]
                                          .FromLiftAvailable !==
                                          quoteDetailedLogs[1]
                                            .FromLiftAvailable ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td>Lift Available</td>
                                            <td>
                                              {
                                                quoteDetailedLogs[0]
                                                  .FromLiftAvailable
                                              }
                                            </td>
                                            <td
                                              className={
                                                quoteDetailedLogs[0]
                                                  .FromLiftAvailable !==
                                                quoteDetailedLogs[1]
                                                  .FromLiftAvailable
                                                  ? "clHighlight"
                                                  : ""
                                              }
                                            >
                                              {
                                                quoteDetailedLogs[1]
                                                  .FromLiftAvailable
                                              }
                                            </td>
                                          </tr>
                                        )}

                                        {(quoteDetailedLogs[0]
                                          .ShowDeliveryPoint ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td
                                              colSpan={3}
                                              className="HeadingRow"
                                            >
                                              Delivery Point
                                            </td>
                                          </tr>
                                        )}
                                        {(quoteDetailedLogs[0].ToPostalCode !==
                                          quoteDetailedLogs[1].ToPostalCode ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td>Post Code</td>
                                            <td>
                                              {
                                                quoteDetailedLogs[0]
                                                  .ToPostalCode
                                              }
                                            </td>
                                            <td
                                              className={
                                                quoteDetailedLogs[0]
                                                  .ToPostalCode !==
                                                quoteDetailedLogs[1]
                                                  .ToPostalCode
                                                  ? "clHighlight"
                                                  : ""
                                              }
                                            >
                                              {
                                                quoteDetailedLogs[1]
                                                  .ToPostalCode
                                              }
                                            </td>
                                          </tr>
                                        )}
                                        {(quoteDetailedLogs[0].ToAddress !==
                                          quoteDetailedLogs[1].ToAddress ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td>Address</td>
                                            <td>
                                              {quoteDetailedLogs[0].ToAddress}
                                            </td>
                                            <td
                                              className={
                                                quoteDetailedLogs[0]
                                                  .ToAddress !==
                                                quoteDetailedLogs[1].ToAddress
                                                  ? "clHighlight"
                                                  : ""
                                              }
                                            >
                                              {quoteDetailedLogs[1].ToAddress}
                                            </td>
                                          </tr>
                                        )}
                                        {(quoteDetailedLogs[0].ToCity !==
                                          quoteDetailedLogs[1].ToCity ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td>City</td>
                                            <td>
                                              {quoteDetailedLogs[0].ToCity}
                                            </td>
                                            <td
                                              className={
                                                quoteDetailedLogs[0].ToCity !==
                                                quoteDetailedLogs[1].ToCity
                                                  ? "clHighlight"
                                                  : ""
                                              }
                                            >
                                              {quoteDetailedLogs[1].ToCity}
                                            </td>
                                          </tr>
                                        )}
                                        {(quoteDetailedLogs[0].ToType !==
                                          quoteDetailedLogs[1].ToType ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td>Type</td>
                                            <td>
                                              {quoteDetailedLogs[0].ToType}
                                            </td>
                                            <td
                                              className={
                                                quoteDetailedLogs[0].ToType !==
                                                quoteDetailedLogs[1].ToType
                                                  ? "clHighlight"
                                                  : ""
                                              }
                                            >
                                              {quoteDetailedLogs[1].ToType}
                                            </td>
                                          </tr>
                                        )}
                                        {(quoteDetailedLogs[0].ToFloorText !==
                                          quoteDetailedLogs[1].ToFloorText ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td>Floor</td>
                                            <td>
                                              {quoteDetailedLogs[0].ToFloorText}
                                            </td>
                                            <td
                                              className={
                                                quoteDetailedLogs[0]
                                                  .ToFloorText !==
                                                quoteDetailedLogs[1].ToFloorText
                                                  ? "clHighlight"
                                                  : ""
                                              }
                                            >
                                              {quoteDetailedLogs[1].ToFloorText}
                                            </td>
                                          </tr>
                                        )}
                                        {(quoteDetailedLogs[0]
                                          .ToLiftAvailable !==
                                          quoteDetailedLogs[1]
                                            .ToLiftAvailable ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td>Lift Available</td>
                                            <td>
                                              {
                                                quoteDetailedLogs[0]
                                                  .ToLiftAvailable
                                              }
                                            </td>
                                            <td
                                              className={
                                                quoteDetailedLogs[0]
                                                  .ToLiftAvailable !==
                                                quoteDetailedLogs[1]
                                                  .ToLiftAvailable
                                                  ? "clHighlight"
                                                  : ""
                                              }
                                            >
                                              {
                                                quoteDetailedLogs[1]
                                                  .ToLiftAvailable
                                              }
                                            </td>
                                          </tr>
                                        )}

                                        {(quoteDetailedLogs[0]
                                          .ShowServiceName ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td
                                              colSpan={3}
                                              className="HeadingRow"
                                            >
                                              Service
                                            </td>
                                          </tr>
                                        )}
                                        {(quoteDetailedLogs[0].ServiceName !==
                                          quoteDetailedLogs[1].ServiceName ||
                                          LogFilters.ShowChangesOnly == 0) && (
                                          <tr>
                                            <td>Services</td>
                                            <td>
                                              {quoteDetailedLogs[0].ServiceName}
                                            </td>
                                            <td
                                              className={
                                                quoteDetailedLogs[0]
                                                  .ServiceName !==
                                                quoteDetailedLogs[1].ServiceName
                                                  ? "clHighlight"
                                                  : ""
                                              }
                                            >
                                              {quoteDetailedLogs[1].ServiceName}
                                            </td>
                                          </tr>
                                        )}

                                        <>
                                          {(quoteDetailedLogs[0]
                                            .ShowQuoteDetail ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td
                                                colSpan={3}
                                                className="HeadingRow"
                                              >
                                                Quote Detail
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0]
                                            .VanAndMoversDetails !==
                                            quoteDetailedLogs[1]
                                              .VanAndMoversDetails ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Van Type And Movers</td>
                                              <td>
                                                {
                                                  quoteDetailedLogs[0]
                                                    .VanAndMoversDetails
                                                }
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .VanAndMoversDetails !==
                                                  quoteDetailedLogs[1]
                                                    .VanAndMoversDetails
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                {
                                                  quoteDetailedLogs[1]
                                                    .VanAndMoversDetails
                                                }
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0].QuoteStatus !==
                                            quoteDetailedLogs[1].QuoteStatus ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Status</td>
                                              <td>
                                                {
                                                  quoteDetailedLogs[0]
                                                    .QuoteStatus
                                                }
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .QuoteStatus !==
                                                  quoteDetailedLogs[1]
                                                    .QuoteStatus
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                {
                                                  quoteDetailedLogs[1]
                                                    .QuoteStatus
                                                }
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0]
                                            .IsLocalQuoteText !==
                                            quoteDetailedLogs[1]
                                              .IsLocalQuoteText ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Local Quote</td>
                                              <td>
                                                {
                                                  quoteDetailedLogs[0]
                                                    .IsLocalQuoteText
                                                }
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .IsLocalQuoteText !==
                                                  quoteDetailedLogs[1]
                                                    .IsLocalQuoteText
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                {
                                                  quoteDetailedLogs[1]
                                                    .IsLocalQuoteText
                                                }
                                              </td>
                                            </tr>
                                          )}

                                          {quoteDetailedLogs[1].IsLocalQuote &&
                                            (quoteDetailedLogs[0]
                                              .RequiredVanTimeText !==
                                              quoteDetailedLogs[1]
                                                .RequiredVanTimeText ||
                                              LogFilters.ShowChangesOnly ==
                                                0) && (
                                              <tr>
                                                <td>Van Booked for (Hours)</td>
                                                <td>
                                                  {
                                                    quoteDetailedLogs[0]
                                                      .RequiredVanTimeText
                                                  }
                                                </td>
                                                <td
                                                  className={
                                                    quoteDetailedLogs[0]
                                                      .RequiredVanTimeText !==
                                                    quoteDetailedLogs[1]
                                                      .RequiredVanTimeText
                                                      ? "clHighlight"
                                                      : ""
                                                  }
                                                >
                                                  {
                                                    quoteDetailedLogs[1]
                                                      .RequiredVanTimeText
                                                  }
                                                </td>
                                              </tr>
                                            )}

                                          {!quoteDetailedLogs[1]
                                            .IsLocalQuote && (
                                            <>
                                              {(quoteDetailedLogs[0]
                                                .LoadingUnLoadingTimeInMinutes !==
                                                quoteDetailedLogs[1]
                                                  .LoadingUnLoadingTimeInMinutes ||
                                                LogFilters.ShowChangesOnly ==
                                                  0) && (
                                                <tr>
                                                  <td>
                                                    Loading Unloading Minutes
                                                  </td>
                                                  <td>
                                                    {
                                                      quoteDetailedLogs[0]
                                                        .LoadingUnLoadingTimeInMinutes
                                                    }
                                                  </td>
                                                  <td
                                                    className={
                                                      quoteDetailedLogs[0]
                                                        .LoadingUnLoadingTimeInMinutes !==
                                                      quoteDetailedLogs[1]
                                                        .LoadingUnLoadingTimeInMinutes
                                                        ? "clHighlight"
                                                        : ""
                                                    }
                                                  >
                                                    {
                                                      quoteDetailedLogs[1]
                                                        .LoadingUnLoadingTimeInMinutes
                                                    }
                                                  </td>
                                                </tr>
                                              )}
                                              {(quoteDetailedLogs[0]
                                                .LoadingTime !==
                                                quoteDetailedLogs[1]
                                                  .LoadingTime ||
                                                LogFilters.ShowChangesOnly ==
                                                  0) && (
                                                <tr>
                                                  <td>
                                                    Service Time (Loading)
                                                  </td>
                                                  <td>
                                                    {
                                                      quoteDetailedLogs[0]
                                                        .LoadingTime
                                                    }
                                                  </td>
                                                  <td
                                                    className={
                                                      quoteDetailedLogs[0]
                                                        .LoadingTime !==
                                                      quoteDetailedLogs[1]
                                                        .LoadingTime
                                                        ? "clHighlight"
                                                        : ""
                                                    }
                                                  >
                                                    {
                                                      quoteDetailedLogs[1]
                                                        .LoadingTime
                                                    }
                                                  </td>
                                                </tr>
                                              )}
                                              {(quoteDetailedLogs[0]
                                                .UnloadingTime !==
                                                quoteDetailedLogs[1]
                                                  .UnloadingTime ||
                                                LogFilters.ShowChangesOnly ==
                                                  0) && (
                                                <tr>
                                                  <td>
                                                    Service Time (Unloading)
                                                  </td>
                                                  <td>
                                                    {
                                                      quoteDetailedLogs[0]
                                                        .UnloadingTime
                                                    }
                                                  </td>
                                                  <td
                                                    className={
                                                      quoteDetailedLogs[0]
                                                        .UnloadingTime !==
                                                      quoteDetailedLogs[1]
                                                        .UnloadingTime
                                                        ? "clHighlight"
                                                        : ""
                                                    }
                                                  >
                                                    {
                                                      quoteDetailedLogs[1]
                                                        .UnloadingTime
                                                    }
                                                  </td>
                                                </tr>
                                              )}
                                            </>
                                          )}

                                          {(quoteDetailedLogs[0]
                                            .RequestedDate !==
                                            quoteDetailedLogs[1]
                                              .RequestedDate ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Requested Date</td>
                                              <td>
                                                {formateDate(
                                                  quoteDetailedLogs[0]
                                                    .RequestedDate,
                                                )}
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .RequestedDate !==
                                                  quoteDetailedLogs[1]
                                                    .RequestedDate
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                {formateDate(
                                                  quoteDetailedLogs[1]
                                                    .RequestedDate,
                                                )}
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0]
                                            .RequestedTime !==
                                            quoteDetailedLogs[1]
                                              .RequestedTime ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Requested Time Slot</td>
                                              <td>
                                                {
                                                  quoteDetailedLogs[0]
                                                    .RequestedTime
                                                }
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .RequestedTime !==
                                                  quoteDetailedLogs[1]
                                                    .RequestedTime
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                {
                                                  quoteDetailedLogs[1]
                                                    .RequestedTime
                                                }
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0].Duration !==
                                            quoteDetailedLogs[1].Duration ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Duration</td>
                                              <td>
                                                {quoteDetailedLogs[0].Duration}
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .Duration !==
                                                  quoteDetailedLogs[1].Duration
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                {quoteDetailedLogs[1].Duration}
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0]
                                            .TotalDistance !==
                                            quoteDetailedLogs[1]
                                              .TotalDistance ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Distance</td>
                                              <td>
                                                {
                                                  quoteDetailedLogs[0]
                                                    .TotalDistance
                                                }
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .TotalDistance !==
                                                  quoteDetailedLogs[1]
                                                    .TotalDistance
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                {
                                                  quoteDetailedLogs[1]
                                                    .TotalDistance
                                                }
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0]
                                            .ClientInstructions !==
                                            quoteDetailedLogs[1]
                                              .ClientInstructions ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Client Instructions</td>
                                              <td>
                                                {
                                                  quoteDetailedLogs[0]
                                                    .ClientInstructions
                                                }
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .ClientInstructions !==
                                                  quoteDetailedLogs[1]
                                                    .ClientInstructions
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                {
                                                  quoteDetailedLogs[1]
                                                    .ClientInstructions
                                                }
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0].FromFloor !==
                                            quoteDetailedLogs[1].FromFloor ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Driver Instructions</td>
                                              <td>
                                                {quoteDetailedLogs[0].FromFloor}
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .FromFloor !==
                                                  quoteDetailedLogs[1].FromFloor
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                {quoteDetailedLogs[1].FromFloor}
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0]
                                            .ShowInsurance ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td
                                                colSpan={3}
                                                className="HeadingRow"
                                              >
                                                Insurance
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0]
                                            .IncludeInsurance !==
                                            quoteDetailedLogs[1]
                                              .IncludeInsurance ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Include Insurance</td>
                                              <td>
                                                {
                                                  quoteDetailedLogs[0]
                                                    .IncludeInsurance
                                                }
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .IncludeInsurance !==
                                                  quoteDetailedLogs[1]
                                                    .IncludeInsurance
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                {
                                                  quoteDetailedLogs[1]
                                                    .IncludeInsurance
                                                }
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0]
                                            .ValueOfGoods !==
                                            quoteDetailedLogs[1].ValueOfGoods ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Value of Goods</td>
                                              <td>
                                                £
                                                {quoteDetailedLogs[0].ValueOfGoods.toFixed(
                                                  2,
                                                )}
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .ValueOfGoods !==
                                                  quoteDetailedLogs[1]
                                                    .ValueOfGoods
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                £
                                                {quoteDetailedLogs[1].ValueOfGoods.toFixed(
                                                  2,
                                                )}
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0]
                                            .ValueOfGoods !==
                                            quoteDetailedLogs[1].ValueOfGoods ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>
                                                Additional liability charges
                                              </td>
                                              <td>
                                                £
                                                {quoteDetailedLogs[0]
                                                  .ValueOfGoods > 15000
                                                  ? (
                                                      (quoteDetailedLogs[0]
                                                        .ValueOfGoods -
                                                        15000) *
                                                      0.009
                                                    ).toFixed(2)
                                                  : "0.00"}
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .ValueOfGoods !==
                                                  quoteDetailedLogs[1]
                                                    .ValueOfGoods
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                £
                                                {quoteDetailedLogs[1]
                                                  .ValueOfGoods > 15000
                                                  ? (
                                                      (quoteDetailedLogs[1]
                                                        .ValueOfGoods -
                                                        15000) *
                                                      0.009
                                                    ).toFixed(2)
                                                  : "0.00"}
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0].FullName !==
                                            quoteDetailedLogs[1].FullName ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Full Name</td>
                                              <td>
                                                {quoteDetailedLogs[0].FullName}
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .FullName !==
                                                  quoteDetailedLogs[1].FullName
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                {quoteDetailedLogs[1].FullName}
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0].Initials !==
                                            quoteDetailedLogs[1].Initials ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Initials</td>
                                              <td>
                                                {quoteDetailedLogs[0].Initials}
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .Initials !==
                                                  quoteDetailedLogs[1].Initials
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                {quoteDetailedLogs[1].Initials}
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0]
                                            .ShowQuoteAmountDetails ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td
                                                colSpan={3}
                                                className="HeadingRow"
                                              >
                                                Quote Amount Details
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0]
                                            .InitialAmount !==
                                            quoteDetailedLogs[1]
                                              .InitialAmount ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Subtotal</td>
                                              <td>
                                                £
                                                {quoteDetailedLogs[0].InitialAmount.toFixed(
                                                  2,
                                                )}
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .InitialAmount !==
                                                  quoteDetailedLogs[1]
                                                    .InitialAmount
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                £
                                                {quoteDetailedLogs[1].InitialAmount.toFixed(
                                                  2,
                                                )}
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0].Discount !==
                                            quoteDetailedLogs[1].Discount ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Discount</td>
                                              <td>
                                                £
                                                {quoteDetailedLogs[0].Discount.toFixed(
                                                  2,
                                                )}
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .Discount !==
                                                  quoteDetailedLogs[1].Discount
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                £
                                                {quoteDetailedLogs[1].Discount.toFixed(
                                                  2,
                                                )}
                                              </td>
                                            </tr>
                                          )}

                                          {(quoteDetailedLogs[0]
                                            .PayableAmount !==
                                            quoteDetailedLogs[1]
                                              .PayableAmount ||
                                            LogFilters.ShowChangesOnly ==
                                              0) && (
                                            <tr>
                                              <td>Total Amount</td>
                                              <td>
                                                £
                                                {quoteDetailedLogs[0].PayableAmount.toFixed(
                                                  2,
                                                )}
                                              </td>
                                              <td
                                                className={
                                                  quoteDetailedLogs[0]
                                                    .PayableAmount !==
                                                  quoteDetailedLogs[1]
                                                    .PayableAmount
                                                    ? "clHighlight"
                                                    : ""
                                                }
                                              >
                                                £
                                                {quoteDetailedLogs[1].PayableAmount.toFixed(
                                                  2,
                                                )}
                                              </td>
                                            </tr>
                                          )}
                                        </>
                                      </>
                                    )}
                                </tbody>
                              </table>
                            </div>
                          </>
                        )}

                        {quoteDetailedLogs.length == 1 && (
                          <div className="flow-auto mt-20">
                            <table className="reuse-table">
                              <thead>
                                <tr>
                                  <th>Field Name</th>
                                  <th>Value</th>
                                </tr>
                              </thead>
                              <tbody>
                                {quoteDetailedLogs &&
                                  quoteDetailedLogs.length == 1 && (
                                    <>
                                      <tr>
                                        <td colSpan={2} className="HeadingRow">
                                          Client
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Client Name</td>
                                        <td>
                                          {quoteDetailedLogs[0].ClientName}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td colSpan={2} className="HeadingRow">
                                          Collection Point
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Post Code</td>
                                        <td>
                                          {quoteDetailedLogs[0].FromPostalCode}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Address</td>
                                        <td>
                                          {quoteDetailedLogs[0].FromAddress}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>City</td>
                                        <td>{quoteDetailedLogs[0].FromCity}</td>
                                      </tr>
                                      <tr>
                                        <td>Type</td>
                                        <td>{quoteDetailedLogs[0].FromType}</td>
                                      </tr>
                                      <tr>
                                        <td>Floor</td>
                                        <td>
                                          {quoteDetailedLogs[0].FromFloorText}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Lift Available</td>
                                        <td>
                                          {
                                            quoteDetailedLogs[0]
                                              .FromLiftAvailable
                                          }
                                        </td>
                                      </tr>

                                      <tr>
                                        <td colSpan={2} className="HeadingRow">
                                          Delivery Point
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Post Code</td>
                                        <td>
                                          {quoteDetailedLogs[0].ToPostalCode}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Address</td>
                                        <td>
                                          {quoteDetailedLogs[0].ToAddress}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>City</td>
                                        <td>{quoteDetailedLogs[0].ToCity}</td>
                                      </tr>
                                      <tr>
                                        <td>Type</td>
                                        <td>{quoteDetailedLogs[0].ToType}</td>
                                      </tr>
                                      <tr>
                                        <td>Floor</td>
                                        <td>
                                          {quoteDetailedLogs[0].ToFloorText}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Lift Available</td>
                                        <td>
                                          {quoteDetailedLogs[0].ToLiftAvailable}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td colSpan={2} className="HeadingRow">
                                          Services
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Service</td>
                                        <td>
                                          {quoteDetailedLogs[0].ServiceName}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td colSpan={2} className="HeadingRow">
                                          Quote Detail
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Van Type</td>
                                        <td>{quoteDetailedLogs[0].VanType}</td>
                                      </tr>
                                      <tr>
                                        <td>Status</td>
                                        <td>
                                          {quoteDetailedLogs[0].QuoteStatus}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Number of Movers</td>
                                        <td>
                                          {quoteDetailedLogs[0].MoverType}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Local Quote</td>
                                        <td>
                                          {
                                            quoteDetailedLogs[0]
                                              .IsLocalQuoteText
                                          }
                                        </td>
                                      </tr>
                                      {quoteDetailedLogs[0].IsLocalQuote && (
                                        <tr>
                                          <td>Van Booked for (Hours)</td>
                                          <td>
                                            {
                                              quoteDetailedLogs[0]
                                                .RequiredVanTimeText
                                            }
                                          </td>
                                        </tr>
                                      )}
                                      {!quoteDetailedLogs[0].IsLocalQuote && (
                                        <>
                                          <tr>
                                            <td>Loading Unloading Minutes</td>
                                            <td>
                                              {
                                                quoteDetailedLogs[0]
                                                  .LoadingUnLoadingTimeInMinutes
                                              }
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Service Time (Loading)</td>
                                            <td>
                                              {quoteDetailedLogs[0].LoadingTime}{" "}
                                              Minutes
                                            </td>
                                          </tr>
                                          <tr>
                                            <td>Service Time (Unloading)</td>
                                            <td>
                                              {
                                                quoteDetailedLogs[0]
                                                  .UnloadingTime
                                              }{" "}
                                              Minutes
                                            </td>
                                          </tr>
                                        </>
                                      )}
                                      <tr>
                                        <td>Requested Date</td>
                                        <td>
                                          {formateDate(
                                            quoteDetailedLogs[0].RequestedDate,
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Requested Time Slot</td>
                                        <td>
                                          {quoteDetailedLogs[0].RequestedTime}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Duration</td>
                                        <td>{quoteDetailedLogs[0].Duration}</td>
                                      </tr>
                                      <tr>
                                        <td>Distance</td>
                                        <td>
                                          {quoteDetailedLogs[0].TotalDistance}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Client Instructions</td>
                                        <td>
                                          {
                                            quoteDetailedLogs[0]
                                              .ClientInstructions
                                          }
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Driver Instructions</td>
                                        <td>
                                          {quoteDetailedLogs[0].FromFloor}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td colSpan={2} className="HeadingRow">
                                          Insurance
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Include Insurance</td>
                                        <td>
                                          {
                                            quoteDetailedLogs[0]
                                              .IncludeInsurance
                                          }
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Value of Goods</td>
                                        <td>
                                          £
                                          {quoteDetailedLogs[0].ValueOfGoods.toFixed(
                                            2,
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Additional liability charges</td>
                                        <td>
                                          {quoteDetailedLogs[0].ValueOfGoods >
                                          15000
                                            ? `£${(
                                                (quoteDetailedLogs[0]
                                                  .ValueOfGoods -
                                                  15000) *
                                                0.009
                                              ).toFixed(2)}`
                                            : "£0.00"}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Full Name</td>
                                        <td>{quoteDetailedLogs[0].FullName}</td>
                                      </tr>
                                      <tr>
                                        <td>Initials</td>
                                        <td>{quoteDetailedLogs[0].Initials}</td>
                                      </tr>

                                      <tr>
                                        <td colSpan={2} className="HeadingRow">
                                          Quote Amount Details
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Subtotal</td>
                                        <td>
                                          £
                                          {quoteDetailedLogs[0].InitialAmount.toFixed(
                                            2,
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Discount</td>
                                        <td>
                                          £
                                          {quoteDetailedLogs[0].Discount.toFixed(
                                            2,
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>Total Amount</td>
                                        <td>
                                          £
                                          {quoteDetailedLogs[0].PayableAmount.toFixed(
                                            2,
                                          )}
                                        </td>
                                      </tr>
                                    </>
                                  )}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {showSendPaymentLink && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">Send Payment Link</h3>
                <a
                  className="close-help"
                  onClick={() => setShowSendPaymentLink(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="grid-d gap-20 mt-20">
                <div className="field-input grid-d  flex-gap3">
                  <span className="font-12 text-left label-color">Email</span>

                  <input
                    type="text"
                    className="input-field w-100"
                    value={ClientData.EnteredEmailAddress || ""}
                    onChange={(e) =>
                      setClientData((prev: any) => ({
                        ...prev,
                        EnteredEmailAddress: e.target.value,
                      }))
                    }
                  />
                </div>
                <div className="field-input grid-d  flex-gap3">
                  <span className="font-12 text-left label-color">Mobile</span>

                  <input
                    type="text"
                    className="input-field w-100"
                    value={ClientData.EnteredMobile || ""}
                    onChange={(e) =>
                      setClientData((prev: any) => ({
                        ...prev,
                        EnteredMobile: e.target.value,
                      }))
                    }
                  />
                </div>
              </div>

              <div className="flex-daj btn-start flex-gap10 mt-20">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    SendPaymentLink(1);
                    setShowSendPaymentLink(false);
                  }}
                >
                  Email
                </a>
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    SendPaymentLink(2);
                    setShowSendPaymentLink(false);
                  }}
                >
                  SMS
                </a>
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    SendPaymentLink(3);
                    setShowSendPaymentLink(false);
                  }}
                >
                  SMS And Email
                </a>
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setShowSendPaymentLink(false)}
                >
                  Cancel
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {showLiabilityChangesPopup && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">
                  Confirm Liability Changes
                </h3>
                <a
                  className="close-help"
                  onClick={() => {
                    setShowLiabilityChangesPopup(false);
                    RevertLiabilityChanges();
                  }}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="modal-body">
                <div className="grid-d flex-gap10 mt-20 font-mont font-13">
                  <div className="flex-da flex-gap10">
                    Old Value:
                    <span className="bold-font">
                      £
                      {Number(infoBackup.ValueOfGoods).toLocaleString("en-GB", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      })}
                    </span>
                  </div>

                  <div className="flex-da flex-gap10">
                    New Value:
                    <span className="bold-font">
                      £
                      {Number(info.ValueOfGoods).toLocaleString("en-GB", {
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                      })}
                    </span>
                  </div>

                  {info.ValueOfGoods > 15000 && (
                    <div className="flex-da flex-gap10">
                      Additional liability charge is:{" "}
                      <span className="bold-font">
                        £
                        {((info.ValueOfGoods - 15000) * 0.009).toLocaleString(
                          "en-GB",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          },
                        )}
                      </span>{" "}
                      + VAT (total £
                      {(
                        (info.ValueOfGoods - 15000) * 0.009 +
                        ((info.ValueOfGoods - 15000) * 0.009 * Vat) / 100
                      ).toLocaleString("en-GB", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                      ).
                    </div>
                  )}
                </div>
                <div className="btn-start flex-daj flex-gap10 mt-20">
                  <a
                    className="flex-daj btn-primary"
                    onClick={() => {
                      setShowLiabilityChangesPopup(false);
                      Update();
                    }}
                  >
                    Confirm
                  </a>

                  <a
                    className="flex-daj btn-primary"
                    onClick={() => {
                      setShowLiabilityChangesPopup(false);
                      RevertLiabilityChanges();
                    }}
                  >
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showAddPaymentMethods && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">Add Payment Method</h3>
                <a
                  className="close-help"
                  onClick={() => setShowAddPaymentMethods(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="grid-d fr-1 gap-20 mt-20">
                {/* Card Number */}
                <div className="field-input grid-d  flex-gap3">
                  <span className="font-12 text-left label-color">
                    CARD NUMBER
                  </span>

                  <input
                    type="text"
                    className={`input-field w-100 ${
                      error.CardNumber ? "" : "RedBorderClass2"
                    }`}
                    placeholder="Valid Card Number"
                    value={paymentObject.CardNumber}
                    onChange={(e) => handleChange("CardNumber", e.target.value)}
                  />
                </div>

                {/* Name */}
                <div className="field-input grid-d  flex-gap3">
                  <span className="font-12 text-left label-color">NAME</span>
                  <input
                    type="text"
                    className={`input-field w-100 ${
                      error.CardName ? "" : "RedBorderClass2"
                    }`}
                    placeholder="Name"
                    value={paymentObject.CardName}
                    onChange={(e) => handleChange("CardName", e.target.value)}
                  />
                </div>

                {/* Expiry Date */}
                <div className="flex-da flex-gap10">
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      EXPIRY DATE (Month)
                    </span>

                    <input
                      type="number"
                      className={`input-field w-100 ${
                        error.ExpMonth ? "" : "RedBorderClass2"
                      }`}
                      placeholder="MM"
                      value={paymentObject.ExpMonth}
                      onChange={(e) => handleChange("ExpMonth", e.target.value)}
                    />
                  </div>
                  <div className="field-input grid-d  flex-gap3">
                    <span className="font-12 text-left label-color">
                      EXPIRY DATE (Year)
                    </span>
                    <input
                      type="number"
                      className={`input-field w-100 ${
                        error.ExpYear ? "" : "RedBorderClass2"
                      }`}
                      placeholder="YY"
                      value={paymentObject.ExpYear}
                      onChange={(e) => handleChange("ExpYear", e.target.value)}
                    />
                  </div>
                </div>

                {/* CV Code */}
                <div className="field-input grid-d  flex-gap3">
                  <span className="font-12 text-left label-color">CV CODE</span>
                  <input
                    type="password"
                    className={`input-field w-100 ${
                      error.CVV ? "" : "RedBorderClass2"
                    }`}
                    placeholder="CV"
                    value={paymentObject.CVV}
                    onChange={(e) => handleChange("CVV", e.target.value)}
                  />
                </div>
              </div>
              <div className="flex-daj btn-start flex-gap10 mt-20">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    savePaymentMethod();
                  }}
                >
                  Save
                </a>
                <a
                  className="btn-primary flex-daj"
                  onClick={() => setShowAddPaymentMethods(false)}
                >
                  Close
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {sendEmailModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">Send Email</h3>
                <a className="close-help" onClick={() => setEmailModal(false)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="grid-d fr-1 gap-20 mt-20">
                <div className="field-input grid-d  flex-gap3">
                  <span className="font-12 text-left label-color">Email</span>
                  <input
                    type="text"
                    className={`input-field w-100 
                      }`}
                    value={MoverEmailAddress}
                    onChange={(e) => setMoverEmailAddress(e.target.value)}
                  />
                </div>
              </div>

              <div className="flex-daj btn-start gap-10 mt-20">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    sendEmailToMover();
                  }}
                >
                  Send Email
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {sendWAModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner sm-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">Send WhatsApp</h3>
                <a className="close-help" onClick={() => setSendWAModal(false)}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="grid-d fr-1 gap-20 mt-20">
                <div className="field-input grid-d  flex-gap3">
                  <span className="font-12 text-left label-color">
                    Mobile No
                  </span>

                  <MobileInput
                    SelectedMobileNumber={MoverMobile}
                    SetSelectedMobileNumber={setMoverMobile}
                  />
                </div>
              </div>

              <div className="flex-daj btn-start gap-10 mt-20">
                <a
                  className="btn-primary flex-daj"
                  onClick={() => {
                    sendWhatsAppToMover();
                  }}
                >
                  Send WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      )}

      {showClientJobModal && (
        <div className="popup-help popup-help-index">
          <div className="help-popup-display">
            <div className="help-inner ms-popup">
              <div className="help-head flex-da justify-btw">
                <h3 className="bold-font flex-d m-all0">Confirmation</h3>
                <a
                  className="close-help"
                  onClick={() => setShowClientJobModal(false)}
                >
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="popup-message mt--15 p-all0">
                Are you sure to copy the details from this job?
              </div>

              <div className="flex-daj btn-start flex-gap10 mt-20">
                {MNVQuote.MNVQuoteStatusID == 6 && (
                  <a
                    className="btn-primary flex-daj"
                    onClick={() =>
                      copyThisJob(selectedClientJobObject.MNVJobID, JobId)
                    }
                  >
                    Copy to current job
                  </a>
                )}
                <a
                  className="btn-primary flex-daj"
                  onClick={() =>
                    copyThisJob(selectedClientJobObject.MNVJobID, 0)
                  }
                >
                  Add new job
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default QuoteDetail;
